export const QUESTIONS = [
  {
    "id": 1,
    "question": "Seth’s organization recently experienced a security incident where an attacker was able to place offensive content on the home page of his organization’s website. Seth would like to implement a series of security controls to prevent this type of attack from occurring in the future. What goal of information security is Seth most directly addressing?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Nonrepudiation",
    "choice_d": "Confidentiality",
    "correct_answer": "A",
    "explanation": "The three main goals of information security are confidentiality, integrity, and availability, so we can eliminate nonrepudiation right away. There is also no indication that there was any disclosure of sensitive information, so we can also eliminate confidentiality. It is possible that we could consider this an availability breach if the attacker made legitimate information unavailable, but integrity is a better answer here, because the attacker definitely altered the content of the website without authorization.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      253,
      257,
      264,
      263,
      298
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 2,
    "question": "Domer Delectables is a U.S. publicly traded company. They are currently undertaking a significant IT project that will redesign their access control systems. What is the best role for Internal Audit in this project?",
    "choice_a": "Develop procedures",
    "choice_b": "Design controls",
    "choice_c": "Provide feedback on control design",
    "choice_d": "Implement controls",
    "correct_answer": "C",
    "explanation": "Any Internal Audit function should not design or implement controls or procedures, other than those in its own department. Internal Audit may, however, opine on the design of controls for their suitability to achieve control objectives and auditability. Internal Audit cannot play a design role in any process or control that it may later be required to audit.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      60,
      87,
      99,
      71,
      363
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 3,
    "question": "Jen is building a series of controls for her organization’s information security program and is categorizing those controls by type. She is updating the organization’s firewall to include next-generation capabilities. What type of control is she working on?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Compensating",
    "choice_d": "Deterrent",
    "correct_answer": "B",
    "explanation": "Firewalls are best described as preventive controls because their purpose is to block an attack from succeeding. Detective controls seek to identify attacks that are taking place, and though a firewall can detect some attacks, this is not the primary purpose of the device. Firewalls may also serve as compensating controls in a regulatory environment, but there is no indication in this question that the firewall is being used as a compensating control. Firewalls are not normally visible to an attacker until after they have attempted an attack, so they cannot serve as deterrent controls.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      264,
      306,
      270,
      263,
      268
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 4,
    "question": "Belinda recently assumed the CISO role at a publicly traded company. She is sorting through the corporate governance model and identifying the roles that different people and groups play in the organization. Which one of the following roles has ultimate authority for the corporation?",
    "choice_a": "CEO",
    "choice_b": "CIO",
    "choice_c": "Board",
    "choice_d": "Board chair",
    "correct_answer": "C",
    "explanation": "The board of directors, acting as a group, has ultimate authority over the organization. They are elected by the shareholders who own the company and serve as the owner’s representatives. They delegate much of their authority to the chief executive officer (CEO) but retain ultimate control.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      4,
      44,
      1,
      6,
      5
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 5,
    "question": "Brandon leads the information security team for a large organization and is working with the software development team to provide them with application security testing services. He would like to document roles and responsibilities of the two teams in a written agreement with the leader of the development team. What type of agreement would be most appropriate?",
    "choice_a": "MOU",
    "choice_b": "SLA",
    "choice_c": "BPA",
    "choice_d": "MSA",
    "correct_answer": "A",
    "explanation": "In this case, Brandon needs an agreement with another internal organization. These types of agreements most commonly take the form of memoranda of understanding (MOU). More formal master service agreements (MSAs) and service level agreements (SLAs) are normally used with external service providers. Business partnership agreements (BPAs) are used when two organizations are entering into a joint effort.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      4,
      44,
      33,
      34,
      54
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 6,
    "question": "Monica is conducting a quantitative risk assessment of the risk that a fire poses to her organization’s primary operating facility. She believes that a serious fire would destroy 50 percent of the facility, causing $10 million in damage. She expects that a fire of this nature would only occur once every 50 years, on average. What is the AV in this scenario?",
    "choice_a": "$200,000",
    "choice_b": "$5 million",
    "choice_c": "$10 million",
    "choice_d": "$20 million",
    "correct_answer": "D",
    "explanation": "The asset value (AV) is the total value of the asset being analyzed. In this case, we know that the data center would be 50 percent destroyed by a fire and that the damage caused by the fire would be valued at $10 million. We can then work backward to determine that if $10 million is 50 percent of the asset value, then the asset value is $20 million.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      21,
      20,
      16,
      24,
      18
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 7,
    "question": "After assessing the risk of fire, Monica decides to install new sprinkler systems throughout the facility to reduce the likelihood of a serious fire. What type of risk treatment action is she taking?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk mitigation",
    "correct_answer": "D",
    "explanation": "Monica is seeking to reduce the likelihood and/or impact of a risk. Therefore, she is engaging in risk mitigation activity. Risk avoidance involves changing business practices to make a risk irrelevant. Risk acceptance involves continuing business activities in the face of a risk. Risk transference involves shifting some of the impact of a risk to a third party, such as an insurance company.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      22,
      16,
      21,
      20,
      24
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 8,
    "question": "Kevin is conducting a SWOT analysis for his organization’s IT program. He is especially proud of the talented and diverse team that exists within his organization. Where would he place this quality on the SWOT matrix?",
    "choice_a": "Upper-left quadrant",
    "choice_b": "Upper-right quadrant",
    "choice_c": "Lower-left quadrant",
    "choice_d": "Lower-right quadrant",
    "correct_answer": "A",
    "explanation": "This is an example of a strength. It is an internal force that is positive. Therefore, it would be placed in the upper-left quadrant. The upper-right quadrant is for internal negative forces, or weaknesses. The lower-left quadrant is for external positive forces, or opportunities. The lower-right quadrant is for external negative forces, or threats.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      261,
      264,
      334,
      350,
      345
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 9,
    "question": "Peihua is reviewing the organizing documents for an organization’s IT program as she prepares for an audit. She comes across a document that outlines the parameters under which the organization will function. What type of document is she reviewing?",
    "choice_a": "Charter",
    "choice_b": "Scope statement",
    "choice_c": "Business purpose statement",
    "choice_d": "Statement of authority",
    "correct_answer": "A",
    "explanation": "Peihua is drafting the organization’s IT charter. This is the organizing document for the program, and it outlines the parameters under which the program will function. This is a tricky question because the scope statement, business purpose statement, and statement of authority are all common elements of the charter.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      161,
      166,
      167,
      206,
      180
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 10,
    "question": "Fred is helping his boss develop a set of metrics for the organization’s security program. After consulting the ITIL framework used by his organization, he decides to track the number of major security incidents that occur each year. What type of metric is this?",
    "choice_a": "KGI",
    "choice_b": "KPI",
    "choice_c": "KSI",
    "choice_d": "KRI",
    "correct_answer": "B",
    "explanation": "This metric is directly out of the ITIL framework’s nine key performance indicators (KPIs) for a security program. KPIs are metrics that demonstrate the success of the program in achieving its objectives and are a look at historical performance. Key goal indicators (KGIs) are similar but track progress toward a defined goal and there is no clear goal in this scenario. Key risk indicators (KRIs) look forward at risks that may jeopardize future security.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      181,
      165,
      166,
      170,
      173
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 11,
    "question": "Roberta is tasked with detecting whether fraud is occurring in sales commission processing. She selects records looking for cases of fraud. What type of sampling is she using?",
    "choice_a": "Statistical sampling",
    "choice_b": "Stratified sampling",
    "choice_c": "Attribute sampling",
    "choice_d": "Discovery sampling",
    "correct_answer": "D",
    "explanation": "When a set of records is too large for an auditor to examine each one, the auditor must choose a sampling technique to select the records to examine. Discovery sampling is used to detect fraud. Statistical sampling employs a strictly random selection of records. Stratified sampling is used to select samples with, for example, low, moderate, and high dollar figures. Attribute sampling involves an examination of one or more values to understand control performance, such as the time required to patch a system.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      92,
      95,
      362,
      89,
      70
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 12,
    "question": "Michael is leading a software development project and is currently in the testing phase. He has completed the unit testing for various modules and is about to proceed with system testing. Which statement best describes the primary focus of system testing in this context?",
    "choice_a": "System testing is primarily concerned with verifying the individual functions of the application as specified in the functional requirements.",
    "choice_b": "System testing focuses on verifying that different modules or components work together correctly and includes testing interfaces and data migration.",
    "choice_c": "System testing is an informal testing phase where developers manually check the code for errors before deployment.",
    "choice_d": "System testing involves end users performing tests to ensure the application meets their needs and requirements.",
    "correct_answer": "B",
    "explanation": "System testing focuses on verifying that different modules or components work together correctly and includes testing interfaces and data migration. This phase ensures that the integrated system functions as intended and all parts interact properly, which is crucial after unit testing individual modules.<br>Verifying the individual functions of the application as specified in the functional requirements is the primary focus of unit testing, not system testing.<br>An informal testing phase where developers manually check the code for errors before deployment refers to ad hoc or informal testing, which is not structured like system testing.<br>End users performing tests to ensure the application meets their needs and requirements is characteristic of user acceptance testing (UAT), which follows system testing.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      121,
      153,
      119,
      122,
      120
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 13,
    "question": "What is a primary advantage of using prototyping as a software development methodology?",
    "choice_a": "It ensures that all functional requirements are addressed, even those unknown to users.",
    "choice_b": "It reduces the risk of the application being developed incorrectly by involving users continuously.",
    "choice_c": "It allows the prototype to be used in production environments without further development.",
    "choice_d": "It eliminates the need for formal documentation and user feedback.",
    "correct_answer": "B",
    "explanation": "Prototyping reduces the risk of the application being developed incorrectly by involving users continuously. This user involvement helps ensure that the development team receives ongoing feedback, which can be used to make necessary adjustments early in the development process, leading to a product that better meets user needs and expectations.<br>Ensuring that all functional requirements are addressed, even those unknown to users, is not a primary advantage of prototyping since unknown requirements can still be missed.<br>Allowing the prototype to be used in production environments without further development is inaccurate because prototypes are typically not fully developed or tested for production use; they serve primarily as models for feedback and iterative development.<br>Eliminating the need for formal documentation and user feedback is incorrect since prototyping often relies on user feedback and may still require documentation to guide the development process and ensure all aspects are covered.<br>.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      124,
      117,
      121,
      119,
      123
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 14,
    "question": "Cindy is concerned that users in her organization might take sensitive data and email it to their personal email accounts for access after they leave the organization. Which one of the following security technologies would best protect against this risk?",
    "choice_a": "Firewall",
    "choice_b": "IPS",
    "choice_c": "DLP",
    "choice_d": "Configuration management",
    "correct_answer": "C",
    "explanation": "While it is possible that any security technology could play an indirect role in preventing the unauthorized exfiltration of information, data loss prevention (DLP) technology is specifically designed to protect against this threat, so that is the best possible answer to this question.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      266,
      295,
      294,
      257,
      345
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 15,
    "question": "Andrea is placing a new server onto her organization’s network. The server is a web server that will be accessible only by internal employees. What network zone would be the most appropriate location for this server?",
    "choice_a": "Internet",
    "choice_b": "Intranet",
    "choice_c": "Extranet",
    "choice_d": "DMZ",
    "correct_answer": "B",
    "explanation": "Servers intended for internal use only should be placed on the intranet, where they are accessible only to other internal systems. The DMZ would be an appropriate location for this server if it permitted public access. An extranet would be appropriate if the server was being accessed by business partners. The Internet is generally never a good location for a server.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      270,
      271,
      306,
      305,
      264
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 16,
    "question": "Tech Solutions is a growing software development company. Recently, they have implemented a companywide documented software development process that all teams are required to follow. This process includes detailed guidelines for each stage of development, and the teams consistently use this process for all projects. However, the company has not yet started measuring the effectiveness or efficiency of the process, nor are there any formal metrics in place to monitor defects.<br>Based on the SEI CMM, at which level of maturity is Tech Solutions currently operating?",
    "choice_a": "Repeatable",
    "choice_b": "Defined",
    "choice_c": "Managed",
    "choice_d": "Optimizing",
    "correct_answer": "B",
    "explanation": "Tech Solutions is currently operating at the Defined level. At this level, the organization has established standardized and documented processes for software development that all teams follow consistently. These processes are described in detail and provide guidelines for each stage of development.<br>The Repeatable level is characterized by basic project management practices, but processes are not standardized across the organization. Teams may have their own practices that are not consistent companywide.<br>The Managed level involves measuring the effectiveness and efficiency of the processes, with formal metrics in place to monitor defects and performance, which Tech Solutions has not yet implemented.<br>The Optimizing level focuses on continuous process improvement through quantitative feedback and innovative practices, which also requires established metrics and measurements, and Tech Solutions has not yet reached this stage.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      138,
      141,
      137,
      136,
      140
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 17,
    "question": "Jen is conducting a financial audit of a large multinational corporation. In reviewing payroll transactions, she notes that a team of five employees was accidentally underpaid by 10 percent on their overtime hours for the past year. What statement best describes the impact of this discovery on the audit?",
    "choice_a": "This is a legal violation and must be immediately reported to governmental authorities.",
    "choice_b": "This error may cause a significant impact on the financial statements and should be reported as an audit finding.",
    "choice_c": "This issue indicates potential fraud and should be investigated further to determine if there are broader implications.",
    "choice_d": "This finding is immaterial.",
    "correct_answer": "D",
    "explanation": "Despite the fact that Jen has discovered a situation that should be corrected, the fact that five employees were underpaid is not going to meet the materiality threshold for a large corporation. Therefore, it will likely have no impact on the results of the financial audit and should not be reported as a finding. Jen should report it to management but is under no obligation to report to any government authorities on this matter. There is no evidence of fraud in this case.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      94,
      95,
      363,
      70,
      92
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 18,
    "question": "Norma is evaluating the security of a web-based system. She determines that the system verifies that dates fall within a logical range before accepting them as input to the system. What term best describes this technique?",
    "choice_a": "Input authorization",
    "choice_b": "Input validation",
    "choice_c": "Logical redundancy",
    "choice_d": "Error handling",
    "correct_answer": "B",
    "explanation": "Input validation ensures that data meets specific criteria before it is accepted into the system, including verifying that dates fall within a logical range, which prevents invalid or malicious data from causing errors or vulnerabilities.<br>Input authorization pertains to ensuring that only authorized personnel can enter data into the system, involving user access controls and approvals, rather than validating the correctness of the data itself.<br>Logical redundancy refers to the duplication of critical components or functions within a system to increase reliability, which is unrelated to the process of validating input data.<br>Error handling involves the actions taken by a system when input validation fails, such as rejecting invalid data or requesting re-input, but it does not describe the process of checking that the input data is correct.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      145,
      143,
      149,
      144,
      146
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 19,
    "question": "Wally is assessing the controls used to protect his organization against the risk of data loss. Which one of the following controls would be the best defense against the accidental deletion of data by an authorized user?",
    "choice_a": "RAID 1",
    "choice_b": "RAID 5",
    "choice_c": "Backups",
    "choice_d": "Access controls",
    "correct_answer": "C",
    "explanation": "Backups allow the organization to recover data that was accidentally deleted. RAID technology is used to protect against the failure of a hard drive and would not protect against the loss of data by user action. Access controls would be effective to prevent an unauthorized user from deleting data but would not stop an authorized user from doing so.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      239,
      231,
      183,
      236,
      244
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 20,
    "question": "Melissa is preparing to test her organization’s disaster recovery plan. During the test, she will activate the organization’s backup processing facility and use it to process data as a test, but normal operations will continue in the primary facility. What type of test is she running?",
    "choice_a": "Parallel test",
    "choice_b": "Cutover test",
    "choice_c": "Simulation test",
    "choice_d": "Walk-through",
    "correct_answer": "A",
    "explanation": "This type of test, where the alternate processing facility is activated but the primary site retains operational control, is known as a parallel test. In a cutover test, the primary site is shut down and operational control moves to the alternate site. Simulations and walk-throughs do not affect normal operations and do not activate the alternate site.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      236,
      245,
      249,
      248,
      237
    ],
    "source": "288380_Assessment Test"
  },
  {
    "id": 21,
    "question": "IT governance is most concerned with:",
    "choice_a": "Security policy",
    "choice_b": "IT policy",
    "choice_c": "IT strategy",
    "choice_d": "IT executive compensation",
    "correct_answer": "C",
    "explanation": "IT governance is the mechanism through which IT strategy is established, controlled, and monitored through the balanced scorecard. Long-term and other strategic decisions are made in the context of IT governance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      3,
      2,
      6,
      15
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 22,
    "question": "What is one of the advantages of outsourcing?",
    "choice_a": "It permits the organization to focus on core competencies.",
    "choice_b": "It results in reduced costs.",
    "choice_c": "It provides greater control over work performed by the outsourcing agency.",
    "choice_d": "It eliminates segregation of duties issues.",
    "correct_answer": "A",
    "explanation": "Outsourcing is an opportunity for the organization to focus on its core competencies. When an organization outsources a business function, it no longer needs to be concerned about training employees in that function. Outsourcing does not always reduce costs, because cost reduction is not always the primary purpose for outsourcing in the first place.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      33,
      27,
      1
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 23,
    "question": "An external IS auditor has discovered a segregation of duties issue in a high-value process. What is the best action for the auditor to take?",
    "choice_a": "Implement a preventive control.",
    "choice_b": "Implement a detective control.",
    "choice_c": "Implement a compensating control.",
    "choice_d": "Document the matter in the audit report.",
    "correct_answer": "D",
    "explanation": "The external auditor can only document the finding in the audit report. An external auditor is not in a position to implement controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      53,
      47,
      55,
      5
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 24,
    "question": "An organization has chosen to open a business office in another country where labor costs are lower and has hired workers to perform business functions there. This organization has:",
    "choice_a": "Outsourced the function",
    "choice_b": "Outsourced the function offshore",
    "choice_c": "Insourced the function on-site",
    "choice_d": "Insourced the function at a remote location",
    "correct_answer": "D",
    "explanation": "An organization that opens a business office in another country and staffs the office with its own employees is insourcing, not outsourcing. Outsourcing is the practice of using contract labor, which is clearly not the case in this example. In this case, the insourcing is taking place at a remote location.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      34,
      57,
      56
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 25,
    "question": "A company has been experiencing high IT staff turnover, long wait times for support, and discontent among end users regarding IT-supported systems. For an IT auditor, which of the following would be the most appropriate initial action to investigate these issues?",
    "choice_a": "Review the IT department’s project management methodologies.",
    "choice_b": "Conduct interviews with IT personnel and end users.",
    "choice_c": "Analyze the organization’s hardware and software standards.",
    "choice_d": "Evaluate the company’s business continuity and disaster recovery plans.",
    "correct_answer": "B",
    "explanation": "Conducting interviews with IT personnel and end users is the most appropriate initial action because it directly addresses the human factors contributing to high turnover, long wait times, and user discontentment. Interviews provide qualitative insights into the specific problems faced by both IT staff and end users, allowing for a more comprehensive understanding of the underlying issues.<br>Reviewing the IT department’s project management methodologies might help identify process inefficiencies but does not directly address staff turnover or user dissatisfaction.<br>Analyzing the organization’s hardware and software standards could reveal technical mismatches or outdated systems, but it doesn’t address the human aspect of the problems.<br>Evaluating the company’s business continuity and disaster recovery plans is important for overall IT governance but is not directly relevant to addressing staff turnover or user satisfaction issues.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      55,
      58,
      53,
      54,
      29
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 26,
    "question": "An organization needs to better understand whether one of its key business processes is effective. What action should the organization consider?",
    "choice_a": "Audit the process.",
    "choice_b": "Benchmark the process.",
    "choice_c": "Outsource the process.",
    "choice_d": "Offshore the process.",
    "correct_answer": "B",
    "explanation": "An organization that needs to understand whether a key process is effective should consider benchmarking the process. This will help the organization better understand whether its approach is similar to that of other organizations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      3,
      20,
      16,
      27
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 27,
    "question": "Annualized loss expectancy (ALE) is defined as:",
    "choice_a": "Single loss expectancy (SLE) × annualized rate of occurrence (ARO)",
    "choice_b": "Exposure factor (EF) × the annualized rate of occurrence (ARO)",
    "choice_c": "Single loss expectancy (SLE) × the exposure factor (EF)",
    "choice_d": "Asset value (AV) × the single loss expectancy (SLE)",
    "correct_answer": "A",
    "explanation": "Annualized loss expectancy (ALE) is the annual expected loss to an asset. It is calculated by multiplying the single loss expectancy (SLE—the financial loss experienced when the loss is realized one time) by the annualized rate of occurrence (ARO—the number of times that the organization expects the loss to occur).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      25,
      22,
      16,
      40
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 28,
    "question": "A quantitative risk analysis is more difficult to perform because:",
    "choice_a": "It is difficult to get accurate figures on the impact of a realized threat.",
    "choice_b": "It is difficult to get accurate figures on the probability of specific threats.",
    "choice_c": "It is difficult to get accurate figures on the value of assets.",
    "choice_d": "It is difficult to calculate the annualized loss expectancy of a specific threat.",
    "correct_answer": "B",
    "explanation": "The most difficult part of a quantitative risk analysis is determining the probability that a threat will actually be realized. It is relatively easy to determine the value of an asset and the impact of a threat event.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      21,
      20,
      22,
      16
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 29,
    "question": "During an IT governance audit, you notice that several projects have been aborted and many others have exceeded their budgets. Which document would most likely provide insight into the underlying causes of these project dysfunctions?",
    "choice_a": "IT procurement process records",
    "choice_b": "IT organization chart and job descriptions",
    "choice_c": "IT steering committee meeting agendas and minutes",
    "choice_d": "HR promotion policy documents",
    "correct_answer": "C",
    "explanation": "IT steering committee meeting agendas and minutes would most likely provide insight into the underlying causes of project dysfunctions such as aborted projects and budget overruns. These documents would contain discussions and decisions about project priorities, resource allocations, risk assessments, and other strategic directives that impact project execution.<br>IT procurement process records would primarily detail the acquisition of technology and services but wouldn’t shed much light on project management or execution issues.<br>The IT organization chart and job descriptions provide information about the structure and roles within the IT department but do not address project-specific decisions and issues.<br>HR promotion policy documents are related to staff career progression and do not directly relate to project management challenges or budgetary issues.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      7,
      53,
      55,
      38,
      58
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 30,
    "question": "What is the purpose of a balanced scorecard?",
    "choice_a": "Measures the efficiency of an IT organization",
    "choice_b": "Evaluates the performance of individual employees",
    "choice_c": "Benchmarks a process in the organization against peer organizations",
    "choice_d": "Measures organizational performance and effectiveness against strategic goals",
    "correct_answer": "D",
    "explanation": "The balanced scorecard is a tool that is used to quantify the performance of an organization against strategic objectives. The focuses of a balanced scorecard are financial, customer, internal processes, and innovation/learning.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      3,
      41,
      51,
      1,
      7
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 31,
    "question": "An organization has discovered that some of its employees have criminal records. What is the best course of action for the organization to take?",
    "choice_a": "Terminate the employees with criminal records.",
    "choice_b": "Immediately perform background checks, including criminal history, on all existing employees.",
    "choice_c": "Immediately perform background checks, including criminal history, on all new employees.",
    "choice_d": "Immediately perform background checks on those employees with criminal records.",
    "correct_answer": "B",
    "explanation": "An organization that has discovered that some employees have criminal records should have background checks performed on all existing employees, and it should also begin instituting background checks (which should include criminal history) for all new employees. It is not necessarily required to terminate these employees; the specific criminal offenses may not warrant termination.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      28,
      4,
      44,
      27,
      9
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 32,
    "question": "What are the options for risk treatment?",
    "choice_a": "Risk mitigation, risk reduction, and risk acceptance",
    "choice_b": "Risk mitigation, risk reduction, risk transfer, and risk acceptance",
    "choice_c": "Risk mitigation, risk avoidance, risk transfer, and risk acceptance",
    "choice_d": "Risk mitigation, risk avoidance, risk transfer, and risk conveyance",
    "correct_answer": "C",
    "explanation": "The options for risk treatment are the actions that management will take when a risk has been identified. The options are risk mitigation (where the risk is reduced), risk avoidance (where the activity is discontinued), risk transfer (where the risk is transferred to an insurance company), and risk acceptance (where management agrees to accept the risk as is).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      16,
      17,
      24,
      9
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 33,
    "question": "An IS auditor is examining the IT standards document for an organization that was last reviewed two years earlier. What is the best course of action for the IS auditor?",
    "choice_a": "Locate the IT policy document and see how frequently IT standards should be reviewed.",
    "choice_b": "Compare the standards with current practices and make a determination of adequacy.",
    "choice_c": "Report that IT standards are not being reviewed often enough.",
    "choice_d": "Report that IT standards are adequate.",
    "correct_answer": "C",
    "explanation": "IT standards that have not been reviewed for two years are out of date. If the IS auditor finds an IT policy that says that IT standards can be reviewed every two years, then there is a problem with IT policy as well; two years is far too long between reviews of IT standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      8,
      54,
      53
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 34,
    "question": "What is the most important step in the process of outsourcing a business function?",
    "choice_a": "Developing a business case",
    "choice_b": "Measuring the cost savings",
    "choice_c": "Measuring the change in risk",
    "choice_d": "Performing due diligence on the external service provider",
    "correct_answer": "A",
    "explanation": "Development of a business case is the most important step when considering the outsourcing of a business function. The other items (measuring cost savings and changes in risk, and performing due diligence on service providers) are parts of development of a business case.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      56,
      16,
      18
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 35,
    "question": "An organization has published a new security policy. What is the best course of action for the organization to undertake to ensure that all employees will support the policy?",
    "choice_a": "The company CEO should send an email to all employees, instructing them to support the policy.",
    "choice_b": "The company should provide training on the new security policy.",
    "choice_c": "The company should publish the policy on an internal website.",
    "choice_d": "The company should require all employees to sign a statement agreeing to support the policy.",
    "correct_answer": "D",
    "explanation": "All employees should be required to sign a statement agreeing to support the policy. The other actions are important but less effective.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      9,
      44,
      5,
      15
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 36,
    "question": "After completing the first year of his security awareness program, Charles reviews the data about how many personnel completed training compared to how many were assigned the training to determine whether he hit the 95 percent completion rate he was aiming for. What is this type of measure called?",
    "choice_a": "A KPI",
    "choice_b": "A metric",
    "choice_c": "An awareness control",
    "choice_d": "A return on investment rate",
    "correct_answer": "A",
    "explanation": "Charles is tracking a key performance indicator (KPI). A KPI is used to measure performance (and success). Without a definition of success, this would simply be a metric, but Charles is working toward a known goal and can measure against it. There is not a return investment calculation in this problem, and the measure is not a control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      41,
      3,
      5,
      7
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 37,
    "question": "An accounting employee at Doolittle Industries was recently arrested for participation in an embezzlement scheme. The employee transferred money to a personal account and then shifted funds around between other accounts every day to disguise the fraud for months. Which one of the following controls might have best allowed the earlier detection of this fraud?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Defense in depth",
    "choice_d": "Mandatory vacation",
    "correct_answer": "D",
    "explanation": "Mandatory vacation programs require that employees take continuous periods of time off each year and revoke their system privileges during that time. The purpose of these required vacation periods is to disrupt any attempt to engage in the cover-up actions necessary to hide fraud and result in exposing the threat. Separation of duties, least privilege, and defense-in-depth controls all may help prevent the fraud in the first place but are unlikely to speed the detection of fraud that has already occurred.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      30,
      47,
      39,
      5,
      20
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 38,
    "question": "Sally is developing a set of metrics that will help her organization assess changes in the threat environment and adjust their security program accordingly. What type of metrics is she developing?",
    "choice_a": "KMIs",
    "choice_b": "KGIs",
    "choice_c": "KRIs",
    "choice_d": "KPIs",
    "correct_answer": "C",
    "explanation": "Key risk indicators (KRIs) are measures that seek to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization.<br>Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look back at historical performance, providing a measuring stick to evaluate the past success of the program.<br>Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. For example, if an organization has a goal to eliminate all stored Social Security numbers (SSNs), a KGI might track the percentage of SSNs removed.<br>KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      52,
      51,
      3,
      41,
      50
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 39,
    "question": "The Acme Widgets Company is putting new controls in place for its accounting department. Management is concerned that a rogue accountant may be able to create a new false vendor and then issue checks to that vendor as payment for services that were never rendered. What security control can best help prevent this situation?",
    "choice_a": "Mandatory vacation",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Job rotation",
    "correct_answer": "B",
    "explanation": "When following the separation of duties principle, organizations divide critical tasks into discrete components and ensure that no one individual has the ability to perform both actions. This prevents a single rogue individual from performing that task in an unauthorized manner.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      47,
      39,
      9,
      31,
      4
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 40,
    "question": "Bob is developing a set of measures designed to evaluate how well the information security program in his organization is functioning. He will provide monthly reporting on these metrics, looking back at the program’s functioning over the past month. What term best describes these metrics?",
    "choice_a": "KMIs",
    "choice_b": "KGIs",
    "choice_c": "KRIs",
    "choice_d": "KPIs",
    "correct_answer": "D",
    "explanation": "Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look back at historical performance, providing a measuring stick to evaluate the past success of the program. Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. For example, if an organization has a goal to eliminate all stored Social Security numbers (SSNs), a KGI might track the percentage of SSNs removed. Key risk indicators (KRIs) are measures that seek to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization. KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      52,
      50,
      3,
      41
    ],
    "source": "288380_Ch 1"
  },
  {
    "id": 41,
    "question": "An IS auditor is planning an audit project and needs to know which areas represent the highest risk. What is the best approach for identifying these risk areas?",
    "choice_a": "Perform the audit; control failures will identify the areas of highest risk.",
    "choice_b": "Perform the audit and then perform a risk assessment.",
    "choice_c": "Perform a risk assessment first, and then concentrate control tests in high-risk areas identified in the risk assessment.",
    "choice_d": "Increase sampling rates in high-risk areas.",
    "correct_answer": "C",
    "explanation": "The IS auditor should conduct a risk assessment first to determine which areas have highest risk, and then devote more testing resources to those high-risk areas.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      359,
      84,
      72,
      75,
      360
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 42,
    "question": "An auditor has detected potential fraud while testing a control objective. What should the auditor do next?",
    "choice_a": "Notify the audit committee.",
    "choice_b": "Conduct a formal investigation.",
    "choice_c": "Report the fraud to law enforcement.",
    "choice_d": "Report the suspected fraud to management.",
    "correct_answer": "A",
    "explanation": "When the IS auditor suspects fraud, they should conduct a careful evaluation of the matter and notify the audit committee. Because audit committee members are generally not involved in business operations, they will be sufficiently removed from the matter, and they will have the authority to involve others as needed.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      362,
      95,
      69,
      60,
      99
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 43,
    "question": "The possibility that a process or procedure will be unable to prevent or detect serious errors and wrongdoing is known as:",
    "choice_a": "Detection risk",
    "choice_b": "Inherent risk",
    "choice_c": "Sampling risk",
    "choice_d": "Control risk",
    "correct_answer": "D",
    "explanation": "Control risk is the term that signifies the possibility that a control will fail to prevent or detect unwanted actions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      81,
      359,
      360,
      96
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 44,
    "question": "The categories of risk treatment are:",
    "choice_a": "Risk reduction, risk transfer, risk avoidance, and risk acceptance",
    "choice_b": "Risk avoidance, risk transfer, and risk mitigation",
    "choice_c": "Risk avoidance, risk reduction, risk transfer, risk mitigation, and risk acceptance",
    "choice_d": "Risk avoidance, risk treatment, risk mitigation, and risk acceptance",
    "correct_answer": "A",
    "explanation": "The four categories of risk treatment are risk reduction (sometimes called risk mitigation, where risks are reduced through a control or process change), risk transfer (where risks are transferred to an external party such as an insurance company), risk avoidance (where the risk-bearing activity is discontinued), and risk acceptance (where management chooses to accept the risk).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      96,
      76,
      75,
      73,
      72
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 45,
    "question": "An IS auditor needs to perform an audit of a financial system and wants to trace individual transactions through the system. What type of testing should the auditor perform?",
    "choice_a": "Discovery testing",
    "choice_b": "Statistical testing",
    "choice_c": "Compliance testing",
    "choice_d": "Substantive testing",
    "correct_answer": "D",
    "explanation": "The auditor should perform substantive testing, which is a test of transaction integrity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      361,
      90,
      89,
      359
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 46,
    "question": "An IS auditor is auditing the change management process for a financial application. The auditor has two primary pieces of evidence: change logs and a written analysis of the change logs performed by a generative AI system. Which evidence is best and why?",
    "choice_a": "The change log is best because it is subjective.",
    "choice_b": "The written analysis is best because it interprets the change log.",
    "choice_c": "The change log is best because it is objective and unbiased.",
    "choice_d": "The written analysis is best because it is objective.",
    "correct_answer": "C",
    "explanation": "The change log is the best evidence because it is objective and not subject to bias or hallucination.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      77,
      362,
      70,
      89
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 47,
    "question": "Under which circumstances should an auditor use subjective sampling?",
    "choice_a": "When the population size is low",
    "choice_b": "When the auditor believes that specific transactions represent higher risk than most others",
    "choice_c": "When the risk of exceptions is low",
    "choice_d": "When statistical sampling cannot be performed",
    "correct_answer": "B",
    "explanation": "Subjective sampling is used when the auditor concentrates on samples representing higher risk.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      92,
      72,
      95,
      361,
      88
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 48,
    "question": "An IS auditor has discovered a high-risk exception during control testing. What is the best course of action for the IS auditor to take?",
    "choice_a": "Immediately perform mitigation.",
    "choice_b": "Include the exception in the report and mark the test as a control failure.",
    "choice_c": "Immediately inform the auditee of the situation.",
    "choice_d": "Immediately inform the audit committee of the situation.",
    "correct_answer": "C",
    "explanation": "The IS auditor should immediately inform the auditee when any high-risk situation is discovered.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      354,
      89,
      90,
      357,
      358
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 49,
    "question": "What is the appropriate role of an IS auditor in a control self-assessment?",
    "choice_a": "The IS auditor should participate as a subject matter expert.",
    "choice_b": "The IS auditor should act as facilitator.",
    "choice_c": "The IS auditor should not be involved.",
    "choice_d": "The IS auditor should design the control self-assessment.",
    "correct_answer": "B",
    "explanation": "The IS auditor should act as a facilitator of a control self-assessment, and management should make any decisions regarding changes to controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      358,
      363,
      352,
      71
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 50,
    "question": "Which of the following would not be useful evidence in an IS audit?",
    "choice_a": "Personnel handbook",
    "choice_b": "Organization mission statement and objectives",
    "choice_c": "Organizational chart",
    "choice_d": "Organization's history",
    "correct_answer": "D",
    "explanation": "Of the choices given, the organization history would be the least useful. The others will provide insight into the organization’s mission and goals and how it sets out to achieve them.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      90,
      89,
      61,
      354,
      353
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 51,
    "question": "An auditor has discovered that automated workpapers were configured with read/write permissions for database administrators. What actions should the auditor take?",
    "choice_a": "Simply continue to rely on the automated workpapers.",
    "choice_b": "Note an exception and continue to rely on these automated workpapers.",
    "choice_c": "Recommend that permissions on automated workpapers be changed so that no personnel have write access and so that this data may be relied on in the future.",
    "choice_d": "Notify the board of directors or the audit committee.",
    "correct_answer": "C",
    "explanation": "If an auditor has discovered that automated workpapers could be updated by any personnel, the workpapers should not be trusted to contain complete and accurate information. Once this is fixed by eliminating write access, the auditor can rely on this data going forward but should not rely on the information prior to that point in time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      365,
      90,
      361,
      89,
      97
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 52,
    "question": "During an audit, an auditor has discovered a process that is being performed consistently and effectively, but the process lacks procedure documentation. What action should the auditor take?",
    "choice_a": "Document the process.",
    "choice_b": "Find that the process is effective but recommend that it be documented.",
    "choice_c": "Write the procedure document for the auditee and include it in audit evidence.",
    "choice_d": "Find that the process is ineffective.",
    "correct_answer": "B",
    "explanation": "The auditor should determine that the process is effective and recommend that it be documented. Some regulations, however, may require that such a process be judged ineffective specifically because it lacks documentation.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      90,
      94,
      64,
      74,
      359
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 53,
    "question": "During audit planning, an auditor has discovered that a key business process in the auditee organization has been outsourced to an external service provider. Which option should the auditor consider?",
    "choice_a": "Audit the external service provider or rely on an SSAE 16 audit report if one is available.",
    "choice_b": "Audit the external service provider.",
    "choice_c": "Determine that the business process is not effective.",
    "choice_d": "Request that the external service provider submit its internal audit workpapers.",
    "correct_answer": "A",
    "explanation": "An auditor who has determined that a key business process has been outsourced needs to determine effectiveness of that process by auditing that process or by relying on a separate audit report of that process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      359,
      85,
      74,
      90
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 54,
    "question": "Why should an auditor prefer bank statements over a department’s own business records that list bank transactions?",
    "choice_a": "Bank statements can be provided in electronic format.",
    "choice_b": "Bank statements contain data not found in internal records.",
    "choice_c": "Bank statements are usually easier to obtain.",
    "choice_d": "Bank statements are independent and objective.",
    "correct_answer": "D",
    "explanation": "An auditor would prefer bank statements over internal records because bank statements are produced by a bank, which is independent and objective. A bank is unlikely to alter its records to improve the audit outcome of one of its customers.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      90,
      87,
      89,
      74,
      357
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 55,
    "question": "Which of the following statements is true about ISACA audit standards and guidelines?",
    "choice_a": "ISACA audit standards are mandatory, whereas ISACA audit guidelines are optional.",
    "choice_b": "ISACA audit standards are optional, whereas ISACA audit guidelines are mandatory.",
    "choice_c": "ISACA audit standards and guidelines are mandatory.",
    "choice_d": "ISACA audit standards and guidelines are optional.",
    "correct_answer": "A",
    "explanation": "ISACA audit standards are mandatory for all ISACA certification holders, including those with the CISA certification. ISACA audit guidelines are optional.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      71,
      69,
      70,
      99
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 56,
    "question": "When planning an audit project, all of the following should be established prior to the start of the project, <i>except</i>:",
    "choice_a": "Audit schedule",
    "choice_b": "Purpose",
    "choice_c": "Sampling technique",
    "choice_d": "Audit scope",
    "correct_answer": "C",
    "explanation": "The schedule, scope, and purpose of an audit should be established prior to the start of the audit. Sampling techniques should be established by auditors once they understand the nature of the systems and processes they are examining.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      84,
      85,
      92,
      89,
      357
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 57,
    "question": "An organization has outsourced the operation of its ERP system to an external service provider. Which audits should the organization expect to receive from the service provider periodically upon request?",
    "choice_a": "SOC 1 and SOC 2 Type I",
    "choice_b": "SOX",
    "choice_c": "SOC 2 Type II",
    "choice_d": "SOC 1 and SOC 2",
    "correct_answer": "D",
    "explanation": "A financial services provider will often provide SOC 1 and SOC 2 Type II audit reports to a customer, providing its customer’s auditor with the information they need to complete audits of the customer’s financial accounting systems.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      97,
      86,
      87,
      353,
      89
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 58,
    "question": "An auditor is examining the population of transactions in a business process. The auditor wants to select samples until an exception is found. What sampling technique is the auditor using?",
    "choice_a": "Exception",
    "choice_b": "Discovery",
    "choice_c": "Stop-or-go",
    "choice_d": "Judgmental",
    "correct_answer": "B",
    "explanation": "The auditor is using the discovery sampling technique, where the auditor is trying to find at least one exception in the population.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      92,
      88,
      90,
      89,
      84
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 59,
    "question": "An IS auditor is auditing an accounting system and is looking for evidence of accounting fraud. Which sampling technique should the auditor use?",
    "choice_a": "Discovery",
    "choice_b": "Variable",
    "choice_c": "Detective",
    "choice_d": "Stratified",
    "correct_answer": "A",
    "explanation": "An IS auditor examining business records to look for evidence of fraud should employ discovery sampling. The auditor is examining a population in which even a single exception would represent a high-risk situation (such as embezzlement or fraud).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      362,
      95,
      90,
      360
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 60,
    "question": "An auditor wants to use AI/ML tools in an examination of a large dataset to identify anomalies. In what conditions may the auditor use these tools?",
    "choice_a": "The use of AI for this purpose is allowable by policy, is legal, and is ethical.",
    "choice_b": "The use of AI for this purpose is allowable by policy.",
    "choice_c": "The use of AI for this purpose is legal and ethical.",
    "choice_d": "The use of AI for this purpose is the most efficient.",
    "correct_answer": "A",
    "explanation": "IS auditors may use AI/ML tools to examine large datasets, provided such use is permitted by policy and is both legal and ethical.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      358,
      71,
      361,
      359
    ],
    "source": "288380_Ch 2"
  },
  {
    "id": 61,
    "question": "What testing activities should developers perform during the development phase?",
    "choice_a": "Security testing",
    "choice_b": "Integration testing",
    "choice_c": "Unit testing",
    "choice_d": "Developers should not perform any testing",
    "correct_answer": "C",
    "explanation": "During the development phase, developers should perform only unit testing to verify that the individual sections of code they have written are performing properly.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      120,
      121,
      153,
      115,
      124
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 62,
    "question": "The purpose of function point analysis (FPA) is to:",
    "choice_a": "Estimate the effort required to develop a software program.",
    "choice_b": "Identify risks in a software program.",
    "choice_c": "Estimate task dependencies in a project plan.",
    "choice_d": "Inventory inputs and outputs in a software program.",
    "correct_answer": "A",
    "explanation": "Function point analysis (FPA) is used to estimate the effort required to develop a software program.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      107,
      116,
      151,
      110,
      104
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 63,
    "question": "A project manager needs to identify the tasks that are responsible for project delays. What approach should the project manager use?",
    "choice_a": "Function point analysis",
    "choice_b": "Gantt analysis",
    "choice_c": "Project evaluation and review technique",
    "choice_d": "Critical path analysis",
    "correct_answer": "D",
    "explanation": "Critical path analysis helps a project manager determine which activities are on a project’s “critical path.”.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      108,
      106,
      110,
      109,
      104
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 64,
    "question": "A software developer has informed the project manager that a portion of the application development is going to take five additional days to complete. The project manager should:",
    "choice_a": "Inform the other project participants of the schedule change.",
    "choice_b": "Change the project schedule to reflect the new completion time.",
    "choice_c": "Create a project change request.",
    "choice_d": "Adjust the resource budget to account for the schedule change.",
    "correct_answer": "C",
    "explanation": "When any significant change needs to occur in a project plan, a project change request should be created to document the reason for the change.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      111,
      132,
      110,
      106,
      150
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 65,
    "question": "The phases and their order in the systems development life cycle are:",
    "choice_a": "Requirements definition, feasibility study, design, development, testing, implementation, post-implementation",
    "choice_b": "Feasibility study, requirements definition, design, development, testing, implementation, post-implementation",
    "choice_c": "Feasibility study, requirements definition, design, development, testing, implementation",
    "choice_d": "Requirements definition, feasibility study, development, testing, implementation, post-implementation",
    "correct_answer": "B",
    "explanation": "The phases of the systems development life cycle are a feasibility study, requirements definition, design, development, testing, implementation, and post-implementation.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      115,
      116,
      117,
      119,
      121
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 66,
    "question": "Which personnel should be involved in the requirements phase of a software development project?",
    "choice_a": "Systems administrators, network administrators, and software developers",
    "choice_b": "Developers, analysts, architects, and users",
    "choice_c": "Security, privacy, and legal analysts",
    "choice_d": "Representatives from each software vendor",
    "correct_answer": "B",
    "explanation": "Requirements need to be developed by several parties, including developers, analysts, architects, and users.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      151,
      116,
      115,
      105
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 67,
    "question": "The primary source for test plans in a software development project is:",
    "choice_a": "Requirements",
    "choice_b": "Developers",
    "choice_c": "End users",
    "choice_d": "Vendors",
    "correct_answer": "A",
    "explanation": "The requirements that are developed for a project should be the primary source for detailed tests.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      121,
      119,
      151,
      152
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 68,
    "question": "The primary purpose of a change management process is to:",
    "choice_a": "Record changes made to systems and infrastructure.",
    "choice_b": "Review and approve proposed changes to systems and infrastructure.",
    "choice_c": "Review and approve changes to a project schedule.",
    "choice_d": "Review and approve changes to application source code.",
    "correct_answer": "B",
    "explanation": "The main purpose of change management is to review and approve proposed changes to systems and infrastructure. This helps to reduce the risk of unintended events and unplanned downtime.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      132,
      154,
      134,
      131,
      111
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 69,
    "question": "What is the purpose of a capability maturity model?",
    "choice_a": "To assess the experience of software developers",
    "choice_b": "To assess the experience of project managers",
    "choice_c": "To assess the integrity of application software",
    "choice_d": "To assess the maturity of business processes",
    "correct_answer": "D",
    "explanation": "A capability maturity model helps an organization to assess the maturity of its business processes, which is an important first step to any large-scale process improvement efforts.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      138,
      140,
      137,
      135,
      136
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 70,
    "question": "The purpose of input validation checking is to:",
    "choice_a": "Ensure that input values are within acceptable ranges.",
    "choice_b": "Ensure that input data contains the correct type of characters.",
    "choice_c": "Ensure that input data is free of hostile or harmful content.",
    "choice_d": "Ensure all of the above.",
    "correct_answer": "D",
    "explanation": "Input validation checking is used to ensure that input values are within established ranges, of the correct character types, and free of harmful content.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      149,
      143,
      146,
      148
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 71,
    "question": "An organization is considering the acquisition of enterprise software that will be hosted by a cloud services provider. What additional requirements need to be considered for the cloud environment?",
    "choice_a": "Logging",
    "choice_b": "Access control",
    "choice_c": "Data segregation",
    "choice_d": "Performance",
    "correct_answer": "C",
    "explanation": "In addition to business, functional, security, and privacy requirements, an organization considering cloud-based services needs to understand how the cloud services provider segregates the organization’s data from that of its other customers.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      126,
      117,
      118,
      130,
      152
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 72,
    "question": "System operators have to make an emergency change in order to keep an application server running. To satisfy change management requirements, the systems operators should:",
    "choice_a": "Document the steps taken.",
    "choice_b": "Fill out an emergency change request form.",
    "choice_c": "Seek approval from management before making the change.",
    "choice_d": "Do all of the above.",
    "correct_answer": "D",
    "explanation": "When making an emergency change, personnel should first seek management approval, document the details of the change, and initiate an emergency change management procedure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      132,
      111,
      131,
      153
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 73,
    "question": "A global organization is planning the migration of a business process to a new application. What cutover methods can be considered?",
    "choice_a": "Parallel, geographic, module by module, or all at once",
    "choice_b": "Parallel, geographic, or module by module",
    "choice_c": "Parallel, module by module, or all at once",
    "choice_d": "Parallel, geographic, or all at once",
    "correct_answer": "A",
    "explanation": "The migration to a new application can be done in several ways: parallel (running old and new systems side by side); geographic (migrating users in each geographic region separately); module by module (migrating individual modules of the application); or migrate all users, locations, and modules at the same time.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      122,
      123,
      158,
      110,
      106
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 74,
    "question": "The purpose of developing risk tiers in third-party management is to:",
    "choice_a": "Determine whether to perform penetration tests.",
    "choice_b": "Satisfy regulatory requirements.",
    "choice_c": "Determine the appropriate level of due diligence.",
    "choice_d": "Determine data classification requirements.",
    "correct_answer": "C",
    "explanation": "Developing risk tiers in third-party management helps an organization determine the level of due diligence for third parties at each risk tier. Because the level of risk varies, some third parties warrant extensive due diligence, whereas a lighter touch is warranted for low-risk parties.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      142,
      160,
      155,
      136,
      138
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 75,
    "question": "The reason that functional requirements need to be measurable is:",
    "choice_a": "Developers need to know how to test functional requirements.",
    "choice_b": "Functional tests are derived directly from functional requirements.",
    "choice_c": "To verify correct system operation.",
    "choice_d": "To measure system performance.",
    "correct_answer": "B",
    "explanation": "Functional requirements should be measurable, because test cases should be developed directly from functional requirements. The same can be said about security and privacy requirements—all must be measurable because all should be tested.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      121,
      119,
      118,
      151
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 76,
    "question": "Which project management approach involves employees having both a permanent reporting relationship in their functional area and a temporary reporting relationship to the project manager?",
    "choice_a": "Supervisor",
    "choice_b": "Influencer",
    "choice_c": "Functional manager",
    "choice_d": "Matrix",
    "correct_answer": "D",
    "explanation": "In a matrix management approach, individuals have two different reporting relationships: a permanent one in their functional area and a temporary one to the project manager. This approach is commonly used when employees work on a project part-time while continuing their functional responsibilities.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      103,
      105,
      110,
      101,
      106
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 77,
    "question": "What is the primary purpose of the benchmarking process in business?",
    "choice_a": "To identify risks in business processes",
    "choice_b": "To improve communication within the organization",
    "choice_c": "To compare key measurements in a business process to those of top-performing organizations",
    "choice_d": "To develop new business strategies",
    "correct_answer": "C",
    "explanation": "The primary purpose of benchmarking is to compare key measurements in a business process to the same measurements performed by other organizations, particularly those considered to be top performers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      137,
      135,
      141,
      138,
      102
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 78,
    "question": "Which component of the NIST Cybersecurity Framework (CSF) describes the set of six security functions that apply across all industries and sectors?",
    "choice_a": "Framework Implementation",
    "choice_b": "Framework Profiles",
    "choice_c": "Framework Core",
    "choice_d": "Maturity Model Tiers",
    "correct_answer": "C",
    "explanation": "The Framework Core is a set of six security functions that apply across all industries and sectors: govern, identify, protect, detect, respond, and recover.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      139,
      138,
      141,
      137,
      135
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 79,
    "question": "A project team has completed the development of a new software application. During the testing phase, they need to verify that all requirements are met and that the application performs as expected according to the specifications. The project manager has instructed the team to simulate various user scenarios and ensure each function of the application works correctly as described in the requirements document. Which stage of testing is the team conducting?",
    "choice_a": "Unit testing",
    "choice_b": "System testing",
    "choice_c": "Functional testing",
    "choice_d": "User acceptance testing",
    "correct_answer": "C",
    "explanation": "The team is conducting functional testing, which involves verifying that all functional requirements are met and that the application performs as expected according to the specifications.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      121,
      117,
      119,
      120,
      123
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 80,
    "question": "A company is transitioning to a DevOps model to improve collaboration between development and operations teams. The goal is to create a more iterative and continuous integration/continuous delivery (CI/CD) pipeline to enhance the efficiency and reliability of software deployments. Which of the following benefits is the company most likely aiming to achieve with this transition?",
    "choice_a": "Reduced project costs by minimizing the number of developers required",
    "choice_b": "Improved time-to-market by enabling faster and more frequent software releases",
    "choice_c": "Increased security by isolating development and operations environments",
    "choice_d": "Enhanced customer satisfaction by reducing the number of features in each release",
    "correct_answer": "B",
    "explanation": "The company is most likely aiming to achieve improved time-to-market by enabling faster and more frequent software releases through the adoption of a DevOps model. This approach enhances collaboration and streamlines workflows, unlike isolating environments or focusing on cost reduction. DevOps improves customer satisfaction by delivering timely updates, not by reducing features.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      124,
      100,
      135,
      137,
      110
    ],
    "source": "288380_Ch 3"
  },
  {
    "id": 81,
    "question": "A web application is displaying information incorrectly, and many users have contacted the IT service desk. This matter should be considered a(n):",
    "choice_a": "Incident",
    "choice_b": "Problem",
    "choice_c": "Bug",
    "choice_d": "Outage",
    "correct_answer": "B",
    "explanation": "A problem is defined as a condition resulting from multiple incidents that exhibit common symptoms. In this example, many users are experiencing the effects of the application error.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      184,
      173,
      161,
      175
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 82,
    "question": "An IT organization is experiencing many cases of unexpected downtime caused by unauthorized changes to application code and operating system configuration. Which process should the IT organization implement to reduce downtime?",
    "choice_a": "Configuration management",
    "choice_b": "Incident management",
    "choice_c": "Change management",
    "choice_d": "Problem management",
    "correct_answer": "C",
    "explanation": "Change management is the process of managing change through a life-cycle process that consists of request, review, approve, implement, and verify.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      166,
      167,
      168,
      169,
      173
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 83,
    "question": "An IT organization manages hundreds of servers, databases, and applications, and is having difficulty tracking changes to the configuration of these systems. What process should be implemented to remedy this?",
    "choice_a": "Configuration management",
    "choice_b": "Change management",
    "choice_c": "Problem management",
    "choice_d": "Incident management",
    "correct_answer": "A",
    "explanation": "Configuration management is the process (often supplemented with automated tools) of tracking configuration changes to systems and system components such as databases and applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      173,
      225,
      227,
      186
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 84,
    "question": "In an audit of configuration management, an auditor should request all the following artifacts <i>except</i>:",
    "choice_a": "System-hardening standards",
    "choice_b": "CMDB procedures",
    "choice_c": "Change management procedures",
    "choice_d": "Check-out/check-in logs",
    "correct_answer": "D",
    "explanation": "Check-out/check-in logs are related to SDLC but not to configuration management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      173,
      167,
      170,
      166
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 85,
    "question": "A database administrator has been asked to configure a database management system so that it records all changes made by users. What should the database administrator implement?",
    "choice_a": "Audit logging",
    "choice_b": "Triggers",
    "choice_c": "Stored procedures",
    "choice_d": "Journaling",
    "correct_answer": "A",
    "explanation": "The database administrator should implement audit logging, causing the database to record every change made to it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      227,
      174,
      178,
      177
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 86,
    "question": "The purpose of vulnerability scanning is all of the following, <i>except</i>:",
    "choice_a": "A quality assurance step to ensure that security configurations and patches are in place",
    "choice_b": "An operational step to direct IT personnel to correct configuration errors and install patches",
    "choice_c": "The first activity in a penetration test to identify easily exploited vulnerabilities",
    "choice_d": "To identify security-related defects in application source code",
    "correct_answer": "D",
    "explanation": "The purposes of vulnerability scanning include confirming that proactive patching and proper configurations are in place, a good first step in a penetration test, and a means for directing IT to correct configuration errors and apply patches. Vulnerability scanning is not used to identify defects in application source code.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      171,
      172,
      169,
      183,
      165
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 87,
    "question": "The best definition of release management is:",
    "choice_a": "A quality process to ensure that end users have signed off on application changes",
    "choice_b": "A gate process to ensure that all problems have been fixed in a new application",
    "choice_c": "A management process to control the promotion of updated applications to production",
    "choice_d": "A compliance process stipulated by HIPAA",
    "correct_answer": "C",
    "explanation": "Release management is the step in the systems/software development life cycle (SDLC) to ensure that all requirements and steps before releasing software to production have been completed correctly and approved by management.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      170,
      166,
      167,
      168,
      169
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 88,
    "question": "All of the following are a part of patch management, <i>except</i>:",
    "choice_a": "Subscribe to vendor security advisories.",
    "choice_b": "Subscribe to non-vendor security advisories.",
    "choice_c": "Conduct vulnerability scans.",
    "choice_d": "Perform risk analysis to determine risk to the organization.",
    "correct_answer": "C",
    "explanation": "Vulnerability scans are not strictly necessary in patch management, as patches should be applied proactively because of vendor and non-vendor advisories.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      172,
      171,
      167,
      183,
      173
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 89,
    "question": "A typical security log entry should contain all of the following, <i>except</i>:",
    "choice_a": "Checksum",
    "choice_b": "Time and date of occurrence",
    "choice_c": "Location",
    "choice_d": "User ID",
    "correct_answer": "A",
    "explanation": "Log entries do not need a checksum. A checksum is employed in lower-protocol layers.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      174,
      164,
      228,
      221,
      203
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 90,
    "question": "For too long, employees in an organization have complained that the IT service desk takes too long to assist. What is the first thing management should put in place to remedy this?",
    "choice_a": "End user bill of rights",
    "choice_b": "Acceptable use policy (AUP)",
    "choice_c": "Service level agreement (SLA)",
    "choice_d": "Automated callback",
    "correct_answer": "C",
    "explanation": "The IT service desk needs to establish SLAs and begin measuring response time.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      176,
      161,
      175,
      164,
      162
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 91,
    "question": "An IT department is putting an SLA in place to determine the maximum time taken to install security patches. Which of the following should not be included in this effort?",
    "choice_a": "Develop separate SLAs based on exploitability.",
    "choice_b": "Develop separate SLAs based on system location.",
    "choice_c": "Develop separate SLAs based on system criticality.",
    "choice_d": "Develop separate SLAs based on compliance context.",
    "correct_answer": "B",
    "explanation": "System location is less likely to be a driver for changes in SLA terms than the other choices.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      176,
      172,
      171,
      167,
      161
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 92,
    "question": "Why should audit logs be read-only for all personnel, including system administrators?",
    "choice_a": "Necessary for referential integrity",
    "choice_b": "Supports nonrepudiation",
    "choice_c": "Improves system performance",
    "choice_d": "Prevents the concealment of disallowed actions",
    "correct_answer": "D",
    "explanation": "Audit logs are set to read-only to prevent tampering, including the concealment of prohibited actions.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      164,
      183,
      169,
      173,
      228
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 93,
    "question": "A system administrator has received a security advisory from a vendor that describes a critical vulnerability that can be escalated by a remote actor who does not require login credentials. How should the system administrator categorize this advisory for Internet-connected systems?",
    "choice_a": "High",
    "choice_b": "Critical",
    "choice_c": "Moderate",
    "choice_d": "Informational",
    "correct_answer": "A",
    "explanation": "The advisory describes a critical vulnerability a threat actor can escalate remotely without login credentials. Such a vulnerability in externally facing systems should be addressed quickly.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      172,
      183,
      164,
      161
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 94,
    "question": "What is the distinction between vulnerability management and patch management?",
    "choice_a": "Patch management is a part of vulnerability management.",
    "choice_b": "Vulnerability management is a part of patch management.",
    "choice_c": "Vulnerability management and patch management are separate, unrelated processes.",
    "choice_d": "Organizations are free to implement vulnerability management or patch management.",
    "correct_answer": "A",
    "explanation": "Patch management is considered a part of vulnerability management. Vulnerability management is also concerned with security configuration settings.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      172,
      171,
      169,
      167,
      183
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 95,
    "question": "In configuration management, what is meant by a configuration item?",
    "choice_a": "An individual system administrator",
    "choice_b": "An individual asset",
    "choice_c": "An individual configuration setting in a system or device",
    "choice_d": "A request to change a configuration setting in a system or device",
    "correct_answer": "B",
    "explanation": "In configuration management, a configuration item (CI) refers to an individual system or device.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      169,
      225,
      183,
      166,
      167
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 96,
    "question": "Which of the following is not a required item in a typical IT department change request?",
    "choice_a": "Verification procedure",
    "choice_b": "Backout procedure",
    "choice_c": "Root cause analysis",
    "choice_d": "Description of the change",
    "correct_answer": "C",
    "explanation": "Root-cause analysis is not typically a part of a change request but instead is performed after an incident or problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      167,
      168,
      173,
      166,
      165
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 97,
    "question": "Which of the following event types is not typically sent to a SIEM?",
    "choice_a": "Hard drive fault",
    "choice_b": "Successful login attempt",
    "choice_c": "Unsuccessful login attempt",
    "choice_d": "Creation of a new privileged user",
    "correct_answer": "A",
    "explanation": "Events such as hard drive faults, CPU utilization, and performance measures are generally monitored by a network monitoring system and not sent to a SIEM.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      174,
      217,
      164,
      198,
      163
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 98,
    "question": "A security analyst works in a small enterprise with a dozen on-premises servers. The analyst manually reviews security logs on the servers every few days. What, if any, improvement is needed for this activity?",
    "choice_a": "Send all security log entries to a SIEM.",
    "choice_b": "Send all security log entries to a Syslog server.",
    "choice_c": "Use a search tool to look for keywords in the security logs.",
    "choice_d": "Implement a SIEM on each of the servers.",
    "correct_answer": "A",
    "explanation": "All security event logs should be sent to a SIEM, which can correlate events and generate alerts for further investigation and action.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      164,
      217,
      175,
      183,
      171
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 99,
    "question": "An IS auditor is auditing an IT department’s operational log monitoring system. Which of the following is likely not a part of the auditor’s examination?",
    "choice_a": "Résumés of personnel who examine logs",
    "choice_b": "Request for monitoring procedures",
    "choice_c": "Request for a list of monitored systems",
    "choice_d": "Request for operational event logs",
    "correct_answer": "D",
    "explanation": "An auditor is not likely to request the event logs themselves, as they would likely be large and cumbersome to deliver to the auditor. The other options are items likely requested for this audit.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      174,
      185,
      183,
      198,
      228
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 100,
    "question": "How should an IT department manage emergency changes in its change management process?",
    "choice_a": "Wait until business hours to submit the change request and make the change.",
    "choice_b": "Obtain approval from designated management, then perform the change.",
    "choice_c": "Make the required change and submit a change request after the fact.",
    "choice_d": "Make the required change and tell the change manager about it.",
    "correct_answer": "B",
    "explanation": "Emergency changes should require management approval before the change is performed. Then, a change request should be filed, indicating that this was an emergency change already performed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      168,
      167,
      165,
      173,
      172
    ],
    "source": "288380_Ch 4"
  },
  {
    "id": 101,
    "question": "What is the portion of a computer that performs most calculations?",
    "choice_a": "CISC",
    "choice_b": "CPU",
    "choice_c": "GPU",
    "choice_d": "Math coprocessor",
    "correct_answer": "B",
    "explanation": "A computer’s CPU, or central processing unit, performs most calculations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      191,
      187,
      200,
      193,
      188
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 102,
    "question": "An IT administrator is describing a problem to a colleague and refers to main storage. What is the main storage on a computer system?",
    "choice_a": "SSD",
    "choice_b": "ROM",
    "choice_c": "RAM",
    "choice_d": "HDD",
    "correct_answer": "C",
    "explanation": "RAM, or random-access memory, is the main storage on a computer system. Secondary storage is implemented with solid-state drives (SSDs) or hard-disk drives (HDDs).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      187,
      200,
      188,
      163
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 103,
    "question": "The practice of having multiple OS instances running on a single system is known as:",
    "choice_a": "Virtualization",
    "choice_b": "Containerization",
    "choice_c": "Clustering",
    "choice_d": "Hypervisor",
    "correct_answer": "A",
    "explanation": "Virtualization permits several separate operating system instances to run on a single hardware platform.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      200,
      201,
      226,
      183
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 104,
    "question": "What are a computer’s CPU, memory, and peripherals connected to each other through?",
    "choice_a": "Kernel",
    "choice_b": "FireWire",
    "choice_c": "Pipeline",
    "choice_d": "Bus",
    "correct_answer": "D",
    "explanation": "A bus connects all the computer’s internal components together, including its CPU, main memory, secondary memory, and peripheral devices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      199,
      200,
      188,
      197
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 105,
    "question": "_____________ is the term used to describe multiple application instances running in a single operating system.",
    "choice_a": "Containerization",
    "choice_b": "Serverless",
    "choice_c": "Virtualization",
    "choice_d": "Vectoring",
    "correct_answer": "A",
    "explanation": "Containerization is the technology that permits multiple application instances to run within a single operating system.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      196,
      200,
      226,
      183,
      187
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 106,
    "question": "What are the layers of the TCP/IP reference model?",
    "choice_a": "Link, Internet, transport, application",
    "choice_b": "Physical, link, Internet, transport, application",
    "choice_c": "Link, transport, Internet, application",
    "choice_d": "Physical, data link, network, transport, session, presentation, application",
    "correct_answer": "A",
    "explanation": "The layers of the TCP/IP model are (from lowest to highest) link, Internet, transport, and application.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      209,
      208,
      215,
      216,
      213
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 107,
    "question": "What is the purpose of the Internet layer in the TCP/IP model?",
    "choice_a": "Encapsulation",
    "choice_b": "Packet delivery on a local network",
    "choice_c": "Packet delivery on a local or remote network",
    "choice_d": "Order of delivery and flow control",
    "correct_answer": "C",
    "explanation": "The purpose of the Internet layer in the TCP/IP model is the delivery of packets from one station to another, on the same network or on a different network.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      209,
      213,
      207,
      216,
      208
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 108,
    "question": "What is the purpose of the DHCP protocol?",
    "choice_a": "To control flow on a congested network",
    "choice_b": "To query a station to discover its IP address",
    "choice_c": "To assign an IP address to a station",
    "choice_d": "To assign an Ethernet MAC address to a station",
    "correct_answer": "C",
    "explanation": "The DHCP protocol is used to assign IP addresses to computers on a network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      216,
      213,
      209,
      208,
      161
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 109,
    "question": "An IS auditor is examining a Wi-Fi network and has determined that the network uses WEP encryption. What action should the auditor take?",
    "choice_a": "Recommend that encryption be changed to WPA2/WPA3.",
    "choice_b": "Recommend that encryption be changed to EAP.",
    "choice_c": "Request documentation for the key management process.",
    "choice_d": "Request documentation for the authentication process.",
    "correct_answer": "A",
    "explanation": "The WEP protocol has been seriously compromised and should be replaced with WPA2/WPA3 encryption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      212,
      228,
      229,
      217,
      224
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 110,
    "question": "What is 126.0.0.1 an example of?",
    "choice_a": "MAC address",
    "choice_b": "Loopback address",
    "choice_c": "Class A address",
    "choice_d": "Subnet mask",
    "correct_answer": "C",
    "explanation": "Class A addresses are in the range 0.0.0.0 to 127.255.255.255. The address 126.0.0.1 falls into this range.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      216,
      209,
      208,
      198,
      183
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 111,
    "question": "Hardware monitoring measures all of the following <i>except</i>:",
    "choice_a": "Disk errors",
    "choice_b": "Ambient temperature",
    "choice_c": "Resource utilization",
    "choice_d": "System health",
    "correct_answer": "B",
    "explanation": "Hardware monitoring is used to measure numerous aspects of a running system, but ambient temperature is not measured. Internal temperature is measured and is an indicator of workload and cooling.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      198,
      164,
      183,
      225,
      217
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 112,
    "question": "An organization has implemented an application architecture consisting of multiple identical servers that service incoming transactions. What server architecture is in use?",
    "choice_a": "Enclave",
    "choice_b": "Processing group",
    "choice_c": "Hypervisor",
    "choice_d": "Cluster",
    "correct_answer": "D",
    "explanation": "A cluster is a set of servers, which often appear as a single logical server to perform transactions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      201,
      238,
      162,
      206
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 113,
    "question": "What technology would be used to store a large number of unstructured data files?",
    "choice_a": "Database management system",
    "choice_b": "Filesystem",
    "choice_c": "Server cluster",
    "choice_d": "Hypervisor",
    "correct_answer": "B",
    "explanation": "A filesystem would be used to store unstructured data files. A database management system is typically used to store structured data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      202,
      177,
      179,
      180,
      226
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 114,
    "question": "An organization needs to implement a mechanism to enforce data retention policy within documents, no matter where they reside. What technology should be used?",
    "choice_a": "Digital rights management",
    "choice_b": "Server clustering",
    "choice_c": "Data clustering",
    "choice_d": "Tokenization",
    "correct_answer": "A",
    "explanation": "Digital rights management (DRM) is the technology of choice for managing retention policy for documents when they reside outside of an organization’s direct control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      205,
      180,
      182,
      186,
      183
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 115,
    "question": "Which of the following statements about virtual server hardening is true?",
    "choice_a": "The configuration of the host operating system will automatically flow to each guest operating system.",
    "choice_b": "Each guest virtual machine needs to be hardened separately.",
    "choice_c": "Guest operating systems do not need to be hardened because they are protected by the hypervisor.",
    "choice_d": "Virtual servers do not need to be hardened because they do not run directly on computer hardware.",
    "correct_answer": "B",
    "explanation": "In a virtualization environment, each guest operating system needs to be hardened; they are no different from operating systems running directly on server (or workstation) hardware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      226,
      200,
      183,
      187
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 116,
    "question": "What is the distinction between a network’s physical structure and its logical structure?",
    "choice_a": "Physical structure refers to cabling, whereas logical structure refers to data flow.",
    "choice_b": "Logical structure refers to cabling, whereas physical structure refers to data flow.",
    "choice_c": "Physical structure refers to frames, whereas logical structure refers to packets.",
    "choice_d": "Logical and physical structure are the same.",
    "correct_answer": "A",
    "explanation": "Physical network structure refers to cabling and other hardware. Logical network structure refers to the inner workings of a network, in terms of protocols and data flow. For instance, an Ethernet network can be a physical star but operate like a logical bus.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      210,
      228,
      209,
      215
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 117,
    "question": "What are email, directory, file storage, and time synchronization examples of?",
    "choice_a": "Data labels",
    "choice_b": "Applications",
    "choice_c": "Utilities",
    "choice_d": "Network services",
    "correct_answer": "D",
    "explanation": "Email, directory, file storage, and time synchronization are examples of network services, available to users via a network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      215,
      217,
      207,
      228
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 118,
    "question": "Which of the following is <i>not</i> a layer of the TCP/IP model?",
    "choice_a": "Data link",
    "choice_b": "Physical",
    "choice_c": "Presentation",
    "choice_d": "Application",
    "correct_answer": "C",
    "explanation": "Presentation is not a layer of the TCP/IP model. The four layers of the TCP/IP model are Link, Internet, Transport, and Application.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      215,
      213,
      207
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 119,
    "question": "What is the most common cabling type in modern LANs?",
    "choice_a": "Thinnet",
    "choice_b": "Twisted-pair",
    "choice_c": "Fiber",
    "choice_d": "Coax",
    "correct_answer": "B",
    "explanation": "Twisted pair cabling, such as Cat-5 and Cat-6, are the most common types of network cabling used in modern LANs.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      210,
      207,
      228,
      211,
      208
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 120,
    "question": "Asset inventory is critical for all of the following activities <i>except</i>:",
    "choice_a": "Static code analysis",
    "choice_b": "Vulnerability scanning",
    "choice_c": "License management",
    "choice_d": "Server hardening",
    "correct_answer": "A",
    "explanation": "Asset inventory is critical for many processes, including vulnerability management, license management, server hardening, data classification, system classification, and incident response. Asset inventory is not relevant to static code analysis.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      171,
      172,
      169,
      165,
      226
    ],
    "source": "288380_Ch 5"
  },
  {
    "id": 121,
    "question": "Which of the following is the best choice for backing up a department file server?",
    "choice_a": "Replication",
    "choice_b": "VTL",
    "choice_c": "Mirroring",
    "choice_d": "RAID",
    "correct_answer": "B",
    "explanation": "The best choice in this instance is to back up to a virtual tape library (VTL). Replication and mirroring are not suitable, as a ransomware attack may be able to encrypt file server data, and that encryption would be replicated or mirrored to alternate storage systems. RAID is not a backup solution but a storage resilience solution.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      183,
      247,
      250
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 122,
    "question": "The discipline that is related to the resilience of business processes is known as:",
    "choice_a": "Redundancy",
    "choice_b": "Disaster recovery planning",
    "choice_c": "Business continuity planning",
    "choice_d": "Contingency planning",
    "correct_answer": "C",
    "explanation": "Business continuity planning is concerned with the resilience of business processes.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      231,
      235,
      233,
      240,
      236
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 123,
    "question": "What is the proper sequence of the following activities?",
    "choice_a": "BIA, CA, BCP, DRP",
    "choice_b": "CA, BIA, BCP, DRP",
    "choice_c": "BIA, CA, DRP, BCP",
    "choice_d": "BCP, DRP, CIA, CA",
    "correct_answer": "A",
    "explanation": "The correct sequence of activities in business resilience is business impact analysis (BIA), criticality analysis (CA), business continuity planning (BCP), then disaster recovery planning (DRP).",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      233,
      234,
      235,
      240,
      231
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 124,
    "question": "Which of the following statements is correct regarding disaster response?",
    "choice_a": "Organizations utilize industry sector disaster response templates for all disaster types.",
    "choice_b": "Organizations develop disaster response plans when a disaster is declared.",
    "choice_c": "Organizations use different procedures for responding to natural disasters versus human-caused disasters.",
    "choice_d": "Organizations use the same procedures for responding to disasters of all types.",
    "correct_answer": "D",
    "explanation": "Organizations would use the same high-level disaster response procedures regardless of the nature of the disaster.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      235,
      232,
      241,
      236
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 125,
    "question": "Which of the following is the correct sequence of DRP tests in order of difficulty and impact?",
    "choice_a": "Walk-through, simulation, parallel test, cutover test",
    "choice_b": "Parallel test, cutover test, simulation",
    "choice_c": "Cutover test, simulation, walk-through, parallel test",
    "choice_d": "On-site test, remote test, cloud test",
    "correct_answer": "A",
    "explanation": "The progression of the types of DRP tests, in order of difficulty and impact, is walk-through (a meeting where the sequence of steps is discussed), simulation (like a walk-through but with a realistic scenario gradually revealed), parallel test (where recovery systems run in parallel with production systems), and cutover test (where recovery systems take over production work from production systems).",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      236,
      249,
      245,
      246,
      247
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 126,
    "question": "A disaster recovery manager is performing an after-action review of a recent BC plan walk-through. One of the participants suggested that future walk-throughs be made more realistic. What kind of a test can be performed in the future to meet this need?",
    "choice_a": "Simulation",
    "choice_b": "Parallel test",
    "choice_c": "Cutover test",
    "choice_d": "Document review",
    "correct_answer": "A",
    "explanation": "A simulation is like a walk-through, where a facilitator develops and provides periodic updates in a realistic scenario.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      235,
      234
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 127,
    "question": "What is the purpose of a criticality assessment in a business resilience program?",
    "choice_a": "Separate critical business processes from noncritical business processes.",
    "choice_b": "Determine the relative criticality of disaster response personnel.",
    "choice_c": "Determine the relative criticality of in-scope business processes.",
    "choice_d": "Determine the relative criticality of service providers.",
    "correct_answer": "C",
    "explanation": "A criticality assessment, performed at the conclusion of a business impact analysis, determines the probability and impact of the incapacitation of business processes and information systems. This leads to a list of processes and systems in order of criticality.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      234,
      233,
      235,
      231,
      236
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 128,
    "question": "What is the result of a system whose RPO is 24 hours and RTO is 1 hour?",
    "choice_a": "In a disaster, the system will be recovered within 24 hours, with as much as 25 hours of lost data.",
    "choice_b": "In a disaster, the system will be recovered within 24 hours, with a potential for as much as 1 hour of lost data.",
    "choice_c": "In a disaster, the system will be recovered within 1 hour, with the potential for as much as 24 hours of lost data.",
    "choice_d": "In a disaster, the recovery team has 1 hour to begin recovery work, which will take no more than 24 hours.",
    "correct_answer": "C",
    "explanation": "RPO, or recovery point objective, is a measure of the maximum acceptable data loss. RTO, or recovery time objective, is a measure of the maximum time that a system or process will not be functioning.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      234,
      233,
      237,
      235,
      236
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 129,
    "question": "An IS auditor is examining a business continuity plan (BCP) and has observed that the BCP was last reviewed 2 years earlier. What can the auditors conclude from this?",
    "choice_a": "The plan may be outdated since it has not been reviewed within the past year.",
    "choice_b": "The plan is outdated since it has not been reviewed within the past year.",
    "choice_c": "Nothing can be concluded, based on the information provided.",
    "choice_d": "This is a low-criticality business process.",
    "correct_answer": "A",
    "explanation": "Auditors generally consider documentation as outdated and invalid if it has not been formally reviewed within the past year.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      252,
      244,
      236,
      245,
      246
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 130,
    "question": "An organization has designed a DR site for a critical business application. From the information given, what type of a recovery site is this?",
    "choice_a": "Offline",
    "choice_b": "Hot",
    "choice_c": "Cold",
    "choice_d": "Warm",
    "correct_answer": "C",
    "explanation": "Since the question describes only the design of a site, we can only conclude that this is a cold site, with no equipment and no readiness for processing transactions.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      237,
      251,
      248,
      246,
      235
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 131,
    "question": "What is the most important consideration when selecting a hot site?",
    "choice_a": "Time zone",
    "choice_b": "Geographic location in relation to the primary site",
    "choice_c": "Proximity to major transportation",
    "choice_d": "Natural hazards",
    "correct_answer": "B",
    "explanation": "An important selection criterion for a hot site is the geographic location in relation to the primary site. If they are too close together, then a single disaster event may involve both locations.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      237,
      251,
      246,
      247,
      248
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 132,
    "question": "An organization has established a recovery point objective of 14 days for its most critical business applications. Which recovery strategy would be the best choice?",
    "choice_a": "Mobile site",
    "choice_b": "Warm site",
    "choice_c": "Hot site",
    "choice_d": "Cold site",
    "correct_answer": "D",
    "explanation": "An organization that has a 14-day recovery time objective (RTO) can use a cold site for its recovery strategy. Fourteen days is enough time for most organizations to acquire hardware and recover applications.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      237,
      234,
      248,
      251,
      246
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 133,
    "question": "What technology should an organization use for its application servers to provide continuous service to users?",
    "choice_a": "Dual power supplies",
    "choice_b": "Server clustering",
    "choice_c": "Dual network feeds",
    "choice_d": "Transaction monitoring",
    "correct_answer": "B",
    "explanation": "An organization that wants its application servers to be continuously available to its users needs to employ server clustering. This enables at least one server to be always available to service user requests.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      201,
      195,
      189,
      176,
      244
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 134,
    "question": "An organization currently stores its backup media in a cabinet next to the computers being backed up. A consultant told the organization to store backup media at an off-site storage facility. What risk did the consultant most likely have in mind when they made this recommendation?",
    "choice_a": "A disaster that damages computer systems can also damage backup media.",
    "choice_b": "Backup media rotation may result in loss of data backed up several weeks in the past.",
    "choice_c": "Corruption of online data will require rapid data recovery from off-site storage.",
    "choice_d": "Physical controls at the data processing site are insufficient.",
    "correct_answer": "A",
    "explanation": "The primary reason for employing off-site backup media storage is to mitigate the effects of a disaster that could otherwise destroy computer systems and their backup media.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      247,
      240,
      246,
      250
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 135,
    "question": "An IT department has designed and implemented a hot recovery site with all of the features and half of the transaction throughput of the primary site. What is the value of RCO and RCapO targets in this case?",
    "choice_a": "RCO is 50% and RCapO is 100%.",
    "choice_b": "RCO is 100% and RCapO is 50%.",
    "choice_c": "RCO and RCapO are 50%.",
    "choice_d": "RCO is 100% and RCapO is 150%.",
    "correct_answer": "B",
    "explanation": "RCO, or recovery consistency objective, generally addresses features and functionality. In this scenario, RCO is 100%. RCapO, or recovery capacity objective, measures the capacity of the recovery site as compared to the primary site. In this scenario, RCapO is 50%.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      234,
      237,
      251,
      246,
      236
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 136,
    "question": "Who are the best persons to develop a DRP for a critical business application?",
    "choice_a": "The most senior IT experts on the business application",
    "choice_b": "The most senior users of the business application",
    "choice_c": "The most senior experts on the type of business application",
    "choice_d": "Consultants",
    "correct_answer": "A",
    "explanation": "The best people to write a DRP for a critical business application are the IT personnel who are most senior and have the most knowledge of the system.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      240,
      235,
      246,
      245,
      252
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 137,
    "question": "A regional disaster has occurred, and the BC and DR plans have just been activated. One of the first responders has arrived at the data center to assess damage. At the data center, they have observed that the most recent backup media is in the data center, as well as hard-copy response procedures, and that one worker has been injured by a falling object. Which of the following should the responders do first?",
    "choice_a": "Assess damage to the most critical systems.",
    "choice_b": "Remove the disaster response procedures before they are damaged.",
    "choice_c": "Remove the backup media before it is damaged.",
    "choice_d": "Tend to the injured worker.",
    "correct_answer": "D",
    "explanation": "The safety of personnel always takes priority over all other considerations. In this scenario, the first responders on site should tend to injured personnel before performing other tasks.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      235,
      240,
      244,
      245,
      252
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 138,
    "question": "An organization’s business continuity plan requires the consensus of any three of the organization’s top executives to declare a disaster. What risk is associated with this stipulation in a regional disaster scenario?",
    "choice_a": "Regulators should be included in disaster declarations.",
    "choice_b": "Top executives are the wrong personnel to declare a disaster.",
    "choice_c": "Lacking hands-on knowledge, top executives are not going to be able to recover critical systems.",
    "choice_d": "It may be difficult to find three of the organization’s top executives, leading to a delay in disaster declaration.",
    "correct_answer": "D",
    "explanation": "In a regional disaster scenario, telecommunications facilities are generally compromised and/or congested. Hence, it may be difficult to find three top executives who are reachable and can agree to activate disaster response proceedings.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      241,
      232,
      240,
      248
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 139,
    "question": "What is the consequence of an organization that declared a disaster they later learned did not exist?",
    "choice_a": "No consequence, since there was no disaster",
    "choice_b": "High consequence in the form of sanctions or fines from regulators",
    "choice_c": "Little consequence, other than the marshaling of resources in preparation for disaster response",
    "choice_d": "High consequence, resulting in a considerable waste of time",
    "correct_answer": "C",
    "explanation": "The consequences of a “false positive,” that of declaring a disaster and activating disaster response, are minimal. Disaster responders can resume their normal duties.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      240,
      241,
      244,
      245
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 140,
    "question": "A nationwide organization with numerous offices and processing centers employs local resources in each region for disaster response. A consultant has suggested that personnel in other regions should also be trained in response procedures. Why would a consultant make this recommendation?",
    "choice_a": "Local personnel in the affected region may not be available for disaster response.",
    "choice_b": "Personnel in other regions should be given a chance to help.",
    "choice_c": "To improve the quality of the disaster response procedures.",
    "choice_d": "To perform disaster response exercises more frequently.",
    "correct_answer": "A",
    "explanation": "In a regional disaster scenario, local disaster response personnel may be unavailable to perform disaster response procedures; they may be tending to family members and securing their residences if they are damaged.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      240,
      252,
      235,
      244,
      241
    ],
    "source": "288380_Ch 6"
  },
  {
    "id": 141,
    "question": "In what cloud security model does the cloud service provider bear the most responsibility for implementing security controls?",
    "choice_a": "IaaS",
    "choice_b": "FaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "The cloud service provider bears the most responsibility for implementing security controls in an SaaS environment and the least responsibility in an IaaS environment. This is due to the division of responsibilities under the cloud computing shared responsibility model.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      278,
      279,
      281,
      280,
      256
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 142,
    "question": "Helen would like to configure her organization’s switches so that they do not allow systems connected to a switch to spoof MAC addresses. Which one of the following features would be helpful in this configuration?",
    "choice_a": "Loop protection",
    "choice_b": "Port security",
    "choice_c": "Flood guard",
    "choice_d": "Traffic encryption",
    "correct_answer": "B",
    "explanation": "Port security restricts the number of unique MAC addresses that may originate from a single switch port. It is commonly used to prevent someone from unplugging an authorized device from the network and connecting an unauthorized device but may also be used to prevent existing devices from spoofing MAC addresses of other devices.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      272,
      271,
      306,
      268,
      264
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 143,
    "question": "Patricia is using a computer at a hotel business center and she is concerned that the operating system on the device may be compromised. What is the best way for her to use this computer in a secure fashion?",
    "choice_a": "Use live boot media.",
    "choice_b": "Connect to a VPN.",
    "choice_c": "Run a malware scan.",
    "choice_d": "Only access secure websites.",
    "correct_answer": "A",
    "explanation": "If Patricia’s major concern is a compromised operating system, she can bypass the operating system on the device by booting it from live boot media and running her own operating system on the hardware. Running a malware scan may provide her with some information but may not detect all compromises and Patricia likely does not have the necessary permissions to correct any issues. Using a VPN or accessing secure sites would not protect her against a compromised operating system, as the operating system would be able to view the contents of her communication prior to encryption.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      269,
      268,
      319,
      313,
      301
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 144,
    "question": "Karim is investigating an alert generated by his organization’s NIDS. The system alerted to a distributed denial-of-service attack and Karim’s investigation revealed that this type of attack did take place. What type of report has the system generated?",
    "choice_a": "False positive",
    "choice_b": "True negative",
    "choice_c": "True positive",
    "choice_d": "False negative",
    "correct_answer": "C",
    "explanation": "In a true positive report, the system reports an attack when an attack actually exists. A false positive report occurs when the system reports an attack that did not take place. A true negative report occurs when the system reports no attack and no attack took place. A false negative report occurs when the system does not report an attack that did take place.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      300,
      308,
      264,
      316
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 145,
    "question": "What type of security solution provides a hardware platform for the storage and management of encryption keys?",
    "choice_a": "HSM",
    "choice_b": "IPS",
    "choice_c": "SIEM",
    "choice_d": "SOAR",
    "correct_answer": "A",
    "explanation": "Hardware security modules (HSMs) provide an effective way to manage encryption keys. These hardware devices store and manage encryption keys in a secure manner that prevents humans from ever needing to work directly with the keys.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      281,
      287,
      286,
      285,
      283
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 146,
    "question": "Ryan is investigating a security incident. He believes that the incident is originating from a single system on the Internet and targeting multiple systems on his network. What control could he put in place to stop the incident as quickly as possible?",
    "choice_a": "DDoS mitigation",
    "choice_b": "Host firewall rule",
    "choice_c": "Operating system update",
    "choice_d": "Network firewall rule",
    "correct_answer": "D",
    "explanation": "The attack in question could be most quickly stopped with a network firewall rule blocking all traffic from the origin system. Host firewall rules would also address the issue but would be more time-consuming to create on every system. An operating system update would not stop attack traffic. There is also no indication that a DDoS attack is underway, so a DDoS mitigation service would not be helpful.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      306,
      270,
      300,
      264,
      268
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 147,
    "question": "Howard is assessing the legal risks to his organization based on its handling of PII. The organization is based in the United States, handles the data of customers located in Europe, and stores information in Japanese data centers. What law would be most important to Howard during his assessment?",
    "choice_a": "Japanese law",
    "choice_b": "European Union law",
    "choice_c": "U.S. law",
    "choice_d": "All should have equal weight.",
    "correct_answer": "D",
    "explanation": "The principle of data sovereignty states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed. In this case, Howard needs to assess the laws of all three jurisdictions.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      280,
      294,
      296,
      297,
      323
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 148,
    "question": "David would like to send Mike a message using an asymmetric encryption algorithm to provide confidentiality. What key should he use to encrypt the message?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "C",
    "explanation": "When encrypting a confidential message using an asymmetric encryption algorithm, the person performing the encryption does so using the recipient’s public key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      284,
      282,
      289,
      283,
      287
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 149,
    "question": "When Mike receives the message that David encrypted for him in Question 8, what key should he use to decrypt the message?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "D",
    "explanation": "In an asymmetric encryption algorithm, the recipient of a confidential message uses their own private key to decrypt messages that they receive.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      284,
      289,
      282,
      286,
      283
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 150,
    "question": "If David wishes to digitally sign the message that he is sending Mike, what key would he use to create the digital signature?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "B",
    "explanation": "The sender of a message may digitally sign the message by encrypting a message digest with the sender’s own private key.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      286,
      284,
      285,
      282,
      283
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 151,
    "question": "When Mike receives the digitally signed message from David, what key should he use to verify the digital signature?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "A",
    "explanation": "The recipient of a digitally signed message may verify the digital signature by decrypting it with the public key of the individual who signed the message.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      284,
      282,
      285,
      287
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 152,
    "question": "An auditor is examining an organization’s data loss prevention (DLP) system. The DLP system is recording instances of sensitive information that is leaving the organization. There are no records of actions taken. What should the IS auditor recommend?",
    "choice_a": "That management appoint a party responsible for taking action when the DLP system detects that sensitive information is leaving the organization",
    "choice_b": "That management develop procedures for responding to DLP system alerts",
    "choice_c": "That management discontinue use of the DLP system since no one is taking action",
    "choice_d": "That the DLP system be reconfigured to stop issuing alerts",
    "correct_answer": "A",
    "explanation": "An organization using a DLP system should be acting on alerts that the DLP system generates in order to curb employee and system behavior.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      266,
      306,
      303,
      346,
      256
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 153,
    "question": "An IS auditor has discovered that an employee has installed a Wi-Fi access point in their cube. What action should the IS auditor take?",
    "choice_a": "The IS auditor should include this in their audit report.",
    "choice_b": "The IS auditor should immediately report this as a high-risk situation.",
    "choice_c": "The IS auditor should ask the employee to turn off the Wi-Fi access point when it is not being used.",
    "choice_d": "The IS auditor should test the Wi-Fi access point to see whether it properly authenticates users.",
    "correct_answer": "B",
    "explanation": "Finding an unauthorized access point is a high-risk situation that the IS auditor should report immediately to management.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      320,
      340,
      303
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 154,
    "question": "Matt is updating the organization’s threat assessment process. What category of control is Matt implementing?",
    "choice_a": "Operational",
    "choice_b": "Technical",
    "choice_c": "Corrective",
    "choice_d": "Managerial",
    "correct_answer": "D",
    "explanation": "Managerial controls are procedural mechanisms that focus on the mechanics of the risk management process. Threat assessment is an example of one of these activities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      263,
      260,
      264,
      259,
      326
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 155,
    "question": "Jade’s organization recently suffered a security breach that affected stored credit card data. Jade’s primary concern is the fact that the organization is subject to sanctions for violating the provisions of the Payment Card Industry Data Security Standard. What category of risk is concerning Jade?",
    "choice_a": "Strategic",
    "choice_b": "Compliance",
    "choice_c": "Operational",
    "choice_d": "Financial",
    "correct_answer": "B",
    "explanation": "Jade is concerned about compliance risk because the issue involves violating the Payment Card Industry Data Security Standard (PCI DSS), which regulates the protection of credit card data. Compliance risk arises when an organization fails to follow laws, regulations, or standards that apply to its operations. Strategic risk involves decisions that affect the long-term goals or competitive position of the organization, which isn't the case here. Operational risk deals with internal processes, systems, or human errors, while financial risk involves the potential for financial loss, but neither of these risks directly relates to regulatory violations like PCI DSS.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      259,
      294,
      297,
      296,
      300
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 156,
    "question": "Chris is responding to a security incident that compromised one of his organization’s web servers. He believes that the attackers defaced one or more pages on the website. What cybersecurity objective did this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "The attack violated integrity because defacing a website alters its content, which means unauthorized changes were made to the website's data. Integrity ensures that information remains accurate and unaltered by unauthorized parties. Confidentiality refers to protecting sensitive information from unauthorized access, which isn’t relevant in this scenario since the attackers modified visible content. Nonrepudiation ensures that actions or communications cannot be denied by the involved parties, but that doesn’t relate to altering website content. Availability ensures systems are accessible when needed, which isn’t affected by mere defacement unless the site becomes inaccessible.QuestionID:.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      253,
      257,
      282,
      285,
      300
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 157,
    "question": "Tonya is concerned about the risk that an attacker will attempt to gain access to her organization’s database server. She is searching for a control that would discourage the attacker from attempting to gain access. What type of security control is she seeking to implement?",
    "choice_a": "Preventive",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Deterrent",
    "correct_answer": "D",
    "explanation": "Deterrent controls are designed to prevent an attacker from attempting to violate security policies in the first place. Preventive controls would attempt to block an attack that was about to take place. Corrective controls would remediate the issues that arose during an attack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      264,
      263,
      268,
      322,
      337
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 158,
    "question": "Which one of the following individuals bears ultimate responsibility for protecting an organization’s data?",
    "choice_a": "Data steward",
    "choice_b": "End users",
    "choice_c": "Data custodian",
    "choice_d": "Data owner",
    "correct_answer": "D",
    "explanation": "All individuals within an organization have some responsibility for protecting data. However, the data owner is the senior-most leader who bears ultimate responsibility for this protection. The data owner may delegate some authority and/or responsibility to data stewards, data custodians, and end users, but they still bear ultimate responsibility.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      262,
      303,
      295,
      294,
      296
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 159,
    "question": "Tony is reviewing the status of his organization’s defenses against a breach of their file server. He believes that a compromise of the file server could reveal information that would prevent the company from continuing to do business. What term <i>best</i> describes the risk that Tony is considering?",
    "choice_a": "Strategic",
    "choice_b": "Reputational",
    "choice_c": "Financial",
    "choice_d": "Operational",
    "correct_answer": "A",
    "explanation": "The risk that Tony is contemplating could fit any one of these categories. However, his primary concern is that the company may no longer be able to do business if the risk materializes. This is a strategic risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      259,
      253,
      257,
      294,
      254
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 160,
    "question": "Which one of the following statements about cloud computing is incorrect?",
    "choice_a": "Cloud computing offers ubiquitous, convenient access.",
    "choice_b": "Cloud computing customers store data on hardware that is shared with other customers.",
    "choice_c": "Cloud computing customers provision resources through the service provider’s sales team.",
    "choice_d": "Cloud computing resources are accessed over a network.",
    "correct_answer": "C",
    "explanation": "One of the important characteristics of cloud computing is that customers can access resources on-demand with minimal service provider interaction. Cloud customers do not need to contact a sales representative each time they wish to provision a resource but can normally do so on a self-service basis.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      277,
      279,
      278,
      281
    ],
    "source": "288380_Ch 7"
  },
  {
    "id": 161,
    "question": "A fire sprinkler system has water in its pipes, and sprinkler heads emit water only if the ambient temperature reaches 220°F. What type of system is this?",
    "choice_a": "Deluge",
    "choice_b": "Post-action",
    "choice_c": "Wet pipe",
    "choice_d": "Pre-action",
    "correct_answer": "C",
    "explanation": "This is a wet pipe system because it involves water being constantly present in the pipes, and the sprinkler heads activate when the ambient temperature reaches a certain point, releasing the water. A deluge system, on the other hand, has open sprinkler heads and releases water through all heads simultaneously when a valve is opened, not requiring high ambient temperature. A post-action system doesn't exist, making it an incorrect option. A pre-action system requires an additional triggering mechanism before water fills the pipes, unlike the wet pipe system where water is already present.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      332,
      349,
      330,
      333,
      334
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 162,
    "question": "An organization is building a data center in an area that experiences frequent power outages. The organization cannot tolerate power outages. What power system controls should be selected?",
    "choice_a": "Uninterruptible power supply and electric generator",
    "choice_b": "Uninterruptible power supply and batteries",
    "choice_c": "Electric generator",
    "choice_d": "Electric generator and line conditioning",
    "correct_answer": "A",
    "explanation": "The combination of an uninterruptible power supply (UPS) and an electric generator should be selected because the UPS provides immediate power to prevent any disruption during the transition, and the generator ensures long-term power availability during extended outages. A UPS with batteries would provide only short-term power and isn't sufficient for prolonged outages. An electric generator alone wouldn't prevent brief outages or surges before it starts. Electric generator and line conditioning would improve power quality but wouldn’t ensure continuous power during outages.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      328,
      327,
      349,
      264,
      253
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 163,
    "question": "An auditor has discovered several errors in user account management: many terminated employees’ computer accounts are still active. What is the best course of action?",
    "choice_a": "Improve the employee termination process.",
    "choice_b": "Shift responsibility for employee terminations to another group.",
    "choice_c": "Audit the process more frequently.",
    "choice_d": "Improve the employee termination process and audit the process more frequently.",
    "correct_answer": "D",
    "explanation": "The best course of action is to improve the employee termination process and audit the process more frequently. Improving the process ensures that terminated employees' accounts are promptly and correctly deactivated, addressing the root cause of the issue. Regular audits then ensure that the improvements are effective and that any future lapses are quickly identified. Simply shifting responsibility might not solve the underlying problem, and auditing more frequently without improving the process won't prevent the errors from occurring in the first place.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      345,
      341,
      343,
      264,
      317
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 164,
    "question": "An auditor has discovered that several administrators in an application share an administrative account. What course of action should the auditor recommend?",
    "choice_a": "Implement activity logging on the administrative account.",
    "choice_b": "Use several named administrative accounts that are not shared.",
    "choice_c": "Implement a host-based intrusion detection system.",
    "choice_d": "Require each administrator to sign nondisclosure and acceptable-use agreements.",
    "correct_answer": "B",
    "explanation": "Using several named administrative accounts that are not shared should be recommended because it ensures accountability by associating actions with specific individuals. This prevents confusion over who performed certain actions and strengthens security. Implementing activity logging on a shared account could track actions but wouldn't solve the issue of identifying which administrator was responsible. A host-based intrusion detection system monitors for malicious activities but doesn't address the problem of shared accounts. Requiring nondisclosure and acceptable-use agreements focuses on behavior rather than resolving the issue of shared account use.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      340,
      318,
      256,
      264
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 165,
    "question": "Tom is building a multifactor authentication system that requires users to enter a passcode and then verifies that their face matches a photo stored in the system. What two factors is this system using?",
    "choice_a": "Something you know and something you have",
    "choice_b": "Something you have and somewhere you are",
    "choice_c": "Something you have and something you are",
    "choice_d": "Something you know and something you are",
    "correct_answer": "D",
    "explanation": "Facial recognition technology is an example of a biometric authentication technique, or “something you are.” A passcode is an example of a knowledge-based authentication technique, or “something you know.”.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      316,
      343,
      319
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 166,
    "question": "Frank is evaluating the effectiveness of a biometric system. Which one of the following metrics would provide him with the best measure of the system’s effectiveness?",
    "choice_a": "IRR",
    "choice_b": "CER",
    "choice_c": "FAR",
    "choice_d": "FRR",
    "correct_answer": "B",
    "explanation": "The false rejection rate (FRR) identifies the number of times that an individual who should be allowed access to a facility is rejected. The false acceptance rate (FAR) identifies the number of times that an individual who should not be allowed access to a facility is admitted. Both the FAR and FRR may be manipulated by changing system settings. The crossover error rate (CER) is the rate at which the FRR and FAR are equal and is less prone to manipulation. Therefore, the CER is the best measure for Fred to use. IRR is not a measure of biometric system effectiveness.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      315,
      314,
      264,
      253
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 167,
    "question": "Gary is logging in to a system and, after entering his username and password, is providing his fingerprint to gain access. What step of the identity and access management process is he performing?",
    "choice_a": "Identification",
    "choice_b": "Authorization",
    "choice_c": "Authentication",
    "choice_d": "Accounting",
    "correct_answer": "C",
    "explanation": "Gary is performing authentication, as he is verifying his identity by providing his fingerprint after entering his username and password. Identification occurs when he provides his username, establishing who he is. Authorization would happen after authentication, where the system determines what actions or resources Gary is allowed to access. Accounting involves tracking and logging Gary's activities within the system after he has gained access.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      343,
      344,
      317,
      319
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 168,
    "question": "John is designing a system that will allow users from Acme Corporation, one of his organization’s vendors, to access John’s accounts payable system using the accounts provided by Acme Corporation. What type of authentication system is John attempting to design?",
    "choice_a": "Single sign-on",
    "choice_b": "Federated authentication",
    "choice_c": "Transitive trust",
    "choice_d": "Multifactor authentication",
    "correct_answer": "B",
    "explanation": "This type of authentication, where one domain trusts users from another domain, is called Federated authentication. Federation authentication may involve transitive trusts, where the trusts may be followed through a series of domains, but this scenario only describes the use of two domains. The scenario only describes use of credentials for a single system and does not describe a multiple-system scenario where single sign-on would be relevant. There is no requirement described for the use of multifactor authentication, which would require the use of two or more diverse authentication techniques.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      314,
      323,
      324,
      309
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 169,
    "question": "An auditor has reviewed the access privileges of some employees and has discovered that employees with longer terms of service have excessive privileges. What can the auditor conclude from this?",
    "choice_a": "Employee privileges are not being removed when they transfer from one position to another.",
    "choice_b": "Long-time employees are able to guess other users’ passwords successfully and add to their privileges.",
    "choice_c": "Long-time employees’ passwords should be set to expire more frequently.",
    "choice_d": "The organization’s termination process is ineffective.",
    "correct_answer": "A",
    "explanation": "The auditor can conclude that employee privileges are not being removed when they transfer from one position to another. This situation often occurs when employees change roles within the organization and retain unnecessary privileges from their previous positions, leading to an accumulation of excessive privileges over time. The idea that long-time employees are guessing passwords is less likely and not directly related to the accumulation of privileges. Frequent password expiration would not address the root cause of privilege creep, and ineffective termination processes would result in former employees retaining access, not current ones with excessive privileges.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      341,
      345,
      340,
      344,
      264
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 170,
    "question": "An organization needs to ensure the confidentiality and integrity of data being sent over the network. Which of the following methods would best achieve this?",
    "choice_a": "Using strong passwords",
    "choice_b": "Implementing encryption protocols",
    "choice_c": "Regularly updating network hardware",
    "choice_d": "Conducting frequent audits",
    "correct_answer": "B",
    "explanation": "Implementing encryption protocols ensures the confidentiality and integrity of data sent over the network by encrypting the data, making it unreadable to unauthorized users, and using cryptographic methods to verify that the data has not been altered during transmission.<br>Using strong passwords enhances security for accessing systems but does not protect the data during transmission across the network.<br>Regularly updating network hardware may improve overall network performance and security but does not specifically protect the data's confidentiality and integrity while it is being transmitted.<br>Conducting frequent audits helps identify security weaknesses and ensure policies are followed, but it does not directly secure the data being transmitted over the network in real-time.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      282,
      285,
      286,
      253,
      319
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 171,
    "question": "What is the primary purpose of conducting regular user account reviews?",
    "choice_a": "To ensure compliance with company policies",
    "choice_b": "To provide user training on new software",
    "choice_c": "To identify and revoke unnecessary permissions",
    "choice_d": "To prepare for external audits",
    "correct_answer": "C",
    "explanation": "Conducting regular user account reviews primarily serves to identify and revoke unnecessary permissions, ensuring that users have only the access they need and reducing the risk of unauthorized access to sensitive information.<br>Ensuring compliance with company policies is a secondary benefit of account reviews but not the primary purpose.<br>Providing user training on new software is unrelated to the objective of reviewing user accounts and their permissions.<br>Preparing for external audits might be a reason for conducting reviews, but it is not the primary goal, which is focused on maintaining appropriate access levels for users.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      318,
      343,
      345,
      344,
      262
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 172,
    "question": "What is the most significant potential risk of not performing a thorough risk assessment before granting third-party access?",
    "choice_a": "Increased operational costs",
    "choice_b": "Reduced employee productivity",
    "choice_c": "Unauthorized data access and potential data breaches",
    "choice_d": "Overuse of system resources",
    "correct_answer": "C",
    "explanation": "Unauthorized data access and potential data breaches are the most significant risks of not performing a thorough risk assessment before granting third-party access, as this could lead to sensitive information being exposed to unauthorized parties.<br>Increased operational costs are a potential concern but are less significant compared to the risk of data breaches.<br>Reduced employee productivity is not directly related to third-party access risk assessment and is less critical than data security issues.<br>Overuse of system resources might be an operational concern, but it does not pose as significant a threat as unauthorized data access and breaches.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      323,
      325,
      294,
      259,
      266
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 173,
    "question": "An organization’s remote access requires a user ID and one-time password token. What weakness does this scheme have?",
    "choice_a": "Someone who finds a one-time password token could log in as the user by guessing the password.",
    "choice_b": "Someone who finds a one-time password token could log in as the user by guessing the user ID.",
    "choice_c": "Someone who knows the user ID could derive the password.",
    "choice_d": "Someone who is able to eavesdrop on the authentication can log in later using a replay attack.",
    "correct_answer": "B",
    "explanation": "The weakness in this scheme is that someone who finds a one-time password token could log in as the user by guessing the user ID. Since the one-time password token generates a new password for each login attempt, the attacker would only need to correctly guess the associated user ID to gain access. Guessing the password or deriving it from the user ID isn't feasible because the password changes frequently and isn't predictable. Eavesdropping and using a replay attack would not work because the password is valid for only a single use and typically has a very short lifespan.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      319,
      343,
      314,
      282,
      318
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 174,
    "question": "Which access control model is most suitable for an environment that requires strict control over who can access certain types of data, without the possibility of user modification?",
    "choice_a": "Discretionary Access Control (DAC)",
    "choice_b": "Role-Based Access Control (RBAC)",
    "choice_c": "Mandatory Access Control (MAC)",
    "choice_d": "Attribute-Based Access Control (ABAC)",
    "correct_answer": "C",
    "explanation": "Mandatory Access Control (MAC) is most suitable for environments requiring strict control over who can access certain types of data, as it enforces access policies set by a central authority and does not allow user modification of access permissions.<br>Discretionary Access Control (DAC) allows data owners to control access, which can lead to less strict enforcement and potential security risks if users modify permissions.<br>Role-Based Access Control (RBAC) assigns access based on roles, which provides good control but still allows some flexibility that might not meet the strictest requirements.<br>Attribute-Based Access Control (ABAC) grants access based on attributes and policies, offering flexibility but also complexity, which may not align with the need for strict, unmodifiable controls.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      311,
      253,
      310,
      313,
      346
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 175,
    "question": "An organization has hundreds of remote locations containing valuable equipment and needs to enact a secure access control system. The locations do not have electricity. What is the best choice for an access control method that can be implemented at these locations?",
    "choice_a": "Keycards",
    "choice_b": "Metal keys",
    "choice_c": "Cipher locks",
    "choice_d": "Video surveillance",
    "correct_answer": "C",
    "explanation": "Cipher locks are the best choice for access control in this situation. They don't require electricity, making them ideal for locations without power, and they offer more flexibility and security than metal keys. Unlike metal keys, which can be difficult to manage across multiple locations, cipher locks can be easily reprogrammed if a combination needs to be changed, reducing the logistical challenges of key distribution and control. Keycards would require power, and video surveillance does not control access, so they are not viable options here.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      337,
      264,
      310,
      333,
      335
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 176,
    "question": "Which type of malware is specifically designed to activate at a certain date and time, causing damage to data?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Logic bomb",
    "correct_answer": "D",
    "explanation": "A logic bomb is specifically designed to activate at a certain date and time, causing damage to data or other malicious activities upon the triggering condition being met.<br>A virus is a type of malware that attaches itself to a host file and spreads to other files and systems but does not necessarily activate based on a specific date and time.<br>A worm is a standalone malware that replicates itself to spread to other computers, typically through a network, but it does not activate based on a specific date and time.<br>A Trojan horse is a type of malware disguised as legitimate software, which may carry out various malicious activities once installed, but its activation is not specifically tied to a certain date and time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      265,
      258,
      264,
      268
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 177,
    "question": "What is the primary purpose of the principle of least privilege in access control?",
    "choice_a": "To increase system performance",
    "choice_b": "To ensure users have enough privileges to perform any task",
    "choice_c": "To minimize the risk of unauthorized access",
    "choice_d": "To simplify the user access management process",
    "correct_answer": "C",
    "explanation": "The principle of least privilege in access control aims to minimize the risk of unauthorized access by ensuring users are granted only the permissions necessary to perform their specific tasks, thereby reducing potential security vulnerabilities.<br>Increasing system performance is not related to access control and least privilege directly focuses on security rather than performance.<br>Ensuring users have enough privileges to perform any task contradicts the principle of least privilege, which seeks to limit access to the minimum necessary.<br>Simplifying the user access management process is a secondary benefit, but the primary focus of the principle of least privilege is on reducing security risks rather than administrative simplicity.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      310,
      314,
      318,
      340,
      313
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 178,
    "question": "Your organization needs to provide secure, remote access to employees who work at home. What technology can best assist with this need?",
    "choice_a": "VPN",
    "choice_b": "IPS",
    "choice_c": "CASB",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "A VPN (Virtual Private Network) can best assist with providing secure, remote access to employees who work from home by encrypting the connection between the user's device and the organization's network, ensuring data security and privacy over the internet.<br>An IPS (Intrusion Prevention System) is designed to detect and prevent security threats within a network but does not facilitate remote access for employees.<br>A CASB (Cloud Access Security Broker) helps manage and secure the use of cloud services but is not primarily focused on providing remote network access.<br>A DLP (Data Loss Prevention) system aims to prevent sensitive data from being lost, misused, or accessed by unauthorized users but does not provide remote access capabilities.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      319,
      273,
      306,
      309,
      281
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 179,
    "question": "You are auditing a network firewall and determine that it is designed in a “fail open” configuration. What will happen if the firewall fails?",
    "choice_a": "It will allow any traffic to enter and leave the network.",
    "choice_b": "It will allow no traffic to enter or leave the network.",
    "choice_c": "It will continue to enforce its last known good configuration.",
    "choice_d": "It will alert administrators to the failure and await instructions.",
    "correct_answer": "A",
    "explanation": "If the firewall is designed in a \"fail open\" configuration, it will allow any traffic to enter and leave the network if it fails. This configuration prioritizes availability, meaning that in the event of a failure, the firewall defaults to allowing all traffic through rather than blocking it, which could pose significant security risks. A \"fail closed\" configuration would prevent any traffic from passing through, ensuring security at the cost of availability. Continuing to enforce the last known good configuration or alerting administrators and awaiting instructions are not characteristics of a \"fail open\" configuration.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      270,
      309,
      264,
      253
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 180,
    "question": "Which environmental control is crucial for protecting data centers from fire damage while minimizing damage to equipment?",
    "choice_a": "Wet pipe sprinkler system",
    "choice_b": "Dry pipe sprinkler system",
    "choice_c": "Inert gas fire suppression system",
    "choice_d": "Portable fire extinguishers",
    "correct_answer": "C",
    "explanation": "An inert gas fire suppression system is crucial for protecting data centers from fire damage while minimizing damage to equipment, as it extinguishes fires without using water, thereby avoiding potential harm to electronic equipment.<br>A wet pipe sprinkler system uses water to suppress fires, which can cause significant damage to data center equipment.<br>A dry pipe sprinkler system also uses water, though it is stored in pipes until needed, which still poses a risk of water damage to sensitive electronics.<br>Portable fire extinguishers can be useful for small, localized fires but are not sufficient for comprehensive protection of a data center and may not be suitable for automated response.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      332,
      331,
      349,
      329,
      330
    ],
    "source": "288380_Ch 8"
  },
  {
    "id": 181,
    "question": "What is the purpose of the IT strategy committee?",
    "choice_a": "This group receives input from the board of directors and makes strategic decisions based on their advice.",
    "choice_b": "This group advises the board of directors on strategies to enable better IT support of the organization’s overall strategy and objectives.",
    "choice_c": "This group oversees the organization’s IS department and is headed by the CIO.",
    "choice_d": "This group advises the IS department on overall IT strategies.",
    "correct_answer": "B",
    "explanation": "The IT strategy committee does not make unilateral decisions but is an advisory body to the board of directors. It does not oversee or advise the IS department.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      6,
      7,
      44,
      4,
      27
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 182,
    "question": "Which organizational role is typically involved with the design of applications, including changes in an application’s original design?",
    "choice_a": "Software developer/programmer",
    "choice_b": "Systems architect",
    "choice_c": "Systems analyst",
    "choice_d": "Software tester",
    "correct_answer": "C",
    "explanation": "System analysts are typically involved with the design of applications, including changes in an application’s original design; the other positions are involved with other phases and processes associated with the system development life cycle (SDLC).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      44,
      29,
      54,
      7
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 183,
    "question": "Which of the following threats is uniquely identified with voice-over IP systems in addition to the normal threats any IP-based network would face?",
    "choice_a": "Denial of service",
    "choice_b": "Eavesdropping",
    "choice_c": "Spoofing",
    "choice_d": "Toll fraud",
    "correct_answer": "D",
    "explanation": "Toll fraud is unique to voice-over-IP (VoIP) systems. Spoofing, eavesdropping, and denial of service are common to all IP-connected devices.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      312,
      275,
      319,
      270,
      323
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 184,
    "question": "Which of the following statements describing hot, warm, and cold recovery sites is true?",
    "choice_a": "Hot recovery sites are the least expensive and permit a rapid return to normal operations.",
    "choice_b": "Cold recovery sites are the least expensive and permit a rapid return to normal operations.",
    "choice_c": "A hot site is the best choice when the RTO is a small amount of time.",
    "choice_d": "A warm site provides a location where backup systems are already running and in a state of near-readiness to return to operations in a short amount of time.",
    "correct_answer": "C",
    "explanation": "Hot recovery sites are the most expensive of the three types of sites, but they allow a rapid return to normal operations. Cold sites are the least expensive but do not provide any rapid recovery options, as this is merely an empty location with no equipment or processing activities already set up. Warm sites normally provide some near-term recovery options but require that backup systems and equipment be installed or activated.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      237,
      251,
      248,
      234,
      236
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 185,
    "question": "Who signs a digital certificate, providing assurance that the certificate, and the identifying information it contains, are valid?",
    "choice_a": "Revocation authority",
    "choice_b": "Issuing authority",
    "choice_c": "Registration authority",
    "choice_d": "Certificate authority",
    "correct_answer": "D",
    "explanation": "The certificate authority is a trusted party who signs the digital certificate with their private key, verifying that the certificate and the entity it identifies have been validated.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      284,
      286,
      285,
      282
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 186,
    "question": "On which types of devices would a “remote destruct” feature be enabled in the event they are lost or stolen?",
    "choice_a": "Smartphones and laptops",
    "choice_b": "Switches and routers",
    "choice_c": "Servers",
    "choice_d": "Desktop PCs",
    "correct_answer": "A",
    "explanation": "Mobile devices, such as smartphones and laptops, require a higher degree of protection, since they are not protected by an organization’s normal physical controls. As such, an extra measure of security might be used in the form of remote destruction software or utilities to destroy data in the event the mobile device is lost or stolen.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      269,
      268,
      321,
      341,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 187,
    "question": "Which of the following project management frameworks is <i>not</i> process-based?",
    "choice_a": "PMBOK®",
    "choice_b": "Scrum",
    "choice_c": "CMMI",
    "choice_d": "PRINCE2",
    "correct_answer": "C",
    "explanation": "CMMI is a project/process improvement model that uses a best-practices approach.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      138,
      141,
      140,
      113,
      135
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 188,
    "question": "What is the term used to describe the audit strategy and audit plans that include scope, objectives, resources, and procedures used to evaluate a set of controls and deliver an audit opinion?",
    "choice_a": "An audit program",
    "choice_b": "An audit system",
    "choice_c": "An external audit",
    "choice_d": "An internal audit",
    "correct_answer": "A",
    "explanation": "An audit program is the plan for conducting audits over a certain period, and it involves planning resources, scope, objectives, and procedures. The other terms don’t signify the overall audit strategy and plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      84,
      359,
      85,
      89
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 189,
    "question": "The software that controls computer hardware and facilitates the use of software applications is called:",
    "choice_a": "Device drivers",
    "choice_b": "Utilities",
    "choice_c": "RDBMS software",
    "choice_d": "Computer operating systems",
    "correct_answer": "D",
    "explanation": "Operating systems such as Unix, Linux, Windows, and macOS control computer hardware and manage applications. Device drivers, utilities, and relational database management system (RDBMS) software do not perform this function.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      200,
      203,
      204,
      183,
      196
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 190,
    "question": "When each step of the release process undergoes formal review and approval before the next step is allowed to begin, this is called a:",
    "choice_a": "Regression test",
    "choice_b": "Use acceptance test",
    "choice_c": "Gate process",
    "choice_d": "Requirements phase",
    "correct_answer": "C",
    "explanation": "A gate process means that each step in the release process undergoes a strict go/no-go review and approval process before the next step is allowed to begin.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      170,
      167,
      168,
      183,
      225
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 191,
    "question": "Which of the following involves the concept of dividing knowledge of a specific object or task between two persons?",
    "choice_a": "Two-person control",
    "choice_b": "Segregation of duties",
    "choice_c": "Split custody",
    "choice_d": "Least privilege",
    "correct_answer": "C",
    "explanation": "Split custody means that each person has separate knowledge required to complete a piece of information or tasks, such as each person possessing half of an encryption key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      314,
      345,
      262,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 192,
    "question": "Which of the following most accurately describes characteristics of qualitative and quantitative risk assessments?",
    "choice_a": "A qualitative risk assessment is considerably more difficult and time consuming to perform than a quantitative risk assessment.",
    "choice_b": "A quantitative risk assessment rates risks as high, medium, and low.",
    "choice_c": "A qualitative risk assessment will verify which risk reduction measures are the ones that will make the most difference from a purely financial standpoint.",
    "choice_d": "A quantitative risk analysis rates risks in actual probabilities and costs.",
    "correct_answer": "D",
    "explanation": "A quantitative risk assessment is the most difficult to perform, due to the requirement for accurate numerical data, such as costs, time, and depreciation. Quantitative risk assessments deal with actual probabilities and costs, whereas qualitative assessments rate risks as high, medium, and low. Furthermore, quantitative risk assessments indicate how successful risk reduction measures are from a cost perspective because they deal with numerical values.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      96,
      72,
      75,
      76,
      73
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 193,
    "question": "Poor capacity planning can affect all of the different aspects of IT management <i>except</i>:",
    "choice_a": "Financial management",
    "choice_b": "Problem and incident management",
    "choice_c": "Access control management",
    "choice_d": "Service level management",
    "correct_answer": "C",
    "explanation": "Access control is rarely affected by capacity management, but the other areas are usually directly affected by poor capacity planning and management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      161,
      183,
      169,
      226
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 194,
    "question": "All of the following are often included as contract provisions when outsourcing a product or process <i>except</i>:",
    "choice_a": "Ownership of intellectual property",
    "choice_b": "Profit margin",
    "choice_c": "Dispute resolution",
    "choice_d": "Service level agreement",
    "correct_answer": "B",
    "explanation": "Ownership of intellectual property, dispute resolution, and service level agreements should all be included as contract provisions when outsourcing products or processes to another organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      33,
      34,
      59,
      37
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 195,
    "question": "Which statement is true regarding recovery time objective (RTO) relationships?",
    "choice_a": "The lower the recovery time objective, the higher the cost to achieve it.",
    "choice_b": "The lower the recovery time objective, the lower the cost to achieve it.",
    "choice_c": "The higher the recovery time objective, the higher the recovery point objective.",
    "choice_d": "The higher the recovery time objective, the lower the recovery point objective.",
    "correct_answer": "A",
    "explanation": "The relationship of RTO to cost is that the lower the RTO, the higher it costs to achieve that RTO.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      237,
      233,
      240,
      236
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 196,
    "question": "An auditor has delivered an audit report to an auditee. The auditee disagrees with one of the findings in the report. The best response for the auditor is to:",
    "choice_a": "Include auditee management comments in the audit report",
    "choice_b": "Permit the auditee to describe its disagreement with the audit results",
    "choice_c": "Refund fees paid by the auditee organization",
    "choice_d": "Report the auditee to regulators",
    "correct_answer": "B",
    "explanation": "The best first step when dealing with an auditee’s disagreement is to listen to the substance of the disagreement. It is possible that the auditor has not fully understood the system or process that was audited.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      94,
      354,
      89,
      68
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 197,
    "question": "What is the purpose of control categorization (e.g., detective, preventive, deterrent)?",
    "choice_a": "Helps to determine how controls should be audited",
    "choice_b": "Helps to determine incident response procedures",
    "choice_c": "Helps to understand how controls can be used to reduce risk",
    "choice_d": "Helps to understand what technologies are in place",
    "correct_answer": "C",
    "explanation": "Control categorization is used to better understand various controls and how they are used to reduce risk. For instance, detective controls help an organization detect incidents, whereas a preventive control, when effective, can help prevent incidents from occurring.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      80,
      79,
      94,
      360,
      88
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 198,
    "question": "A system that filters incoming power spikes and other noise and supplies power for short periods through a bank of batteries is called a(n):",
    "choice_a": "Power distribution unit",
    "choice_b": "Dual power feed",
    "choice_c": "Generator",
    "choice_d": "Uninterruptible power supply (UPS)",
    "correct_answer": "D",
    "explanation": "An uninterruptible power supply (UPS) filters spikes, noise, and provides continuous power through a bank of batteries. Typically, an organization uses a combination of a UPS and an electric generator to provide clean, long-term power.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      328,
      327,
      349,
      337,
      310
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 199,
    "question": "The purpose for an auditor to follow up with management well after the completion of the audit is to:",
    "choice_a": "Remind management of audit exceptions",
    "choice_b": "Show interest and concern for the organization’s health",
    "choice_c": "Remind management of its need to remediate all audit findings",
    "choice_d": "Increase the chances for performing additional audits in the future",
    "correct_answer": "B",
    "explanation": "The purpose for post-audit follow-up is to give the auditor an opportunity to show interest and concern for the organization’s well-being. The purpose of the audit is to point out opportunities for improvement; follow-up communication helps to improve the auditor-auditee partnership.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      363,
      354,
      357,
      99
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 200,
    "question": "Which device joins two networks together and uses logical Internet Protocol addresses to determine where packets must be sent?",
    "choice_a": "Bridge",
    "choice_b": "Firewall",
    "choice_c": "Router",
    "choice_d": "Switch",
    "correct_answer": "C",
    "explanation": "A router works at layer 3 of the OSI model (network layer) to route packets between two connected networks and uses logical Internet Protocol (IP) addresses to make routing decisions.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      208,
      209,
      216,
      215,
      213
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 201,
    "question": "Which term describes the time frame for the audit, geography, technology involved, business process to be audited, and portion of the organization affected by the audit?",
    "choice_a": "Charter",
    "choice_b": "Scope",
    "choice_c": "Audit program",
    "choice_d": "Audit plan",
    "correct_answer": "B",
    "explanation": "It is important to determine the scope of an audit before the audit is executed. This defines the time schedule, physical geography or location of the audit, technologies and business processes to be audited, and which parts of the organization will be affected by the audit. The other terms describe different components or characteristics of an audit.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      84,
      353,
      357,
      85,
      89
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 202,
    "question": "In ITIL terminology, if the incident has been seen before and its root cause is known, this is called a(n):",
    "choice_a": "Service outage",
    "choice_b": "Known error",
    "choice_c": "Problem",
    "choice_d": "Incident",
    "correct_answer": "B",
    "explanation": "A known error is a category of problem seen before, so its causes and effects are readily known.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      184,
      169,
      168,
      181
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 203,
    "question": "The consequences of failure to comply with applicable laws and regulations include all of the following <i>except</i>:",
    "choice_a": "Seizure of equipment",
    "choice_b": "Loss of reputation",
    "choice_c": "Fines",
    "choice_d": "Lawsuits",
    "correct_answer": "A",
    "explanation": "Loss of reputation, fines, and lawsuits are consequences that may result from a failure to comply with security and privacy regulations. It is highly unlikely that the violation of a security or privacy regulation would result in seizure of equipment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      67,
      65,
      66,
      62
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 204,
    "question": "COBIT is composed of how many key IT processes?",
    "choice_a": "11",
    "choice_b": "37",
    "choice_c": "5",
    "choice_d": "32",
    "correct_answer": "B",
    "explanation": "The COBIT framework contains 37 key IT processes, along with the means for any individual organization to determine how much (and what kind of) control is appropriate for each organization, based on its business objectives and how IT supports them.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      2,
      39,
      41,
      1,
      15
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 205,
    "question": "What is the relationship, in terms of service level management, that the IT department has with both internal and external customers?",
    "choice_a": "There are usually separate IT departments charged with handling internal or external customers.",
    "choice_b": "The IT department can be both service provider to internal customers and a customer to external providers, and often, the two are interrelated.",
    "choice_c": "The IT department will measure and manage <i>only</i> the services that it provides directly to internal customers.",
    "choice_d": "IT departments do not manage services that are provided by external service providers; these are managed by the organization’s contracts department.",
    "correct_answer": "B",
    "explanation": "In its role of managing internal and external information systems, the IT department can be both service provider to internal customers and a customer to external providers, and often, the two are interrelated.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      176,
      161,
      175,
      165,
      246
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 206,
    "question": "Which two purposes do digital signatures serve?",
    "choice_a": "Message authentication and compression",
    "choice_b": "Message authentication and confidentiality",
    "choice_c": "Message authentication and integrity",
    "choice_d": "Message integrity and confidentiality",
    "correct_answer": "C",
    "explanation": "The purpose of a digital signature is to authenticate a message and to guarantee its integrity. Digital signatures do not protect the confidentiality of a message; however, encryption is not one of the operations performed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      282,
      285,
      284,
      253
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 207,
    "question": "Which quality management system component concerns itself with information used by management to understand the frequency and effort expended for a process?",
    "choice_a": "Documented processes",
    "choice_b": "Key measurements",
    "choice_c": "Audits",
    "choice_d": "Process changes",
    "correct_answer": "B",
    "explanation": "Each process under quality management must have some key measurement points so that management will be able to understand the frequency and effort expended for the process. Measurement goes beyond simply tallying and must include methods for recognizing, classifying, and measuring incidents, events, problems, and defects.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      27,
      51,
      3,
      48
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 208,
    "question": "Which site is best for a recovery time objective (RTO) that is small?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Reciprocal site",
    "correct_answer": "A",
    "explanation": "When a short recovery time objective (RTO) is required, a hot site is the best alternate processing site, because it is almost ready for immediate processing, and can be made ready within a short time, usually minutes to hours. Recovery for the other types of sites takes more time.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      237,
      251,
      234,
      248,
      236
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 209,
    "question": "Which automated attack method is effectively thwarted by the account lockout security measure?",
    "choice_a": "Offline brute-force password attack",
    "choice_b": "Offline dictionary password attack",
    "choice_c": "Online dictionary password attack",
    "choice_d": "Online brute-force password attack",
    "correct_answer": "D",
    "explanation": "Automated online brute-force password attacks are effectively defended against by the account lockout feature, which locks an account after a certain number of failed password attempts.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      343,
      344,
      264,
      312,
      340
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 210,
    "question": "What is a PBC list and what is its purpose?",
    "choice_a": "“Provided by client” list sent to a client at the start of an audit, to request evidence from control owners",
    "choice_b": "“Provided by client” list of evidence that was provided by the client during the audit",
    "choice_c": "“Proof by corroboration” list of client personnel who corroborated evidence provided by others",
    "choice_d": "“Proof by corroboration” list of corroborated evidence provided by the audit client",
    "correct_answer": "A",
    "explanation": "The PBC (“provided by client”) is an auditor’s request for the client to provide evidence at the start of an audit, not a list of evidence received from the client.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      89,
      360,
      359,
      84,
      70
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 211,
    "question": "An organization’s director of business continuity needs to understand the priority of business processes. What activity should be performed?",
    "choice_a": "Business impact analysis",
    "choice_b": "Business impact assessment",
    "choice_c": "Risk assessment",
    "choice_d": "Criticality assessment",
    "correct_answer": "D",
    "explanation": "A criticality assessment is used to determine the most critical business processes in the organization. A criticality assessment is performed after a business impact analysis has been completed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      233,
      246,
      240,
      235
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 212,
    "question": "Which of the following terms describes an authentication system that uses physical attributes as part of its access control mechanism?",
    "choice_a": "Challenge Handshake Authentication Protocol (CHAP)",
    "choice_b": "Kerberos authentication",
    "choice_c": "Biometric",
    "choice_d": "Psychometric",
    "correct_answer": "C",
    "explanation": "Biometric authentication uses a person’s physical attributes, such as fingerprint, voice, and iris pattern, as part of its authentication mechanism.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      343,
      316,
      319
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 213,
    "question": "The best description of a program is:",
    "choice_a": "A key project that fulfills an organization’s objectives",
    "choice_b": "A set of one or more projects that are ongoing at any given time",
    "choice_c": "A set of one or more projects that will fulfill key business objectives",
    "choice_d": "The plan for a set of large projects",
    "correct_answer": "C",
    "explanation": "A program is a set of projects designed to fulfill a business goal or objective. A program is run by a program manager, who coordinates the allocation of resources among the projects in the program.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      103,
      102,
      105,
      106
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 214,
    "question": "An organization collects payments from customers in the form of credit card numbers. What type of audit must this organization undergo to validate the effectiveness of its payment controls?",
    "choice_a": "PCI",
    "choice_b": "QSA",
    "choice_c": "ASV",
    "choice_d": "CISP",
    "correct_answer": "A",
    "explanation": "An organization that collects payments via credit card number is likely to be required to undergo PCI audits or required to perform PCI self-assessments.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      65,
      67,
      86,
      97,
      84
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 215,
    "question": "In an RDBMS, what is the relationship between foreign and primary keys?",
    "choice_a": "There can be many matching primary key fields for one foreign key.",
    "choice_b": "There can be many matching foreign key fields for one primary key.",
    "choice_c": "There can be only one matching foreign key field for each primary key.",
    "choice_d": "There can be many matching foreign keys for many different primary keys.",
    "correct_answer": "B",
    "explanation": "The relationship of primary key to foreign keys in a relational database management system (RDBMS) is typically one-to-many.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      177,
      227,
      186,
      230
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 216,
    "question": "What are the effects of humidity on computing equipment?",
    "choice_a": "When humidity drops below 40 percent, most computing equipment will not function.",
    "choice_b": "When humidity rises above 55 percent, an increase in temperature in electronic equipment will occur.",
    "choice_c": "Too high humidity can result in condensation; too low can result in static buildup.",
    "choice_d": "Too low humidity can result in condensation; too high can result in static buildup.",
    "correct_answer": "C",
    "explanation": "If the humidity is too high, condensation can form, and computing equipment can be short-circuited. If the humidity is too low, static charge can build up and damage sensitive electronic circuits.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      329,
      330,
      253,
      257,
      268
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 217,
    "question": "Advantages of control self-assessments include all of the following <i>except</i>:",
    "choice_a": "Employee awareness of controls is improved through involvement in their improvement.",
    "choice_b": "It could fulfill the requirement for internal auditing.",
    "choice_c": "Risks can be detected earlier, since subject matter experts are involved earlier.",
    "choice_d": "Internal controls are improved.",
    "correct_answer": "B",
    "explanation": "Control self-assessments should not be considered a substitute for an internal audit, as internal audits are not completely independent, unbiased, and objective since they are performed by stakeholders in the process and not by a trained, objective auditor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      366,
      353,
      354,
      60
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 218,
    "question": "Which of the following statements about general computing controls (GCCs) is true?",
    "choice_a": "They are built into all systems in an organization.",
    "choice_b": "They are automatic controls that protect all systems in an organization.",
    "choice_c": "They apply to selected systems in an organization.",
    "choice_d": "They apply to all systems in an organization.",
    "correct_answer": "D",
    "explanation": "By definition, general computing controls apply to all systems in an organization.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      82,
      79,
      80,
      71,
      84
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 219,
    "question": "Which of the following is considered a key element or key elements in a quality management system?",
    "choice_a": "Error or defect recovery",
    "choice_b": "Documented processes and key measurements",
    "choice_c": "Focus on quality of final product versus process quality",
    "choice_d": "Rewards for achieving optional quality standards",
    "correct_answer": "B",
    "explanation": "Key elements in a quality management system include processes that are thoroughly documented and facilitate the measurement of key areas.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      54,
      15,
      48,
      39
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 220,
    "question": "Which segregation of duties control requires two (or more) persons to approve certain transactions?",
    "choice_a": "Workflow approval",
    "choice_b": "Transaction authorization",
    "choice_c": "Split custody",
    "choice_d": "Two-person control",
    "correct_answer": "B",
    "explanation": "These items are measures taken to separate duties, information, and critical task approval, but transaction authorization requires two persons to approve certain actions, such as financial transactions.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      47,
      39,
      31,
      30,
      8
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 221,
    "question": "Which of the following is <i>not</i> a valid form of risk treatment?",
    "choice_a": "Avoidance",
    "choice_b": "Acceptance",
    "choice_c": "Closure",
    "choice_d": "Reduction",
    "correct_answer": "C",
    "explanation": "The valid forms of risk treatment are reduction, transfer (or risk sharing), avoidance, and acceptance. Closure is not a valid form of risk treatment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      76,
      72,
      75,
      73
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 222,
    "question": "Which of the following best describes ISACA audit guidelines?",
    "choice_a": "Statements that help IS auditors better understand how ISACA standards can be implemented",
    "choice_b": "Examples of steps that can be followed when auditing specific business processes or technology systems",
    "choice_c": "Statements that all IS auditors are expected to follow and can be considered a rule of law for auditors",
    "choice_d": "Guidelines that are mandated by governing laws and regulations, and that dictate how audits will be performed",
    "correct_answer": "A",
    "explanation": "ISACA audit guidelines help IS auditors better understand how ISACA standards can be implemented.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      68,
      69,
      70,
      72
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 223,
    "question": "An example of a policy that will be developed to support a law or regulation is a(n):",
    "choice_a": "Data classification policy",
    "choice_b": "Nondisclosure policy",
    "choice_c": "Privacy policy",
    "choice_d": "Equipment acquisition policy",
    "correct_answer": "C",
    "explanation": "While these policies may have some link to legal or regulatory requirements, privacy policies are strictly and closely driven by laws and other regulations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      8,
      15,
      9,
      10
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 224,
    "question": "What is an issue that must be planned when managing preventive maintenance on hardware?",
    "choice_a": "Data restore",
    "choice_b": "Data backup",
    "choice_c": "Scheduled downtime",
    "choice_d": "Server failover",
    "correct_answer": "C",
    "explanation": "Downtime for any hardware undergoing preventive maintenance is an issue that must be planned in advance.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      197,
      225,
      161,
      163,
      233
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 225,
    "question": "Which of the following is <i>not</i> one of the alternatives considered when making a decision to purchase or develop a software application?",
    "choice_a": "Delivering the raw information to someone else to process and purchasing back the results",
    "choice_b": "Developing the application in-house",
    "choice_c": "Purchasing the application",
    "choice_d": "Renting the application (software as a service, or SaaS)",
    "correct_answer": "A",
    "explanation": "They all are alternatives when making a “make versus buy” decision on software applications. A is not normally an option, as there may be regulatory and intellectual property issues with delivering raw information to a third party and purchasing back the processed results.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      36,
      33,
      56,
      59,
      23
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 226,
    "question": "An organization has acquired forensic data acquisition tools and a system to run them on. But if the organization does not implement a chain-of-custody procedure, what is likely to result?",
    "choice_a": "Forensic evidence may be lost.",
    "choice_b": "Forensic examiners may forget where forensic evidence is stored.",
    "choice_c": "Opposing parties will be able to cast doubt on the integrity of forensic evidence.",
    "choice_d": "Pieces of forensic evidence will not be able to be linked together.",
    "correct_answer": "C",
    "explanation": "Without effective chain-of-custody procedures, an organization with even the best forensic tools cannot hope to prevail in legal proceedings; opposing parties will be able to easily convince authorities that forensic data may have been tampered with during the forensic process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      347,
      304,
      257,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 227,
    "question": "Why do mobile devices require compensating controls to reduce the risk of data compromise?",
    "choice_a": "Because they are usually not protected by other physical and logical protections such as locked doors and firewalls",
    "choice_b": "Because they are high-dollar-value items",
    "choice_c": "Because the data they contain is much more sensitive than that of the organization’s servers and workstations",
    "choice_d": "Because end users cannot be trusted to properly secure those devices",
    "correct_answer": "A",
    "explanation": "Mobile devices, including laptop computers, smartphones, and tablets, are frequently used to store and transmit sensitive personal or company information. Because mobile devices are in the hands of their users and because they are frequently outside of the ring of protection provided by physical security controls, mobile devices usually require additional controls to safeguard the information that they store.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      264,
      268,
      309,
      351
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 228,
    "question": "Which of the following functions might an organization be more likely to outsource?",
    "choice_a": "Engineering",
    "choice_b": "Security",
    "choice_c": "Software development",
    "choice_d": "Overhead and support functions",
    "correct_answer": "D",
    "explanation": "An organization may wish to concentrate on hiring for positions related to its core purpose (engineering and software development) and to retain risk management and security. Organizations are more likely to outsource functions that are considered “overhead” that are not a part of its core competencies.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      33,
      34,
      27,
      16
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 229,
    "question": "Which of the following best describes the term “crossover error rate” in the context of biometric authentication mechanisms?",
    "choice_a": "The rate at which valid subjects are rejected. This occurs when the biometric system has too small a margin for error.",
    "choice_b": "The point at which the false reject rate (FRR) equals the false accept rate (FAR). This is the ideal point for a well-tuned biometric system.",
    "choice_c": "The rate at which invalid subjects are accepted as valid. This occurs when the biometric system has too large a margin of error.",
    "choice_d": "The point at which the maximum threshold of allowable authentication errors is reached, and the system becomes unusable.",
    "correct_answer": "B",
    "explanation": "Crossover error rate is that point at which the false reject rate (FRR) equals the false accept rate (FAR). This is the ideal point for a well-tuned biometric system.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      316,
      315,
      314,
      317,
      309
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 230,
    "question": "When the root cause of a problem has been identified, which processes are enacted to make temporary and permanent fixes?",
    "choice_a": "Configuration management and release management",
    "choice_b": "Change management and release management",
    "choice_c": "Incident management and problem management",
    "choice_d": "Change management and configuration management",
    "correct_answer": "D",
    "explanation": "When the root cause of a problem has been identified, the change and configuration management processes are implemented to make both temporary and permanent fixes to correct the problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      167,
      169,
      173,
      184
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 231,
    "question": "PKI is based on what kind of keys?",
    "choice_a": "Symmetric, or private, key pairs",
    "choice_b": "Asymmetric, or public, key pairs",
    "choice_c": "Symmetric, or public, key pairs",
    "choice_d": "Asymmetric, or private, key pairs",
    "correct_answer": "B",
    "explanation": "Public key infrastructure (PKI) is based on asymmetric, or public, key pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      284,
      289,
      287,
      286,
      282
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 232,
    "question": "What is the process of constant control and recording of evidence handling known as?",
    "choice_a": "Forensic audit",
    "choice_b": "Admissibility",
    "choice_c": "Evidence handling",
    "choice_d": "Chain of custody",
    "correct_answer": "D",
    "explanation": "Chain of custody is the term used to describe the process of documentation that shows the acquisition, storage, control, and analysis of evidence. The chain of custody may be needed if the evidence is to be used in a legal proceeding. The other terms describe other types of audits or activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      362,
      70,
      89,
      353,
      95
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 233,
    "question": "All of the following are reasons why all information should not be treated at the same sensitivity level <i>except</i>:",
    "choice_a": "Simplistic information-handling guidelines",
    "choice_b": "Different access levels required by different personnel",
    "choice_c": "Cost",
    "choice_d": "Handling, transport, and storage overhead",
    "correct_answer": "A",
    "explanation": "All information is not normally treated at the same sensitivity or classification level, because the information itself varies by criticality, sensitivity, and may or may not be in scope for various types of regulations, such as privacy.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      294,
      262,
      259,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 234,
    "question": "What is the best type of tool to use for making a forensic copy of a system’s hard drive?",
    "choice_a": "Backup program",
    "choice_b": "Media copier",
    "choice_c": "Drag-and-drop",
    "choice_d": "Directory copier",
    "correct_answer": "B",
    "explanation": "A media copier is used to make a forensic copy of a computer’s hard drive, and media copying tools must be used to make an exact bit-by-bit copy of the entire contents of the hard drive.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      302,
      301,
      304,
      346
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 235,
    "question": "Which of the following is <i>not</i> a consideration when outsourcing a product or service?",
    "choice_a": "Accountability",
    "choice_b": "Quality",
    "choice_c": "Security",
    "choice_d": "Process control",
    "correct_answer": "A",
    "explanation": "They all are considerations when determining whether to outsource a product or service. The organization always maintains accountability, as that is the one thing that cannot be outsourced.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      56,
      27,
      32
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 236,
    "question": "The system that is used to store and manage access to an organization’s application source and object code is known as:",
    "choice_a": "Tape library",
    "choice_b": "Source code escrow",
    "choice_c": "Patch management",
    "choice_d": "Software program library",
    "correct_answer": "D",
    "explanation": "The system that is used to store and manage access to an organization’s application source and object code is known as the software program library.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      161,
      203,
      204,
      166
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 237,
    "question": "All of the following statements characterize denial-of-service (DoS) attacks <i>except</i>:",
    "choice_a": "DoS attacks can be caused by user errors that create software application error messages.",
    "choice_b": "DoS attacks can be carried out by sending an enormous volume of messages to the target system to flood its input buffers and exhaust its available resources.",
    "choice_c": "DoS attacks can be carried out by sending a specially built message that is known to cause a service or application running on the target system to malfunction or stop running altogether.",
    "choice_d": "DoS attacks can be distributed (DDoS) to emanate simultaneously from hundreds to thousands of computers, making them more difficult to withstand because of the volume of incoming messages and the large number of attacking systems.",
    "correct_answer": "A",
    "explanation": "DoS attacks are characterized by a high volume of messages sent to a target system, intending to disable the target. These messages can be sent from a potentially large number of devices. Alternatively, a DoS attack can be caused by a single, specially crafted message that disables the target system.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      275,
      253,
      257,
      312,
      300
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 238,
    "question": "What ITIL term is associated with the set of activities that is concerned with the ability of the organization to continue providing services, primarily in the event that a natural or human-made disaster occurs?",
    "choice_a": "Disaster recovery",
    "choice_b": "Service continuity management",
    "choice_c": "Business continuity",
    "choice_d": "Service level agreement",
    "correct_answer": "B",
    "explanation": "Service continuity management is the set of activities that is concerned with the ability of the organization to continue providing services, primarily in the event that a natural or man-made disaster occurs. Service continuity management is ITIL parlance for the more common terms business continuity planning and disaster recovery planning.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      231,
      235,
      240,
      233,
      243
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 239,
    "question": "In an audit of a business process, why is it important to interview personnel in addition to gathering process documentation?",
    "choice_a": "To determine how much personnel know about their business processes",
    "choice_b": "To determine how well actual practices correspond to written process documentation",
    "choice_c": "To see how many different versions of process documents exist",
    "choice_d": "To see whether personnel think the business process is effective",
    "correct_answer": "B",
    "explanation": "Auditors ask questions of control owners to determine whether written processes are followed. Discrepancies will elevate auditors’ level of concern for management’s control of a process, and wonder whether the as-performed procedure, or the written procedure, is correct.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      90,
      91,
      74,
      354,
      89
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 240,
    "question": "Which of the following policies is <i>most</i> likely to be affected by legal or regulatory requirements?",
    "choice_a": "Data destruction policy",
    "choice_b": "User account/password policy",
    "choice_c": "Development practices policy",
    "choice_d": "Privacy policy",
    "correct_answer": "D",
    "explanation": "Although these policies may be affected by some legal requirements, the privacy policy is most likely to be affected because of the pervasion of privacy laws into the information technology domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      14,
      8,
      9,
      11
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 241,
    "question": "Which of the following is <i>not</i> one of the phases of a typical audit methodology?",
    "choice_a": "Audit objective",
    "choice_b": "Audit training",
    "choice_c": "Audit scope",
    "choice_d": "Audit subject",
    "correct_answer": "B",
    "explanation": "Audit training is a necessary element to building a competent team of auditors, but it’s not part of the methodology and processes.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      89,
      84,
      85,
      352,
      353
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 242,
    "question": "Which of the following normally would <i>not</i> be an indication that an incident is taking place?",
    "choice_a": "Inability to access a public website",
    "choice_b": "Widespread network outages",
    "choice_c": "Disk space on the server rapidly filling up",
    "choice_d": "A financial transaction processing with a delay",
    "correct_answer": "D",
    "explanation": "A financial transaction processing with a delay is not a sure indication of an incident taking place. Transactions that process normally usually are not an indication of an incident, even if they are slower than usual. This may be only an indication of a bandwidth or performance problem.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      299,
      300,
      347,
      259,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 243,
    "question": "What is the first phase of a risk analysis performed by an auditor?",
    "choice_a": "Identifying business risks",
    "choice_b": "Mitigating risk",
    "choice_c": "Evaluating business processes",
    "choice_d": "Monitoring",
    "correct_answer": "C",
    "explanation": "Before auditors identify, mitigate, and monitor risks and their remediation, auditors just first evaluate underlying business processes to better understand their context, purpose, and operation.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      74,
      72,
      84,
      359,
      76
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 244,
    "question": "All of the following are risk treatment methods <i>except</i>:",
    "choice_a": "Accept",
    "choice_b": "Mitigate",
    "choice_c": "Transfer",
    "choice_d": "Eliminate",
    "correct_answer": "D",
    "explanation": "Although risk can be reduced or treated in several different ways, such as acceptance, mitigation, transfer, and even avoidance, it can never be completely eliminated.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      22,
      16,
      24,
      20,
      18
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 245,
    "question": "Which of the following could result from an auditor not using a formal risk-based approach to auditing?",
    "choice_a": "An auditor may assign risk to audited areas based on probability of occurrence.",
    "choice_b": "An auditor may assign risk to audited systems based on severity of impact.",
    "choice_c": "The auditor may apply additional scrutiny in areas where they feel less comfortable with the technology in use.",
    "choice_d": "The auditor may assign risk to audited systems based on asset value.",
    "correct_answer": "C",
    "explanation": "When an auditor takes a risk-based approach to auditing, the auditor may assign higher risk to areas based on probability of occurrence, severity of impact, or asset value. In the absence of a risk analysis, an IS auditor is likely to follow their “gut instinct” and apply additional scrutiny in areas where they feel risks are higher.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      74,
      84,
      359,
      75
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 246,
    "question": "An audit manager has directed an auditor to falsify a client’s audit report. What is the auditor’s best response?",
    "choice_a": "Report the matter to executive management.",
    "choice_b": "Notify law enforcement.",
    "choice_c": "Notify the audit client.",
    "choice_d": "Resign their position.",
    "correct_answer": "A",
    "explanation": "The best course of action is for the auditor to notify executive management in their chain of command.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      68,
      99,
      362,
      363,
      357
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 247,
    "question": "Policies cover all of the following <i>except</i>:",
    "choice_a": "Roles and responsibilities",
    "choice_b": "Development processes",
    "choice_c": "Operational practices",
    "choice_d": "Network protocols",
    "correct_answer": "D",
    "explanation": "All are areas that are normally the subject of policies. Network protocols are examples of standards that may be used in an organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      15,
      12,
      9,
      11
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 248,
    "question": "To support an organization’s mission, goals, and objectives, network infrastructure design should include which of the following?",
    "choice_a": "Physical network architecture only",
    "choice_b": "Data flow architecture only",
    "choice_c": "Logical network architecture only",
    "choice_d": "Physical and logical network architecture, data flow architecture, and network standards and services",
    "correct_answer": "D",
    "explanation": "Infrastructure design includes all facets of the architecture, including physical and logical network architecture and data flows.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      206,
      207,
      228,
      161,
      229
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 249,
    "question": "Which software development methodology uses the Scrum project methodology?",
    "choice_a": "Agile development",
    "choice_b": "Prototyping",
    "choice_c": "Spiral model",
    "choice_d": "Iterative model",
    "correct_answer": "A",
    "explanation": "The agile development model uses the Scrum project methodology.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      124,
      109,
      113,
      115
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 250,
    "question": "An auditor is evaluating a business process and has found that personnel perform tasks consistently, but was told that there are no written procedure documents. What opinion should the auditor write for this process?",
    "choice_a": "No exception: the process is effective",
    "choice_b": "Major exception: lack of procedure document",
    "choice_c": "Minor exception: lack of procedure document",
    "choice_d": "Minor exception: the process is not effective",
    "correct_answer": "C",
    "explanation": "In most cases, if a process or procedure is being performed consistently, then the process may be found to be effective, even if the process or procedure itself is not written down. Only in unusual cases would this amount to a major exception.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      363,
      94,
      90,
      74,
      91
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 251,
    "question": "Which ISACA audit standard specifies that audit activities in an organization should be formally defined and should include statements of scope, responsibility, and authority for conducting audits?",
    "choice_a": "1201, Engagement Planning",
    "choice_b": "1001, Audit Charter",
    "choice_c": "1202, Risk Assessment in Planning",
    "choice_d": "1203, Performance and Supervision",
    "correct_answer": "B",
    "explanation": "Audit activities in an organization should be formally defined in an audit charter. This should include statements of scope, responsibility, and authority for conducting audits. Senior management should support the audit charter through direct signature or by linking the audit charter to corporate policy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      60,
      357,
      61,
      85
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 252,
    "question": "An auditor is examining security configurations in a server farm and is finding that security configurations are inconsistent from one server to the next. How should the auditor proceed?",
    "choice_a": "Increase the sample size.",
    "choice_b": "Examine all servers.",
    "choice_c": "Stop sampling and develop conclusions.",
    "choice_d": "Immediately notify the audit client of the finding.",
    "correct_answer": "A",
    "explanation": "Examining all servers might be the right step, but it probably would not be if there were large numbers of them. Similarly, an auditor could stop sampling at this point, but that would not be the best action after observing that individual samples within a given population are inconsistent with one another. Notifying the audit client is unnecessary as this would probably not be considered an emergency.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      92,
      90,
      360,
      89,
      95
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 253,
    "question": "What is the document that clearly defines the roles and responsibilities that are consistent with ISACA audit standards and guidelines?",
    "choice_a": "Auditing policy",
    "choice_b": "Audit charter",
    "choice_c": "Audit program",
    "choice_d": "Internal audit",
    "correct_answer": "B",
    "explanation": "The proper document for defining an audit in terms of roles, responsibilities, audit standards, and guidelines is the audit charter.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      69,
      70,
      357,
      61
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 254,
    "question": "Which of the following statements regarding single sign-on is false?",
    "choice_a": "Single sign-on refers to an interconnected environment where applications are logically connected to a centralized authentication server that is aware of the logged-in/out status of each user.",
    "choice_b": "Single sign-on refers to an environment where a centralized directory service such as LDAP, RADIUS, or Microsoft Active Directory is used by several applications for authentication.",
    "choice_c": "Single sign-on is more complex than reduced sign-on. In a single sign-on environment, each participating application must be able to communicate with a centralized authentication controller and act accordingly, either by requiring a new user to log in or not.",
    "choice_d": "A user needs to sign on only one time, even in a multiple-application environment.",
    "correct_answer": "B",
    "explanation": "Option B refers to an environment where a centralized directory service such as LDAP, RADIUS, or Microsoft Active Directory is used by several applications for authentication and is not a description of single sign-on, but of reduced sign-on.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      309,
      345,
      343,
      315
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 255,
    "question": "Which of the following would <i>not</i> be considered a good source of evidence to support audit findings?",
    "choice_a": "System documentation",
    "choice_b": "Policy documents",
    "choice_c": "Vulnerability scan results",
    "choice_d": "Individual opinions of the personnel interviewed",
    "correct_answer": "D",
    "explanation": "Individual opinions of the people being interviewed are not usually considered to be evidence (although they may point the way to useful evidence).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      70,
      362,
      365,
      94
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 256,
    "question": "All of the following are characteristics of system hardening <i>except</i>:",
    "choice_a": "Preserving default configurations",
    "choice_b": "Eliminating unnecessary services",
    "choice_c": "Changing systems from multifunction to single-function",
    "choice_d": "Limiting privileges of necessary services",
    "correct_answer": "A",
    "explanation": "Default settings often include unnecessary services that increase the chances that an attacker can find a way to break into a system. In addition, some systems are shipped with default administrative passwords that make it easy for a new customer to configure the system, and many organizations fail to change these passwords. The practice of system hardening is used to remove all unnecessary services, change nonsecure default settings and passwords, and make security configuration changes on a system to make it as secure as possible.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      268,
      313,
      308,
      267,
      322
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 257,
    "question": "Which of the following terms refers to the tendency for sensitive information from an organization’s databases to be disclosed to unauthorized parties through various means?",
    "choice_a": "Full disclosure",
    "choice_b": "Need to know",
    "choice_c": "Unauthorized access",
    "choice_d": "Information leakage",
    "correct_answer": "D",
    "explanation": "Information leakage refers to the tendency for sensitive information to leak out of an organization’s databases through various means. There are fundamentally two forms of information leakage: accidental and malicious.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      266,
      294,
      257,
      258,
      296
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 258,
    "question": "An accounts payable department is experiencing a high rate of data entry errors. What type of control would be the best choice for correcting this problem?",
    "choice_a": "Use batch totals to detect entry errors within an item in a batch.",
    "choice_b": "Have the data entry operator enter error-prone items twice to detect data input errors.",
    "choice_c": "Use checksums on critical fields.",
    "choice_d": "Have the data entry operator enter all items twice to detect data input errors.",
    "correct_answer": "B",
    "explanation": "The best choice in this situation is to have data entry operators enter the error-prone fields twice to ensure that they are input correctly. There is no reason to reenter all fields, as some may be time-consuming and not associated with errors. Batches may not be feasible, as data may not be processed in batches.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      81,
      88,
      90,
      360,
      89
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 259,
    "question": "Which function serves as a collection point for ITSM processes such as change management, configuration management, service-level management, availability management, and other ITSM functions?",
    "choice_a": "Network management",
    "choice_b": "Service-level management",
    "choice_c": "Service desk",
    "choice_d": "Incident response team",
    "correct_answer": "C",
    "explanation": "The service desk (or helpdesk), in addition to handling service requests on behalf of customers by acting as a single point of contact, can serve as a collection point for other ITSM processes such as change management, configuration management, service-level management, availability management, and other ITSM functions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      176,
      166,
      169,
      162
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 260,
    "question": "All of the following are measures used to protect user IDs and passwords <i>except</i>:",
    "choice_a": "Never sharing passwords",
    "choice_b": "Using complex passwords",
    "choice_c": "Using a security token",
    "choice_d": "Transmitting encrypted passwords",
    "correct_answer": "C",
    "explanation": "Using complex passwords that are not shared and that are transmitted with encryption is the best measure for protecting passwords. Using a security token does not change the protection of passwords.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      315,
      319,
      313,
      282,
      343
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 261,
    "question": "During which phase of the system development life cycle (SDLC) should security controls consideration begin?",
    "choice_a": "Requirements definition",
    "choice_b": "Feasibility study",
    "choice_c": "Design",
    "choice_d": "Development",
    "correct_answer": "A",
    "explanation": "The requirements definition phase is where security control consideration must begin, as controls must be defined in that phase or risk being an afterthought.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      116,
      115,
      151,
      119
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 262,
    "question": "An auditor is reviewing an organization’s change management process and has found that many changes are being performed without approval. What is the best approach for the organization to take?",
    "choice_a": "The organization should identify and punish those staff members who are performing unapproved changes.",
    "choice_b": "The organization should train its staff members on the proper use of the change management process.",
    "choice_c": "The change management process should be changed to permit low-risk changes to be done without approval.",
    "choice_d": "The organization should reiterate its policy that no unapproved changes should be performed, and that this can result in termination of employment.",
    "correct_answer": "D",
    "explanation": "While the organization’s change management process may need some improvements, the organization must first control the process and require compliance from all staff members.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      166,
      167,
      161,
      173,
      169
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 263,
    "question": "What is the purpose of vulnerability scanning?",
    "choice_a": "Identify vulnerabilities to gain control of a system.",
    "choice_b": "Confirm that all patches have been applied to a system.",
    "choice_c": "Determine if a system meets minimum requirements for certification and accreditation (C&A).",
    "choice_d": "Identify vulnerabilities in one or more target systems.",
    "correct_answer": "D",
    "explanation": "Vulnerability scanning only finds and lists vulnerabilities on a target system; it is not used to exploit those vulnerabilities, as penetration testing does. Vulnerability scanning is also not solely used to determine if a system meets a level of certification, as many other factors would also help determine that. It is also not used to determine patch levels on systems, as other tools perform that function, and often, a vulnerability may not be associated with a particular patch but may be a configuration issue.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      322,
      308,
      268,
      313,
      264
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 264,
    "question": "An auditor is performing an audit of a retail grocery store chain. The audit client wants to tell the auditor which stores should be examined in the field portion of the audit. What is the auditor’s best response?",
    "choice_a": "Inform the audit client that the auditor needs to perform sampling.",
    "choice_b": "Accept the audit client’s sampling request and examine those stores.",
    "choice_c": "Notify the audit client’s board of directors.",
    "choice_d": "Notify law enforcement.",
    "correct_answer": "A",
    "explanation": "Audit clients are not permitted to select samples; this is the auditor’s responsibility.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      84,
      85,
      360,
      92,
      69
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 265,
    "question": "What language is used to select and extract data from a relational database management system (RDBMS)?",
    "choice_a": "Structured Query Language (SQL)",
    "choice_b": "Object-Oriented Programming (OOP) language",
    "choice_c": "Practical Extraction and Reporting Language (PERL)",
    "choice_d": "Object Query Language (OQL)",
    "correct_answer": "A",
    "explanation": "Relational databases are accessed and updated through the SQL (Structured Query Language) computer language. Standardized in ISO and ANSI standards, SQL is used in many popular relational database management system products.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      178,
      177,
      186,
      227,
      179
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 266,
    "question": "An option for system backup that permits organizations to back up their systems and data to an off-site location, which could be a storage system in another data center or a third-party service provider, is called:",
    "choice_a": "Transaction journaling",
    "choice_b": "Remote storage",
    "choice_c": "E-vaulting",
    "choice_d": "Full backup",
    "correct_answer": "C",
    "explanation": "E-vaulting permits organizations to back up their systems and data to an off-site location, which could be a storage system in another data center or a third-party service provider. E-vaulting accomplishes two important objectives: reliable backup and off-site storage of backup media.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      250,
      239,
      247,
      246,
      238
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 267,
    "question": "Which part of the audit report can be used as evidence for other organizations that an audit has taken place?",
    "choice_a": "Cover letter",
    "choice_b": "Executive summary",
    "choice_c": "Findings section",
    "choice_d": "Remediation and mitigation section",
    "correct_answer": "A",
    "explanation": "Audit reports frequently include a cover letter that describes the audit, its scope and purpose, and findings. Often, this cover letter is used as evidence to other organizations that the audit took place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      364,
      94,
      357,
      353,
      70
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 268,
    "question": "Which of the following models assumes that one or more components in an environment may be considered compromised?",
    "choice_a": "TOGAF",
    "choice_b": "Zachman",
    "choice_c": "Zero trust",
    "choice_d": "Assume breach",
    "correct_answer": "C",
    "explanation": "Zero trust is an architecture model where one or more portions of an environment are considered untrusted (and, potentially, compromised).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      39,
      20,
      17,
      11
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 269,
    "question": "Which perspective of the balanced scorecard is concerned with measurements of key activities, including the number of projects and the effectiveness of key internal activities of the organization?",
    "choice_a": "Financial",
    "choice_b": "Innovation and learning",
    "choice_c": "Customer",
    "choice_d": "Internal processes",
    "correct_answer": "D",
    "explanation": "The internal processes perspective measures key activities, including the number of projects and the effectiveness of key internal activities of the organization. The other three perspectives measure other key areas.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      3,
      51,
      27,
      39,
      1
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 270,
    "question": "Which two factors figure significantly in the risk analysis process in terms of evaluating different risk mitigation solutions?",
    "choice_a": "Single loss expectancy (SLE) and annualized loss expectancy (ALE)",
    "choice_b": "Asset value (AV) and exposure factor (EF)",
    "choice_c": "Exposure factor (EF) and annualized rate of occurrence (ARO)",
    "choice_d": "Annualized rate of occurrence (ARO) and annualized loss expectancy (ALE)",
    "correct_answer": "C",
    "explanation": "An important part of risk analysis is the investigation of potential solutions for reducing or eliminating risk. This involves understanding specific threats and their impact (EF) and likelihood of occurrence (ARO).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      20,
      21,
      22,
      24,
      52
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 271,
    "question": "An organization has established a system classification scheme for identifying the criticality of systems for disaster recovery purposes. The organization’s primary e-commerce application has been classified as Critical. How should the organization’s DNS servers be classified?",
    "choice_a": "DNS servers need to be independently classified according to their criticality.",
    "choice_b": "DNS servers do not need to be classified because they do not contain customer data.",
    "choice_c": "DNS servers should be classified as Nonsensitive because they do not contain customer data.",
    "choice_d": "DNS servers should be classified as Critical so that customers can contact the e-commerce servers.",
    "correct_answer": "D",
    "explanation": "A business impact analysis (BIA) needs to identify interdependencies between critical systems and those that are essential for their operation, such as DNS servers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      16,
      19,
      11,
      5
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 272,
    "question": "What are the typical components of a change management process?",
    "choice_a": "Review requirements, perform change, review change",
    "choice_b": "Request change, perform change, approve change",
    "choice_c": "Perform emergency changes, obtain change approval, test changes",
    "choice_d": "Request change, review change, perform the change, perform emergency changes",
    "correct_answer": "D",
    "explanation": "The proper sequence of the processes for change management starts with a formal request of the change; management then reviews the changes and implications before approval; the change is then performed and reviewed, and emergency changes are also included in this process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      132,
      154,
      131,
      134,
      136
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 273,
    "question": "What is the definition of single loss expectancy (SLE)?",
    "choice_a": "The exposure factor for a single loss",
    "choice_b": "The probability of a single loss",
    "choice_c": "Financial loss from a single event",
    "choice_d": "Financial loss from events in a single year",
    "correct_answer": "C",
    "explanation": "Single loss expectancy is the financial loss that results from a single event. Exposure factor (EF) is a percentage of an asset’s value, after salvage. The financial loss from events in a single year is known as annual loss expectancy (ALE).",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      20,
      19,
      22,
      25,
      26
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 274,
    "question": "An organization considering infrastructure as a service (IaaS) via cloud computing should be concerned with all of the following controls <i>except</i>:",
    "choice_a": "Physical security",
    "choice_b": "Administrative access to operating systems",
    "choice_c": "User access to applications",
    "choice_d": "Protection of stored data",
    "correct_answer": "C",
    "explanation": "An organization considering IaaS via cloud computing should be concerned that the service provider has adequate controls over physical access to systems, administrative access to systems, and protection of stored data. User access to applications run in the cloud environment is the concern and the responsibility of the organization, not the service provider.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      126,
      117,
      130,
      144,
      133
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 275,
    "question": "An event where the confidentiality, integrity, or availability of information (or an information system) has been compromised is called a(n):",
    "choice_a": "Data compromise",
    "choice_b": "Incident response",
    "choice_c": "Security incident",
    "choice_d": "Disaster",
    "correct_answer": "C",
    "explanation": "A security incident is an event where the confidentiality, integrity, or availability of information—or an information system—has been compromised somehow.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      299,
      253,
      258,
      300,
      259
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 276,
    "question": "An organization is considering outsourcing a department to an offshore service provider. How can the organization best ensure that the offshore provider’s service quality will be adequate?",
    "choice_a": "Continuously monitor service levels and quality.",
    "choice_b": "Contractually require minimum service levels.",
    "choice_c": "Contractually link service quality to payments for service.",
    "choice_d": "Contractually require dispute and resolution procedures.",
    "correct_answer": "C",
    "explanation": "Note that although none of these other practices is the best choice for the answer, all are essential for a contract with an offshore service provider.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      34,
      33,
      56,
      57,
      37
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 277,
    "question": "Who is responsible for setting overall strategic direction and policy, ensuring that IT strategy is in alignment with the organization’s strategy and objectives?",
    "choice_a": "IT department",
    "choice_b": "CISO",
    "choice_c": "Steering committee",
    "choice_d": "CFO",
    "correct_answer": "C",
    "explanation": "The steering committee is responsible for setting overall strategic direction and policy, ensuring that IT strategy is in alignment with the organization’s strategy and objectives. The wishes of the steering committee are carried out through projects and tasks that steer the IT organization toward strategic objectives.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      7,
      6,
      1,
      4,
      44
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 278,
    "question": "An event where a security policy has been compromised is called a(n):",
    "choice_a": "Attack",
    "choice_b": "Problem",
    "choice_c": "Incident",
    "choice_d": "Compromise",
    "correct_answer": "C",
    "explanation": "A security incident is an event where a security policy has been violated. The other terms are descriptive of other specific types of events that can also affect information systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      299,
      300,
      259,
      347,
      256
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 279,
    "question": "What auditing technique is used when it would be impractical or impossible to test an entire population?",
    "choice_a": "Sampling",
    "choice_b": "Interview",
    "choice_c": "Controls testing",
    "choice_d": "Documentation review",
    "correct_answer": "A",
    "explanation": "“Sampling” refers to the technique that is used when it is not feasible to test an entire population of transactions. The objective of sampling is to select a portion of a population so that the characteristics observed in the sample will reasonably reflect the characteristics of the entire population.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      361,
      95,
      89
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 280,
    "question": "Which of the following protocols is the best choice for transmitting transaction files?",
    "choice_a": "TFTP",
    "choice_b": "UDP",
    "choice_c": "TCP",
    "choice_d": "ICMP",
    "correct_answer": "C",
    "explanation": "Only the TCP protocol guarantees the order of delivery and confirmed delivery of packets. The other protocols, TFTP, UDP, and ICMP, are not suited for transferring business data, as they do not guarantee order of delivery.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      208,
      211,
      216,
      207,
      161
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 281,
    "question": "An IS auditor is auditing computer operations and has observed that operators are consistently cleaning tape drives daily, even though there are no procedures or records for this activity. What should the auditor conclude from this observation?",
    "choice_a": "The auditor should find the process effective but note that it lacks documentation and records.",
    "choice_b": "The auditor should find the process ineffective because of a lack of records.",
    "choice_c": "The auditor should find the process ineffective because of a lack of written procedures.",
    "choice_d": "The auditor should not document a conclusion, as this is a noncritical control.",
    "correct_answer": "A",
    "explanation": "In many circumstances, a noncritical procedure performed correctly and consistently can usually be judged as effective even if there are no records associated with it. In some environments, however, operational guidelines are quite strict, and in such a case, this circumstance could result in an audit finding.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      183,
      161,
      197,
      182,
      185
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 282,
    "question": "Which framework contains 37 key IT processes and identifies and measures key performance indicators, with the aim of enabling continuous improvement to processes and technology?",
    "choice_a": "SEI CMMI",
    "choice_b": "ITIL",
    "choice_c": "COBIT",
    "choice_d": "ISO 20000",
    "correct_answer": "C",
    "explanation": "COBIT is a continuous improvement process framework that consists of 37 key IT processes. The other frameworks do not fulfill this purpose.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      2,
      41,
      39,
      53,
      3
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 283,
    "question": "A cluster that can automatically transfer processing to a standby member of the cluster in the event of the failure of one of the other computers in the cluster is said to be in which type of mode?",
    "choice_a": "Active-active mode",
    "choice_b": "Passive-passive mode",
    "choice_c": "Hot standby mode",
    "choice_d": "Active-passive mode",
    "correct_answer": "D",
    "explanation": "In active-passive mode, in the event of the failure of one of the other computers in the cluster, processing can be transferred automatically to a previously passive standby member of the cluster. The other modes do not provide this functionality.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      201,
      195,
      231,
      240,
      236
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 284,
    "question": "All of the following activities take place in the post-implementation phase <i>except</i>:",
    "choice_a": "System adequacy",
    "choice_b": "Security review",
    "choice_c": "Requirements gathering",
    "choice_d": "Identification of issues/problems",
    "correct_answer": "C",
    "explanation": "Gathering requirements is performed early in the SDLC, during the requirements definition phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      117,
      115,
      122,
      153
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 285,
    "question": "What are the key measurements that are used to determine how well an organization can fulfill its mission and strategic objectives?",
    "choice_a": "Market share and market penetration",
    "choice_b": "Financial, customer, internal processes, and innovation and learning",
    "choice_c": "Profit/loss ratios",
    "choice_d": "Production counts",
    "correct_answer": "B",
    "explanation": "These are all measurements used in the balanced scorecard.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      3,
      1,
      7,
      27,
      16
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 286,
    "question": "All of the following should be considered in capacity planning <i>except</i>:",
    "choice_a": "Bandwidth",
    "choice_b": "Disk space",
    "choice_c": "Throughput",
    "choice_d": "Network protocols",
    "correct_answer": "D",
    "explanation": "Bandwidth, disk space, and throughput are all factors that affect capacity and network growth.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      225,
      227,
      206,
      161
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 287,
    "question": "Which statement describes the relationship between configuration management and change control?",
    "choice_a": "Configuration management is the process of requesting changes; change management is used to perform changes.",
    "choice_b": "Configuration management and change management have no relationship to each other and are separate processes.",
    "choice_c": "Change management is the review and approval of changes, while configuration management is used to perform and record changes.",
    "choice_d": "Change management applies to line-of-business applications and software management, and configuration management covers networks, systems, and IT infrastructure.",
    "correct_answer": "C",
    "explanation": "Configuration and change management are related processes, with change management being the formal request, review, and approval of configuration changes, and configuration management the implementation and recording process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      132,
      134,
      154,
      122,
      153
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 288,
    "question": "All of the following are important considerations when planning a backup and restoration strategy <i>except</i>:",
    "choice_a": "Off-site storage",
    "choice_b": "Time required to restore data from media",
    "choice_c": "Reliability of backup media",
    "choice_d": "Cost of backup media",
    "correct_answer": "D",
    "explanation": "Off-site storage, the time required to restore data from media, and the reliability of backup media are important considerations when planning a data backup and restoration strategy. Costs of backup media have fallen significantly in recent years, and this should not be an important consideration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      250,
      247,
      233,
      246
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 289,
    "question": "Threats that physical security measures attempt to address include which of the following?",
    "choice_a": "Data destruction by authenticated users",
    "choice_b": "Data theft by authenticated users",
    "choice_c": "Equipment theft, sabotage, and destruction by any person",
    "choice_d": "Data modification by any person",
    "correct_answer": "C",
    "explanation": "Logical controls, such as permissions, privileges, and auditing, are designed to prevent data theft, destruction, or modification by any person, authenticated or not. Physical controls normally can’t specifically and directly address data, but they can address physical threats such as equipment theft, destruction, or sabotage.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      334,
      335,
      337,
      329,
      327
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 290,
    "question": "Which of the following access control models states that the owner of an object is able to determine how and by whom the object may be accessed, and that the discretion of the owner determines permitted accesses by subjects?",
    "choice_a": "Administrator access control (AAC)",
    "choice_b": "Mandatory access control (MAC)",
    "choice_c": "Subject-object access control",
    "choice_d": "Discretionary access control (DAC)",
    "correct_answer": "D",
    "explanation": "In the discretionary access control model, the owner of an object is able to determine how and by whom the object may be accessed. The discretion of the owner determines permitted access by subjects. DAC permits flexibility by permitting an owner to set access rights.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      311,
      309,
      314,
      262,
      312
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 291,
    "question": "Which of the following best describes residual risk?",
    "choice_a": "Residual risk is the amount of risk eliminated from using mitigating controls.",
    "choice_b": "All risk prior to applying mitigating controls is residual risk.",
    "choice_c": "Original risk – mitigated risk – transferred risk = residual risk",
    "choice_d": "Residual risk is the amount of risk present if no controls are applied.",
    "correct_answer": "C",
    "explanation": "Residual risk is what remains after all risk mitigation and transfer measures have been applied to the original risk.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      22,
      24,
      21,
      18,
      16
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 292,
    "question": "When a message is signed using a private key and verified with a public key, this action fulfills the message:",
    "choice_a": "Confidentiality and integrity",
    "choice_b": "Integrity and availability",
    "choice_c": "Authenticity and integrity",
    "choice_d": "Authenticity",
    "correct_answer": "C",
    "explanation": "A message signed with a private key and verified with a public key enables the message recipient to authenticate the message, and have confidence in the integrity of the message.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      286,
      282,
      284,
      285,
      289
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 293,
    "question": "Which type of attack attempts to discover open, and possibly vulnerable, ports on target systems?",
    "choice_a": "Service scanning",
    "choice_b": "Port scanning",
    "choice_c": "OS fingerprinting",
    "choice_d": "Passive scanning",
    "correct_answer": "B",
    "explanation": "Port scanning is used to discover open—and potentially vulnerable—ports on target systems. Port scanning can also be used to discover devices on a network.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      312,
      322,
      306,
      274,
      320
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 294,
    "question": "What term is associated with identifying and tracking significant events in the project, points at which go/no-go decisions on project continuation often occur?",
    "choice_a": "Check pointing",
    "choice_b": "Milestone tracking",
    "choice_c": "Goal tracking",
    "choice_d": "Progress monitoring",
    "correct_answer": "B",
    "explanation": "Milestones are significant events in the project when major phases of the project have been completed. Tracking them allows management to conduct a project review meeting to make go/no-go decisions on whether the project should be permitted to continue.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      106,
      108,
      110,
      113,
      115
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 295,
    "question": "A data analyst has been appointed to perform unit testing. What type of activity will the data analyst be performing?",
    "choice_a": "Individual business functions",
    "choice_b": "The lowest-level functions, calculations, and subroutines",
    "choice_c": "Individual steps within business functions",
    "choice_d": "The entire system",
    "correct_answer": "B",
    "explanation": "Unit testing is the testing of individual functions, calculations, and subroutines within an individual program.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      121,
      120,
      152,
      153,
      143
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 296,
    "question": "When the temperature in a data center is too high, computing and electronic equipment can overheat. What can happen if the temperature gets too low in a data center?",
    "choice_a": "A temperature that is too low can cause condensation on equipment that can result in corrosion, and even cause short circuits when condensation occurs on electrical components.",
    "choice_b": "Low temperatures can cause the equipment to perform poorly or even freeze up.",
    "choice_c": "A temperature that is too low can cause issues with mechanical equipment, such as tape drives and printers.",
    "choice_d": "Low temperatures can cause network cabling to become brittle and easily break.",
    "correct_answer": "A",
    "explanation": "If a low-temperature condition occurs, condensation may form on equipment, causing corrosion or short-circuiting in electrical equipment.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      330,
      329,
      349,
      328,
      333
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 297,
    "question": "Which of the following are <i>not</i> security and privacy laws and standards in the United States?",
    "choice_a": "Electronic Communications Act of 1986",
    "choice_b": "Gramm Leach Bliley Act (GLBA) of 1999",
    "choice_c": "Personal Information Protection and Electronic Documents Act (PIPEDA)",
    "choice_d": "Health Insurance Portability and Accountability Act (HIPAA) of 1996",
    "correct_answer": "C",
    "explanation": "Personal Information Protection and Electronic Documents Act (PIPEDA) is a Canadian law. All others are U.S. laws.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      65,
      66,
      67,
      64,
      69
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 298,
    "question": "Which network topology is typically more resistant to failures?",
    "choice_a": "Star",
    "choice_b": "Ring",
    "choice_c": "Bus",
    "choice_d": "FDDI",
    "correct_answer": "A",
    "explanation": "A star topology is typically more fault tolerant; a cable break from the central node to a station will not take out the entire LAN, as it would in a bus or ring configuration. Usually, only the affected station would be affected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      210,
      207,
      208,
      209,
      161
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 299,
    "question": "How does a business case differ from a feasibility study in terms of describing the benefits of a particular solution?",
    "choice_a": "A business case goes beyond a feasibility study in terms of describing the business benefits of one solution and includes actual figures for costs and benefits.",
    "choice_b": "Unlike a feasibility study, a business case defines the business problem and describes a number of potential solutions.",
    "choice_c": "A business case outlines the business problem but does not include any actual solutions.",
    "choice_d": "A business case does not define the problem but offers several possible solutions without regard to feasibility.",
    "correct_answer": "A",
    "explanation": "A business case goes beyond a feasibility study in terms of describing the business benefits of one solution and includes actual figures for costs and benefits.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      102,
      116,
      100,
      115,
      101
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 300,
    "question": "All of the following are considered legal forms of intellectual property <i>except</i>:",
    "choice_a": "Source code",
    "choice_b": "Designs",
    "choice_c": "Processes",
    "choice_d": "Protocol standards",
    "correct_answer": "D",
    "explanation": "Protocol standards are open, well-known standards used throughout the IT industry, and usually are not specific to an organization. Source code, designs, and processes are generally developed by the organization and protected as intellectual property.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      12,
      56,
      19,
      1,
      14
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 301,
    "question": "Which process is an intellectual effort that seeks to determine whether a specific change or set of changes in business processes and underlying applications is practical to undertake?",
    "choice_a": "Business impact analysis",
    "choice_b": "Feasibility study",
    "choice_c": "Requirements gathering",
    "choice_d": "Unit acceptance test",
    "correct_answer": "B",
    "explanation": "The feasibility study is the first formal phase in the SDLC. It is an analysis of proposed changes to business processes and supporting applications, including the costs associated with making those changes and the benefits that are expected as a result of those changes.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      116,
      102,
      151,
      115,
      117
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 302,
    "question": "All of the following are risks associated with the use of peer-to-peer computing <i>except</i>:",
    "choice_a": "Malware",
    "choice_b": "Denial of service",
    "choice_c": "Violation of intellectual property laws",
    "choice_d": "Data leakage",
    "correct_answer": "B",
    "explanation": "Denial of service is not generally thought of as a significant risk associated with peer-to-peer computing.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      292,
      323,
      324,
      326,
      309
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 303,
    "question": "Which evidence will help the auditor better understand the tone and direction set by management, as well as give the auditor a better idea of how well organized the IS organization is?",
    "choice_a": "Review of third-party contracts and service level agreements (SLAs)",
    "choice_b": "Review of IS standards",
    "choice_c": "Review of IS system documentation",
    "choice_d": "Review of IS policies and procedures",
    "correct_answer": "D",
    "explanation": "A review of the IS policies and procedures is an indicator of how well organized and committed the organization is to protect its information and systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      354,
      74,
      89,
      72
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 304,
    "question": "Which process involves decommissioning encryption keys?",
    "choice_a": "Key escrow",
    "choice_b": "Key disposal",
    "choice_c": "Key compromise",
    "choice_d": "Key generation",
    "correct_answer": "B",
    "explanation": "Key disposal refers to the process of decommissioning encryption keys. This may be done upon receipt of an order to destroy a dataset that is encrypted with a specific encryption key—destroying an encryption key can be as effective (and a whole lot easier) than destroying the encrypted data itself.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      284,
      287,
      288,
      289,
      262
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 305,
    "question": "What is the primary reason organizations perform internal and external audits?",
    "choice_a": "To comply with shareholder requirements",
    "choice_b": "To comply with board of director requirements",
    "choice_c": "To comply with laws and regulations",
    "choice_d": "To establish budget, profit, and loss projections for the next fiscal year",
    "correct_answer": "C",
    "explanation": "Auditing may provide valuable information to aid in these processes, but they do not necessarily require internal and external audits, depending on the organization. Auditing is primarily driven by legal and regulatory requirements.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      64,
      67,
      62,
      87,
      60
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 306,
    "question": "Which of the following security measures is being used when a user account is temporarily unavailable for a specified time after several incorrect password attempts?",
    "choice_a": "Password reset",
    "choice_b": "Account lockout",
    "choice_c": "Disabling an account",
    "choice_d": "Account delay",
    "correct_answer": "B",
    "explanation": "Account lockout is activated for user accounts after a number of unsuccessful login attempts. This measure is used to prevent automated password attacks against a user account.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      344,
      264,
      312,
      313
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 307,
    "question": "Which model depicts how the characteristics of a product defined throughout the system development life cycle (SDLC) are tested using various tests?",
    "choice_a": "Functional testing model",
    "choice_b": "Integrated test model",
    "choice_c": "V-model",
    "choice_d": "T-model",
    "correct_answer": "C",
    "explanation": "The V-model depicts a correspondence between different software characteristics, functions, and requirements and their respective types of tests.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      121,
      119,
      115,
      114,
      124
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 308,
    "question": "An IS auditor is reviewing wireless networks that are used to support wireless point-of-sale terminals in retail locations. The IS auditor has observed that these wireless networks do not broadcast SSID, and they employ Wired Equivalent Privacy encryption with 64-bit keys that are changed each quarter. What action should the auditor take?",
    "choice_a": "Recommend that better encryption be used.",
    "choice_b": "Recommend that keys be changed more often.",
    "choice_c": "Recommend that longer keys be used.",
    "choice_d": "Recommend that SSIDs be broadcast.",
    "correct_answer": "A",
    "explanation": "The Wi-Fi networks in this example are using WEP (Wired Equivalent Privacy), which is inadequate for protecting wireless networks, especially those supporting financial transactions. WPA2 or another stronger method should be used.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      212,
      224,
      208,
      209,
      183
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 309,
    "question": "How do centralized monitoring systems typically use networks to assist in monitoring and managing devices?",
    "choice_a": "By periodically sending configuration data across the network to an administrator",
    "choice_b": "By using monitoring consoles that can send alert messages to the personnel who manage the systems being monitored",
    "choice_c": "By using host-based monitoring systems that require actual interactive logon by the network administrator",
    "choice_d": "By sending broadcast messages to other network devices",
    "correct_answer": "B",
    "explanation": "Monitoring systems typically alert technical personnel by sending messages via networks in the event of a system event, such as a performance issue.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      217,
      198,
      164,
      174,
      161
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 310,
    "question": "All of the following organization requirements are considered during the requirements definition phase of the system development life cycle (SDLC) <i>except</i>:",
    "choice_a": "Business functional requirements",
    "choice_b": "Technical requirements",
    "choice_c": "Code design",
    "choice_d": "Security and regulatory requirements",
    "correct_answer": "C",
    "explanation": "Code design is accomplished later in the SDLC during the design phase.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      119,
      115,
      151,
      152
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 311,
    "question": "All of the following statements are true regarding the construction and use of passwords <i>except</i>:",
    "choice_a": "Systems should require passwords of a minimum length (typically eight characters) and enforce complexity requirements.",
    "choice_b": "Systems should require that passwords be changed periodically, and forbid the use of recently used passwords.",
    "choice_c": "Passwords should never be transmitted through email or over clear-text methods.",
    "choice_d": "System administrators should have a listing of all users’ passwords in the event of a user’s termination or extended absence.",
    "correct_answer": "D",
    "explanation": "A password must never be shared with anyone, including a system administrator. In the event of a user’s absence or termination, the password can simply be reset to a new one.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      344,
      345,
      315,
      298,
      263
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 312,
    "question": "Which recovery and resilience technology is used when the recovery time objective (RTO) is much smaller than the time required to restore data from media?",
    "choice_a": "Replication",
    "choice_b": "Full backup",
    "choice_c": "RAID-0",
    "choice_d": "E-vaulting",
    "correct_answer": "A",
    "explanation": "Replication is often used for applications where the recovery time objective (RTO) is smaller than the time necessary to recover data from backup media. Replication ensures that up-to-date information is present on a remote storage system that can be put online in a short period.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      236,
      246,
      248
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 313,
    "question": "Which network access control protocol is used to control whether a system is permitted to connect to enterprise network resources?",
    "choice_a": "Kerberos",
    "choice_b": "IPsec",
    "choice_c": "802.11b",
    "choice_d": "802.1X",
    "correct_answer": "D",
    "explanation": "The 802.1X network access control protocol is used to control whether a system is permitted to connect to corporate network resources. 802.1X uses an authentication mechanism to determine whether each new device is permitted to connect. If the device lacks the necessary credentials, then it cannot logically connect to the network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      306,
      309,
      314,
      270
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 314,
    "question": "During which phase is the infrastructure assembled, tested, and placed into production use?",
    "choice_a": "Testing",
    "choice_b": "Procurement",
    "choice_c": "Implementation",
    "choice_d": "Configuration management",
    "correct_answer": "C",
    "explanation": "Infrastructure is usually installed and placed into production during the implementation phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      131,
      153,
      123,
      154
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 315,
    "question": "Which of the following statements concerning T-carrier circuits is true?",
    "choice_a": "T-carrier circuits are found only in Europe.",
    "choice_b": "T1 (also known as DS-1) circuits contain 24 DS-0 channels.",
    "choice_c": "North American T1 carrier standards are based on multiples of 32 circuits.",
    "choice_d": "The data rate of a T3 circuit is 1.544 Mbps.",
    "correct_answer": "B",
    "explanation": "T1 (also known as DS-1) circuits, found in North America, contain 24 DS-0 channels.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      211,
      208,
      215,
      201,
      187
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 316,
    "question": "All of the following are centralized fire suppression systems <i>except</i>:",
    "choice_a": "Wet pipe systems",
    "choice_b": "Deluge systems",
    "choice_c": "Inert gas",
    "choice_d": "Handheld fire extinguishers",
    "correct_answer": "D",
    "explanation": "Using handheld fire extinguishers is a stand-alone, or decentralized, means of extinguishing a fire.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      332,
      331,
      349,
      329,
      337
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 317,
    "question": "A stand-alone storage system that can be configured to contain several virtual volumes and to connect to several servers through fiber optic cables, and is seen as “local” storage by servers’ operating systems, is called a(n):",
    "choice_a": "Storage area network (SAN)",
    "choice_b": "Network attached storage (NAS)",
    "choice_c": "Logical server cluster",
    "choice_d": "Active-active server cluster",
    "correct_answer": "A",
    "explanation": "A storage-area network (SAN) is a stand-alone storage system that can be configured to contain several virtual volumes and to connect to several servers through fiber optic cables. The servers’ operating systems will consider this storage to be “local,” as if it consisted of one or more hard disks present in the server’s own chassis.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      210,
      203,
      183,
      163
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 318,
    "question": "Which application controls validate data for authorization, reasonableness, completeness, and integrity?",
    "choice_a": "Data file controls",
    "choice_b": "Processing controls",
    "choice_c": "Input controls",
    "choice_d": "Error handling controls",
    "correct_answer": "C",
    "explanation": "While data file, processing, and error handling controls are checked at various stages during a transaction, input controls handle validation of initial authorization, reasonableness, completeness, and integrity of data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      143,
      144,
      145,
      148,
      146
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 319,
    "question": "Firewalls are normally placed at all of the following locations <i>except</i>:",
    "choice_a": "Between the internal network and the Internet",
    "choice_b": "Between the internal network and the DMZ network",
    "choice_c": "Between user workstations and an internal file server",
    "choice_d": "Between separate zones of trust on an internal network",
    "correct_answer": "C",
    "explanation": "There are many locations in a network where a firewall is typically placed; access and other technical problems may arise when placing a firewall directly between users and the resources they require to perform their job functions. Access controls such as object permissions can be used to protect shared file resources and normally would not require a firewall.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      270,
      309,
      320,
      321
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 320,
    "question": "All of the following should be considered when determining if an individual requires access to sensitive or classified information <i>except</i>:",
    "choice_a": "Rank or position within the organization",
    "choice_b": "Need to know",
    "choice_c": "Security clearance level",
    "choice_d": "If access to the information is required to perform one’s job functions",
    "correct_answer": "A",
    "explanation": "Need to know, security clearance level, and the necessity for performing work are all considerations for requiring access to classified information. A person’s rank, status, or position in the organization should not determine whether they receive access to restricted or sensitive information. Even a vice president of one division may not have a need to know or clearance for information used in another division.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      311,
      262,
      309,
      256
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 321,
    "question": "An examination of IS, security, or business controls to determine control existence and effectiveness, and that concentrates on the IS management of a business process or on the business process itself, is known as what type of audit?",
    "choice_a": "Financial audit",
    "choice_b": "Operational audit",
    "choice_c": "Integrated audit",
    "choice_d": "Compliance audit",
    "correct_answer": "B",
    "explanation": "An operational audit is the only one that is an examination of IS, security, or business controls to determine control existence and effectiveness, and concentrates on the IS management of a business process.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      86,
      361,
      90,
      94,
      84
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 322,
    "question": "Which type of water-pipe fire suppression method is usually considered best for data centers?",
    "choice_a": "Dry pipe",
    "choice_b": "Wet pipe",
    "choice_c": "Pre-action",
    "choice_d": "Deluge",
    "correct_answer": "C",
    "explanation": "A pre-action system is used in areas where there are high-value assets, such as computer equipment, and delays water from being released out of the pipes until a certain temperature is met.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      332,
      349,
      331,
      333,
      329
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 323,
    "question": "Which of the following is <i>not</i> a controls framework?",
    "choice_a": "ISO/IEC 27002",
    "choice_b": "ISO/IEC 20000",
    "choice_c": "CIS CSC",
    "choice_d": "NIST 800-53",
    "correct_answer": "B",
    "explanation": "ISO/IEC 20000 is the standard for IT service management. ISO/IEC 27002, CIS CSC, and NIST 800-53 are control frameworks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      2,
      37,
      40,
      24
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 324,
    "question": "What is the primary disadvantage of simulation disaster recovery (DR) testing?",
    "choice_a": "A simulation does not evaluate the organization’s actual ability to recover from a disaster.",
    "choice_b": "The risks associated with a simulation test are high.",
    "choice_c": "The high cost of simulation testing is rarely worth it.",
    "choice_d": "It is difficult to develop a realistic simulation.",
    "correct_answer": "A",
    "explanation": "A simulation test can be thought of as a fancy, scripted walkthrough. A simulation helps the test participants expand their thinking about recovery operations, but IT systems are not actually tested.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      236,
      249,
      245,
      237,
      234
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 325,
    "question": "In addition to controlling outgoing hardware to minimize theft from an organization, controlling incoming hardware can help prevent which of the following attacks?",
    "choice_a": "Physically connecting sniffers or other malicious systems to the network",
    "choice_b": "Equipment replacement",
    "choice_c": "Sabotage",
    "choice_d": "Brute-force password attacks",
    "correct_answer": "A",
    "explanation": "If an attacker has access to the physical network and can directly connect sniffing tools to the network, these tools can be used to steal information or launch other forms of attack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      334,
      320,
      337,
      266
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 326,
    "question": "Who acts as the single point of contact for customer requests?",
    "choice_a": "IT manager",
    "choice_b": "Network operations section",
    "choice_c": "CIO",
    "choice_d": "IT service desk",
    "correct_answer": "D",
    "explanation": "The IT service desk function handles incidents and service requests on behalf of customers by acting as a single point of contact. The service desk will perform end-to-end management of incidents and service requests (at least from the customer’s perspective) and be responsible for communicating the status to the customer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      176,
      161,
      175,
      184
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 327,
    "question": "How are emergency changes related to problem and incident management?",
    "choice_a": "The steps for the emergency change process are completely different from those established for normal problem and incident management.",
    "choice_b": "Emergency changes are often related to incidents or problems, and can reference those issues so they can be closed.",
    "choice_c": "Emergency changes fall under incident response procedures, not under the normal problem management processes.",
    "choice_d": "Emergency changes are not related to problem and incident management, and are handled outside the normal problem management process due to urgency and necessity.",
    "correct_answer": "B",
    "explanation": "Emergency changes to software and hardware should be managed under the same processes as incidents and problems, since they are usually related to or caused by these issues, and can be closed in the trouble ticket management system as a normal problem or incident would be.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      173,
      168,
      165,
      166,
      169
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 328,
    "question": "An organization is considering upgrades to its network backbone. Which aspects of its architecture should be considered?",
    "choice_a": "Physical security, power, compatibility with standards, and cost",
    "choice_b": "Physical security, compatibility, cost, and operations and support",
    "choice_c": "Physical security, power, compatibility with standards, and operations and support",
    "choice_d": "Power, compatibility with standards, operations and support, and cost",
    "correct_answer": "C",
    "explanation": "When considering any upgrade to IT infrastructure, it is crucial to consider the existing architecture, including physical security, size and weight, power requirements, compatibility with existing and future standards, and operations and support.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      129,
      128,
      134,
      131,
      102
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 329,
    "question": "Which term is associated with restrictions on the database that will not permit a program (or user) to delete rows from a table if there are records in other tables whose foreign keys reference the row to be deleted?",
    "choice_a": "Primary key",
    "choice_b": "Foreign key",
    "choice_c": "Referential integrity",
    "choice_d": "Join",
    "correct_answer": "C",
    "explanation": "Referential integrity is a term that means that data in one table cannot be deleted if it refers to or is linked to data in another table through a primary-foreign key relationship. Referential integrity is enforced for data consistency in a relational database management system (RDBMS).",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      178,
      186,
      177,
      180,
      179
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 330,
    "question": "All of the following are components of a business case <i>except</i>:",
    "choice_a": "Risk",
    "choice_b": "Business problem",
    "choice_c": "High-level project plan",
    "choice_d": "Technical specifications",
    "correct_answer": "D",
    "explanation": "Technical specifications are usually not developed at that point in the process but come later in systems development within the system development life cycle (SDLC).",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      102,
      116,
      119,
      117,
      100
    ],
    "source": "288380_Practice Exam 1"
  },
  {
    "id": 331,
    "question": "All of the following statements accurately describe the relationships of an organization’s policies, procedures, and standards to the overall IT strategy and legal requirements <i>except</i>:",
    "choice_a": "Procedures detail legal and strategic requirements.",
    "choice_b": "IT strategies are developed that must support legal requirements as well as the business goals and requirements.",
    "choice_c": "Policies are made to direct what must be done to support strategies and legal requirements.",
    "choice_d": "Standards are developed or adopted to enforce a level of compliance to strategic or legal requirements.",
    "correct_answer": "A",
    "explanation": "They all describe the relationships between policies, procedures, standards, and legal requirements and IT strategy. Procedures do not typically detail legal and strategic requirements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      15,
      12,
      14,
      1
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 332,
    "question": "What is the first step in the risk management life cycle?",
    "choice_a": "Identifying risks",
    "choice_b": "Identifying assets",
    "choice_c": "Identifying mitigations",
    "choice_d": "Reducing risk",
    "correct_answer": "B",
    "explanation": "The first step in the risk management life cycle is to identify organizational assets, such as facilities, equipment, and data. These assets may be tangible or intangible, physical, logical, or virtual.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      16,
      18,
      20,
      22
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 333,
    "question": "Which of the following would <i>not</i> be relied on by multifactor authentication to successfully authenticate an individual?",
    "choice_a": "Something you know (e.g., a PIN)",
    "choice_b": "Something you have (e.g., smartcard, token)",
    "choice_c": "Something you are (e.g., fingerprint, voice recognition pattern)",
    "choice_d": "Something you calculate (e.g., hash value)",
    "correct_answer": "D",
    "explanation": "Multifactor authentication employs something you know (e.g., a password or PIN), something you have (e.g., a smartcard or token—including a soft token on a smartphone), and something you are (e.g., fingerprint, voice recognition, handprint, iris scan). Something you calculate (e.g., hash value) is not a part of multifactor authentication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      316,
      314,
      343,
      344
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 334,
    "question": "An audit of an organization’s business continuity and disaster recovery programs should include all of the following <i>except</i>:",
    "choice_a": "Review of all documentation",
    "choice_b": "Interviews with all key personnel",
    "choice_c": "An evaluation of processes and procedures",
    "choice_d": "A requirement that the organization initiate an unplanned cutover test",
    "correct_answer": "D",
    "explanation": "During an audit of an organization’s business continuity and disaster recovery programs, auditors should examine program documentation, interview personnel, and evaluate relevant processes and procedures. Requiring the organization to undergo an unplanned cutover test is unnecessary and wastes resources, and it could cause unplanned downtime.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      246,
      252
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 335,
    "question": "Which crime is made possible by the proliferation of private information and the failure to adequately secure that information?",
    "choice_a": "Identity theft",
    "choice_b": "Hacking",
    "choice_c": "Invasion of privacy",
    "choice_d": "Phishing",
    "correct_answer": "A",
    "explanation": "Identity theft is a widespread crime caused by the failure to protect personal information. Hacking and phishing are two methods used to gain nonsecure personal information, and invasion of privacy can result from identity theft as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      294,
      292,
      298,
      296,
      297
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 336,
    "question": "How should physical media containing highly sensitive information be packaged and transported?",
    "choice_a": "In a double-wrapped package; by regular mail",
    "choice_b": "In a double-wrapped package; using a courier and requiring a signature by the recipient",
    "choice_c": "Wrapped with an inner and outer envelope; by messenger",
    "choice_d": "None of the above; send electronically only",
    "correct_answer": "B",
    "explanation": "Physical media (drives, optical discs, etc.) containing sensitive information should be double-wrapped, sent by courier, and packaged accordingly, and a receipt signature should be required.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      321,
      304,
      334,
      337,
      296
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 337,
    "question": "When is risk management introduced into a project?",
    "choice_a": "During a feasibility study",
    "choice_b": "During business case development",
    "choice_c": "When the project is initiated",
    "choice_d": "At each project milestone review",
    "correct_answer": "B",
    "explanation": "Risk management must begin before the project starts, during business case development, so that risks can be identified and defined adequately, and risk assessment and treatment can begin.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      102,
      113,
      101,
      150,
      151
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 338,
    "question": "Which type of audit is an examination of the organization’s accounting system, including accounting department processes and procedures?",
    "choice_a": "Operational audit",
    "choice_b": "Integrated audit",
    "choice_c": "IS audit",
    "choice_d": "Financial audit",
    "correct_answer": "D",
    "explanation": "The objective of a financial audit is to determine whether business controls are sufficient to ensure the integrity of financial statements. The other terms are associated with other types of audits.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      86,
      88,
      81,
      84,
      68
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 339,
    "question": "Which of the following practices is <i>not</i> considered to be effective regarding software licensing?",
    "choice_a": "Software licensing policies",
    "choice_b": "Allowing users to install only legally licensed software brought from home",
    "choice_c": "Software metering",
    "choice_d": "Centralized software management and procurement",
    "correct_answer": "B",
    "explanation": "Allowing users to bring software from home is not only ineffective, but it can actually create software licensing issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      204,
      219,
      218,
      185
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 340,
    "question": "Which level of RAID creates a “mirror,” where data written to one disk in the array is also written to a second disk in the array, making the volume more reliable through the preservation of data even when one disk in the array fails?",
    "choice_a": "RAID-1",
    "choice_b": "RAID-6",
    "choice_c": "RAID-5",
    "choice_d": "RAID-0",
    "correct_answer": "A",
    "explanation": "RAID-1 is the standard that creates a mirror. The other RAID levels provide varying degrees of data redundancy and performance using data “striping,” but do not use disk mirroring.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      183,
      239,
      196,
      161
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 341,
    "question": "Which of the following forms of attack perpetrated through email contains messages that advertise legitimate goods and services as well as fakes and could contain malware?",
    "choice_a": "Spam",
    "choice_b": "Phishing",
    "choice_c": "Spoofing",
    "choice_d": "Trojan horses",
    "correct_answer": "A",
    "explanation": "Spam refers to large volumes of email traffic, some containing harmless messages or advertising fake goods and services, and some containing malware.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      292,
      298,
      258,
      294,
      300
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 342,
    "question": "Of the four possible methods for risk treatment, which one typically involves the use of insurance, which is used to compensate the organization for the financial losses or damages that occur if the threat were realized?",
    "choice_a": "Risk reduction",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transfer",
    "choice_d": "Risk avoidance",
    "correct_answer": "C",
    "explanation": "Only risk transfer involves using insurance to compensate an organization financially in the event of loss due to the exercise of a threat. In this case, the risk is transferred to the insurance company, which assumes the financial loss in the event of a flood, hurricane, or theft, for example.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      96,
      73,
      75,
      72,
      78
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 343,
    "question": "All of the following are characteristics of the TCP protocol <i>except</i>:",
    "choice_a": "Establishes a connection between two hosts",
    "choice_b": "Uses sequence numbers to guarantee segment delivery in the correct order",
    "choice_c": "Used for data transfers requiring high integrity",
    "choice_d": "Connectionless protocol",
    "correct_answer": "D",
    "explanation": "TCP is a connection-oriented protocol, not a connectionless protocol.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      208,
      207,
      200,
      192,
      177
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 344,
    "question": "Which of the following is a formal statement of the terms of employment, facts about the organization, benefits, compensation, conduct, and other policies?",
    "choice_a": "Offer letter",
    "choice_b": "Welcome letter",
    "choice_c": "Employee handbook",
    "choice_d": "Performance evaluation",
    "correct_answer": "C",
    "explanation": "The employee handbook is a collection of policies and other information disseminated to employees, and it may contain information on compensation, standards of conduct, benefits, security, and other items. The other documents do not fulfill this same purpose.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      29,
      54,
      1,
      27,
      44
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 345,
    "question": "An organization’s incident management procedure lacks any steps for determining an incident’s root cause. What is the best statement that describes the result of this?",
    "choice_a": "Without knowing the root cause, the organization will have a difficult time making structural improvements.",
    "choice_b": "Root cause analysis is more closely related to change management.",
    "choice_c": "Root cause analysis is more closely related to configuration management.",
    "choice_d": "Root cause analysis does not help an organization make improvements.",
    "correct_answer": "A",
    "explanation": "An organization that does not attempt to determine the root cause of its incidents is doomed to repeat those incidents and see little improvement in its operations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      173,
      164,
      161,
      183
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 346,
    "question": "An auditor is examining business records related to the creation of computer user accounts. While gathering samples, the auditor has noticed that several items are related to high-privilege access. What sampling approach should the auditor take in this case?",
    "choice_a": "Stop-or-go sampling",
    "choice_b": "Attribute sampling",
    "choice_c": "Statistical sampling",
    "choice_d": "Judgmental sampling",
    "correct_answer": "D",
    "explanation": "The auditor should not rely solely on statistical sampling. Instead, the auditor should judgmentally choose more of the privileged user accounts. The reason for this is that privileged user accounts allow users to perform higher-risk activities. Because of the higher risks associated with these accounts, more of them should be selected to ensure that the user account creation process is effective.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      92,
      90,
      95,
      89,
      74
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 347,
    "question": "Why are automatic controls preferred over manual controls?",
    "choice_a": "Automatic controls function without human intervention.",
    "choice_b": "Automatic controls cost less to operate.",
    "choice_c": "Automatic controls are faster.",
    "choice_d": "Logs from automatic controls can be retained longer.",
    "correct_answer": "A",
    "explanation": "When properly designed and implemented, automatic controls are more accurate and reliable than manual controls, but the cost and speed of controls is not always better with automatic controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      76,
      94,
      72
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 348,
    "question": "Intrusion detection systems can be classified in which of the following ways?",
    "choice_a": "Network-based IDS (NIDS) or host-based IDS (HIDS)",
    "choice_b": "Internal or external",
    "choice_c": "Software or hardware",
    "choice_d": "Signature-based or heuristics-based",
    "correct_answer": "A",
    "explanation": "Intrusion detection systems are normally classified as either network-based IDS (NIDS) or host-based IDS (HIDS), which identifies whether they reside on the network or on an individual host.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      266,
      265,
      320,
      305
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 349,
    "question": "An auditor who is auditing an account-receivable process and underlying IT systems should examine all of the following <i>except</i>:",
    "choice_a": "Source code",
    "choice_b": "Process architecture",
    "choice_c": "Procedures and records",
    "choice_d": "System architecture",
    "correct_answer": "A",
    "explanation": "When an auditor is examining a business process, the auditor will want to examine the process charter, architecture, process and procedure documents, and business records. An auditor will rarely, if ever, need to examine system source code.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      84,
      91,
      88,
      71
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 350,
    "question": "All of the following activities should be practiced by an organization in managing its software licensing program <i>except</i>:",
    "choice_a": "Develop acceptable use policy.",
    "choice_b": "Allow employees to take home licensed software for “personal use.”",
    "choice_c": "Centralize procurement.",
    "choice_d": "Implement software metering.",
    "correct_answer": "B",
    "explanation": "Acceptable use policy, centralized procurement, and software metering are practices that organizations should implement in their software licensing management program. Allowing employees to use software at home for “personal use” may violate licensing agreements unless specifically allowed in such agreements.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      204,
      219,
      161,
      223,
      181
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 351,
    "question": "Which automated technique is frequently used to gather sample data from complex information systems?",
    "choice_a": "Computer-assisted audit techniques (CAATs)",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Downloading configuration files from network devices",
    "choice_d": "Exporting IS databases",
    "correct_answer": "A",
    "explanation": "CAAT (computer-assisted audit techniques) is the term used to describe using special tools or techniques to gather system data, including databases, operating system information, and configuration files.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      93,
      361,
      90,
      92,
      89
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 352,
    "question": "How do managers in IT organizations determine if their operations are effective?",
    "choice_a": "By measuring all aspects of operations that need to be measured, reviewing those measurements and reports, and carrying out management-directed changes",
    "choice_b": "By gathering customer satisfaction data",
    "choice_c": "By immediately reacting to business process changes",
    "choice_d": "By directing strategic business changes based upon the changes in the IT environment",
    "correct_answer": "A",
    "explanation": "Measuring performance is the method managers use to determine the effectiveness of operations; the measurements are then reviewed, and any necessary corrective changes are applied.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      161,
      175,
      176,
      164,
      183
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 353,
    "question": "The purpose of a cover letter in a written audit result is to:",
    "choice_a": "Specify the recipients of the audit report",
    "choice_b": "Describe the level of effort required to complete the audit",
    "choice_c": "Summarize the audit engagement and findings",
    "choice_d": "List ineffective processes found by the auditors",
    "correct_answer": "C",
    "explanation": "The purpose of an audit report cover letter is to provide a summary of the audit engagement and its results. The letter can also be used as evidence that the audit has taken place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      94,
      363,
      70,
      89,
      356
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 354,
    "question": "What is the term associated with the cost of a piece of equipment in the context of resource management?",
    "choice_a": "Depreciated value",
    "choice_b": "Asset value",
    "choice_c": "Replacement cost",
    "choice_d": "Salvage cost",
    "correct_answer": "B",
    "explanation": "These are values related to a piece of equipment that may be used in certain circumstances, but the asset value is the cost (usually the replacement cost, but not necessarily) of the item that is used in resource and risk management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      21,
      19,
      16,
      24,
      22
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 355,
    "question": "To make use of access controls to enforce database security, what must occur?",
    "choice_a": "Databases must authenticate the identity of users.",
    "choice_b": "The database tables must be encrypted.",
    "choice_c": "SQL queries to and from the database must be encrypted.",
    "choice_d": "Permissions at the table and field levels must be enforced.",
    "correct_answer": "A",
    "explanation": "Access controls can be enforced only if the user is properly identified, and then database control mechanisms, such as roles and permissions, are applied to the user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      177,
      178,
      227,
      226
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 356,
    "question": "Which of the following terms describes a cryptographic operation on a block of data that returns a fixed-length string of characters, used to verify the integrity of a message?",
    "choice_a": "Encrypt",
    "choice_b": "Decrypt",
    "choice_c": "Digital signing",
    "choice_d": "Hash function",
    "correct_answer": "D",
    "explanation": "A hash function is a cryptographic operation on a block of data that returns a fixed-length string of characters, used to verify the integrity of a message. This produces a message digest, which is the result of a cryptographic hash function.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      285,
      286,
      282,
      253,
      257
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 357,
    "question": "What is the main purpose of a social media policy?",
    "choice_a": "Protection of proprietary information",
    "choice_b": "Worker productivity",
    "choice_c": "Malware protection",
    "choice_d": "Ransomware",
    "correct_answer": "A",
    "explanation": "Social media policy primarily exists so that workers do not share company secrets. While excessive use of social media may affect worker productivity, this is not usually the main reason for a social media policy. Malware and ransomware are threats handled with other controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      8,
      9,
      15,
      1
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 358,
    "question": "An IS auditor is evaluating a change management process and has observed that there are no records for emergency changes present. How should the auditor respond?",
    "choice_a": "Determine that change management is effective since it does not contain records of emergency changes.",
    "choice_b": "Determine that change management is ineffective since it does not contain records of emergency changes.",
    "choice_c": "Look for emergency change records in the configuration management system.",
    "choice_d": "Look for emergency change records in the incident management system.",
    "correct_answer": "B",
    "explanation": "It would be difficult to believe that an organization had no emergency changes in its environment. If an auditor finds no records of emergency changes, then the auditor could reasonably conclude that emergency changes are not being recorded in the change management system. The incident and configuration management systems are not the appropriate place for recording emergency change management information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      168,
      167,
      166,
      165,
      173
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 359,
    "question": "The purpose for retaining quiz scores in security awareness training is:",
    "choice_a": "To eliminate the ability for a user to claim they weren’t aware of security principles",
    "choice_b": "To calculate salary increases",
    "choice_c": "To identify the most security-savvy workers in the organization",
    "choice_d": "To reward workers at the end of the year",
    "correct_answer": "A",
    "explanation": "Retaining quiz scores for workers denies them the ability to claim that they were not aware of organization policies and other content delivered in the security awareness program.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      303,
      340,
      298,
      263,
      264
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 360,
    "question": "Which of the following is <i>not</i> a benefit of enforcing mandatory vacations on an organization’s personnel?",
    "choice_a": "Reduced likelihood of the employee performing prohibited activities",
    "choice_b": "Opportunity to audit the employee’s work",
    "choice_c": "Opportunity to train other employees to increase skills on a process or system",
    "choice_d": "Loss of knowledge and experience in key areas during the employee’s absence",
    "correct_answer": "D",
    "explanation": "All are advantages of enforcing mandatory vacations. Loss of knowledge and experience is <i>not</i> a benefit to be gained from mandatory leaves of absence.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      27,
      44,
      5,
      42
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 361,
    "question": "An auditor has discovered that several administrators share the administrative account in a hypervisor. All of the following are risks associated with this practice <i>except</i>:",
    "choice_a": "It is impossible to determine accountability for administrators’ actions.",
    "choice_b": "It is more difficult to determine who performed specific actions.",
    "choice_c": "An intruder will be able to crack the administrative password more easily.",
    "choice_d": "The organization faces compliance risk because most security standards and regulations forbid shared accounts.",
    "correct_answer": "C",
    "explanation": "That an intruder will be able to crack the administrative password more easily is <i>not</i> a risk associated with the sharing of a hypervisor admin account.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      340,
      304,
      268,
      315,
      344
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 362,
    "question": "When a database’s use is restricted so that personnel have only the permissions and privileges needed to perform their job, which access control principle is being followed?",
    "choice_a": "Mandatory access control",
    "choice_b": "Split custody",
    "choice_c": "Least privilege",
    "choice_d": "Separation of duties",
    "correct_answer": "C",
    "explanation": "The principle of least privilege states that users should have only the permissions and privileges needed to perform their job, and no more. When a database is restricted using views, permissions, and roles, this principle is being enforced, as these mechanisms allow only the actions and access to the data the user requires in performing their job.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      314,
      262,
      340
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 363,
    "question": "Which of the following sets ensures accurate data conversion?",
    "choice_a": "Record counts, batch totals, and checksums",
    "choice_b": "Field padding and truncation",
    "choice_c": "Sum, count, and aggregate functions",
    "choice_d": "Data type conversion and error checking",
    "correct_answer": "A",
    "explanation": "Record counts, batch totals, and checksums can assist in verifying the accuracy and integrity of data conversion.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      148,
      145,
      146,
      143,
      122
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 364,
    "question": "An auditor is reviewing a computer access provisioning process and is examining records. Because some of the records in this process are for the provisioning of administrative accounts, the auditor chooses to select more of those records to ensure that there were proper approvals. What type of sampling is the auditor performing?",
    "choice_a": "Weighted",
    "choice_b": "Arbitrary",
    "choice_c": "Statistical",
    "choice_d": "Judgmental",
    "correct_answer": "D",
    "explanation": "The auditor is practicing judgmental sampling, where the auditor will deliberately choose certain samples because of their risk. The other techniques are used in different circumstances.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      88,
      89,
      95
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 365,
    "question": "Which device operates at layer 2 of the OSI model and is concerned with listening to traffic to learn the MAC address(es) associated with each of its ports and sending packets only to destination ports?",
    "choice_a": "Router",
    "choice_b": "Bridge",
    "choice_c": "Switch",
    "choice_d": "CSU/DSU",
    "correct_answer": "C",
    "explanation": "Switches are the layer 2 network devices that transmit packets based on MAC addresses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      208,
      210,
      215,
      207,
      228
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 366,
    "question": "Which of the following protocols may be used to encrypt a remote access connection?",
    "choice_a": "IPsec",
    "choice_b": "MD5",
    "choice_c": "SHA1",
    "choice_d": "FISH",
    "correct_answer": "A",
    "explanation": "IPsec (IP Security) is the only protocol listed that is specifically designed to encrypt communication sessions over networks. MD5 and SHA1 are hashing algorithms, and FISH is a stream cipher.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      273,
      319,
      282,
      283,
      286
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 367,
    "question": "The primary objective of a control self-assessment is to:",
    "choice_a": "Reduce the requirements for auditing",
    "choice_b": "Reduce the need for trained auditors",
    "choice_c": "Transfer some of the responsibility for oversight of controls to the control owners",
    "choice_d": "Prepare for an external audit",
    "correct_answer": "C",
    "explanation": "Control self-assessments are conducted primarily to involve the control owners in the risk assessment and treatment processes. A control self-assessment (CSA) in no way reduces the requirements for auditing or the need for trained auditors. Auditing requirements will still exist, perhaps by statute or regulation. Trained auditors will still need to fulfill their roles as required by these laws and regulations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      354,
      359,
      361,
      60
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 368,
    "question": "An auditor has discovered evidence of illegal activity during an audit. What is the auditor’s best course of action?",
    "choice_a": "Immediately notify the audit client.",
    "choice_b": "Include the finding and related evidence in the audit report.",
    "choice_c": "Immediately notify the board of directors or the audit committee.",
    "choice_d": "Immediately notify law enforcement.",
    "correct_answer": "C",
    "explanation": "The audit client may be involved in the illegal activity and should be bypassed; it’s important to notify instead the highest management in the organization: its board of directors, or the audit committee (which typically consists of board of directors members).",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      70,
      69,
      354,
      364,
      95
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 369,
    "question": "Which internationally accepted IT standard is used for global Internet communication?",
    "choice_a": "NIST standard",
    "choice_b": "FIPS standard",
    "choice_c": "IPX/SPX protocol",
    "choice_d": "TCP/IP protocol",
    "correct_answer": "D",
    "explanation": "The global Internet protocol standard used for communication is the TCP/IP protocol. The other choices are protocols and standards used in other specific areas.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      2,
      3,
      4
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 370,
    "question": "Which of the following risk analysis methods is the most appropriate to use in an organization that requires an additional analysis of higher-ranked risks?",
    "choice_a": "Qualitative risk analysis",
    "choice_b": "Probability analysis",
    "choice_c": "Quantitative risk analysis",
    "choice_d": "Impact analysis",
    "correct_answer": "C",
    "explanation": "A quantitative risk analysis is used when a more in-depth or concrete understanding of risk is needed in areas of higher-ranked risks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      21,
      20,
      24,
      22,
      16
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 371,
    "question": "Which sampling technique is used when an IS auditor is trying to find at least one exception in a population?",
    "choice_a": "Variable sampling",
    "choice_b": "Stop-or-go sampling",
    "choice_c": "Discovery sampling",
    "choice_d": "Statistical sampling",
    "correct_answer": "C",
    "explanation": "Discovery sampling is a technique used when an IS auditor is trying to find at least one exception in a population. When an IS auditor is examining a population where even a single exception would represent a high-risk situation (such as embezzlement or fraud), the auditor will recommend a more intensive investigation to determine whether additional exceptions exist.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      95,
      362,
      88
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 372,
    "question": "A risk analysis that is carried out by an auditor is distinct and separate from the risk analysis that is performed as part of the IS risk management program in all of the following ways <i>except</i>:",
    "choice_a": "Perspective.",
    "choice_b": "Focus of risk assessment.",
    "choice_c": "It identifies a high risk in an existing control.",
    "choice_d": "It identifies a low risk in an existing control.",
    "correct_answer": "D",
    "explanation": "These are ways that the risk analysis performed by an auditor is different from one performed by the IS risk management function. A low risk with an existing control applied is likely to be treated similarly in either case.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      78,
      72,
      96,
      75,
      76
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 373,
    "question": "Which value of an asset is used in risk analysis?",
    "choice_a": "Estimated replacement value",
    "choice_b": "Actual depreciated value",
    "choice_c": "Asset value, plus downtime in event of a loss",
    "choice_d": "Asset value, plus value of data associated with asset",
    "correct_answer": "B",
    "explanation": "The actual depreciated value is used during risk analysis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      21,
      20,
      24,
      16,
      19
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 374,
    "question": "Which process specifically involves testing and installing new security and other relevant software updates?",
    "choice_a": "Risk management",
    "choice_b": "Patch management",
    "choice_c": "Incident response",
    "choice_d": "Change management",
    "correct_answer": "B",
    "explanation": "Patch management involves identifying, testing, installing, and fielding security patches and other relevant software updates.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      172,
      183,
      168,
      170,
      161
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 375,
    "question": "Which formula describes risk in simple terms?",
    "choice_a": "Risk = annualized loss expectancy (ALE) × exposure factor (EF)",
    "choice_b": "Risk = single loss expectancy (SLE) × exposure factor (EF)",
    "choice_c": "Risk = probability × impact",
    "choice_d": "Risk = vulnerability (V) × exposure factor (EF)",
    "correct_answer": "C",
    "explanation": "Risk is measured in terms of probability and impact.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      21,
      16,
      24,
      52
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 376,
    "question": "Which two network entry points can potentially be used to circumvent logical and network access controls?",
    "choice_a": "Web server and email server",
    "choice_b": "Intranet server and extranet server",
    "choice_c": "Border router and firewall",
    "choice_d": "Wireless connections and modems",
    "correct_answer": "D",
    "explanation": "Unauthorized and poorly protected Wi-Fi access points in an office or data center and network backdoors in the form of dial-in modems both represent entry points into a network that can be used to bypass security mechanisms, such as firewalls.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      342,
      319,
      292,
      309
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 377,
    "question": "Storage media that is no longer required should be physically destroyed or disposed of by erasure using which of the following methods?",
    "choice_a": "Using a degaussing magnet",
    "choice_b": "Erasing under DoD 5220.22-M specifications",
    "choice_c": "Formatting the media",
    "choice_d": "Deleting the data on the media",
    "correct_answer": "B",
    "explanation": "Data on media must be securely erased or wiped using specifications or guidelines meeting Department of Defense (DoD) 5220.22-M standards to ensure complete data destruction. Other methods listed do not completely or securely erase data from storage media.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      296,
      321,
      304,
      341,
      301
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 378,
    "question": "Which perspective of the standard IT balanced scorecard reports key indicators concerning the perception of IT department effectiveness and value as seen from other (non-IT) corporate executives?",
    "choice_a": "Business contribution",
    "choice_b": "Operational excellence",
    "choice_c": "Innovation",
    "choice_d": "User",
    "correct_answer": "A",
    "explanation": "In the business contribution perspective, key indicators are the perception of IT department effectiveness and value as seen from other (non-IT) corporate executives.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      3,
      2,
      51,
      6,
      1
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 379,
    "question": "Which of the following statements concerning viruses is true?",
    "choice_a": "Viruses are stand-alone programs capable of human-assisted and automatic propagation.",
    "choice_b": "Viruses are fragments of code that attach themselves to EXE files (executable programs) and are activated when the program they’re attached to is run.",
    "choice_c": "Viruses are programs that are purported to perform one function but that actually perform other (or additional) undesired functions.",
    "choice_d": "Viruses are designed to hide themselves from the operating system as well as evade detection by antivirus software, and are able to run “underneath” the operating system so that they are undetectable.",
    "correct_answer": "B",
    "explanation": "Viruses are fragments of code that attach themselves to EXE files (executable programs) and are activated when the program they’re attached to is run. Viruses are not stand-alone, but must attach themselves to an executable program. When the executable program executes, the virus code is executed.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      293,
      268,
      264,
      300,
      291
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 380,
    "question": "Which is the prevalent type of database system, rendering older database models obsolete?",
    "choice_a": "Relational",
    "choice_b": "Hierarchical",
    "choice_c": "Network",
    "choice_d": "Flat",
    "correct_answer": "A",
    "explanation": "The relational database model is the most prevalent model used today, and it is based on primary and foreign key relationships.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      179,
      177,
      186,
      227
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 381,
    "question": "All of the following are used to protect mobile devices <i>except</i>:",
    "choice_a": "Encryption",
    "choice_b": "Strong access control",
    "choice_c": "Allowing the device to be used only in a controlled area, such as a server room",
    "choice_d": "Remote data destruct",
    "correct_answer": "C",
    "explanation": "Encryption, strong access controls, and remote data destruction are all measures used to protect mobile devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      319,
      296,
      315,
      309
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 382,
    "question": "Which term is the foundation for IS controls and is a statement of desired states or outcomes from business operations?",
    "choice_a": "Control objective",
    "choice_b": "Administrative control",
    "choice_c": "Control family",
    "choice_d": "Control statement",
    "correct_answer": "A",
    "explanation": "Control objectives are the foundation for controls. For each control objective, there will be one or more controls that exist to ensure the realization of the control objective.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      80,
      363,
      88,
      89
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 383,
    "question": "How is a user’s public key verified?",
    "choice_a": "By verifying it with a ring of trust",
    "choice_b": "By contacting the public key’s owner",
    "choice_c": "By using the public key’s key fingerprint",
    "choice_d": "By using the certificate revocation list (CRL)",
    "correct_answer": "C",
    "explanation": "If a user wishes to verify a public key, the user retrieves the public key and calculates the key’s fingerprint. The user then contacts the claimed owner of the public key, who runs a function against their private key that returns a string of numbers. The user also runs a function against the owner’s public key, which returns a string of numbers. If both numbers match, the public key is genuine.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      284,
      287,
      285,
      282
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 384,
    "question": "What is the objective of war driving?",
    "choice_a": "To locate out-of-band connections into a network",
    "choice_b": "To locate dial-in modems on a network",
    "choice_c": "To locate nonsecure wireless networks that can be exploited",
    "choice_d": "To locate vulnerable ports and services on a network",
    "correct_answer": "C",
    "explanation": "War driving is used to detect and exploit wireless networks that have weak encryption or other security measures.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      292,
      320,
      268,
      266
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 385,
    "question": "What do you call the practice of setting organization security policy and then taking steps to ensure that policy is followed?",
    "choice_a": "Reporting management",
    "choice_b": "Security governance",
    "choice_c": "Policy enforcement",
    "choice_d": "Internal auditing",
    "correct_answer": "B",
    "explanation": "Security governance consists of setting the organization’s security policies and ensuring that the policies are enforced.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      5,
      1,
      8,
      9
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 386,
    "question": "Which recovery objective is a direct result of the frequency of data backup or replication?",
    "choice_a": "Recovery time objective (RTO)",
    "choice_b": "Recovery point objective (RPO)",
    "choice_c": "Recovery site objective (RSO)",
    "choice_d": "Restoral point objective (RPO)",
    "correct_answer": "B",
    "explanation": "The value of a system’s RPO (recovery point objective) target is a direct result of the frequency of backup or replication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      183,
      247,
      236,
      233
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 387,
    "question": "Which of the following best describes a token?",
    "choice_a": "A small, credit card–sized device that contains electronic memory and that is accessed with a smartcard reader, and that might contain a digital certificate or other identifying information that is difficult or impossible to reproduce",
    "choice_b": "An electronic document that uses a digital signature to bind a public encryption key with a user’s identity",
    "choice_c": "A numeric code used to gain access via a numeric touchpad",
    "choice_d": "A small electronic device that either displays a string of characters to be typed in to authenticate a user or contains information, such as a digital certificate, that is associated with the authentication",
    "correct_answer": "D",
    "explanation": "A token is a small electronic device (or mobile application) that either displays a string of characters to be typed in to authenticate a user or contains information, such as a digital certificate, that is associated with the authentication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      314,
      287,
      343,
      317,
      282
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 388,
    "question": "Which primary factor or factors determine the selection of a recovery site?",
    "choice_a": "The location of the recovery site and speed of application recovery",
    "choice_b": "The cost of the recovery site",
    "choice_c": "The distance from the recovery site to the nearest airport",
    "choice_d": "Service level agreements with reciprocal sites",
    "correct_answer": "A",
    "explanation": "The primary determining factors in selecting a recovery site are the speed at which a critical application can be recovered at the site and the location of the site itself.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      237,
      251,
      246,
      247,
      248
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 389,
    "question": "An auditor discovers a risk in a business process. What is the auditor’s best course of action?",
    "choice_a": "Communicate the risk but not any countermeasures.",
    "choice_b": "Suggest a list of possible countermeasures.",
    "choice_c": "Suggest the best countermeasure.",
    "choice_d": "Lead the remediation effort.",
    "correct_answer": "A",
    "explanation": "The auditor’s role is to document and report on risks, but not to solve them. It is not the auditor’s role to suggest countermeasures or remediate the risk.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      363,
      98,
      76,
      72,
      75
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 390,
    "question": "Which term describes a method where an IT organization charges for the services that it provides (usually through budget transfers but occasionally through real funds)?",
    "choice_a": "Account transfer",
    "choice_b": "Chargeback",
    "choice_c": "Payback",
    "choice_d": "Service fee",
    "correct_answer": "B",
    "explanation": "The term “chargeback” refers to the transfer of funds or budget from one internal organization to another for services provided, such as IT services. The other types of transactions fulfill other purposes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      32,
      27,
      2
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 391,
    "question": "Characteristics about audit evidence that contribute to its weight and reliability include all of the following <i>except</i>:",
    "choice_a": "Independence of the evidence provider",
    "choice_b": "Objectivity",
    "choice_c": "Qualifications of the evidence provider",
    "choice_d": "Subjectivity",
    "correct_answer": "D",
    "explanation": "Evidence should be independent of the provider, objective, and provided by a competent source. Evidence should not be subjective.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      70,
      95,
      99,
      362
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 392,
    "question": "Which of the following types of information would be considered public information?",
    "choice_a": "Passwords",
    "choice_b": "Mission statement",
    "choice_c": "Production statistics",
    "choice_d": "Employee records",
    "correct_answer": "B",
    "explanation": "Mission statements are broad statements that describe the organization’s purpose and can usually be found on a public website or other published information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      294,
      296,
      323,
      325
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 393,
    "question": "Video surveillance is an example of which type of control?",
    "choice_a": "Preventive only",
    "choice_b": "Preventive and deterrent",
    "choice_c": "Detective only",
    "choice_d": "Detective and deterrent",
    "correct_answer": "D",
    "explanation": "Video surveillance is both a detective control (because it can record unwanted activity) and a deterrent control (because its presence may deter unwanted activity).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      80,
      79,
      361,
      94,
      81
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 394,
    "question": "Which document describes in great detail the work that is to be performed to support a contract?",
    "choice_a": "Statement of work (SOW)",
    "choice_b": "Request for proposal (RFP)",
    "choice_c": "Request for information (RFI)",
    "choice_d": "Service level agreement (SLA)",
    "correct_answer": "A",
    "explanation": "Statements of work (SOWs), sometimes called work orders, describe in greater detail the work that is to be performed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      33,
      34,
      54,
      59
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 395,
    "question": "Which ISACA auditing guideline provides additional details regarding types of evidence, how evidence can be represented, and selecting and gathering evidence?",
    "choice_a": "1204, Materiality",
    "choice_b": "2207, Irregularities and Illegal Acts",
    "choice_c": "1205, Evidence",
    "choice_d": "2205, Evidence",
    "correct_answer": "D",
    "explanation": "2205, Evidence, is the appropriate audit guideline. The standards (1000 series) do not provide this information to this detail.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      71,
      90,
      68,
      69,
      70
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 396,
    "question": "An auditor has insufficient local storage to collect evidence during an audit. What is the auditor’s best course of action?",
    "choice_a": "Ask the auditee to email evidence to the auditor.",
    "choice_b": "Describe evidence observed in audit notes.",
    "choice_c": "Ask the auditee to upload the evidence to their personal cloud storage service.",
    "choice_d": "Collect the evidence when the auditor has sufficient storage to collect the evidence.",
    "correct_answer": "D",
    "explanation": "The evidence may contain sensitive information, so emailing it or storing it in a personal cloud service may be risky and may even be a violation of laws or regulations. Failure to collect the evidence would compromise the integrity of the audit. It’s best for the auditor to safely collect the evidence when they are able to do so.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      362,
      365,
      70,
      357
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 397,
    "question": "Official, management-approved statements that define the technologies, protocols, suppliers, and methods that are used by an IT organization are called:",
    "choice_a": "Standards",
    "choice_b": "Policies",
    "choice_c": "Procedures",
    "choice_d": "Regulations",
    "correct_answer": "A",
    "explanation": "IT standards are official, management-approved statements that define the technologies, protocols, suppliers, and methods that are used by an IT organization. Standards help drive consistency into the IT organization, which will make the organization more cost-efficient and cost-effective. Policies, procedures, and regulations fulfill different purposes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      8,
      1,
      2
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 398,
    "question": "When designing a wireless network infrastructure, an organization that wants to create a secure network should use all of the following methods <i>except</i>:",
    "choice_a": "Using the maximum signal strength possible",
    "choice_b": "MAC address filtering",
    "choice_c": "WPA2 encryption",
    "choice_d": "Disabling SSID broadcasting",
    "correct_answer": "A",
    "explanation": "Using the maximum signal strength often extends the wireless network beyond the bounds of a work facility, which can increase security risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      212,
      207,
      228,
      229,
      214
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 399,
    "question": "Which of the following is <i>not</i> a project closure activity?",
    "choice_a": "Project debrief",
    "choice_b": "Requirements definition",
    "choice_c": "Formal turnover",
    "choice_d": "Documentation archival",
    "correct_answer": "B",
    "explanation": "The definition of requirements occurs in the earliest phases of a project or SDLC.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      111,
      123,
      115,
      150,
      112
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 400,
    "question": "The objective of most information privacy laws is to:",
    "choice_a": "Regulate the usage and dissemination of sensitive personal information",
    "choice_b": "Define the categories of sensitive personal information",
    "choice_c": "Define the penalties for misuse of sensitive personal information",
    "choice_d": "Require encryption of sensitive personal information",
    "correct_answer": "A",
    "explanation": "The primary purpose of information privacy laws is to regulate how organizations use sensitive personal information that they collect, and to control how those organizations may transfer that information to other organizations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      65,
      64,
      67,
      62
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 401,
    "question": "Which ISACA audit standard covers the audit report, and what it should contain to communicate the results of the audit to the stakeholders?",
    "choice_a": "1201, Engagement Planning",
    "choice_b": "1203, Performance and Supervision",
    "choice_c": "1401, Reporting",
    "choice_d": "1402, Follow-up Activities",
    "correct_answer": "C",
    "explanation": "Standard 1401, Reporting, specifies that the audit report should follow an established format that includes a statement of scope, period of coverage, recipient organization, and controls or standards that were audited, as well as any limitations or qualifications. The audit report should document the process followed, inquiries, observations, evidence, findings, conclusions, and recommendations from the audit. The report should also contain sufficient evidence to support the findings of the audit. The other standards cover other aspects of audit that are not related to reporting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      94,
      70,
      364,
      363,
      89
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 402,
    "question": "An auditor is auditing a user account management process and has noted that access requestors are able to approve their own access requests. How should the auditor proceed?",
    "choice_a": "Notify audit client management immediately.",
    "choice_b": "Note the audit exception that requestors may approve their access requests in some cases.",
    "choice_c": "Examine business records to see whether there have been any instances of managers approving their own access requests.",
    "choice_d": "Continue with auditing, because there is no finding here.",
    "correct_answer": "B",
    "explanation": "Requestors should not be able to approve their own requests. Auditors will usually determine that an audit finding should be reported.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      91,
      94,
      362,
      71
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 403,
    "question": "What purpose does audit planning serve?",
    "choice_a": "It specifies the objectives and methods for an upcoming internal audit.",
    "choice_b": "It allows the organization’s auditors to plan which auditing methodology they will use for upcoming audits.",
    "choice_c": "It allows management to prioritize assets and processes for auditing within the audit window.",
    "choice_d": "It determines the audit activities that need to take place in the future, including an estimate on the resources (budget and manpower) required to support those activities.",
    "correct_answer": "D",
    "explanation": "Audit planning determines the audit activities that need to take place in the future, including an estimate on the resources (budget and labor) required to support those activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      85,
      61,
      63,
      359
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 404,
    "question": "Which of the following fire suppression methods is considered the best one for computer/data centers?",
    "choice_a": "Inert gas",
    "choice_b": "Class A fire extinguisher",
    "choice_c": "Dry pipe",
    "choice_d": "Deluge",
    "correct_answer": "A",
    "explanation": "Inert gas is a preferred extinguishing agent in data centers because its harm to computing equipment is minimal, especially when compared to alternatives, such as water and the contents of fire extinguishers.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      332,
      331,
      349,
      329,
      333
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 405,
    "question": "What are the two types of risk assessment used in auditing?",
    "choice_a": "High- and low-risk assessment",
    "choice_b": "Qualitative and quantitative",
    "choice_c": "Cost and mitigation",
    "choice_d": "Threat and impact",
    "correct_answer": "B",
    "explanation": "The two types of risk assessment commonly used are qualitative and quantitative.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      359,
      72,
      75,
      73
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 406,
    "question": "Privacy encompasses which activity or activities?",
    "choice_a": "Sharing personal information with government agencies",
    "choice_b": "Appropriate use of personal information",
    "choice_c": "Protection of personal information",
    "choice_d": "Protection and appropriate use of personal information",
    "correct_answer": "D",
    "explanation": "Privacy is primarily concerned with both the protection and the appropriate use of personal information.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      294,
      296,
      266,
      282,
      257
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 407,
    "question": "What is an electronic list of digital certificates that have been revoked prior to their expiration date called?",
    "choice_a": "Revocation authority",
    "choice_b": "Certification authority",
    "choice_c": "Certification practice statement (CPS)",
    "choice_d": "Certificate revocation list (CRL)",
    "correct_answer": "D",
    "explanation": "A certificate revocation list (CRL) is an electronic list of digital certificates that have been revoked prior to their expiration date.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      284,
      286,
      282
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 408,
    "question": "An auditor is auditing a computer user account provisioning process. After selecting a statistical sample, the auditor examines the samples to see how many requests were for administrative accounts. What type of sampling is the auditor performing?",
    "choice_a": "Discovery sampling",
    "choice_b": "Statistical sampling",
    "choice_c": "Variable sampling",
    "choice_d": "Attribute sampling",
    "correct_answer": "D",
    "explanation": "The auditor is performing attribute sampling, where the auditor wants to know how many items from their sample have a given characteristic (in this case, requests for administrative accounts). The other sampling techniques would be used for other circumstances.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      360,
      88,
      89
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 409,
    "question": "All of the following are security features that should be included in a database system design <i>except</i>:",
    "choice_a": "Views",
    "choice_b": "Encryption",
    "choice_c": "Multiple database administrators",
    "choice_d": "Audit logging",
    "correct_answer": "C",
    "explanation": "Views, encryption, and audit logging are security features that should be incorporated into a database design. The number of database administrators, however, should be kept to a bare minimum for security purposes, and a role-based access system should be used to limit the permissions of database users to the data and functions they require, and no more.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      186,
      178,
      227,
      226,
      177
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 410,
    "question": "Which network security system behaves like an IDS but goes one step further by selectively blocking malicious traffic and stopping an attack?",
    "choice_a": "Firewall",
    "choice_b": "Intrusion prevention system (IPS)",
    "choice_c": "Border router",
    "choice_d": "Web proxy",
    "correct_answer": "B",
    "explanation": "Intrusion prevention systems can detect anomalies on the network, like an IDS. However, an IPS is also able to block an offending system by instructing a network switch to disconnect it. This can be used to block both internal and external threats, whether they are intruders trying to break into a system or some malware that has been able to penetrate defenses on an organization-owned device.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      306,
      265,
      270,
      308
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 411,
    "question": "Which item in the post-implementation phase should be measured initially and again after several business cycles?",
    "choice_a": "Return on investment",
    "choice_b": "Configuration management",
    "choice_c": "System maintenance",
    "choice_d": "System changes",
    "correct_answer": "A",
    "explanation": "Return on investment must be measured initially and then measured again after the completion of several business cycles to determine if the product or system is generating the expected return that was initially forecast during the early phases of the project. The other activities are normal IT service management activities.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      123,
      102,
      116,
      122,
      115
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 412,
    "question": "The set of activities that ensures the efficient and effective delivery of IT services through active management and the continuous improvement of processes is known as:",
    "choice_a": "IT service management",
    "choice_b": "Business continuity planning",
    "choice_c": "Disaster recovery planning",
    "choice_d": "Incident response",
    "correct_answer": "A",
    "explanation": "IT service management (ITSM) is the set of activities that ensures the delivery of IT services is efficient and effective through active management and the continuous improvement of processes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      181,
      165,
      175,
      162,
      166
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 413,
    "question": "Which two elements are key to implementing secure remote access?",
    "choice_a": "Authentication and encryption",
    "choice_b": "Identification and encryption",
    "choice_c": "Encryption and permissions",
    "choice_d": "Identification and authorization",
    "correct_answer": "A",
    "explanation": "Two key requirements must be met to implement a remote access solution: authentication of the user (or, in some cases, even the device) and encryption of data traversing the remote access connection.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      319,
      315,
      314,
      273,
      343
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 414,
    "question": "An auditor needs to audit a financial transaction process to see whether it performs calculations correctly. Which type of testing should the auditor perform?",
    "choice_a": "End-to-end testing",
    "choice_b": "Substantive testing",
    "choice_c": "Stop-and-go testing",
    "choice_d": "Compliance testing",
    "correct_answer": "B",
    "explanation": "Substantive testing is used to confirm whether transactions are performed and calculated properly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      361,
      360,
      90,
      89
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 415,
    "question": "Which of the following tests should be conducted first when evaluating the effectiveness of disaster recovery plans?",
    "choice_a": "Document review",
    "choice_b": "Simulation",
    "choice_c": "Parallel test",
    "choice_d": "Cutover test",
    "correct_answer": "A",
    "explanation": "Usually, an organization will perform the less intensive tests (such as document reviews, walk-throughs, and simulations) first to identify the most obvious flaws, and follow with tests that require more effort and carry more risk.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      236,
      235,
      248,
      246,
      233
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 416,
    "question": "What is the primary disadvantage of a cutover disaster recovery (DR) test?",
    "choice_a": "A cutover test does not evaluate the organization’s actual ability to recover from a disaster.",
    "choice_b": "The risks associated with a cutover test are high.",
    "choice_c": "The costs associated with a cutover test are high.",
    "choice_d": "A cutover test can be performed only during an actual disaster.",
    "correct_answer": "B",
    "explanation": "The primary disadvantage of a cutover test is that it may induce a service interruption unless the test goes perfectly. This is because the primary production systems are shut down (or disconnected), and recovery systems are used to perform actual business transactions. If the recovery environment does not work properly, there may be disruptions in the business processes supported by the systems being tested.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      248,
      235
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 417,
    "question": "The term that describes the threshold where serious errors, omissions, irregularities, or illegal acts could occur is:",
    "choice_a": "Tolerance",
    "choice_b": "Auditing threshold",
    "choice_c": "Error limit",
    "choice_d": "Materiality",
    "correct_answer": "D",
    "explanation": "Materiality, in financial audits, is a dollar amount threshold that alters the results on an organization’s financial statements. In IS audits, materiality is the threshold where serious errors, omissions, irregularities, or illegal acts could occur.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      70,
      90,
      96,
      362,
      88
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 418,
    "question": "Which model can be used to determine the maturity level of an organization’s processes and focuses on whether an organization’s processes have a level of maturity associated with measurement and continuous improvement?",
    "choice_a": "Capability Maturity Model Integration (CMMI)",
    "choice_b": "Control Objectives for Information and related Technology (COBIT)",
    "choice_c": "IT Infrastructure Library (ITIL)",
    "choice_d": "ISO 9000",
    "correct_answer": "A",
    "explanation": "CMMI is an integrated capability maturity model that measures the maturity level of an organization’s processes. The other frameworks are not used to measure maturity.<br>This question comes from ISACA Certified Information Systems Auditor exam objective 2A and covers material discussed in Chapter 1.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      2,
      39,
      37,
      3
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 419,
    "question": "An organization has initiated a business relationship with an outsourced service provider. The service provider will carry out many projects for the organization. How should the organization define and initiate each project?",
    "choice_a": "Service level agreements",
    "choice_b": "Work orders",
    "choice_c": "Contracts",
    "choice_d": "Change orders",
    "correct_answer": "B",
    "explanation": "Work orders are essential documents that need to be in place between an organization and an external service provider. The correct way for an organization to initiate a new project with a service provider is with a work order, sometimes known as a statement of work (SOW). The other documents are essential for service provider relationships but serve other purposes.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      34,
      56,
      33,
      57,
      27
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 420,
    "question": "Which IT standards determine the rules for network communications used in an organization?",
    "choice_a": "Technology standards",
    "choice_b": "Protocol standards",
    "choice_c": "Architecture standards",
    "choice_d": "Configuration standards",
    "correct_answer": "B",
    "explanation": "Protocol standards specify the network communication protocols that the organization uses. For instance, an IT organization may opt to use TCP/IP v6 for its internal networks, IGRP for routing protocols, FTPS for file transfer, SSH for device management, and so on.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      15,
      14,
      2,
      37
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 421,
    "question": "Which level of project governance is responsible for approving the project, assigning IT resources to the project, and approving the project schedule, among other responsibilities?",
    "choice_a": "Senior management",
    "choice_b": "Project sponsor",
    "choice_c": "IT steering committee",
    "choice_d": "Project manager",
    "correct_answer": "C",
    "explanation": "While these levels of governance all have essential roles to fill, the IT steering committee is directly responsible for approving the project, assigning IT resources to the project, approving the project schedule, reviewing the project status, and taking corrective action when project priorities conflict.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      101,
      103,
      110,
      104,
      150
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 422,
    "question": "During which phase of the system development life cycle (SDLC) are requirements compared with the application design to ensure that they agree?",
    "choice_a": "Requirements definition phase",
    "choice_b": "Implementation phase",
    "choice_c": "Development phase",
    "choice_d": "Design phase",
    "correct_answer": "D",
    "explanation": "Depending on the SDLC model used, requirements may be added to or changed at various phases, but during the design phase, the suggested design is compared with the requirements to ensure that all requirements are addressed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      115,
      152,
      121,
      117
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 423,
    "question": "Who in the organization is legally responsible for overseeing the organization’s activities?",
    "choice_a": "Chief executive officer (CEO)",
    "choice_b": "Chief legal counsel",
    "choice_c": "Chief information security officer (CISO)",
    "choice_d": "Board of directors",
    "correct_answer": "D",
    "explanation": "The board of directors is legally responsible for overseeing the organization’s activities. The executive positions do have considerable responsibility, however.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      4,
      44,
      6,
      45,
      5
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 424,
    "question": "How do IT personnel determine whether incidents and problems are related to specific systems configurations?",
    "choice_a": "By manually checking all devices to determine if a configuration error exists",
    "choice_b": "By consulting with a hardware vendor to determine what the system’s default configuration should be",
    "choice_c": "By using an intelligent problem and incident management system that can access the configuration management database",
    "choice_d": "By running monitoring tools to determine if there is malicious traffic on the network",
    "correct_answer": "C",
    "explanation": "Using an intelligent problem and incident management system that can access the configuration management database (CMDB) will assist IT personnel in determining whether a problem stems from the baseline system environment or from an out-of-configuration issue.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      173,
      165,
      184,
      167
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 425,
    "question": "A seemingly harmless program that is supposed to perform one function but that actually performs another (or additional) undesired function is called a:",
    "choice_a": "Trojan horse",
    "choice_b": "Polymorphic virus",
    "choice_c": "Worm",
    "choice_d": "Macro virus",
    "correct_answer": "A",
    "explanation": "Trojan horses are programs that supposedly do one thing but actually do another, usually a hidden malicious function.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      258,
      293,
      268,
      303,
      308
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 426,
    "question": "The process whereby senior management exerts strategic control over business functions through policies, objectives, delegation of authority, and measurement is called:",
    "choice_a": "Standards",
    "choice_b": "Policy",
    "choice_c": "Strategic management",
    "choice_d": "Governance",
    "correct_answer": "D",
    "explanation": "Governance is a process whereby senior management exerts strategic control over business functions through policies, objectives, delegation of authority, and measurement. Governance is management’s control over all other IT processes to ensure that IT processes continue to effectively meet the organization’s business needs. It is a collection of top-down activities intended to control the IT organization from a strategic perspective.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      15,
      6,
      7,
      5
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 427,
    "question": "Which of the following is the primary advantage of using software as a service (SaaS) as opposed to self-hosting?",
    "choice_a": "Reduction in capital and labor expenses",
    "choice_b": "Third-party control of information assets",
    "choice_c": "Increase in risk associated with hosting data with another organization",
    "choice_d": "Accountability and liability transfer",
    "correct_answer": "A",
    "explanation": "Reduction in capital and labor expenses is the primary advantages of SaaS; the other choices are disadvantages of using SaaS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      35,
      36,
      32,
      34,
      33
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 428,
    "question": "Which attack is used to take over communications that are taking place between two parties?",
    "choice_a": "Spoofing attack",
    "choice_b": "Smurf attack",
    "choice_c": "On-path attack",
    "choice_d": "DDoS attack",
    "correct_answer": "C",
    "explanation": "In an on-path attack, an attacker intercepts communications being sent from one party to another and injects new, altered communications in their place. The attacker must be able to impersonate each party in the communication so that each party believes it is talking directly with the other party.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      282,
      320,
      314,
      288,
      285
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 429,
    "question": "The choices of risk treatment are:",
    "choice_a": "Risk sharing, risk transfer, risk avoidance, and risk acceptance",
    "choice_b": "Risk reduction, risk avoidance, and risk acceptance",
    "choice_c": "Risk reduction, risk transfer, risk avoidance, and risk acceptance",
    "choice_d": "Risk reduction, risk transfer, and risk acceptance",
    "correct_answer": "C",
    "explanation": "There are four possible positions that an organization can take for a risk: it can reduce the risk through some form of risk mitigation; it can transfer the risk to another organization (usually, this takes the form of insurance); it can discontinue the activity that created the risk (risk avoidance); or it can accept the risk as is.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      72,
      76,
      75,
      84
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 430,
    "question": "A network device that serves to control the flow of network messages between networks, usually placed at the boundary between the Internet and an organization’s internal network, is called a(n):",
    "choice_a": "Firewall",
    "choice_b": "Router",
    "choice_c": "Intrusion prevention system",
    "choice_d": "VPN switch",
    "correct_answer": "A",
    "explanation": "A firewall serves as the main network traffic control between the Internet and the internal network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      270,
      306,
      309,
      320,
      272
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 431,
    "question": "What is one potential weakness of certificate-based authentication?",
    "choice_a": "It may be possible to forge the digital certificate.",
    "choice_b": "It may be possible to decrypt the digital certificate.",
    "choice_c": "It may be possible to duplicate the digital certificate.",
    "choice_d": "It may be possible to revoke the digital certificate.",
    "correct_answer": "C",
    "explanation": "The greatest risk of certificate-based authentication is that it may be possible for an attacker to find the digital certificate on a target system and steal it for the attacker’s own use.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      284,
      287,
      268,
      335,
      315
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 432,
    "question": "Which management tool is used to measure the performance and effectiveness of an organization and how well the organization can fulfill its mission and strategic objectives?",
    "choice_a": "Independent audit",
    "choice_b": "Balanced scorecard (BSC)",
    "choice_c": "Management effectiveness inspection (MEI)",
    "choice_d": "Controls validation test (CVT)",
    "correct_answer": "B",
    "explanation": "A balanced scorecard is a tool that measures the performance of an organization in four key areas. The other activities are used for other purposes.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      3,
      41,
      51,
      1,
      7
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 433,
    "question": "When an authorized user is able to access some portion of application source code and make a copy under strict management control, presumably to make a modification or perform analysis, this is referred to as:",
    "choice_a": "Program checkout",
    "choice_b": "Version control",
    "choice_c": "Unit testing",
    "choice_d": "Code analysis",
    "correct_answer": "A",
    "explanation": "Program checkout is a strict management control used to manage software change and versioning.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      166,
      169,
      170,
      173,
      172
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 434,
    "question": "What is the reason that project requirements should be measurable?",
    "choice_a": "Engineers will know how to build each module.",
    "choice_b": "Developers will know how to code each requirement.",
    "choice_c": "Measurable requirements can be verified through testing.",
    "choice_d": "Users will be able to use the software correctly.",
    "correct_answer": "C",
    "explanation": "Requirements need to be measurable to develop a test procedure for each requirement. Through this, the system can be tested to see whether it meets the requirement.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      121,
      119,
      151,
      104
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 435,
    "question": "Who in the organization is responsible for compliance management in the organization, and how is compliance with strategies, policies, standards, and procedures verified?",
    "choice_a": "CISO; internal audits",
    "choice_b": "CIO; external audits",
    "choice_c": "CISO; internal and external audits",
    "choice_d": "CIO; internal and external audits",
    "correct_answer": "C",
    "explanation": "The CISO is responsible for compliance management, and this is verified through the use of both internal and external audits.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      17,
      54,
      55,
      5
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 436,
    "question": "What is the term associated with any event that is not part of the standard operation of a service and that causes, or may cause, an interruption to, or a reduction in, the quality of that service?",
    "choice_a": "Incident",
    "choice_b": "Known error",
    "choice_c": "Problem",
    "choice_d": "Issue",
    "correct_answer": "A",
    "explanation": "ITIL defines an incident as “An unplanned interruption to an IT Service or reduction in the quality of an IT service. Failure of a configuration item that has not yet affected service is also an incident—for example, failure of one disk from a mirror set.”.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      165,
      184,
      175,
      162,
      166
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 437,
    "question": "Project SMART objectives refer to objectives that are:",
    "choice_a": "Specific, measurable, achievable, related, and time-bound",
    "choice_b": "Specific, managed, achievable, relevant, and time-bound",
    "choice_c": "Specific, managed, achievable, relevant, and time-bound",
    "choice_d": "Specific, measurable, achievable, relevant, and time-bound",
    "correct_answer": "D",
    "explanation": "The SMART acronym is specific, measurable, achievable, relevant, and time-bound.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      104,
      102,
      106,
      110,
      113
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 438,
    "question": "Which of the following actions will most greatly reduce the impact of malware on an end-user workstation?",
    "choice_a": "Remove end-user rights to eavesdrop on local area networks.",
    "choice_b": "Remove end-user privileges to install software.",
    "choice_c": "Remove local administrator privileges from end-user accounts.",
    "choice_d": "Remove end-user rights to alter operating system files.",
    "correct_answer": "C",
    "explanation": "Removing local administration privileges from end users will accomplish many things, including preventing the alteration of operating system files, installing software, and eavesdropping on local area networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      200,
      183,
      204,
      196
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 439,
    "question": "Which type of malware performs one or more surveillance-type actions on a computer, reporting back to the malware owner?",
    "choice_a": "Trojan horses",
    "choice_b": "Viruses",
    "choice_c": "Spyware",
    "choice_d": "Worms",
    "correct_answer": "C",
    "explanation": "Spyware is specially designed malware whose purpose is to intercept and relay data back to its owner, often including keystrokes, passwords, financial data, and so on.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      265,
      266,
      264,
      257
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 440,
    "question": "Blowfish is an example of which type of encryption algorithm?",
    "choice_a": "Hashing algorithm",
    "choice_b": "Private key algorithm",
    "choice_c": "Public key algorithm",
    "choice_d": "Key exchange protocol",
    "correct_answer": "B",
    "explanation": "Blowfish, like AES, Triple DES, and Twofish, is a private key encryption algorithm.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      283,
      289,
      282,
      284,
      273
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 441,
    "question": "Which of the following may an employer check during a background investigation of a potential employee?",
    "choice_a": "Religious background",
    "choice_b": "Criminal record",
    "choice_c": "Previous marriages",
    "choice_d": "Sexual orientation",
    "correct_answer": "B",
    "explanation": "All are normally not checked during a background verification, due to regulatory or privacy requirements. Criminal records are usually checked during routine background screening for potential employees. The other options do not reflect areas covered by background checks in most jurisdictions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      54,
      10,
      11,
      59
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 442,
    "question": "Which classification of information should never be stored on a mobile device and must be encrypted and properly labeled while in storage?",
    "choice_a": "Public",
    "choice_b": "Restricted",
    "choice_c": "Secret",
    "choice_d": "Confidential",
    "correct_answer": "C",
    "explanation": "Secret—usually the highest level of classification of information an organization may have—is normally not stored on mobile devices and is usually encrypted on the media it is stored on.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      295,
      269,
      282,
      262,
      304
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 443,
    "question": "Which of the following spoofing techniques involves altering the OSI layer 3 addressing information?",
    "choice_a": "MAC address spoofing",
    "choice_b": "Email address spoofing",
    "choice_c": "Web address spoofing",
    "choice_d": "IP address spoofing",
    "correct_answer": "D",
    "explanation": "A host’s IP address is the layer 3 address and can be spoofed. A MAC address can also be spoofed, but that is a layer 2 address. Website addresses and email addresses also can be spoofed, but they occur at different layers of the OSI model.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      272,
      306,
      320,
      309,
      268
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 444,
    "question": "Which final two types of tests must be performed before a product is considered to be accepted for implementation into production?",
    "choice_a": "User acceptance testing and quality assurance testing",
    "choice_b": "Unit testing and regression testing",
    "choice_c": "Interface testing and migration testing",
    "choice_d": "System testing and unit testing",
    "correct_answer": "A",
    "explanation": "User acceptance testing and quality assurance testing are performed during the implementation phase before the product is considered accepted for integration into production.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      122,
      153,
      123,
      152
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 445,
    "question": "During which phase of a project is the business problem defined?",
    "choice_a": "Business case",
    "choice_b": "Requirements",
    "choice_c": "Testing",
    "choice_d": "Design",
    "correct_answer": "A",
    "explanation": "The business problem should be defined in the business case, which is the very first step in a project, or is performed before the project starts.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      102,
      116,
      151,
      115,
      117
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 446,
    "question": "Which method of encryption is considered superior to WEP in terms of protecting wireless networks?",
    "choice_a": "SSL/TLS",
    "choice_b": "WPA2",
    "choice_c": "SSH",
    "choice_d": "MD5",
    "correct_answer": "B",
    "explanation": "WPA2 is a more current, more secure replacement for WEP encryption. The other choices are encryption algorithms used in other aspects of security.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      269,
      306,
      320,
      282,
      283
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 447,
    "question": "Which of the following represents standards in the ISACA audit standards framework?",
    "choice_a": "2004, Reasonable Expectation",
    "choice_b": "2005, Due Professional Care",
    "choice_c": "2205, Evidence",
    "choice_d": "1007, Assertions",
    "correct_answer": "D",
    "explanation": "ISACA audit standards (in the 1000 series) define minimum standards of performance related to security, audits, and the actions that result from audits. ISACA guidelines (in the 2000 series) are a series of articles that clarify the meaning of the audit standards. They cite specific ISACA IS audit standards and COBIT controls, and provide specific guidance on various audit activities. ISACA audit guidelines also provide insight into why each guideline was developed and published.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      68,
      69,
      70,
      71,
      94
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 448,
    "question": "Which load balancing technology is designed to transparently recover from failure as well as offer enhanced network performance?",
    "choice_a": "Synchronous replication",
    "choice_b": "RAID",
    "choice_c": "Server clusters",
    "choice_d": "Asynchronous replication",
    "correct_answer": "C",
    "explanation": "A cluster is a tightly coupled collection of computers that is used to solve a common task. In a cluster, one or more servers actively perform tasks, while zero or more computers may be in a “standby” state, ready to assume active duty should the need arise. Clusters usually give the appearance of a single computer to the perspective of outside systems. Clusters usually operate in one of two modes: active-active and active-passive. In active-active mode, all servers perform tasks, while in active-passive mode, some servers are in a standby state, waiting to become active in an event called a <i>failover</i>, which usually occurs when one of the active servers has become incapacitated.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      201,
      240,
      246,
      231
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 449,
    "question": "What is a logical representation of the high-level and detailed tasks that must be performed to complete a project, and that can be the basis for the creation of the project schedule?",
    "choice_a": "PERT chart",
    "choice_b": "Gantt chart",
    "choice_c": "Object breakdown structure (OBS)",
    "choice_d": "Work breakdown structure (WBS)",
    "correct_answer": "D",
    "explanation": "A WBS provides a logical view of high-level and detailed tasks that must be performed to complete the project. The other tools provide different information about a project in different contexts.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      104,
      106,
      110,
      113,
      150
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 450,
    "question": "A new CIO needs to gather information about applications. What does the CIO need to create?",
    "choice_a": "Project portfolio",
    "choice_b": "Configuration management database (CMDB)",
    "choice_c": "Data dictionary",
    "choice_d": "Application portfolio",
    "correct_answer": "D",
    "explanation": "The CIO needs to create an application portfolio to catalog, manage, and measure applications in the environment. A project portfolio is used to track projects. A CMDB is a repository for every component in an environment that contains information on every configuration change made on those components. A data dictionary is a set of data in a database management system that describes the structure of databases stored there.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      38,
      44,
      45,
      19,
      27
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 451,
    "question": "What is the main purpose of change management?",
    "choice_a": "To ensure that all proposed changes to an IT environment are vetted for suitability and risk, and to ensure that changes will not interfere with each other or with other planned or unplanned activities",
    "choice_b": "To record the configuration of IT systems",
    "choice_c": "To respond to changes in the IT environment, such as incidents, outages, and other issues",
    "choice_d": "To allow an organization to project financial resources for new IT systems acquisition",
    "correct_answer": "A",
    "explanation": "Change management is a process designed to ensure that only approved changes are applied to processes and systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      166,
      167,
      168,
      172,
      169
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 452,
    "question": "Which one of the following is <i>not</i> a characteristic of Secure Shell (SSH)?",
    "choice_a": "SSH is used to create a secure channel between two systems.",
    "choice_b": "SSH supports tunneling of protocols such as X-Windows.",
    "choice_c": "SSH offers secure authentication and encryption.",
    "choice_d": "SSH was replaced by SSL and HTTPS protocols.",
    "correct_answer": "D",
    "explanation": "SSH replaces nonsecure protocols such as Telnet and FTP, but it has not been replaced by other secure protocols such as SSL/TLS or HTTPS. These protocols are used for different types of secure sessions/transactions and complement SSH, but they do not replace it.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      273,
      282,
      284,
      288,
      309
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 453,
    "question": "The technique used to statistically determine the characteristic of a given population to answer the question “How much?” is known as:",
    "choice_a": "Variable sampling",
    "choice_b": "Attribute sampling",
    "choice_c": "Judgmental sampling",
    "choice_d": "Statistical sampling",
    "correct_answer": "A",
    "explanation": "Variable sampling is the technique employed when auditors want to know “how much?” For example, if an auditor wants to know the total value of a population of transactions, auditors would select samples and statistically determine the total value of transactions in the total population.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      88,
      360,
      89,
      95
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 454,
    "question": "Which testing method identifies active systems on a network, discovers the services that are active on those systems, identifies vulnerabilities on those systems, and then exploits those vulnerabilities?",
    "choice_a": "Regression testing",
    "choice_b": "Penetration testing",
    "choice_c": "Vulnerability testing",
    "choice_d": "Quality assurance testing",
    "correct_answer": "B",
    "explanation": "The purpose of penetration testing is to identify active systems on a network and to discover the services that are active on those systems. Many penetration testing tools go a step further and identify vulnerabilities in systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      322,
      306,
      293,
      305
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 455,
    "question": "Laws and regulations that affect organizations’ use of information systems are primarily concerned with which of the following characteristics and uses of information and information systems?",
    "choice_a": "Security, integrity, and privacy",
    "choice_b": "Liability, security, and privacy",
    "choice_c": "Profitability, privacy, and liability",
    "choice_d": "Confidentiality, integrity, and availability",
    "correct_answer": "A",
    "explanation": "Laws and regulations affecting information and the systems that store and process it are concerned with the organization’s ability to provide security of the information, ensure its integrity, and protect the privacy of the individuals about whom the information is processed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      66,
      65,
      67,
      69
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 456,
    "question": "Which of the following logical security measures should be used to protect sensitive backup media while it is being transported?",
    "choice_a": "Locked box",
    "choice_b": "Assigning a high-sensitivity classification to the media",
    "choice_c": "Security guard",
    "choice_d": "Encryption",
    "correct_answer": "D",
    "explanation": "Encryption, a logical access control, should be used to protect backup media while it is being transported (and also while in storage). Other physical security measures, such as storage in a locked container or escort by security guards, can also be used. Because backup media is often transported from place to place, there are opportunities for media to be misplaced or lost in transit. For this reason, data on backup media should be encrypted so that any third party who happens to find a backup media volume will not be able to retrieve any data from it. When backup media is encrypted, a lost tape means only the loss of an inexpensive asset and not a potential compromise of sensitive information.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      321,
      283,
      266,
      292,
      264
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 457,
    "question": "A security analyst needs to design a control to ensure that data that is input into a system has been examined for completeness. What type of a control should be designed?",
    "choice_a": "Input validation",
    "choice_b": "Input authorization",
    "choice_c": "Input calculations",
    "choice_d": "Input security",
    "correct_answer": "A",
    "explanation": "The types of controls used to examine the values of input data to ensure that they are of the proper type and fall within allowed ranges are known as input validation controls.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      145,
      143,
      148,
      144,
      156
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 458,
    "question": "Which type of legal document normally covers capacity management in terms of service delivery?",
    "choice_a": "Third-party contract",
    "choice_b": "Service level agreement (SLA)",
    "choice_c": "Reciprocal agreement",
    "choice_d": "Business continuity agreement",
    "correct_answer": "B",
    "explanation": "Capacity and other guarantees for services are usually included in the service level agreement (SLA), which may be a part of a legal agreement (or cited by a legal agreement).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      176,
      163,
      246,
      181,
      162
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 459,
    "question": "Why is regression testing important to the release process?",
    "choice_a": "To make sure that functions that were confirmed to be working properly in prior releases continue to work as expected",
    "choice_b": "To allow users to test all functions prior to the final release",
    "choice_c": "To ensure that units of code are error-free before being integrated into the overall system",
    "choice_d": "To confirm whether software is performing according to requirements",
    "correct_answer": "A",
    "explanation": "Regression testing is used to ensure that functions that previously worked well, both in newer versions of software and in integrated systems, still work after a change is introduced into the system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      172,
      167,
      166,
      173,
      236
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 460,
    "question": "Which of the following post-implementation items should be audited to ensure that systems and infrastructures meet organizational requirements and are subject to internal controls?",
    "choice_a": "Any data items in a transaction that were altered in the data flow and where alterations occurred, and whether audit log entries recorded those transaction changes, including who made the changes.",
    "choice_b": "The organization performed a formal RFP (request for proposal) process.",
    "choice_c": "The application supports the entire body of requirements established during the project.",
    "choice_d": "Adequate records exist that indicate how much the change management process is followed.",
    "correct_answer": "C",
    "explanation": "Confirmation that the application supports the entire body of requirements established during the project is specific to the post-implementation phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      123,
      117,
      129,
      100
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 461,
    "question": "What is the most effective measure against interception of client-server communications?",
    "choice_a": "Biometrics",
    "choice_b": "Strong passwords",
    "choice_c": "Encryption",
    "choice_d": "Antimalware software",
    "correct_answer": "C",
    "explanation": "Eavesdropping and interception of client-server communications can result in a compromise of sensitive or valuable information. The most effective countermeasure for traffic interception is network encryption between servers and client workstations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      282,
      283,
      312,
      288
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 462,
    "question": "Which data recovery scheme involves the use of hot-swappable disk arrays in the equipment chassis?",
    "choice_a": "Clusters",
    "choice_b": "RAID",
    "choice_c": "Tape backup",
    "choice_d": "Replication",
    "correct_answer": "B",
    "explanation": "RAID (Redundant Array of Independent Disks) is a technology that involves the use of multiple hot-swappable disks installed in the server chassis. These drives can be switched out, and data can be recovered if one of them fails or otherwise becomes defective.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      203,
      240,
      246
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 463,
    "question": "All of the following are techniques and methods used in computer forensics <i>except</i>:",
    "choice_a": "Data extraction",
    "choice_b": "Data protection",
    "choice_c": "Data acquisition",
    "choice_d": "Data alteration",
    "correct_answer": "D",
    "explanation": "Data extraction, data acquisition, and data protection are techniques that are inherent to computer forensic investigations. Data alteration is an area that must be avoided at all cost during an investigation, as this will invalidate the results of the investigation itself.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      301,
      347,
      302,
      257,
      296
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 464,
    "question": "Which entity usually performs quality assurance testing (QAT)?",
    "choice_a": "End-user",
    "choice_b": "Independent third party",
    "choice_c": "Developer",
    "choice_d": "IT department",
    "correct_answer": "D",
    "explanation": "Quality assurance testing is a formal verification of system specifications and technologies. Users are usually not involved in QAT; instead, IT departments typically perform this testing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      121,
      105,
      153,
      120,
      119
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 465,
    "question": "An organization that wants to establish a secure virtual private network (VPN) connection using IPsec will need to configure it to use which mode?",
    "choice_a": "Transport mode",
    "choice_b": "Security association mode",
    "choice_c": "Tunnel mode",
    "choice_d": "Encrypted mode",
    "correct_answer": "C",
    "explanation": "Tunnel mode is used for VPN implementations, since it can encapsulate, or “tunnel,” data securely through otherwise nonsecure networks.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      213,
      214,
      209,
      207,
      206
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 466,
    "question": "All of the following are examples of physical security threats <i>except</i>:",
    "choice_a": "Unauthorized entry",
    "choice_b": "Equipment theft",
    "choice_c": "Unauthorized deletion of data",
    "choice_d": "Sabotage",
    "correct_answer": "C",
    "explanation": "Unauthorized entry, equipment theft, and sabotage are physical threats, whereas unauthorized deletion of data is a logical threat.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      335,
      337,
      336,
      334,
      309
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 467,
    "question": "An IS auditor is reviewing the disaster recovery (DR) plans for an online service provider, and has found that the DR plans are reviewed and updated annually. What statement best describes the finding that the auditor should write?",
    "choice_a": "It only matters whether the DR plan is tested, not whether it is updated.",
    "choice_b": "It is not necessary to update DR plans unless the organization’s business model changes.",
    "choice_c": "An annual review of the organization’s DR plan is adequate.",
    "choice_d": "In a rapidly changing IT environment, DR plans should be reviewed more often.",
    "correct_answer": "D",
    "explanation": "In an online environment that is undergoing frequent changes and updates, DR plans should be reviewed more frequently to ensure that they will be effective in the event of a disaster.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      252,
      248,
      244,
      249,
      247
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 468,
    "question": "Which term refers to the practices of entrusting software code to a third party for safekeeping in case of a software developer failure?",
    "choice_a": "Code checkout",
    "choice_b": "Source code escrow",
    "choice_c": "Code lockdown",
    "choice_d": "Code transfer",
    "correct_answer": "B",
    "explanation": "Source code escrow involves entrusting source code to a third party for protection if the software developer has a business or other failure.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      152,
      115,
      118,
      123
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 469,
    "question": "Which of the following is true regarding protecting voice-over IP (VoIP) communications?",
    "choice_a": "VoIP is not vulnerable to the same attacks as traditional IP networks.",
    "choice_b": "Protecting VoIP communications requires different technologies and countermeasures than traditional IP networks.",
    "choice_c": "VoIP should always run on IP networks separate from the organization’s data network.",
    "choice_d": "Because VoIP systems communicate over TCP/IP, and because many are based on conventional operating systems, VoIP is protected through primarily the same measures that are used to protect other IT systems.",
    "correct_answer": "D",
    "explanation": "Because it uses TCP/IP protocols, VoIP is vulnerable to the same types of attacks as traditional networks and should be protected using the same technologies. In addition, many organizations run VoIP over the same networks that carry their data.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      309,
      270,
      268,
      272,
      275
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 470,
    "question": "Which of the following is the primary risk associated with third-party service providers?",
    "choice_a": "The service provider will have access to some of the organization’s equipment.",
    "choice_b": "The service provider will have access to some of the organization’s sensitive information.",
    "choice_c": "The service provider will have physical access to some of the organization’s facilities.",
    "choice_d": "The service provider will have access to some of the organization’s personnel.",
    "correct_answer": "B",
    "explanation": "The primary risk associated with third-party service providers is that they will have access to an organization’s sensitive information assets.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      323,
      325,
      324,
      295,
      326
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 471,
    "question": "The type of testing used to determine the accuracy and integrity of transactions that flow through processes and information systems is called:",
    "choice_a": "Compliance testing",
    "choice_b": "Validation testing",
    "choice_c": "Substantive testing",
    "choice_d": "Controls testing",
    "correct_answer": "C",
    "explanation": "Substantive testing is used to determine the accuracy and integrity of transactions that flow through processes and information systems.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      88,
      361,
      360,
      92,
      93
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 472,
    "question": "Which of the following attack vectors is the <i>least</i> technically demanding to execute?",
    "choice_a": "Social engineering",
    "choice_b": "IP spoofing",
    "choice_c": "Ping of death",
    "choice_d": "Smurf attack",
    "correct_answer": "A",
    "explanation": "Social engineering is the least technically involved attack method, relying on the exploitation of human weakness to carry out the attack.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      292,
      291,
      335,
      348,
      323
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 473,
    "question": "All of the following are included in a business case <i>except</i>:",
    "choice_a": "Feasibility study results",
    "choice_b": "Budget",
    "choice_c": "Risk",
    "choice_d": "Past performance reviews",
    "correct_answer": "D",
    "explanation": "Past performance reviews are not included, because the solution presented usually does not have any previous performance data to consider.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      102,
      116,
      117,
      119,
      123
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 474,
    "question": "All of the following are used in the capacity management function <i>except</i>:",
    "choice_a": "Static infrastructure",
    "choice_b": "Changes in technology",
    "choice_c": "Considering planned changes",
    "choice_d": "Periodic measurement",
    "correct_answer": "A",
    "explanation": "Technology changes, planned changes, and periodic measurements are activities that are used to manage capacity. Infrastructures are rarely static; changes in infrastructure are almost always what drive changes in capacity.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      163,
      161,
      225,
      227,
      198
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 475,
    "question": "What process is used to determine the level of security required for a set of information?",
    "choice_a": "Marking",
    "choice_b": "Information classification",
    "choice_c": "Privacy policy",
    "choice_d": "Top secret",
    "correct_answer": "B",
    "explanation": "Information classification is the process by which information is labeled and handled according to its sensitivity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      253,
      262,
      296,
      263
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 476,
    "question": "What factor primarily determines if there is sufficient capacity in IT systems and IT processes?",
    "choice_a": "If there is sufficient processing and storage capacity to meet 125 percent of the organization’s projected needs over one year",
    "choice_b": "If a particular processor or storage device is operating at no more than 80 percent of its intended capacity",
    "choice_c": "If its performance falls within an acceptable range as specified in service level agreements (SLAs)",
    "choice_d": "Capacity planning based on individual business unit projections",
    "correct_answer": "C",
    "explanation": "The service level agreement defines the acceptable level of performance for an IT system. Management must monitor SLA compliance and direct corrective action when SLAs are violated.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      176,
      163,
      162,
      161,
      198
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 477,
    "question": "Bidirectional replication that has transaction concurrency issues can be resolved using a:",
    "choice_a": "Multiprimary replication system",
    "choice_b": "Multimaster replication system",
    "choice_c": "Distributed lock manager",
    "choice_d": "Primary-backup replication system",
    "correct_answer": "C",
    "explanation": "In bidirectional replication, simultaneous transactions on different servers could conflict with one another (such as two clerks trying to update an invoice at the same time). Some form of concurrent transaction control, such as a “distributed lock manager,” would be required.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      238,
      201,
      183,
      161,
      246
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 478,
    "question": "An organization needs to build a process that will help it to keep careful track of each state of its critical information systems over the lifetime of the system. What kind of a process does the organization need to develop?",
    "choice_a": "Release management",
    "choice_b": "Configuration management",
    "choice_c": "Change management",
    "choice_d": "Log management",
    "correct_answer": "B",
    "explanation": "Configuration management is the process of recording the configuration of a system through each of its changes, permitting an organization to determine the precise configuration of a system at a point in time, and even to return a system to a previous configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      134,
      154,
      132,
      131,
      133
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 479,
    "question": "Which device is used to view network traffic at a highly detailed level?",
    "choice_a": "Router",
    "choice_b": "Protocol analyzer",
    "choice_c": "Switch",
    "choice_d": "Gateway",
    "correct_answer": "B",
    "explanation": "A protocol analyzer (sometimes referred to as a “sniffer”) is used to view network communications traffic on a highly detailed level to solve performance, bandwidth, and security issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      217,
      209,
      208,
      215,
      228
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 480,
    "question": "Which of the following terms defines a complex transaction as either having to be completed in its entirety or having none of it completed?",
    "choice_a": "Atomicity",
    "choice_b": "Referential integrity",
    "choice_c": "Granularity",
    "choice_d": "Third normal form",
    "correct_answer": "A",
    "explanation": "The characteristic of atomicity states that a complex transaction, which could consist of simultaneous actions on many records in many different tables, is performed as a single unit of work: either it will all be completed properly, or none of it will be completed. This technique helps to ensure the integrity of all data in the database management system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      157,
      145,
      148,
      156,
      144
    ],
    "source": "288380_Practice Exam 2"
  },
  {
    "id": 481,
    "question": "The IT Assurance Framework consists of all of the following except:",
    "choice_a": "ISACA Code of Professional Ethics",
    "choice_b": "IS audit and assurance standards",
    "choice_c": "ISACA Audit Job Practice",
    "choice_d": "IS audit and assurance guidelines",
    "correct_answer": "C",
    "explanation": "The IT Assurance Framework is an ISACA publication that includes the ISACA Code of Professional Ethics, IS audit and assurance standards, IS audit and assurance guidelines, and IS audit and assurance tools and techniques. It does not contain the ISACA Audit Job Practice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      69,
      71,
      83,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 482,
    "question": "An auditor is examining an IT organization’s change control process. The auditor has determined that Change Advisory Board (CAB) meetings take place on Tuesdays and Fridays, where planned changes are discussed and approved. The CAB does not discuss emergency changes that are not approved in advance. What opinion should the auditor reach concerning emergency changes?",
    "choice_a": "The CAB should not be discussing changes made in the past.",
    "choice_b": "The CAB should be discussing recent emergency changes.",
    "choice_c": "Personnel should not be making emergency changes without CAB permission.",
    "choice_d": "Change control is concerned only with planned changes, not emergency changes.",
    "correct_answer": "B",
    "explanation": "The CAB should discuss emergency changes made since the last CAB meeting. Although the changes have been made already, they should go through a similar approval process to ensure that all stakeholders are aware of the changes and agree that they were appropriate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      363,
      89,
      81,
      94,
      354
    ],
    "source": "9781394290116"
  },
  {
    "id": 483,
    "question": "A conspicuous video surveillance system would be characterized as what type(s) of control?",
    "choice_a": "Detective and deterrent",
    "choice_b": "Detective only",
    "choice_c": "Deterrent only",
    "choice_d": "Preventive and deterrent",
    "correct_answer": "A",
    "explanation": "A video surveillance system is considered a detective control because it only records events without actually preventing events, unlike preventive controls such as locked doors and other barriers. A video surveillance system, when its components are conspicuous, is also considered a deterrent control because its presence serves as a visible deterrent to persons considering an intrusion into a building.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      80,
      79,
      81,
      361,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 484,
    "question": "Michael is developing an audit plan for an organization’s data center operations. Which of the following will help Michael determine which controls require potentially more scrutiny than others?",
    "choice_a": "Security incident log",
    "choice_b": "Last year’s data center audit results",
    "choice_c": "Risk assessment of the data center",
    "choice_d": "Data center performance metrics",
    "correct_answer": "C",
    "explanation": "A risk assessment is the primary means for determining which controls may represent greater organizational risk.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      359,
      72,
      96,
      76,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 485,
    "question": "An organization processes payroll and expense reports for thousands of corporate customers in an SAAS-based environment. Those customers want assurance that the organization’s processes are effective. What kind of audit should the organization undertake?",
    "choice_a": "Compliance audit",
    "choice_b": "Operational audit",
    "choice_c": "Service provider audit",
    "choice_d": "IS audit",
    "correct_answer": "C",
    "explanation": "A service provider audit, such as an SSAE18, SOC 2, ISO 27001 certification, or AUP audit, is designed for service providers that want to provide objective assurance of the integrity of their control environments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      86,
      363,
      71,
      356
    ],
    "source": "9781394290116"
  },
  {
    "id": 486,
    "question": "An audit project has been taking far too long, and management is beginning to ask questions about its schedule and completion. This audit may be lacking:",
    "choice_a": "Effective project management",
    "choice_b": "Cooperation from individual auditees",
    "choice_c": "Enough skilled auditors",
    "choice_d": "Clearly stated scope and objectives",
    "correct_answer": "A",
    "explanation": "Although any of these answers are plausible, the first thing that should be examined is whether the audit is being effectively project managed so that all parties understand the audit’s objectives, schedule, resources required, and regular status reporting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      359,
      360,
      354,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 487,
    "question": "An auditor is auditing the user account request and fulfillment process. The event population consists of hundreds of transactions, so the auditor cannot view them all. The auditor wants to view a random selection of transactions. This type of sampling is known as:",
    "choice_a": "Judgmental sampling",
    "choice_b": "Random sampling",
    "choice_c": "Stratified sampling",
    "choice_d": "Statistical sampling",
    "correct_answer": "D",
    "explanation": "In an audit where an auditor needs to select a portion of events to test, statistical sampling is the best approach.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      360,
      84,
      88
    ],
    "source": "9781394290116"
  },
  {
    "id": 488,
    "question": "An auditor is auditing an organization’s user account request and fulfillment process. What is the first type of evidence collection the auditor will likely want to examine?",
    "choice_a": "Observation",
    "choice_b": "Document review",
    "choice_c": "Walkthrough",
    "choice_d": "Corroborative inquiry",
    "correct_answer": "B",
    "explanation": "An auditor will generally examine process documentation first to understand how a process is supposed to be performed. This will be followed by a walkthrough, observation, examination of records, and corroborative inquiry (and often in that sequence).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      90,
      361,
      360,
      74,
      91
    ],
    "source": "9781394290116"
  },
  {
    "id": 489,
    "question": "A lead auditor is building an audit plan for a client’s financial accounting system. The plan calls for periodic testing of a large number of transactions throughout the audit project. What is the best approach for accomplishing this?",
    "choice_a": "Reperform randomly selected transactions.",
    "choice_b": "Periodically submit test transactions to the audit client.",
    "choice_c": "Develop one or more CAATs.",
    "choice_d": "Request a list of all transactions to analyze.",
    "correct_answer": "C",
    "explanation": "The task of auditing a large number of transactions needs to be automated with one or more computer-assisted audit techniques (CAATs). Manually testing a large number of transactions would be onerous and costly.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      93,
      361,
      360,
      85,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 490,
    "question": "A lead auditor is building an audit plan for a client’s financial transaction processing system. The audit will take approximately three months. Which of the following is the best approach for reporting audit exceptions to the audit client?",
    "choice_a": "Report the exceptions to the audit committee.",
    "choice_b": "List the exceptions in the final audit report.",
    "choice_c": "Include the exceptions in a weekly status report.",
    "choice_d": "Advise the client of exceptions as they are discovered and confirmed.",
    "correct_answer": "D",
    "explanation": "There is rarely a valid reason why the audit client should not be notified immediately of an audit exception. That said, the auditor will often need to reserve the final audit opinion until all the testing has been completed and all the audit exceptions analyzed. Still, notifying the audit client of individual exceptions during the audit provides the audit client with opportunities to begin remediation.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      98,
      363,
      89,
      356,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 491,
    "question": "Which of the following is true about the ISACA Audit Standards and Audit Guidelines?",
    "choice_a": "ISACA Audit Standards are mandatory.",
    "choice_b": "ISACA Audit Standards are optional.",
    "choice_c": "ISACA Audit Guidelines are mandatory.",
    "choice_d": "ISACA Audit Standards are only mandatory for SOX audits.",
    "correct_answer": "A",
    "explanation": "ISACA Audit Standards are mandatory for all audit professionals – compliance with ISACA Audit Standards is a requirement for earning and retaining the CISA certification.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      68,
      69,
      71,
      352,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 492,
    "question": "An auditor is auditing an organization’s identity and access management program. The auditor has found that automated workflows are used to receive and track access requests and approvals. However, the auditor has identified a number of exceptions where subjects were granted access without the necessary requests and approvals. What remedy should the auditor recommend?",
    "choice_a": "Monthly review of access approvers",
    "choice_b": "Annual review of access approvers",
    "choice_c": "Annual user access reviews",
    "choice_d": "Monthly user access reviews",
    "correct_answer": "D",
    "explanation": "The problem with the existing business process can be partly remedied by a frequent user access review, which will partly compensate for the control failures. However, the organization should seek to identify and correct the root cause(s) of the control failures so that fewer exceptions are identified in the monthly user access reviews and subsequent audits.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      94,
      360,
      363,
      95
    ],
    "source": "9781394290116"
  },
  {
    "id": 493,
    "question": "Why are preventive controls preferred over detective controls?",
    "choice_a": "Preventive controls are easier to justify and implement than detective controls.",
    "choice_b": "Preventive controls are less expensive to implement than detective controls.",
    "choice_c": "Preventive controls stop unwanted events from occurring, whereas detective controls only record them.",
    "choice_d": "Detective controls stop unwanted events from occurring, whereas preventive controls only record them.",
    "correct_answer": "C",
    "explanation": "The best and first approach to unwanted events is prevention. Where prevention is difficult or expensive, detection is the next best approach.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      80,
      79,
      76,
      94,
      96
    ],
    "source": "9781394290116"
  },
  {
    "id": 494,
    "question": "For the purposes of audit planning, can an auditor rely on the audit client’s risk assessment?",
    "choice_a": "Yes, in all cases.",
    "choice_b": "Yes, if the risk assessment was performed by a qualified external entity.",
    "choice_c": "No. The auditor must perform a risk assessment themselves.",
    "choice_d": "No. The auditor does not require a risk assessment to develop an audit plan.",
    "correct_answer": "B",
    "explanation": "An auditor can use a risk assessment performed by a qualified external party to develop a risk-based audit plan, resulting in areas of higher risk being examined more closely than areas of lower risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      359,
      72,
      96,
      84,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 495,
    "question": "An organization processes payroll and expense reports in an SAAS-based environment for thousands of corporate customers. Those customers want assurance that the organization’s processes are effective. What kind of an audit should the organization undertake?",
    "choice_a": "AUP",
    "choice_b": "PA DSS",
    "choice_c": "PCI DSS",
    "choice_d": "SSAE18",
    "correct_answer": "D",
    "explanation": "The payroll services organization should undertake an SSAE18 audit. This type of audit is designed for financial services providers so that the auditors of the customers of the payroll services organization can rely on the payroll services organization’s SSAE18 audit report while auditing financial controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      67,
      85,
      356,
      364
    ],
    "source": "9781394290116"
  },
  {
    "id": 496,
    "question": "An auditor is auditing an organization’s system-hardening policy within its vulnerability management process. The auditor has examined the organization’s system-hardening standards and wants to examine the configuration of some of the production servers. What is the best method for the auditor to obtain evidence?",
    "choice_a": "Capture screenshots from servers selected by the systems engineer during a walkthrough.",
    "choice_b": "Request screenshots from servers selected by the systems engineer.",
    "choice_c": "Request screenshots of randomly selected servers from the systems engineer.",
    "choice_d": "Capture screenshots from randomly selected servers during a walkthrough with the systems engineer.",
    "correct_answer": "D",
    "explanation": "The auditor should select which servers are to be sampled (by whatever sampling methodology) and view the configurations during a walkthrough with a systems engineer. Walkthroughs are the most reliable method for ensuring the integrity of the evidence.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      92,
      360,
      91,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 497,
    "question": "An auditor is auditing the user account request and fulfillment process. The event population consists of hundreds of transactions, so the auditor cannot view them all. The auditor wants to view a random selection of transactions, as well as some of the transactions for privileged access requests. This type of sampling is known as:",
    "choice_a": "Judgmental sampling",
    "choice_b": "Random sampling",
    "choice_c": "Stratified sampling",
    "choice_d": "Statistical sampling",
    "correct_answer": "A",
    "explanation": "The auditor wants to examine the population and select specific high-risk transactions. Strictly random selections may not include enough privileged access requests; judgmental sampling is needed to pick enough privileged access request transactions to satisfy the auditor’s needs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      92,
      90,
      89,
      84,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 498,
    "question": "An auditor is auditing an organization’s user account request and fulfillment process. The auditor has requested that the control owner describe the process to the auditor. What type of auditing is taking place?",
    "choice_a": "Observation",
    "choice_b": "Document review",
    "choice_c": "Walkthrough",
    "choice_d": "Corroborative inquiry",
    "correct_answer": "C",
    "explanation": "A control owner describing a process is known as a walkthrough. Here, each step of a process is described in detail to the auditor.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      90,
      354,
      89,
      360,
      88
    ],
    "source": "9781394290116"
  },
  {
    "id": 499,
    "question": "An external audit firm is performing an audit of a customer’s financial accounting processes and IT systems. While examining a data storage system’s user access permissions, the staff auditor discovered the presence of illegal content. What should the staff auditor do next?",
    "choice_a": "Notify law enforcement.",
    "choice_b": "Inform their supervisor.",
    "choice_c": "Notify the auditee.",
    "choice_d": "Notify the auditee’s audit committee.",
    "correct_answer": "B",
    "explanation": "The staff auditor should first notify their supervisor, who may notify others in the audit firm. Depending on the nature of the illegal content, it may be appropriate for the audit firm to notify law enforcement, the auditee, or senior officials in the auditee organization, such as audit committee members. Local laws and regulations may influence this decision.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      70,
      69,
      64,
      87,
      357
    ],
    "source": "9781394290116"
  },
  {
    "id": 500,
    "question": "A QSA auditor in an audit firm has completed a PCI DSS audit of a client and found the client noncompliant with one or more PCI DSS controls. Management in the audit firm has asked the QSA auditor to sign off the audit as compliant, arguing that the client’s level of compliance has improved from prior years. What should the QSA auditor do?",
    "choice_a": "Refuse to sign the audit report as compliant.",
    "choice_b": "Sign the audit report as compliant, under duress.",
    "choice_c": "Sign the audit report as compliant.",
    "choice_d": "Notify the audit client of the matter.",
    "correct_answer": "A",
    "explanation": "The QSA auditor signing the audit report as compliant would violate the ISACA Code of Professional Ethics. If ISACA were to learn about this matter, the auditor could lose their ISACA certifications.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      69,
      68,
      358,
      94,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 501,
    "question": "An organization wants to drive accountability for the performance of security controls to their respective control owners. Which activity is the best to undertake to accomplish this objective?",
    "choice_a": "Direct control owners to sign a document of accountability.",
    "choice_b": "Have the internal audit department audit the controls.",
    "choice_c": "Have an external audit firm audit the controls.",
    "choice_d": "Undergo control self-assessments (CSAs).",
    "correct_answer": "D",
    "explanation": "Control self-assessments (CSAs) force control owners to focus on the effectiveness of their controls. For the most part, control owners will self-regulate and improve their control procedures to ensure that their controls are more effective.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      354,
      361,
      90,
      98,
      359
    ],
    "source": "9781394290116"
  },
  {
    "id": 502,
    "question": "An auditor is evaluating a control related to a key card mechanism protecting a data center from unauthorized visitors. The auditor has determined that the key card control is ineffective because visitors often “piggyback” their way into the data center. What detective control should be implemented to compensate for this control deficiency?",
    "choice_a": "A video surveillance system with 90-day content retention that records all entrances into and exits from the data center",
    "choice_b": "A visitor’s log inside the data center that all visitors would be required to sign",
    "choice_c": "A man trap",
    "choice_d": "A policy requiring all visitors to be escorted",
    "correct_answer": "A",
    "explanation": "A video surveillance system would record all persons entering and leaving the data center. A security manager could examine the video contents from time to time to understand whether specific persons violate the policy.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      80,
      94,
      360,
      79,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 503,
    "question": "A US-based organization processes payroll and expense reports in an SAAS-based environment for thousands of corporate customers. Customers outside the US want assurance that the organization’s processes are effective. What kind of an audit should the organization undertake?",
    "choice_a": "ISO/IEC 27001",
    "choice_b": "SOC2",
    "choice_c": "ISAE3402",
    "choice_d": "SSAE18",
    "correct_answer": "C",
    "explanation": "An ISAE3402 audit is the international version of the SSAE18 audit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      67,
      66,
      65,
      356
    ],
    "source": "9781394290116"
  },
  {
    "id": 504,
    "question": "A large merchant organization has commissioned a QSA (PCI) audit firm to perform a PCI DSS Report on Compliance (ROC). The audit firm has noted that the merchant’s compliance deadline is less than one month away. What should the audit firm do next?",
    "choice_a": "File a compliance extension with the PCI Standards Council on behalf of the merchant.",
    "choice_b": "Inform the merchant that the ROC can be completed on time.",
    "choice_c": "Inform the merchant that the ROC cannot be completed on time and that an extension should be requested.",
    "choice_d": "File a compliance extension with the merchant’s acquiring bank.",
    "correct_answer": "C",
    "explanation": "There is little hope that the ROC can be completed in four weeks. After being notified by the audit firm, the merchant organization should request an extension from its acquiring bank.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      65,
      67,
      85,
      356,
      98
    ],
    "source": "9781394290116"
  },
  {
    "id": 505,
    "question": "An auditor is developing an audit plan for an accounts payable function. Rather than randomly selecting transactions to examine, the auditor wants to select transactions from low, medium, and large payment amounts. Which sample methodology is appropriate for this approach?",
    "choice_a": "Judgmental sampling",
    "choice_b": "Stratified sampling",
    "choice_c": "Nonrandom sampling",
    "choice_d": "Statistical sampling",
    "correct_answer": "B",
    "explanation": "Stratified sampling involves selecting samples based on some quantified value in each sample (in this case, the payment amount). Stratified sampling is useful for situations like this, where auditors want to examine very high- or very low-value samples that might not be selected in random sampling.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      92,
      361,
      360,
      88,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 506,
    "question": "A cybersecurity audit firm has completed a penetration test of an organization’s web application. The final report contains two findings that indicate the presence of two critical vulnerabilities. The organization disputes the findings because of compensating controls outside the web application interface. How should the audit proceed?",
    "choice_a": "The audit firm should remove the findings from the final report.",
    "choice_b": "The organization should select another firm to conduct the penetration test.",
    "choice_c": "The organization’s management should protest the findings and include a letter accompanying the pen test report.",
    "choice_d": "The audit firm should permit the customer to include some management comments in the final report.",
    "correct_answer": "D",
    "explanation": "Management’s comments will appear in the report discussing the specific findings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      94,
      80,
      98,
      360,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 507,
    "question": "What is the objective of the ISACA audit standard on organizational independence?",
    "choice_a": "The auditor’s placement in the organization should ensure that the auditor can act independently.",
    "choice_b": "The auditor should not work in the same organization as the auditee.",
    "choice_c": "To ensure that the auditor has the appearance of independence.",
    "choice_d": "To ensure that the auditor has a separate operating budget.",
    "correct_answer": "A",
    "explanation": "ISACA audit standard 1002, “Organizational Independence,” states, “The IS auditor’s placement in the command-and-control structure of the organization should ensure that the IS auditor can act independently.” This helps to avoid the possibility that the auditor is being coerced into providing a favorable audit opinion.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      60,
      99,
      357,
      68
    ],
    "source": "9781394290116"
  },
  {
    "id": 508,
    "question": "An auditor is auditing an organization’s risk management process. During the walkthrough, the auditor asked the auditee to list all of the information sources contributing to the process. The auditee cited penetration tests, vendor advisories, nonvendor advisories, and security incidents as inputs. What conclusion should the auditor draw from this?",
    "choice_a": "The process is effective because risks are obtained from several disparate sources.",
    "choice_b": "The process is ineffective as risk assessments do not occur or contribute to the process.",
    "choice_c": "The process is effective because both internal and external sources are used.",
    "choice_d": "The process is ineffective because an anonymous tip line was not among the sources.",
    "correct_answer": "B",
    "explanation": "The absence of risk assessments (or their omission as an input to the risk management process) constitutes an ineffective process. Risk assessments are among the most important inputs to the risk management process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      73,
      74,
      84,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 509,
    "question": "The capability wherein a server is constituted from backup media is known as which type of control?",
    "choice_a": "Primary control",
    "choice_b": "Manual control",
    "choice_c": "Compensating control",
    "choice_d": "Recovery control",
    "correct_answer": "D",
    "explanation": "Restoration of a server from backup media is known as a recovery control.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      80,
      88,
      360,
      84,
      96
    ],
    "source": "9781394290116"
  },
  {
    "id": 510,
    "question": "Prior to planning an audit, an auditor would need to conduct a risk assessment to identify high-risk areas in all of the following situations <i>except</i>:",
    "choice_a": "When a client’s most recent risk assessment is two years old",
    "choice_b": "When a client’s risk assessment does not appear to be adequately rigorous",
    "choice_c": "A PCI “Report on Compliance” audit",
    "choice_d": "A SOC2 audit",
    "correct_answer": "C",
    "explanation": "The PCI audit is not risk-based, and the presence or absence of a risk assessment will not alter the audit plan. This is despite the fact that PCI (as of version 4.0.1) requires an organization to conduct a risk assessment, although this has no bearing on the organization’s obligation to implement all controls in the standard.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      65,
      72,
      84,
      359,
      62
    ],
    "source": "9781394290116"
  },
  {
    "id": 511,
    "question": "Which of the following audit types is appropriate for a financial services provider such as a payroll service?",
    "choice_a": "SOC 1",
    "choice_b": "SAS70",
    "choice_c": "AUP",
    "choice_d": "Sarbanes-Oxley",
    "correct_answer": "A",
    "explanation": "A SOC 1 audit is specifically intended for financial service providers in payroll, general accounting, expense management, and other financial services.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      86,
      97,
      85,
      359,
      356
    ],
    "source": "9781394290116"
  },
  {
    "id": 512,
    "question": "Which of the following is the best method for ensuring that an audit project can be completed on time?",
    "choice_a": "Distribute a “provided by client” evidence request list at the start of the audit.",
    "choice_b": "Prepopulate the issues list with findings likely to occur.",
    "choice_c": "Increase the number of auditors on the audit team.",
    "choice_d": "Reduce the frequency of status meetings from weekly to monthly.",
    "correct_answer": "A",
    "explanation": "Auditees sometimes take a long time to search for and provide requested evidence to auditors. By providing this request list at the beginning of the audit, auditors will obtain evidence earlier than if they wait until their walkthrough meetings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      360,
      89,
      85,
      367,
      357
    ],
    "source": "9781394290116"
  },
  {
    "id": 513,
    "question": "An auditor is about to start an audit of a user account access request and fulfillment process. The audit covers six months, from January through June. The population contains 1,800 transactions. Which of the following sampling methodologies is best suited for this audit?",
    "choice_a": "Examine the results of the client’s control self-assessment (CSA).",
    "choice_b": "Submit some user account access requests and observe how they are performed.",
    "choice_c": "Request the first 30 transactions from the auditee.",
    "choice_d": "Request the first five transactions from each month in the audit period.",
    "correct_answer": "D",
    "explanation": "This methodology captures transactions throughout the entire audit period. In a period of this length, there could be personnel changes and other changes that could result in periods of acceptable or unacceptable performance throughout the period.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      84,
      85,
      88,
      62
    ],
    "source": "9781394290116"
  },
  {
    "id": 514,
    "question": "An auditor is auditing an organization’s personnel onboarding process and examining the background check process. The auditor is mainly interested in whether background checks are performed for all personnel and whether background checks result in no-hire decisions. Which of the following evidence-collection techniques will support this audit objective?",
    "choice_a": "Request the full contents of background checks along with hire/no-hire decisions.",
    "choice_b": "Request the background check ledger that includes the candidates’ names, results of background checks, and hire/no-hire decisions.",
    "choice_c": "Request the hire/no-hire decisions from the auditee.",
    "choice_d": "Examine the background check process, and note which characteristics of each candidate are included.",
    "correct_answer": "B",
    "explanation": "This evidence request will provide enough information for the auditor to understand whether background checks are performed for all positions requiring them, as well as whether any no-hire decisions are made.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      90,
      74,
      93,
      352,
      356
    ],
    "source": "9781394290116"
  },
  {
    "id": 515,
    "question": "An auditor wants to audit the changes made to the DBMS configuration of a financial accounting system. What should the auditor use as the transaction population?",
    "choice_a": "All of the transactions in the database",
    "choice_b": "All of the requested changes in the change management process",
    "choice_c": "All of the changes made to the database",
    "choice_d": "All of the approved changes in the change management business process",
    "correct_answer": "C",
    "explanation": "The total population is the total set of configuration changes present in the DBMS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      360,
      84,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 516,
    "question": "A credit card payment processor undergoes an annual PCI DSS Report on Compliance (ROC) audit. What evidence of a passing audit should the payment processor provide to merchant organizations and others?",
    "choice_a": "The signed Report on Compliance (ROC)",
    "choice_b": "The signed attestation of compliance (AOC)",
    "choice_c": "The signed report of validation (ROV)",
    "choice_d": "The signed self-assessment questionnaire (SAQ)",
    "correct_answer": "B",
    "explanation": "It is entirely sufficient for the service provider to provide the signed attestation of compliance (AOC) to any merchant, customer, or other entity requesting evidence of PCI DSS compliance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      65,
      94,
      357,
      86,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 517,
    "question": "Which of the following statements about the ISACA Audit Guidelines is correct?",
    "choice_a": "ISACA Audit Guidelines apply only to audit firms and not to internal audit departments.",
    "choice_b": "ISACA Audit Guidelines are required. Violations may result in fines for violators.",
    "choice_c": "ISACA Audit Guidelines are required. Violations may result in loss of certifications.",
    "choice_d": "ISACA Audit Guidelines are not required.",
    "correct_answer": "D",
    "explanation": "ISACA Audit Guidelines are suggested implementation guidelines and are not required of ISACA-certified personnel.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      71,
      68,
      69,
      70,
      97
    ],
    "source": "9781394290116"
  },
  {
    "id": 518,
    "question": "An external auditor is auditing an organization’s third-party risk management (TPRM) process. The auditor has observed that the organization has developed an ISO 27001-based questionnaire sent to all third-party service providers annually. What value-added remarks can the auditor provide?",
    "choice_a": "The process can be more efficient if the organization develops risk-based tiers to save time auditing low-risk vendors.",
    "choice_b": "The organization should not be sending questionnaires to vendors every year.",
    "choice_c": "The organization should structure its questionnaires based on CSA Star.",
    "choice_d": "The organization should outsource its third-party management process.",
    "correct_answer": "A",
    "explanation": "The TPRM process could be more efficient if the organization stratified its vendors based on risk. The highest-risk vendors would be assessed annually with the most rigorous questionnaire, whereas vendors at lower-risk tiers would be assessed with shorter questionnaires or not at all.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      61,
      84,
      74,
      92
    ],
    "source": "9781394290116"
  },
  {
    "id": 519,
    "question": "What is the difference between SSAE18 Type I and SSAE18 Type II audits?",
    "choice_a": "A Type I audit is an audit of process effectiveness, whereas a Type II audit is an audit of process effectiveness and design.",
    "choice_b": "A Type I audit is an audit of process design and effectiveness, whereas a Type II audit is an audit of process design.",
    "choice_c": "A Type I audit is an audit of process design, whereas a Type II audit is an audit of process design and effectiveness.",
    "choice_d": "A Type I audit is an audit of process design and effectiveness, whereas a Type II audit is an audit of process effectiveness.",
    "correct_answer": "C",
    "explanation": "This is the correct definition of SSAE18 Type I and Type II audits.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      86,
      87,
      89,
      90,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 520,
    "question": "An auditor is auditing the payment systems for a retail store chain that has 80 stores in the region. The auditor needs to observe and take samples from some of the stores’ systems. The audit client has selected two stores in the same city as the store chain headquarters and two stores in a nearby town. How should the audit of the store locations proceed?",
    "choice_a": "The auditor should learn more about the stores’ systems and practices before deciding what to do.",
    "choice_b": "The auditor should audit the selected stores and proceed accordingly.",
    "choice_c": "The auditor should accept the sampling but select additional stores.",
    "choice_d": "The auditor should select which stores to examine and proceed accordingly.",
    "correct_answer": "A",
    "explanation": "Although the auditee’s desire to select the stores to audit may seem proactive, the auditor needs to better understand the nature of each store’s information systems before overruling the auditee. For instance, the systems in all stores may be identically configured, and the nearby store operators may be better equipped to explain audit processes. On the other hand, if store systems are not identically configured and operated, the client’s desire to select samples may have to be overruled so the auditor retains independence.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      69,
      60,
      357,
      92,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 521,
    "question": "As part of an audit of a business process, the auditor has discussed the process with the control owner and the control operators and has collected procedure documents and records related to the process. The auditor is asking internal customers of the business process to describe in their own words how the business process is operated. What kind of evidence collection are these discussions with internal customers?",
    "choice_a": "Reconciliation",
    "choice_b": "Reperformance",
    "choice_c": "Walkthrough",
    "choice_d": "Corroborative inquiry",
    "correct_answer": "D",
    "explanation": "An auditor discussing a business process with additional personnel outside the process is known as corroborative inquiry. This helps to give the auditor more confidence in the veracity of the evidence obtained from control owners and operators.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      74,
      354,
      89,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 522,
    "question": "Three months after the completion of an audit, the auditor contacted the auditee to inquire about the auditee’s activities since the audit and whether the auditee has made any progress related to audit findings. What sort of communication is this outreach from the auditor?",
    "choice_a": "The auditor is a good audit partner and wants to ensure that the auditee is successful.",
    "choice_b": "The auditor is acting improperly by contacting the auditee outside of an audit and should be censored for unethical behavior.",
    "choice_c": "The auditee should assume that the auditor’s outreach is personal in nature because this kind of communication is forbidden.",
    "choice_d": "The auditor clearly ensures that the auditee is happy with the auditor’s work so that the auditor gets next year’s audit assignment.",
    "correct_answer": "A",
    "explanation": "An auditor is free to contact an auditee after an audit to show concern for the auditee and be sure that the auditee is proceeding properly by working to resolve any findings identified by the auditor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      89,
      94,
      99,
      68
    ],
    "source": "9781394290116"
  },
  {
    "id": 523,
    "question": "According to ISACA Audit Standard 1202, which types of risks should be considered when planning an audit?",
    "choice_a": "Fraud risk",
    "choice_b": "Business risk",
    "choice_c": "Cybersecurity risk",
    "choice_d": "Financial risk",
    "correct_answer": "B",
    "explanation": "All types of risks should be considered when planning an audit of a business process or system.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      70,
      359,
      84,
      75,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 524,
    "question": "An IT service desk department that provisions user accounts performs a monthly activity whereby all user account changes in the prior month are checked against the list of corresponding requests in the ticketing system. This activity is known as:",
    "choice_a": "An audit",
    "choice_b": "A monthly provisioning review",
    "choice_c": "A control threat assessment (CTA)",
    "choice_d": "A risk assessment",
    "correct_answer": "B",
    "explanation": "The service desk is performing a monthly review of user account provisioning to make sure that all such account provisioning activities were, in fact, requested.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      88,
      90,
      359,
      360,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 525,
    "question": "An organization that uses video surveillance at a work center has placed visible notices on building entrances that inform people that video surveillance systems are in use. The notices are an example of:",
    "choice_a": "Administrative controls",
    "choice_b": "Preventive controls",
    "choice_c": "Detective controls",
    "choice_d": "Deterrent controls",
    "correct_answer": "D",
    "explanation": "Visible notices announcing its presence are an example of a deterrent control.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      80,
      81,
      90,
      94,
      362
    ],
    "source": "9781394290116"
  },
  {
    "id": 526,
    "question": "An auditor is planning an audit of a financial planning application. Can the auditor rely on a recent application penetration test as a risk-based audit?",
    "choice_a": "No, because a penetration test does not reveal risks.",
    "choice_b": "No, because a penetration test is not a risk assessment.",
    "choice_c": "No: the auditor can make use of the pen test, but a risk assessment is still needed.",
    "choice_d": "Yes, because the penetration test serves as a risk assessment in this case.",
    "correct_answer": "C",
    "explanation": "A penetration test reveals a limited view of risks, and a full risk assessment is still needed if the audit is to be truly risk driven.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      96,
      97,
      359,
      88
    ],
    "source": "9781394290116"
  },
  {
    "id": 527,
    "question": "Which of the following is the best example of a control self-assessment of a user account provisioning process?",
    "choice_a": "An examination of Active Directory to ensure that only domain administrators can make user account permission changes",
    "choice_b": "Checks to see that only authorized personnel made user account changes",
    "choice_c": "Confirmation that all user account changes were approved by appropriate personnel",
    "choice_d": "Reconciliation of all user account changes against approved requests in the ticketing system",
    "correct_answer": "D",
    "explanation": "A reconciliation of all user account changes with approved requests in the ticketing system ensures that all such changes were actually requested and approved.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      88,
      79,
      360,
      366
    ],
    "source": "9781394290116"
  },
  {
    "id": 528,
    "question": "The proper sequence of an audit of an accounts payable process is:",
    "choice_a": "Identify control owners, make evidence requests, perform walkthroughs, and perform corroborative interviews.",
    "choice_b": "Make evidence requests, identify control owners, and perform corroborative interviews.",
    "choice_c": "Identify control owners, perform corroborative interviews, make evidence requests, and perform walkthroughs.",
    "choice_d": "Perform corroborative interviews, identify control owners, make evidence requests, and perform walkthroughs.",
    "correct_answer": "A",
    "explanation": "It is necessary to identify control owners to send evidence requests to the right personnel. Next, walkthroughs are performed, and finally, corroborative interviews are held.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      89,
      90,
      91,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 529,
    "question": "An auditor is auditing an accounts payable process and has found no exceptions. The auditor has decided to select additional samples to see whether any exceptions may be found. Which type of sampling is the auditor performing?",
    "choice_a": "Stop-or-go sampling",
    "choice_b": "Discovery sampling",
    "choice_c": "Judgmental sampling",
    "choice_d": "Exception sampling",
    "correct_answer": "B",
    "explanation": "Discovery sampling is used when an auditor is examining samples in the search for at least one exception.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      92,
      88,
      90,
      362,
      95
    ],
    "source": "9781394290116"
  },
  {
    "id": 530,
    "question": "Which of the following methods is best suited for an auditee to deliver evidence to an auditor during the audit of a background check process?",
    "choice_a": "FTP server",
    "choice_b": "Secure file transfer portal",
    "choice_c": "Email with SMTP over TLS",
    "choice_d": "Courier",
    "correct_answer": "B",
    "explanation": "A secure file transfer portal is the best choice because sensitive information will be encrypted in transit, end to end, and the portal can handle volumes of evidence that may be too large to email.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      89,
      357,
      70,
      74
    ],
    "source": "9781394290116"
  },
  {
    "id": 531,
    "question": "An auditor has completed an audit, and the deliverable is ready to give to the audit client. What is the best method for delivering the audit report to the client?",
    "choice_a": "Courier",
    "choice_b": "Secure file transfer portal",
    "choice_c": "Email with SMTP over TLS",
    "choice_d": "In person, in a close-out meeting",
    "correct_answer": "D",
    "explanation": "The best way to deliver an audit report is face-to-face so that the auditor can explain the audit project, provide the audit report, and answer any questions that the audit client might have. An in-person meeting provides the auditor with valuable body language cues from the audit client to better understand the audit client’s response to the audit report and its description of findings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      364,
      357,
      94,
      89,
      363
    ],
    "source": "9781394290116"
  },
  {
    "id": 532,
    "question": "What are the potential consequences if an IS auditor is a member of ISACA and CISA certified and violates the ISACA Code of Professional Ethics?",
    "choice_a": "Fines",
    "choice_b": "Imprisonment",
    "choice_c": "Termination of employment",
    "choice_d": "Loss of ISACA certifications",
    "correct_answer": "D",
    "explanation": "An ISACA member violating the ISACA Code of Professional Ethics “can result in an investigation into a member’s or certification holder’s conduct and, ultimately, in disciplinary measures,” including loss of certifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      68,
      358,
      71,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 533,
    "question": "An auditor is auditing an accounts payable process and has discovered that a single individual has requested and also approved several payments to vendors. What kind of an issue has the auditor found?",
    "choice_a": "A separation-of-duties issue",
    "choice_b": "A split-custody issue",
    "choice_c": "A dual-custodian issue",
    "choice_d": "No issue has been identified",
    "correct_answer": "A",
    "explanation": "The auditor has discovered a separation-of-duties (sometimes known as segregation-of-duties) issue. Payment requests and approvals should be handled by separate persons in accounts payable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      81,
      360,
      90,
      74
    ],
    "source": "9781394290116"
  },
  {
    "id": 534,
    "question": "An organization uses an automated workflow process for request, review, approval, and provisioning of user accounts. Anyone in the organization can request access. Specific individuals are assigned to the review and approval steps. Provisioning is automated. What kind of control is the separation of duties between the review and approval steps?",
    "choice_a": "Compensating control",
    "choice_b": "Manual control",
    "choice_c": "Preventive control",
    "choice_d": "Administrative control",
    "correct_answer": "C",
    "explanation": "This is a preventive control and also an automatic control. The workflow prevents a single individual from performing the review and approval steps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      91,
      361,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 535,
    "question": "An auditor is planning an audit of a monthly terminated-users review procedure. The auditor is planning to ask the auditee for a list of current user accounts in Active Directory, as well as a list of current employees and a list of terminated employees from Human Resources so that the auditor can compare the lists. What kind of an audit is the auditor planning to perform?",
    "choice_a": "Reperformance",
    "choice_b": "Observation",
    "choice_c": "Corroboration",
    "choice_d": "Walk-back",
    "correct_answer": "A",
    "explanation": "This is a reperformance audit because the auditor will essentially repeat the steps performed in the review.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      360,
      84,
      86,
      359
    ],
    "source": "9781394290116"
  },
  {
    "id": 536,
    "question": "An IT service desk manager is the control owner for the IT department change control process. In an audit of the change control process, the auditor has asked the IT service desk manager to provide all change control tickets whose request numbers end with the digit 6. What sampling methodology has the auditor used?",
    "choice_a": "Judgmental sampling",
    "choice_b": "Statistical sampling",
    "choice_c": "Stratified sampling",
    "choice_d": "Stop-or-go sampling",
    "correct_answer": "B",
    "explanation": "This is statistical sampling, where the auditor has requested 10% of the population, effectively random and spread throughout the audit period. This assumes, of course, that change-control requests are serialized sequentially.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      360,
      89,
      354
    ],
    "source": "9781394290116"
  },
  {
    "id": 537,
    "question": "An audit firm is planning an audit of an organization’s asset management records. For what reason would the auditor request a copy of the entire asset database from the third-party DBA versus a report of assets from the owner of the asset process?",
    "choice_a": "Honesty of the evidence provider",
    "choice_b": "Objectivity of the evidence provider",
    "choice_c": "Independence of the evidence provider",
    "choice_d": "Qualification of the evidence provider",
    "correct_answer": "C",
    "explanation": "The DBA is an independent party from the asset process owner and should have little or no interest in the audit’s outcome.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      357,
      90,
      84,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 538,
    "question": "An auditor has delivered a Sarbanes–Oxley audit report containing 12 exceptions to the audit client, who disagrees with the findings. The audit client is upset and is asking the auditor to remove six findings from the report. A review of the audit findings confirmed that all 12 findings are valid. How should the auditor proceed?",
    "choice_a": "Remove the three lowest-risk findings from the report.",
    "choice_b": "Remove the six lowest-risk findings from the report.",
    "choice_c": "Report the auditee to the Securities and Exchange Commission.",
    "choice_d": "Explain to the auditee that the audit report cannot be changed.",
    "correct_answer": "D",
    "explanation": "The auditor has no choice but to stand by the audit report as is, particularly after a review upholds all findings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      94,
      364,
      98,
      357
    ],
    "source": "9781394290116"
  },
  {
    "id": 539,
    "question": "An auditor has delivered a Sarbanes–Oxley audit report containing 12 exceptions to the audit client, who disagrees with the findings. The audit client is upset and is asking the auditor to remove six findings from the report in exchange for a payment of $25,000. A review of the audit findings confirmed that all 12 findings are valid. How should the auditor proceed?",
    "choice_a": "The auditor should report the matter to their manager.",
    "choice_b": "The auditor should reject the payment and meet the auditee halfway by removing three of the findings.",
    "choice_c": "The auditor should reject the payment and remove six of the findings.",
    "choice_d": "The auditor should report the incident to the audit client’s audit committee.",
    "correct_answer": "A",
    "explanation": "The auditor should first report the matter to their manager, who will, in turn, decide how to handle the matter. More than likely, the audit manager will notify the audit client’s audit committee, which can decide whether to refer the matter to regulatory authorities.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      69,
      99,
      364,
      357,
      68
    ],
    "source": "9781394290116"
  },
  {
    "id": 540,
    "question": "An auditor is auditing a change control process. During a walkthrough, the control owner described the process as follows: “Engineers plan their changes and send an email about their changes to the IT manager before 5 p.m. on Wednesday. The engineers then proceed with their changes during the change window on Friday evening.” What, if any, findings should the auditor identify?",
    "choice_a": "The change control process is fine as is but could be improved by creating a ledger of changes.",
    "choice_b": "The change control process is fine as is.",
    "choice_c": "The change control process lacks a review step.",
    "choice_d": "The change control process lacks review and approval steps.",
    "correct_answer": "D",
    "explanation": "The change-control process lacks a step where requested changes are reviewed, discussed, and approved. As it stands, it appears that engineers unilaterally decide what changes to make.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      360,
      90,
      94,
      363
    ],
    "source": "9781394290116"
  },
  {
    "id": 541,
    "question": "An organization utilizes a video surveillance system on all ingress and egress points in its work facility; surveillance cameras are concealed from view, and there are no visible notices. What type of control is this?",
    "choice_a": "Administrative control",
    "choice_b": "Secret control",
    "choice_c": "Detective control",
    "choice_d": "Deterrent control",
    "correct_answer": "C",
    "explanation": "This is a detective control. The system is not a deterrent control because the video surveillance system is not visible.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      80,
      81,
      94,
      89,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 542,
    "question": "An auditor is selecting samples from records in the user access request process. Although privileged access requests account for approximately 5% of all access requests, the auditor wants 20% of the samples to be requests for administrative access. What sampling technique has the auditor selected?",
    "choice_a": "Judgmental sampling",
    "choice_b": "Stratified sampling",
    "choice_c": "Statistical sampling",
    "choice_d": "Variable sampling",
    "correct_answer": "B",
    "explanation": "This is stratified sampling, where an auditor selects samples from various classes or values – in this case, higher-risk privileged accounts.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      92,
      95,
      89,
      85,
      71
    ],
    "source": "9781394290116"
  },
  {
    "id": 543,
    "question": "An auditor is auditing a change control process by examining change logs in a database management system and requesting change control records to show that those changes were approved. The auditor plans to proceed until the first exception is found. What sampling technique is being used here?",
    "choice_a": "Discovery sampling",
    "choice_b": "Stop-or-go sampling",
    "choice_c": "Attribute sampling",
    "choice_d": "Exception sampling",
    "correct_answer": "A",
    "explanation": "This is an example of the discovery sampling technique, where an auditor examines samples until an exception is found.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      88,
      360,
      95
    ],
    "source": "9781394290116"
  },
  {
    "id": 544,
    "question": "Which of the following is the best description of stop-or-go sampling?",
    "choice_a": "The auditor wants to select samples based on arbitrary criteria.",
    "choice_b": "The auditor wants to know how many transactions contain a certain range of values.",
    "choice_c": "The auditor wants to know the total value of the transaction population.",
    "choice_d": "The auditor believes the risk is low and wants to sample as few records as possible.",
    "correct_answer": "D",
    "explanation": "Stop-or-go sampling is performed when an auditor believes the overall risk is low and wants to sample as few records as possible.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      92,
      95,
      84,
      88,
      361
    ],
    "source": "9781394290116"
  },
  {
    "id": 545,
    "question": "While auditing a payroll process, an auditor intends to keep selecting samples until an error is found. What type of sampling is being performed?",
    "choice_a": "Discovery sampling",
    "choice_b": "Stop-or-go sampling",
    "choice_c": "Attribute sampling",
    "choice_d": "Exception sampling",
    "correct_answer": "A",
    "explanation": "This is an example of the discovery sampling technique, where an auditor examines samples until an exception is found.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      92,
      88,
      95,
      360,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 546,
    "question": "A staff auditor is auditing a process, which involves examining the contents of some employee laptop computers. The auditor has detected the presence of child pornography on one laptop computer. What should the auditor do next?",
    "choice_a": "Confront the user of the laptop computer.",
    "choice_b": "Delete the content from the laptop computer.",
    "choice_c": "Notify their supervisor.",
    "choice_d": "Notify law enforcement.",
    "correct_answer": "C",
    "explanation": "In the US, auditors (as well as IT and cybersecurity) are generally required to notify law enforcement when child pornography is detected. However, in many (if not most) cases, a staff employee is not authorized to notify external parties; instead, the staff employee should notify their supervisor, who will follow audit firm policy to determine who is authorized to notify law enforcement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      358,
      60,
      64,
      98
    ],
    "source": "9781394290116"
  },
  {
    "id": 547,
    "question": "An audit firm has completed an audit of several auditee business processes. The audit firm is in the process of archiving information for the audit. Which of the following information can be excluded from the archiving process?",
    "choice_a": "Field notes",
    "choice_b": "Draft audit report",
    "choice_c": "Sampled transactions",
    "choice_d": "None of these",
    "correct_answer": "D",
    "explanation": "None of these items should be excluded from the audit archive; all may be needed to support the audit trail, conclusions, and evidence retained for the engagement.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      89,
      357,
      90,
      94,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 548,
    "question": "In an external audit of a client organization, one of the staff auditors realizes that their business partner in a side business is one of the auditee managers in the client organization. What should the staff auditor do about this?",
    "choice_a": "Maintain professional and ethical behavior during the audit.",
    "choice_b": "Refrain from discussing the side business with their business partner during the audit.",
    "choice_c": "Notify their supervisor about a potential conflict of interest.",
    "choice_d": "Request reassignment to another audit project.",
    "correct_answer": "C",
    "explanation": "Staff auditors should always notify their supervisors when they detect a potential conflict of interest situation. Audit management can then decide how to proceed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      60,
      99,
      357,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 549,
    "question": "An auditor is auditing a release management process by examining policies, procedures, and records and interviewing personnel. The auditor has determined that the personnel who initiate individual software releases are also the approvers. What might the auditor conclude from this?",
    "choice_a": "The process appears to have a segregation-of-duties issue.",
    "choice_b": "The process appears to have a race condition.",
    "choice_c": "The design of the process is appropriate and sound.",
    "choice_d": "Nothing can be concluded from this information.",
    "correct_answer": "A",
    "explanation": "Generally, the requestor and approver in a business process should be two different people or roles. When the requestor and approver are the same person, an issue with segregation of duties exists.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      74,
      90,
      360,
      362
    ],
    "source": "9781394290116"
  },
  {
    "id": 550,
    "question": "An auditor is auditing an organization’s vendor risk practices. The information security manager described the process to the auditor, which consists of the security manager performing a security scan of a new vendor’s website to measure the level of risk and reaching a conclusion about the vendor’s suitability solely based on the scan results. What might the auditor conclude from this?",
    "choice_a": "The organization’s vendor management risk process is adequate because security scanning is the primary means for identifying risk.",
    "choice_b": "The organization’s vendor management risk process is inadequate because an objective party should perform the scan.",
    "choice_c": "The organization’s vendor management risk process is inadequate because the organization should also issue a questionnaire to the vendor.",
    "choice_d": "The organization’s vendor management risk process is inadequate because it should be performed by an outside party instead of internally.",
    "correct_answer": "C",
    "explanation": "A security scan of a vendor’s website is just one of many ways the vendor should be assessed for risk, but by itself it is inadequate. Other means of assessing risk include issuing detailed questionnaires, reviewing audit reports, and obtaining information about the health of a vendor’s business from business intelligence bureaus.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      96,
      359,
      90,
      97,
      75
    ],
    "source": "9781394290116"
  },
  {
    "id": 551,
    "question": "An auditor has completed fieldwork on a customer’s SOC 2 audit and has briefed the customer on findings that will appear in the report. What should the customer do next?",
    "choice_a": "Challenge the auditor and ask them to prove their findings.",
    "choice_b": "Agree with the auditor.",
    "choice_c": "Ask for a second opinion from a different partner in the audit firm.",
    "choice_d": "Produce management comments that will appear in the published report.",
    "correct_answer": "D",
    "explanation": "In SOC 1 and SOC 2 audits, the auditee can issue comments that will appear in the report, explaining their perspective regarding the findings. Often, management will state that the business process will be fixed or has been fixed.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      363,
      94,
      98,
      353,
      86
    ],
    "source": "9781394290116"
  },
  {
    "id": 552,
    "question": "Why would an organization’s Internal Audit department conduct its own risk assessment versus relying on the risk assessment performed by the Information Security department?",
    "choice_a": "The auditor may not believe that the Information Security department is capable of conducting a proper risk assessment.",
    "choice_b": "As an objective, independent party, the Internal Audit department should conduct its own risk assessment.",
    "choice_c": "The internal auditor is prohibited by law from relying on the Information Security department’s risk assessment.",
    "choice_d": "The internal auditor would put themselves in a conflict of interest situation.",
    "correct_answer": "B",
    "explanation": "An organization’s Internal Audit department will typically perform a risk assessment every year or two to see for itself where important risks exist in the organization, helping Internal Audit develop its audit plan for the year, including paying more attention to those higher-risk activities and areas.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      359,
      84,
      72,
      78,
      61
    ],
    "source": "9781394290116"
  },
  {
    "id": 553,
    "question": "An organization recently hired an experienced cybersecurity leader to make strategic improvements in the organization’s cybersecurity capabilities. One item of interest to the cybersecurity leader is the matter of control owner–operators and their commitment to control effectiveness. Which of the following would best serve to improve this commitment?",
    "choice_a": "Control self-assessments",
    "choice_b": "Security awareness training",
    "choice_c": "Penetration testing",
    "choice_d": "An external audit",
    "correct_answer": "A",
    "explanation": "Control self-assessments (CSAs) are a good way of instilling ownership and quality on the part of control owner–operators because they will be asked to demonstrate the soundness of their controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      361,
      98,
      89,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 554,
    "question": "To save time in an audit, one of the staff auditors has decided to upload audit findings to a public LLM AI service to direct the service in composing the audit executive summary. The audit manager discovered this practice. What should the audit manager do next?",
    "choice_a": "Discipline the staff auditor for compromising the auditee’s confidential information.",
    "choice_b": "Recognize and reward the staff auditor for innovation and efficiency.",
    "choice_c": "Update audit procedures so that other staff auditors will do the same.",
    "choice_d": "Notify law enforcement.",
    "correct_answer": "A",
    "explanation": "Confidential information should not be uploaded to a public LLM AI service such as ChatGPT or Bard, as this may result in the compromise and exposure of that information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      99,
      357,
      77,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 555,
    "question": "The director of Internal Audit in a new US-based public company has decided to staff its internal audit with contractors from a public accounting firm. This is an example of:",
    "choice_a": "Insourced external audit",
    "choice_b": "Outsourced external audit",
    "choice_c": "Outsourced internal audit",
    "choice_d": "Insourced internal audit",
    "correct_answer": "C",
    "explanation": "The use of contractors in an Internal Audit department is considered the outsourcing of internal audit.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      87,
      357,
      60,
      61,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 556,
    "question": "When planning an audit, a lead auditor must determine all of the following <i>except</i>:",
    "choice_a": "Findings",
    "choice_b": "Scope",
    "choice_c": "Purpose",
    "choice_d": "Schedule",
    "correct_answer": "A",
    "explanation": "Audit planning requires that the scope, purpose, and schedule of an audit be determined. Findings will be identified during the audit.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      84,
      85,
      359,
      89,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 557,
    "question": "An organization is required to comply with Sarbanes-Oxley, PCI DSS, ISO 27001, and NIST SP 800-53. What is the best approach for determining how the organization can plan to comply with these?",
    "choice_a": "Create separate controls and procedures for each framework.",
    "choice_b": "Map all controls together, thus creating the organization’s General Computing Controls.",
    "choice_c": "Create separate controls, procedures, and records for each framework.",
    "choice_d": "Identify the scope for each framework, and map common controls.",
    "correct_answer": "D",
    "explanation": "Organizations obligated to comply with multiple control frameworks should first identify the scope of each and then map those controls in common where they overlap, helping to identify activities that are common to two or more controls and control frameworks.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      67,
      65,
      359,
      83,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 558,
    "question": "Two cybersecurity staff members are arguing about the classification of the organization’s video surveillance system. One argues that video surveillance is a deterrent control, and the other argues that video surveillance is a detective control. Who is right, and why?",
    "choice_a": "Video surveillance is neither deterrent nor detective.",
    "choice_b": "Video surveillance is a detective control.",
    "choice_c": "Video surveillance is both deterrent and detective.",
    "choice_d": "Video surveillance is a deterrent control.",
    "correct_answer": "C",
    "explanation": "Video surveillance is often considered both a deterrent control (because cameras and perhaps even monitors are plainly visible, thus deterring any wrongdoing for fear of detection) and a detective control (because the system will permit observation of activities). This is common in control classification, where a control can have one or more classifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      361,
      94,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 559,
    "question": "An online retail merchant organization with an online product catalog accepts credit card payments from customers but does not store credit card data. A third-party organization accepts payments through a gateway. The CFO argues that the organization is not required to comply with PCI DSS because the organization does not store credit card data. What, if any, are the organization’s requirements for complying with PCI DSS?",
    "choice_a": "The organization is required to comply because its website directs payments to the third-party payment gateway.",
    "choice_b": "The organization is not required to comply because it does not store credit card data.",
    "choice_c": "The organization is required to comply because it advertises its acceptance of credit cards for payment.",
    "choice_d": "The organization is not required to comply because another organization accepts payments on its behalf.",
    "correct_answer": "A",
    "explanation": "The organization is still required to comply with PCI DSS because its own website directs customers to the third-party payment gateway for processing payments. The organization will not be required to comply with specific PCI DSS controls related to the storage of credit card numbers, but many other controls will still apply.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      65,
      67,
      97,
      81,
      79
    ],
    "source": "9781394290116"
  },
  {
    "id": 560,
    "question": "The advantages of control self-assessments include all of the following <i>except</i>:",
    "choice_a": "Control risks can be identified earlier.",
    "choice_b": "Favorable self-assessments can result in audits being delayed.",
    "choice_c": "Relationships with control owners can improve through collaboration.",
    "choice_d": "More personnel will be aware of the need for effective controls.",
    "correct_answer": "B",
    "explanation": "Favorable results in control self-assessments are not likely to alter the scheduling of audits. Instead, CSAs help identify control issues before audits occur and instill ownership on the part of control owners.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      366,
      354,
      87,
      361,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 561,
    "question": "Management’s control of information technology processes is best described as:",
    "choice_a": "Information technology policies",
    "choice_b": "Information technology policies, along with audits of those policies",
    "choice_c": "Information technology governance",
    "choice_d": "Metrics as compared to similar organizations",
    "correct_answer": "C",
    "explanation": "ISACA defines governance as a set of processes that “Ensures that stakeholder needs, conditions, and options are evaluated to determine balanced, agreed-on enterprise objectives to be achieved; setting direction through prioritization and decision-making; and monitoring performance and compliance against agreed-on direction and objectives.”.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      17,
      4,
      27,
      39,
      3
    ],
    "source": "9781394290116"
  },
  {
    "id": 562,
    "question": "What is the best method for ensuring that an organization’s IT department achieves adequate business alignment?",
    "choice_a": "Find and read the organization’s articles of incorporation.",
    "choice_b": "Understand the organization’s vision, mission statement, and objectives.",
    "choice_c": "Determine who the CIO reports to in the organization.",
    "choice_d": "Study the organization’s application portfolio.",
    "correct_answer": "B",
    "explanation": "The best way to align an IT department to the business is to find and understand the organization’s vision statement, mission statement, goals, and objectives. Many organizations develop and publish one or more of these statements. Others take a simpler approach and develop strategic objectives for a calendar or fiscal year. Whatever can be found is valuable: once an IT manager understands these statements, they can prioritize resources and activities in the IT department to support the vision, mission, goals, or other strategic statements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      7,
      6,
      3,
      27
    ],
    "source": "9781394290116"
  },
  {
    "id": 563,
    "question": "Roberta has located her organization’s mission statement and a list of strategic objectives. What steps should Roberta take to ensure that the IT department aligns with the business?",
    "choice_a": "Discuss strategic objectives with business leaders to better understand what they wish to accomplish and what steps are being taken to achieve the objectives.",
    "choice_b": "Develop a list of activities that will support the organization’s strategic objectives, and determine the cost of each.",
    "choice_c": "Select those controls from the organization’s control framework that align with each objective, and then ensure that those controls are effective.",
    "choice_d": "Select the policies from the organization’s information security policy that are relevant to each objective, and ensure that those policies are current.",
    "correct_answer": "A",
    "explanation": "The best first step in aligning an IT department to the organization’s strategic objectives is to better understand those objectives, including the resources and activities that will be employed to achieve them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      7,
      3,
      15,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 564,
    "question": "Michael wants to improve the risk management process in his organization by creating content that will help management understand when certain risks should be accepted and when certain risks should be mitigated. The policy that Michael needs to create is known as:",
    "choice_a": "A security policy",
    "choice_b": "A control framework",
    "choice_c": "A risk appetite statement",
    "choice_d": "A control testing procedure",
    "correct_answer": "C",
    "explanation": "A risk appetite statement (sometimes known as a risk tolerance statement or risk capacity statement) provides guidance on the types of risk and the amount of risk an organization may be willing to accept versus what risks an organization may instead prefer to mitigate, avoid, or transfer. Risk appetite statements are most often created in financial services organizations, although they are seen in other types of organizations as well. They help management seek a more consistent approach to risk treatment decisions. In part, this can help management avoid the appearance of being biased or preferential through the use of objective or measurable means for risk treatment decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      22,
      24,
      18,
      8
    ],
    "source": "9781394290116"
  },
  {
    "id": 565,
    "question": "In a typical risk management process, the best person to make a risk treatment decision is:",
    "choice_a": "The chief risk officer (CRO)",
    "choice_b": "The chief information officer (CIO)",
    "choice_c": "The department head associated with the risk",
    "choice_d": "The chief information security officer (CISO)",
    "correct_answer": "C",
    "explanation": "The department head (or division head or business owner, as appropriate) associated with the business activity regarding the risk treatment decision should be the person making the risk treatment decision. This is because a risk treatment decision is a business decision that should be made by the person responsible for the business function. Many organizations employ a cybersecurity steering committee to discuss such matters, but the final decision often rests with the business unit head.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      18,
      24,
      22,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 566,
    "question": "The ultimate responsibility for an organization’s cybersecurity program lies with:",
    "choice_a": "The board of directors",
    "choice_b": "The chief executive officer (CEO)",
    "choice_c": "The chief information officer (CIO)",
    "choice_d": "The chief information security officer (CISO)",
    "correct_answer": "A",
    "explanation": "The ultimate responsibility for everything in an organization, including its cybersecurity program, lies with its board of directors. Various laws and regulations define board member responsibilities, particularly in publicly traded organizations in the United States and other countries.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      4,
      44,
      1,
      6,
      17
    ],
    "source": "9781394290116"
  },
  {
    "id": 567,
    "question": "In a US public company, a CIO will generally report the state of the organization’s IT function to:",
    "choice_a": "The Treadway Commission",
    "choice_b": "Independent auditors",
    "choice_c": "The US Securities and Exchange Commission",
    "choice_d": "The board of directors",
    "correct_answer": "D",
    "explanation": "In most US publicly traded companies, the CIO will report the state of the organization’s IT function to members of the board of directors. Although this is the best answer, in some organizations, the CIO or COO may instead report on the IT function.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      6,
      4,
      44,
      45,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 568,
    "question": "A new CIO in an organization is building its formal IT department from the ground up. To ensure collaboration among business leaders and department heads in the organization, the CIO should form and manage:",
    "choice_a": "A technology committee of the board of directors",
    "choice_b": "An IT steering committee",
    "choice_c": "An audit committee of the board of directors",
    "choice_d": "A business-aligned IT policy",
    "correct_answer": "B",
    "explanation": "An IT steering committee, consisting of senior executives, business unit leaders, and department heads, when properly facilitated by the CIO, can discuss organization-wide issues related to IT and make strategic decisions about the allocation of resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      7,
      27,
      1,
      6,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 569,
    "question": "The best person or group to make risk treatment decisions is:",
    "choice_a": "The chief information security officer (CISO)",
    "choice_b": "The audit committee of the board of directors",
    "choice_c": "The cybersecurity steering committee",
    "choice_d": "External auditors",
    "correct_answer": "C",
    "explanation": "The cybersecurity steering committee, which should consist of senior executives, business unit leaders, and department heads, should openly discuss, collaborate, and decide on most risk treatment issues in an organization. If decisions are made by an individual such as the CISO or CRO, business leaders may be less likely to support those decisions as they may not have had as large a role in decision-making.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      4,
      44,
      24,
      18,
      22
    ],
    "source": "9781394290116"
  },
  {
    "id": 570,
    "question": "Which is the best party to conduct access reviews?",
    "choice_a": "Users’ managers",
    "choice_b": "Information security manager",
    "choice_c": "IT service desk",
    "choice_d": "Department head",
    "correct_answer": "D",
    "explanation": "The persons who are responsible for business activities should review users’ access to applications that support their business activities. All too often, however, access reviews are performed by persons less qualified to make decisions about which persons should have access (and at what levels or capabilities) to systems and applications critical to their business processes. Commonly, IT personnel perform these reviews as a proxy for business owners, but often, IT personnel do not have as much knowledge about relevant business operations and are therefore less qualified to make quality decisions about user access.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      44,
      4,
      11,
      31,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 571,
    "question": "Which is the best party to make decisions about the configuration and function of business applications?",
    "choice_a": "Business department head",
    "choice_b": "IT business analyst",
    "choice_c": "Application developer",
    "choice_d": "End user",
    "correct_answer": "A",
    "explanation": "As the parties responsible for the ongoing operations and success of business operations and business processes, business department heads are best suited to determine the behavior of business applications supporting business processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      44,
      4,
      53,
      13,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 572,
    "question": "Which of the following is the best definition of custodial responsibility?",
    "choice_a": "The custodian protects assets based on the customer’s defined interests.",
    "choice_b": "The custodian protects assets based on its own defined interests.",
    "choice_c": "The custodian makes decisions based on its own defined interests.",
    "choice_d": "The custodian makes decisions based on the customer’s defined interests.",
    "correct_answer": "D",
    "explanation": "A custodian is charged with a potentially wide range of decisions regarding the care of an asset. Decisions are based on the customer’s defined interests. A germane example is an IT department that builds and maintains information systems on behalf of internal customers; the IT department will make various decisions about the design and operation of an information system so that the system will best meet customers’ needs.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      44,
      4,
      47,
      1,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 573,
    "question": "What is the primary risk of IT acting as custodian for a business owner?",
    "choice_a": "IT may not have enough interest to provide quality care for business applications.",
    "choice_b": "IT may not have sufficient staffing to properly care for business applications.",
    "choice_c": "IT may have insufficient knowledge of business operations to make good decisions.",
    "choice_d": "Business departments may not give IT sufficient access to properly manage applications.",
    "correct_answer": "C",
    "explanation": "IT personnel tend to focus their thoughts on the technology supporting business departments and do not focus enough on the business operations occurring in the business departments they support. Often, IT departments are observed to make too many assumptions about the needs of their customers and do not work hard enough to understand their users’ needs to ensure that business applications will support them properly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      7,
      44,
      27,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 574,
    "question": "An organization needs to hire an executive who will build a management program that considers threats and vulnerabilities. The best job title for this position is:",
    "choice_a": "CSO",
    "choice_b": "CRO",
    "choice_c": "CISO",
    "choice_d": "CIRO",
    "correct_answer": "B",
    "explanation": "The CRO (chief risk officer) is responsible for managing risk for multiple types of assets, commonly information assets, as well as physical assets and/or workplace safety. In financial services organizations, the CRO will also manage risks associated with financial transactions or financial asset portfolios.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      45,
      18,
      44,
      17,
      20
    ],
    "source": "9781394290116"
  },
  {
    "id": 575,
    "question": "An organization needs to hire an executive who will be responsible for ensuring that the organization’s policies, business processes, and information systems are compliant with laws and regulations concerning the proper collection, use, and protection of personally identifiable information. What is the best job title for the organization to use for this position?",
    "choice_a": "CSO",
    "choice_b": "CIRO",
    "choice_c": "CISO",
    "choice_d": "CPO",
    "correct_answer": "D",
    "explanation": "The chief privacy officer (CPO) is the best title for a position in which the executive ensures that the organization’s policies, practices, controls, and systems enforce policies that address the proper collection, use, and protection of personally identifiable information (PII).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      45,
      10,
      4,
      29,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 576,
    "question": "The Big Data Company is adjusting several position titles in its IT department to reflect industry standards. Included in the consideration are two individuals. The first is responsible for the overall relationships and data flows among the company’s internal and external information systems. The second is responsible for the overall health and management of systems containing information. Which two job titles are most appropriate for these two roles?",
    "choice_a": "Systems architect and database administrator",
    "choice_b": "Data architect and data scientist",
    "choice_c": "Data scientist and database administrator",
    "choice_d": "Data architect and database administrator",
    "correct_answer": "D",
    "explanation": "A data architect is the best position title for someone who is responsible for the overall relationships and data flows among a company’s information systems. Database administrator (DBA) is the best position title for someone who is responsible for maintaining the systems containing information (often, database management systems [DBMSs]) throughout the organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      49,
      44,
      13,
      45
    ],
    "source": "9781394290116"
  },
  {
    "id": 577,
    "question": "What is the primary distinction between a network engineer and a telecom engineer?",
    "choice_a": "A network engineer is primarily involved with networks and internal network media, whereas a telecom engineer is primarily involved with networks and external (carrier) network media.",
    "choice_b": "A network engineer is primarily involved with networks and external (carrier) network media, whereas a telecom engineer is primarily involved with networks and internal network media.",
    "choice_c": "A network engineer is primarily involved with Layer 3 protocols and above, whereas a telecom engineer is primarily involved with Layer 1 and Layer 2 protocols.",
    "choice_d": "There is no distinction, as both are involved in all aspects of an organization’s networks.",
    "correct_answer": "A",
    "explanation": "A network engineer is primarily involved with networks and internal network media (including cabling and internal wireless networks such as Wi-Fi), whereas a telecom engineer is primarily involved with networks and external (carrier) network media such as MPLS, Frame Relay, and dark fiber.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      46,
      48,
      44,
      43,
      27
    ],
    "source": "9781394290116"
  },
  {
    "id": 578,
    "question": "An organization that is a US public company is redesigning its access management and access review controls. What is the best role for Internal Audit in this redesign effort?",
    "choice_a": "Develop procedures.",
    "choice_b": "Design controls.",
    "choice_c": "Provide feedback on control design.",
    "choice_d": "Develop controls and procedures.",
    "correct_answer": "C",
    "explanation": "Any Internal Audit function should not design or implement controls or procedures other than those in its own department. Internal Audit may, however, opine on the design of controls for their suitability to achieve control objectives and auditability. Internal Audit cannot play a design role in any process or control that it may later be required to audit.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      5,
      1,
      47,
      29,
      39
    ],
    "source": "9781394290116"
  },
  {
    "id": 579,
    "question": "A security operations manager proposes that engineers who design and manage information systems play a role in monitoring those systems. Is design and management compatible with monitoring? Why or why not?",
    "choice_a": "No. Personnel who design and manage systems should not perform a monitoring role, as this is a conflict of interest.",
    "choice_b": "Yes. Personnel who design and manage systems will be more familiar with the steps to take, as well as the reasons to take them when alerts are generated.",
    "choice_c": "No. Personnel who design and manage systems will not be familiar with response procedures when alerts are generated.",
    "choice_d": "No. Personnel who design and manage systems are not permitted access to production environments and should not perform monitoring.",
    "correct_answer": "B",
    "explanation": "Personnel who design and manage information systems are more likely to be familiar with the nature of alerts, as well as procedures for responding to them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      47,
      46,
      50,
      4,
      9
    ],
    "source": "9781394290116"
  },
  {
    "id": 580,
    "question": "The purpose of metrics in an IT department is to:",
    "choice_a": "Measure the performance and effectiveness of controls.",
    "choice_b": "Measure the likelihood of an attack on the organization.",
    "choice_c": "Predict the likelihood of an attack on an organization.",
    "choice_d": "Predict the next IT service outage.",
    "correct_answer": "A",
    "explanation": "The purpose of metrics is to manage the performance and effectiveness of security controls. The meaning and usefulness of specific metrics will depend upon the context and measurement method of specific controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      50,
      3,
      41,
      52
    ],
    "source": "9781394290116"
  },
  {
    "id": 581,
    "question": "Which security metric is best considered a leading indicator of an attack?",
    "choice_a": "Number of firewall rules triggered",
    "choice_b": "Number of security awareness training sessions completed",
    "choice_c": "Percentage of systems scanned",
    "choice_d": "Mean time to apply security patches",
    "correct_answer": "D",
    "explanation": "There is a strong correlation between the absence of security patches and the likelihood and success of attacks on systems. Information systems patched soon after patches are available are far less likely to be successfully attacked, whereas systems without security patches (and those where the organization takes many months to apply patches) are easy targets for intruders.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      51,
      50,
      20,
      40,
      22
    ],
    "source": "9781394290116"
  },
  {
    "id": 582,
    "question": "Steve, a CISO, has vulnerability management metrics and needs to build business-level metrics. Which of the following is the best business-level leading indicator metric suitable for his organization’s board of directors?",
    "choice_a": "Average time to patch servers supporting manufacturing processes",
    "choice_b": "Frequency of security scans of servers supporting manufacturing processes",
    "choice_c": "Percentage of servers supporting manufacturing processes that are scanned by vulnerability scanning tools",
    "choice_d": "Number of vulnerabilities remediated on servers supporting manufacturing processes",
    "correct_answer": "A",
    "explanation": "This is the best metric that serves as a leading indicator. This metric portrays the average time that critical servers are potentially exposed to new security threats. A metric is considered a leading indicator if it foretells future events.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      52,
      51,
      3,
      40,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 583,
    "question": "The metric “percentage of systems with completed installation of advanced anti-malware” is best described as:",
    "choice_a": "A key operational indicator (KOI)",
    "choice_b": "A key performance indicator (KPI)",
    "choice_c": "A key goal indicator (KGI)",
    "choice_d": "A key risk indicator (KRI)",
    "correct_answer": "C",
    "explanation": "An “installation completion” metric is most likely associated with a strategic goal; in this case, the installation of advanced antimalware on systems. This metric could, arguably, be a KRI as well because this may also indicate risk reduction on account of an improved capability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      7,
      16,
      41
    ],
    "source": "9781394290116"
  },
  {
    "id": 584,
    "question": "A member of the board of directors has asked Ravila, a CIRO, to produce a metric showing the reduction of risk as a result of the organization making key improvements to its security information and event management system. Which type of metric is most suitable for this purpose?",
    "choice_a": "KGI",
    "choice_b": "RACI",
    "choice_c": "KRI",
    "choice_d": "ROSI",
    "correct_answer": "C",
    "explanation": "The most suitable metric is a key risk indicator (KRI). Still, this will be a challenge because high-impact events usually occur rarely.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      25,
      16,
      24,
      26
    ],
    "source": "9781394290116"
  },
  {
    "id": 585,
    "question": "A common way to determine the effectiveness of IT metrics is the SMART method. SMART stands for:",
    "choice_a": "Security Metrics Are Risk Treatment",
    "choice_b": "Specific, Measurable, Attainable, Relevant, Timely",
    "choice_c": "Specific, Measurable, Actionable, Relevant, Timely",
    "choice_d": "Specific, Manageable, Actionable, Relevant, Timely",
    "correct_answer": "B",
    "explanation": "SMART, in the context of metrics, stands for Specific, Measurable, Attainable, Relevant, and Timely.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      3,
      51,
      34,
      37,
      2
    ],
    "source": "9781394290116"
  },
  {
    "id": 586,
    "question": "The statement “Complete migration of flagship system to the latest version of vendor-supplied software” is an example of:",
    "choice_a": "A mission statement",
    "choice_b": "A vision statement",
    "choice_c": "A purpose statement",
    "choice_d": "An objective statement",
    "correct_answer": "D",
    "explanation": "“Complete migration of flagship system to latest version of vendor-supplied software” is a statement of a strategic objective.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      7,
      6,
      1,
      18,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 587,
    "question": "Ernie, a CIO who manages a large IT team, wants to create a mission statement for the team. What is the best approach for creating this mission statement?",
    "choice_a": "Start with the organization’s mission statement.",
    "choice_b": "Start with Ernie’s most recent performance review.",
    "choice_c": "Start with the results of the most recent risk assessment.",
    "choice_d": "Start with the body of open items in the project portfolio.",
    "correct_answer": "A",
    "explanation": "The best way to manage an IT department is to align it with the business it is supporting. When creating an IT department mission statement, a good start is to look at the overall organization’s mission statement; this way, the IT department’s mission is more likely to align with the overall organization. If the overall organization lacks a mission statement, the CIO can use what he knows about the organization’s purpose to build an IT department mission statement that is sure to support the organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      7,
      6,
      18,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 588,
    "question": "Which of the following statements is the best description for the purpose of performing risk management?",
    "choice_a": "Identify and manage vulnerabilities that may permit security events to occur.",
    "choice_b": "Identify and manage threats that are relevant to the organization.",
    "choice_c": "Assess the risks associated with third-party service providers.",
    "choice_d": "Assess and manage risks associated with doing business online.",
    "correct_answer": "B",
    "explanation": "The purpose of risk management is to identify threats that, if they occurred, would cause some sort of harm to the organization.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      16,
      20,
      18,
      24,
      9
    ],
    "source": "9781394290116"
  },
  {
    "id": 589,
    "question": "Key metrics showing the effectiveness of a risk management program would <i>not</i> include:",
    "choice_a": "Reduction in the number of security events",
    "choice_b": "Reduction in the impact of security events",
    "choice_c": "Reduction in the time to remediate vulnerabilities",
    "choice_d": "Reduction in the number of patches applied",
    "correct_answer": "D",
    "explanation": "The number of patches applied is not a metric that indicates risk management program effectiveness or even the effectiveness of a vulnerability management program.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      51,
      52,
      50,
      24,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 590,
    "question": "Examples of security program performance metrics include all of the following <i>except</i>:",
    "choice_a": "Time to detect security incidents",
    "choice_b": "Time to remediate security incidents",
    "choice_c": "Time to perform security scans",
    "choice_d": "Time to discover vulnerabilities",
    "correct_answer": "C",
    "explanation": "The time required to perform security scans is <i>not</i> a good example of a security program performance metric.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      50,
      41,
      52,
      3
    ],
    "source": "9781394290116"
  },
  {
    "id": 591,
    "question": "Two similar-sized organizations are merging. Paul will be the CIO of the new combined organization. What is the greatest risk that may occur as a result of the merger?",
    "choice_a": "Differences in practices that may not be understood",
    "choice_b": "Duplication of effort",
    "choice_c": "Gaps in coverage of key processes",
    "choice_d": "Higher tooling costs",
    "correct_answer": "A",
    "explanation": "A merger of two organizations typically results in the introduction of new practices that are not always understood. The CIO may specify directives to the new, combined IT department that could result in an increase in one or more risks. For example, the combining of two different organizations’ device configuration standards could result in a new standard that leads to new, unforeseen problems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      18,
      16,
      27
    ],
    "source": "9781394290116"
  },
  {
    "id": 592,
    "question": "The purpose of value delivery metrics is:",
    "choice_a": "Long-term reduction in costs",
    "choice_b": "Reduction in ROSI",
    "choice_c": "Increase in ROSI",
    "choice_d": "Increase in net profit",
    "correct_answer": "A",
    "explanation": "Value delivery metrics are most often associated with long-term reductions in costs in proportion to other measures, such as the number of employees and assets.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      51,
      3,
      34,
      50,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 593,
    "question": "Joseph, a CIO, is collecting statistics on several operational areas and needs to find a standard way of measuring and publishing information about the effectiveness of his program. Which of the following is the best approach to follow?",
    "choice_a": "Scaled score",
    "choice_b": "NIST Cybersecurity Framework (CSF)",
    "choice_c": "Business Model for Information Security (BMIS)",
    "choice_d": "Balanced scorecard (BSC)",
    "correct_answer": "D",
    "explanation": "The balanced scorecard is a well-known framework that is used to measure the performance and effectiveness of an organization. The balanced scorecard is used to determine how well an organization can fulfill its mission and strategic objectives and how well it is aligned with overall organizational objectives.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      3,
      41,
      1,
      6,
      7
    ],
    "source": "9781394290116"
  },
  {
    "id": 594,
    "question": "Which of the following is the best description of the Business Model for Information Security (BMIS)?",
    "choice_a": "Describes the relationships (as dynamic interconnections) between policy, people, process, and technology",
    "choice_b": "Describes the relationships (as dynamic interconnections) between people, process, technology, and the organization",
    "choice_c": "Describes the primary elements (people, process, and technology) in an organization",
    "choice_d": "Describes the dynamic interconnections (people, process, and technology) in an organization",
    "correct_answer": "B",
    "explanation": "The Business Model for Information Security (BMIS) describes the dynamic interconnections between the four elements of an organization: people, process, technology, and the organization itself. The dynamic interconnections describe the relationship between each of the relationship pairs. For example, the dynamic interconnection known as “human factors” describes the relationship between people and technology.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      1,
      2,
      40,
      43,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 595,
    "question": "What is the correct name for the model shown here?<img src=\"/question_assets/CISA/c02f001.png\" alt=\"Triangular diagram with nodes for People, Technology, Strategy, and central Process node, connected with each other with its subcategories.\"/>\n\n<figcaption>Triangular diagram with nodes for People, Technology, Strategy, and central Process node, connected with each other with its subcategories.</figcaption>",
    "choice_a": "COBIT Model for Information Technology",
    "choice_b": "COBIT Model for Information Security",
    "choice_c": "Business Model for Information Security",
    "choice_d": "Business Model for Information Technology",
    "correct_answer": "C",
    "explanation": "This is a depiction of the Business Model for Information Security (BMIS), which was developed by ISACA to help individuals better understand the nature of the relationships between people, process, technology, and the organization itself.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      1,
      2,
      17,
      50,
      3
    ],
    "source": "9781394290116"
  },
  {
    "id": 596,
    "question": "Jacqueline, an experienced CISO, is reading the findings in a recent risk assessment that describes deficiencies in the organization’s vulnerability management process. How would Jacqueline use the Business Model for Information Security (BMIS) to analyze the deficiency?",
    "choice_a": "Identify the elements connected to the process dynamic interconnection (DI).",
    "choice_b": "Identify the DIs connected to the process element.",
    "choice_c": "Identify the dynamic elements connected to human factors.",
    "choice_d": "Identify the dynamic elements connected to technology.",
    "correct_answer": "B",
    "explanation": "The deficiency was identified in the vulnerability management process. The CISO would see what dynamic interconnections (DIs) are connected to the process element. They are emergence (connecting to people), enabling and support (connecting to technology), and governing (connecting to organization). A description of the deficiency in the vulnerability management process should lead Jacqueline to one of the dynamic interconnections: emergence, enabling and support, or governing. In this case, the process deficiency is related to the frequency of scans, which is most likely the governing DI. Further investigation reveals that policy permits vulnerability scans only during small service windows, which is not enough time for scans to be completed. The solution to this deficiency is likely a process or policy change so that scans will be permitted to run through to completion.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      40,
      15,
      9,
      5,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 597,
    "question": "Which of the following would constitute an appropriate use of the Zachman enterprise framework?",
    "choice_a": "An IT service management model, as an alternative to ITIL",
    "choice_b": "Identifying system components, followed by high-level design and business functions",
    "choice_c": "Development of business requirements, translated top-down into technical architecture",
    "choice_d": "IT systems described at a high level and then in increasing levels of detail",
    "correct_answer": "D",
    "explanation": "Zachman is an IT enterprise framework that describes IT systems at a high level and in increasing levels of detail, down to individual components.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      13,
      1,
      15,
      41,
      37
    ],
    "source": "9781394290116"
  },
  {
    "id": 598,
    "question": "An IT architect needs to document the flow of data from one system to another, including external systems operated by third-party service providers. What kind of documentation does the IT architect need to develop?",
    "choice_a": "Data flow diagrams (DFDs)",
    "choice_b": "Entity relationship diagrams (ERDs)",
    "choice_c": "A Zachman architecture framework",
    "choice_d": "Visio diagrams showing information systems and data flows",
    "correct_answer": "A",
    "explanation": "The IT architect needs to develop data flow diagrams, which are visual depictions showing information systems (and information system components, optionally) and the detailed nature of data flowing among them. DFDs are sometimes accompanied by documents that describe metadata, such as system specifications and descriptions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      13,
      33,
      34,
      57,
      56
    ],
    "source": "9781394290116"
  },
  {
    "id": 599,
    "question": "Carole is a CISO in a new organization with a fledgling security program. Carole needs to identify and develop mechanisms to ensure desired outcomes in selected business processes. What is a common term used to define these mechanisms?",
    "choice_a": "Checkpoints",
    "choice_b": "Detective controls",
    "choice_c": "Controls",
    "choice_d": "Preventive controls",
    "correct_answer": "C",
    "explanation": "<i>Controls</i> is the best term describing the mechanisms designed to ensure desired outcomes in business processes.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      4,
      5,
      50,
      15,
      22
    ],
    "source": "9781394290116"
  },
  {
    "id": 600,
    "question": "What is the best approach to developing security controls in a new organization?",
    "choice_a": "Start with a standard control framework and make risk-based adjustments as needed.",
    "choice_b": "Start from scratch and develop controls based on risk as needed.",
    "choice_c": "Start with NIST CSF and move up to ISO 27001 and then NIST 800-53 as the organization matures.",
    "choice_d": "Develop controls in response to an initial risk assessment.",
    "correct_answer": "A",
    "explanation": "Starting with a standard control framework is the best approach, particularly if an appropriate business-relevant framework is selected. In a proper risk management framework, risk assessment and risk treatment will result in adjustments to the framework (removing, improving, and adding controls) over time.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      39,
      16,
      40,
      22,
      18
    ],
    "source": "9781394290116"
  },
  {
    "id": 601,
    "question": "Which of the following is the best description of the COBIT framework?",
    "choice_a": "A security process and controls framework that can be integrated with ITIL or ISO 20000",
    "choice_b": "An IT controls and process framework on which IT controls and processes can be added at an organization’s discretion",
    "choice_c": "An IT process framework with optional security processes when Extended COBIT is implemented",
    "choice_d": "An IT process framework that includes security processes that are interspersed throughout the framework",
    "correct_answer": "D",
    "explanation": "COBIT is an IT process framework with security processes that appear throughout the framework. Developed by ISACA and now in its fifth major release, COBIT’s four domains are Plan and Organize, Acquire and Implement, Deliver and Support, and Monitor and Evaluate. IT and security processes are contained in each of these domains.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      2,
      39,
      41,
      53,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 602,
    "question": "One distinct disadvantage of the ISO 27001 standard is:",
    "choice_a": "The standard is costly (over US$100 per copy).",
    "choice_b": "The standard is available only for use outside the US.",
    "choice_c": "The standard is available only for use in the US.",
    "choice_d": "The standard is suitable only for large organizations.",
    "correct_answer": "A",
    "explanation": "Single copies of the ISO 27001 standard (as well as virtually all other ISO standards) cost over US $100 each. This prevents widespread adoption of the standard, as organizations are somewhat less likely to implement it because the standard costs hundreds of dollars to download and understand. Further, students are unlikely to learn about the standard in school because of its cost. Contrast this with most other standards, such as NIST SP 800-53 or CIS, which are free to download and use.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      40,
      2,
      14,
      37,
      39
    ],
    "source": "9781394290116"
  },
  {
    "id": 603,
    "question": "Which of the following statements about ISO 27001 is correct?",
    "choice_a": "ISO 27001 consists primarily of a framework of security controls, followed by an appendix of security requirements for running a security management program.",
    "choice_b": "ISO 27001 consists primarily of a body of requirements for running a security management program, along with an appendix of security controls.",
    "choice_c": "ISO 27001 consists of a framework of information security controls.",
    "choice_d": "ISO 27001 consists of a framework of requirements for running a security management program.",
    "correct_answer": "B",
    "explanation": "ISO 27001’s main focus is the body of requirements that describe all of the required activities and business records needed to run an information security program. ISO 27001 also includes an appendix containing a framework of information security controls. The controls here are described briefly; the ISO 27002 standard contains the same control framework but with extensive descriptions for each control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      39,
      2,
      9,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 604,
    "question": "The US law that regulates the protection of data related to medical care is:",
    "choice_a": "PIPEDA",
    "choice_b": "HIPAA",
    "choice_c": "GLBA",
    "choice_d": "GDPR",
    "correct_answer": "B",
    "explanation": "HIPAA is the Health Insurance Portability and Accountability Act, which is composed of a “Privacy Rule” and a “Security Rule.”.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      59,
      40,
      4,
      5,
      33
    ],
    "source": "9781394290116"
  },
  {
    "id": 605,
    "question": "The regulation “Security and Privacy Controls for Federal Information Systems and Organizations” is better known as:",
    "choice_a": "ISO/IEC 27001",
    "choice_b": "ISO/IEC 27002",
    "choice_c": "NIST CSF",
    "choice_d": "NIST SP 800-53",
    "correct_answer": "D",
    "explanation": "NIST SP 800-53, also known as NIST 800-53, is the security controls framework developed by the US National Institute for Standards and Technology and published in its 800-series Special Publication library. NIST SP 800-53 is required for all branches of the US federal government and has also been widely adopted by other government agencies and private industry in the US and around the world.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      40,
      2,
      9,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 606,
    "question": "What is the best explanation for the Implementation Tiers in the NIST Cybersecurity Framework?",
    "choice_a": "Implementation Tiers are levels of risk as determined by the organization.",
    "choice_b": "Implementation Tiers are stages of implementation of controls in the framework.",
    "choice_c": "Implementation Tiers are likened to maturity levels.",
    "choice_d": "Implementation Tiers are levels of risk as determined by an external auditor or regulator.",
    "correct_answer": "C",
    "explanation": "Although the CSF states that Implementation Tiers are not strictly maturity levels, they are very similar to maturity levels.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      2,
      41,
      40,
      51
    ],
    "source": "9781394290116"
  },
  {
    "id": 607,
    "question": "Jeffrey is a CIO in an organization that provides financial services for private organizations, government agencies, and federal agencies in the US. Which is the best information security controls framework for this organization?",
    "choice_a": "CIS",
    "choice_b": "ISO 27001",
    "choice_c": "NIST CSF",
    "choice_d": "NIST SP 800-53",
    "correct_answer": "D",
    "explanation": "As a service provider for the US federal government, Jeffrey’s organization is required to adopt the NIST SP 800-53 controls framework.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      2,
      40,
      34,
      59
    ],
    "source": "9781394290116"
  },
  {
    "id": 608,
    "question": "The scope of requirements of PCI DSS is:",
    "choice_a": "All systems that store, process, and transmit credit card numbers, as well as all other systems that can communicate with these systems",
    "choice_b": "All systems that store, process, and transmit credit card numbers",
    "choice_c": "All systems that store, process, and transmit unencrypted credit card numbers",
    "choice_d": "All systems in an organization where credit card numbers are stored, processed, and transmitted",
    "correct_answer": "A",
    "explanation": "The systems that are in scope for PCI DSS are all those that store, process, or transmit credit card numbers, as well as all other systems that can communicate with those systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      14,
      39,
      10,
      18
    ],
    "source": "9781394290116"
  },
  {
    "id": 609,
    "question": "Which of the following statements is true about controls in the Payment Card Industry Data Security Standard?",
    "choice_a": "Many controls are required, whereas some are “addressable,” or optional, based on risk.",
    "choice_b": "All applicable controls are required, regardless of actual risk.",
    "choice_c": "The required controls are determined for each organization by the acquiring bank.",
    "choice_d": "In addition to core controls, each credit card brand has its own unique controls.",
    "correct_answer": "B",
    "explanation": "All applicable controls are required for all organizations. Additional controls are required for service providers.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      14,
      40,
      34,
      56,
      59
    ],
    "source": "9781394290116"
  },
  {
    "id": 610,
    "question": "The PCI DSS is an example of:",
    "choice_a": "An industry regulation that is enforced with fines",
    "choice_b": "A private industry standard that is enforced with contracts",
    "choice_c": "A voluntary standard that, if used, can reduce cyber insurance premiums",
    "choice_d": "An international law enforced through treaties with member nations",
    "correct_answer": "B",
    "explanation": "PCI DSS was developed by a consortium of the major credit card brands in the world: Visa, MasterCard, American Express, Discover, and JCB. PCI DSS is enforced through credit card brands’ operating rules, as well as by acquiring banks – all enforced through contracts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      14,
      39,
      22,
      9
    ],
    "source": "9781394290116"
  },
  {
    "id": 611,
    "question": "What are three factors that a risk manager might consider when developing an information security strategy?",
    "choice_a": "Threats, risks, and solutions",
    "choice_b": "Prevention, detection, and response",
    "choice_c": "Risk levels, staff qualifications, and security tooling",
    "choice_d": "Risk levels, operating costs, and compliance levels",
    "correct_answer": "D",
    "explanation": "When a risk manager is developing a long-term strategy for an information security program, the best three factors are risk levels, operating costs, and compliance levels. One of these factors may be more important than others in any given organization and for a variety of reasons. Generally, a long-term strategy is being developed to improve the state of one of these: reduction of risk, reduction of cost, or improvement of compliance.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      16,
      17,
      20,
      24,
      50
    ],
    "source": "9781394290116"
  },
  {
    "id": 612,
    "question": "The responsibility for facilitation of an organization’s cybersecurity program lies with:",
    "choice_a": "The board of directors",
    "choice_b": "The chief executive officer (CEO)",
    "choice_c": "The chief information officer (CIO)",
    "choice_d": "The chief information security officer (CISO)",
    "correct_answer": "D",
    "explanation": "A primary role of the CISO is the facilitation of an organization’s cybersecurity program and the risk management process. With few exceptions, the CISO should facilitate discussions and decisions on risk treatment but should not be the final decision maker on such matters.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      4,
      45,
      50,
      16,
      22
    ],
    "source": "9781394290116"
  },
  {
    "id": 613,
    "question": "The Zachman framework is:",
    "choice_a": "An IT process framework",
    "choice_b": "An enterprise architecture framework",
    "choice_c": "A security governance framework",
    "choice_d": "An IT governance framework",
    "correct_answer": "B",
    "explanation": "Zachman is an enterprise architecture framework used to depict the layers of an IT environment in increasing levels of detail.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      1,
      43,
      27,
      41
    ],
    "source": "9781394290116"
  },
  {
    "id": 614,
    "question": "An enterprise architect wants to create a visual artifact that illustrates information moving between systems. This artifact is a/an:",
    "choice_a": "Data flow diagram",
    "choice_b": "Entity-relationship diagram",
    "choice_c": "Gantt chart",
    "choice_d": "Zachman model",
    "correct_answer": "A",
    "explanation": "A data flow diagram (DFD) visually depicts the flow of information between systems and/or entities.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      13,
      14,
      20,
      19,
      24
    ],
    "source": "9781394290116"
  },
  {
    "id": 615,
    "question": "The philosophy whereby persons’ and systems’ identities are considered untrusted by default is known as:",
    "choice_a": "Least privilege",
    "choice_b": "Trust but verify",
    "choice_c": "Zero trust",
    "choice_d": "Transitive trust",
    "correct_answer": "C",
    "explanation": "Zero trust is an architectural philosophy wherein one or more portions of an environment are considered untrusted by default.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      9,
      11,
      40,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 616,
    "question": "In an organization with numerous business locations, including sales offices, corporate offices, warehouses, and data centers, IT and security leaders want to develop a more consistent approach to protective measures in these locations. The IT and security leaders should develop:",
    "choice_a": "A data classification policy",
    "choice_b": "A site classification policy",
    "choice_c": "An access control policy",
    "choice_d": "An access control guideline",
    "correct_answer": "B",
    "explanation": "A site classification policy can be used to define various classifications with respective protective measures to drive consistency to site protection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      15,
      8,
      12,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 617,
    "question": "Who in an organization should be authorized to represent the organization on social media sites?",
    "choice_a": "Data privacy officer",
    "choice_b": "Chief information officer",
    "choice_c": "Chief information security officer",
    "choice_d": "Public information officer",
    "correct_answer": "D",
    "explanation": "A public information officer (PIO) should be the person or role authorized to represent the organization on social media. Similar titles include social media manager and corporate communications director.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      44,
      29,
      4,
      11,
      45
    ],
    "source": "9781394290116"
  },
  {
    "id": 618,
    "question": "An IT worker is reading a document that contains helpful information for implementing an encryption algorithm within a software program. What kind of a document is the IT worker reading?",
    "choice_a": "A policy",
    "choice_b": "A guideline",
    "choice_c": "A standard",
    "choice_d": "A procedure",
    "correct_answer": "B",
    "explanation": "A guideline is a document containing information to help personnel understand how to comply with a policy or standard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      8,
      1,
      9,
      50
    ],
    "source": "9781394290116"
  },
  {
    "id": 619,
    "question": "All of the following are options for risk treatment <i>except</i>:",
    "choice_a": "Transfer",
    "choice_b": "Avoid",
    "choice_c": "Accept",
    "choice_d": "Defer",
    "correct_answer": "D",
    "explanation": "The four options for risk treatment are Accept, Mitigate (or Reduce), Transfer, and Avoid. Defer is not a valid risk treatment option.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      22,
      24,
      20,
      21,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 620,
    "question": "In the context of risk management, what should be considered as assets in an organization?",
    "choice_a": "All systems, data, equipment, intellectual property, buildings and property, and personnel",
    "choice_b": "All systems, data, equipment, intellectual property, and buildings and property",
    "choice_c": "All systems, software, and devices",
    "choice_d": "All systems, software, data, and devices",
    "correct_answer": "A",
    "explanation": "In the context of risk management, assets include buildings and property, equipment, IT systems and devices, supplies and materials, records, information, intellectual property, personnel, and more.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      19,
      16,
      20,
      18,
      22
    ],
    "source": "9781394290116"
  },
  {
    "id": 621,
    "question": "A new cybersecurity manager is setting up a risk management program in an organization that lacks an asset management system. What sources should the manager utilize to get a reasonably complete list of assets?",
    "choice_a": "Financial system asset inventory, network discovery scans, and endpoint management system data",
    "choice_b": "Network discovery scans",
    "choice_c": "Network discovery scans and endpoint management system data",
    "choice_d": "Financial system asset inventory and network discovery scans",
    "correct_answer": "A",
    "explanation": "The most effective method for building a reasonably complete asset inventory requires acquiring data from multiple sources, including but not limited to network discovery scans, financial asset inventory, and endpoint management system data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      16,
      18,
      20,
      55
    ],
    "source": "9781394290116"
  },
  {
    "id": 622,
    "question": "While conducting a risk assessment of a group of business processes and supporting systems, the risk manager identified a number of risks. What further analysis, if any, should the risk manager conduct on those identified risks?",
    "choice_a": "No further analysis is required; identified risks can be brought up for risk treatment decisions.",
    "choice_b": "One or more risk mitigation options should be developed for each identified risk.",
    "choice_c": "One or more risk treatment options should be developed for each identified risk.",
    "choice_d": "Quantified risk analysis should then be performed on identified risks.",
    "correct_answer": "C",
    "explanation": "The best next step is the development of one or more risk mitigation options for each identified risk. This often includes the development of multiple risk mitigation strategies, with risk analysis performed on each to determine whether there are any clear favorites.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      20,
      24,
      16,
      21
    ],
    "source": "9781394290116"
  },
  {
    "id": 623,
    "question": "A risk analyst is conducting a risk assessment on a group of systems. The risk analyst first conducted research into the potential threats against these systems. What should the risk analyst do next?",
    "choice_a": "Continue with quantitative or semi-quantitative risk analysis.",
    "choice_b": "Identify vulnerabilities in the systems.",
    "choice_c": "Calculate the probability of occurrence for those threat events.",
    "choice_d": "Develop a rank-ordered list of mitigation tasks.",
    "correct_answer": "B",
    "explanation": "After identifying potential threats, the best next step is the identification of vulnerabilities. Only when threats and corresponding vulnerabilities are identified can risks then be identified.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      16,
      24,
      21,
      19
    ],
    "source": "9781394290116"
  },
  {
    "id": 624,
    "question": "In the context of cybersecurity risk management, which of the following statements about probability and impact is true?",
    "choice_a": "Both probability and impact are relatively easy to quantify.",
    "choice_b": "Both probability and impact are relatively difficult to quantify.",
    "choice_c": "Impact is relatively difficult to quantify, whereas probability is easy to quantify.",
    "choice_d": "Impact is relatively easy to quantify, whereas probability is not easy to quantify.",
    "correct_answer": "D",
    "explanation": "It is relatively easy to quantify the impact of a threat event in terms of recovery costs, lost revenue, and other costs. However, the probability of threat events is far more difficult to quantify, in part because there are so many risk factors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      25,
      22,
      24,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 625,
    "question": "Missing security patches, non-expiring passwords, and incorrect configuration settings are examples of:",
    "choice_a": "Incidents",
    "choice_b": "Vulnerabilities",
    "choice_c": "Threats",
    "choice_d": "Risks",
    "correct_answer": "B",
    "explanation": "Missing patches, non-expiring passwords, and incorrect configuration settings are all vulnerabilities. These conditions could make it easier for threat events to occur.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      40,
      39,
      9,
      11
    ],
    "source": "9781394290116"
  },
  {
    "id": 626,
    "question": "Which of the following is the best description of exposure factor (EF)?",
    "choice_a": "The financial loss that results from the realization of a threat, expressed as the asset’s total value",
    "choice_b": "The financial loss that results from the realization of a threat, expressed as a percentage of the asset’s total value",
    "choice_c": "The probability of occurrence of a single instance of a threat event",
    "choice_d": "The probability of occurrence of all instances of a threat event",
    "correct_answer": "B",
    "explanation": "Exposure factor, expressed as a percentage, represents the financial loss that occurs when a threat is realized. A threat does not always completely destroy an asset, hence the expression of exposure factor as a percentage of the total value of an asset.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      22,
      19,
      9,
      40
    ],
    "source": "9781394290116"
  },
  {
    "id": 627,
    "question": "An estimate of the number of times that a threat may occur within a single year is known as:",
    "choice_a": "Annualized rate of occurrence (ARO)",
    "choice_b": "Exposure factor (EF)",
    "choice_c": "Annualized loss expectancy (ALE)",
    "choice_d": "Annualized exposure factor (AEF)",
    "correct_answer": "A",
    "explanation": "Annualized rate of occurrence (ARO) is an estimate of the number of times that a threat event will occur in a single year.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      20,
      25,
      22,
      17,
      40
    ],
    "source": "9781394290116"
  },
  {
    "id": 628,
    "question": "How is annualized loss expectancy (ALE) calculated?",
    "choice_a": "Asset value (AV) divided by exposure factor (EF)",
    "choice_b": "Asset value (AV) times exposure factor (EF)",
    "choice_c": "Single loss expectancy (SLE) times annualized rate of occurrence (ARO)",
    "choice_d": "Single loss expectancy (SLE) divided by the annualized rate of occurrence (ARO)",
    "correct_answer": "C",
    "explanation": "Annualized loss expectancy (ALE), defined as the annualized loss of asset value due to threat realization, is calculated by multiplying single loss expectancy (SLE minus the financial loss of a single instance of a threat event) times annualized rate of occurrence (ARO minus an estimate of the number of times that a threat event will occur in a year).",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      21,
      20,
      16,
      22,
      25
    ],
    "source": "9781394290116"
  },
  {
    "id": 629,
    "question": "The acquisition of a cyber insurance policy is an example of:",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk transfer",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk acceptance",
    "correct_answer": "B",
    "explanation": "Cyber insurance policies – as well as other types of insurance policies – represent risk transfer, where another organization accepts certain risks in exchange for a fee.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      16,
      24,
      9,
      20
    ],
    "source": "9781394290116"
  },
  {
    "id": 630,
    "question": "A Europe-based organization has performed a risk assessment on a new online service. The risk assessment identified a high-rated risk related to the privacy of customers. In risk treatment, the organization’s executives selected risk avoidance as its risk treatment decision. What does this decision mean?",
    "choice_a": "The organization will enact one or more controls to reduce risk.",
    "choice_b": "The organization will purchase cyber incident insurance to protect the new online service.",
    "choice_c": "The organization will mitigate risks associated with the new online service.",
    "choice_d": "The organization will discontinue the new online service.",
    "correct_answer": "D",
    "explanation": "Generally, when a risk treatment decision for avoidance is made, this means that the activity associated with the risk will be discontinued.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      16,
      24,
      20,
      26
    ],
    "source": "9781394290116"
  },
  {
    "id": 631,
    "question": "An internal publication describing compensation, benefits, dress code, paid time off, and conduct is known as:",
    "choice_a": "An employee policy manual",
    "choice_b": "An intranet",
    "choice_c": "An employment agreement",
    "choice_d": "A notice of employment practices",
    "correct_answer": "A",
    "explanation": "An employee policy manual, sometimes known as an employee handbook, is a collection of policies, expectations, benefits, compensation, and other employer–employee matters.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      8,
      54,
      44,
      30
    ],
    "source": "9781394290116"
  },
  {
    "id": 632,
    "question": "In the financial services industry, what is the purpose of mandatory vacations?",
    "choice_a": "Gives other employees an opportunity to cross-train",
    "choice_b": "Reduces employers’ financial obligations",
    "choice_c": "Provides extended time for rest and relaxation",
    "choice_d": "Provides adequate time for auditors to examine an employee’s behavior while absent from work",
    "correct_answer": "D",
    "explanation": "In financial services and other industries, mandatory vacations provide an extended block of time that can be used to carefully examine an employee’s activities, including the existence of wrongdoing.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      30,
      47,
      4,
      5,
      28
    ],
    "source": "9781394290116"
  },
  {
    "id": 633,
    "question": "Which of the following is the best description of the accumulation of privilege?",
    "choice_a": "Gaining access rights over an extended period of time",
    "choice_b": "Gaining new user accounts over an extended period of time",
    "choice_c": "Building up a long history of passwords that have been used",
    "choice_d": "Being given local administrator rights based on trust",
    "correct_answer": "A",
    "explanation": "Accumulation of privileges occurs in organizations when access rights are granted to long-time employees, particularly those who transfer from department to department. This is exacerbated in organizations where access rights are seldom or never reviewed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      11,
      29,
      44,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 634,
    "question": "Which of the following best explains how accumulation of privileges occurs?",
    "choice_a": "Long-time IT administrators are given more administrative rights over time.",
    "choice_b": "Long-time employees slowly accumulate privileges, particularly when transferring from department to department.",
    "choice_c": "A malware attack gives attackers access to more systems and devices over time.",
    "choice_d": "AI-generated phishing emails convince many more employees to click on links or open attachments.",
    "correct_answer": "B",
    "explanation": "Accumulation of privileges occurs most frequently with personnel who stay in one organization for many years, slowly accumulating access to more systems and information. Organizations that lack periodic access reviews are less likely to detect this.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      30,
      11,
      53,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 635,
    "question": "IS auditors have detected several instances of lack of segregation of duties in a small organization’s accounting department. How can risk best be reduced?",
    "choice_a": "Hire additional personnel.",
    "choice_b": "Perform additional activity reviews to detect any wrongdoing.",
    "choice_c": "Adopt a strict “need to know” access policy.",
    "choice_d": "Adopt a strict “least privilege” access policy.",
    "correct_answer": "B",
    "explanation": "Segregation of duties issues more often arise in smaller organizations that lack enough personnel to separate roles in critical processes. One remedy is to increase the frequency and/or rigor of periodic transaction reviews to detect and deter wrongdoing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      47,
      30,
      22,
      54,
      20
    ],
    "source": "9781394290116"
  },
  {
    "id": 636,
    "question": "A metric that is used to depict the probability and/or impact of cyber threat events is known as:",
    "choice_a": "A key risk indicator (KRI)",
    "choice_b": "A key performance indicator (KPI)",
    "choice_c": "A key compliance indicator (KCI)",
    "choice_d": "A trailing indicator",
    "correct_answer": "A",
    "explanation": "A key risk indicator is a metric that depicts an important measure of cyber risk.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      51,
      21,
      20,
      16,
      3
    ],
    "source": "9781394290116"
  },
  {
    "id": 637,
    "question": "Which of the following supports the notion of source code vulnerabilities as a quality problem?",
    "choice_a": "Source code vulnerabilities reduce developer productivity.",
    "choice_b": "Source code vulnerabilities require more debugging time.",
    "choice_c": "Source code vulnerabilities are defects that may permit an attacker to more easily compromise a system.",
    "choice_d": "Source code vulnerabilities may lead to application malfunction.",
    "correct_answer": "C",
    "explanation": "Vulnerabilities in application source code are potential entry points for attackers who intend to compromise a system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      39,
      40,
      2,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 638,
    "question": "The prospect of an organization running afoul of an applicable cyber regulation is known as:",
    "choice_a": "An unacceptable risk",
    "choice_b": "The cost of doing business",
    "choice_c": "Cyber risk",
    "choice_d": "Compliance risk",
    "correct_answer": "D",
    "explanation": "Compliance risk is the risk of an organization being found out of compliance with any applicable law, regulation, standard, or other legal obligation. In some instances of compliance risk, there is no appreciable cyber risk, meaning that the probability or impact of a related threat event is low.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      17,
      16,
      14,
      24
    ],
    "source": "9781394290116"
  },
  {
    "id": 639,
    "question": "An auditor is reviewing an organization’s risk management program policies, procedures, and records. The auditor has noted that, in the risk treatment process, risks that are accepted are accepted in perpetuity. What should the auditor conclude from this practice?",
    "choice_a": "The auditor should notify the organization’s board of directors.",
    "choice_b": "There is insufficient information on what the auditor should do.",
    "choice_c": "The auditor should document a finding.",
    "choice_d": "The auditor should note that the organization is following best practices.",
    "correct_answer": "C",
    "explanation": "In risk treatment, when a risk is accepted, the risk should be reviewed again in the future to determine whether the risk should continue to be accepted or another risk treatment option selected. A risk that is acceptable today may not be acceptable in the future because of changes in threats, vulnerabilities, business practices, and risk appetite.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      16,
      24,
      18,
      52
    ],
    "source": "9781394290116"
  },
  {
    "id": 640,
    "question": "An auditor is reviewing an organization’s risk management program and has determined that the risk manager (who reports to the CISO) performs risk assessments and makes the organization’s risk treatment decisions. What should the auditor conclude from this practice?",
    "choice_a": "The auditor should document a finding because a business leader should be making risk treatment decisions.",
    "choice_b": "The auditor should document a finding because the CISO should be making risk treatment decisions.",
    "choice_c": "The auditor should note that the organization is following best practices.",
    "choice_d": "The auditor should suggest that business leaders be informed of risk treatment decisions.",
    "correct_answer": "A",
    "explanation": "Risk managers and CISOs should not be routinely making risk treatment decisions; instead, business leaders should be making these decisions because those decisions have an operational impact on business operations. Additionally, there may be independence issues because the risk manager works for the CISO.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      18,
      44,
      24,
      9
    ],
    "source": "9781394290116"
  },
  {
    "id": 641,
    "question": "What is the best reason for considering a proof of concept?",
    "choice_a": "The system being considered is too expensive to implement all at once.",
    "choice_b": "The system being considered will be a fully customized solution.",
    "choice_c": "The system being considered is too complicated to evaluate fully.",
    "choice_d": "The system being considered is not yet available.",
    "correct_answer": "C",
    "explanation": "The system being evaluated is too complex to evaluate in a walkthrough or by analyzing its specifications.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      130,
      152,
      129,
      117,
      121
    ],
    "source": "9781394290116"
  },
  {
    "id": 642,
    "question": "A formal process whereby the organization gathers all business and technical requirements and forwards them to several qualified vendors, who then respond to them, is called:",
    "choice_a": "Request for information (RFI)",
    "choice_b": "Request for proposals (RFP)",
    "choice_c": "Request for evaluation (RFE)",
    "choice_d": "Request for quote (RFQ)",
    "correct_answer": "B",
    "explanation": "An RFP is a formal process used to publish the organization’s requirements to several vendors, who will then reply formally with proposals that will meet those requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      152,
      130,
      151,
      116
    ],
    "source": "9781394290116"
  },
  {
    "id": 643,
    "question": "An organization that wishes to acquire IT products or services that it fully understands should issue what kind of document?",
    "choice_a": "Request for proposals (RFP)",
    "choice_b": "Request for information (RFI)",
    "choice_c": "Statement of work (SOW)",
    "choice_d": "Bid schedule",
    "correct_answer": "A",
    "explanation": "An organization that wishes to acquire a new IT system or service that it already fully understands should issue a request for proposals (RFP). If the organization does not yet understand the IT products or services it wants to acquire, it should first issue a request for information (RFI) to learn more about them.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      130,
      117,
      116,
      102,
      129
    ],
    "source": "9781394290116"
  },
  {
    "id": 644,
    "question": "Which SEI CMM maturity level states that there is some consistency in the ways that individuals perform tasks from one time to the next, as well as some management planning and direction to ensure that tasks and projects are performed consistently?",
    "choice_a": "Initial",
    "choice_b": "Defined",
    "choice_c": "Repeatable",
    "choice_d": "Managed",
    "correct_answer": "C",
    "explanation": "The repeatable level of the SEI CMM five-level model states that there is some consistency in the ways that individuals perform tasks from one time to the next, as well as some management planning and direction to ensure that tasks and projects are performed consistently.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      138,
      140,
      141,
      115,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 645,
    "question": "At what stage in the acquisition process should a project team develop requirements?",
    "choice_a": "After writing the test plan",
    "choice_b": "After operational process development",
    "choice_c": "Prior to writing the test plan",
    "choice_d": "Prior to operational process development",
    "correct_answer": "C",
    "explanation": "Requirements should be developed early in the systems development/acquisitions life cycle. The best answer here is prior to writing the test plan, but ideally, requirements will be developed far earlier than that – even before the solution is designed.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      117,
      116,
      115,
      151,
      119
    ],
    "source": "9781394290116"
  },
  {
    "id": 646,
    "question": "All of the following are activities a project manager must perform to ensure that a project is progressing in accordance with its plan <i>except</i>:",
    "choice_a": "Designing and testing the system",
    "choice_b": "Tracking project expenditures",
    "choice_c": "Recording task completion",
    "choice_d": "Managing the project schedule",
    "correct_answer": "A",
    "explanation": "It is not the project manager’s job to design and test the system but instead to coordinate those activities as performed by others.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      110,
      103,
      105,
      106,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 647,
    "question": "During which phase of the infrastructure development life cycle are all changes to the environment performed under formal processes, including incident management, problem management, defect management, change management, and configuration management?",
    "choice_a": "Testing",
    "choice_b": "Design",
    "choice_c": "Implementation",
    "choice_d": "Maintenance",
    "correct_answer": "D",
    "explanation": "After a system has been put into production, the maintenance phase involves activities relating to incident management, problems, defects, changes, and configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      123,
      134,
      115
    ],
    "source": "9781394290116"
  },
  {
    "id": 648,
    "question": "Which management processes cover the post-implementation phase of the SDLC?",
    "choice_a": "Maintenance management and change management",
    "choice_b": "Change management and configuration management",
    "choice_c": "Service management and configuration management",
    "choice_d": "Incident management and problem management",
    "correct_answer": "B",
    "explanation": "The post-implementation phase of the SDLC is carried out by the change management and configuration management processes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      134,
      123,
      153
    ],
    "source": "9781394290116"
  },
  {
    "id": 649,
    "question": "Change management and configuration management are key to which phase of the SDLC?",
    "choice_a": "Requirement definition",
    "choice_b": "Design",
    "choice_c": "Maintenance",
    "choice_d": "Testing",
    "correct_answer": "C",
    "explanation": "Change management and configuration management are essential operational processes in the maintenance phase of the SDLC.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      131,
      132,
      123,
      134,
      153
    ],
    "source": "9781394290116"
  },
  {
    "id": 650,
    "question": "Which of the following is a formal verification of system specifications and technologies?",
    "choice_a": "Design review",
    "choice_b": "User acceptance testing (UAT)",
    "choice_c": "Implementation review",
    "choice_d": "Quality assurance testing (QAT)",
    "correct_answer": "D",
    "explanation": "Quality assurance testing is a formal verification of system specifications and technologies. Users are usually not involved in QAT; instead, this testing is typically performed by IT or IS departments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      105,
      153,
      119,
      120
    ],
    "source": "9781394290116"
  },
  {
    "id": 651,
    "question": "All of the following are considerations when selecting and evaluating a software vendor <i>except</i>:",
    "choice_a": "Source code languages",
    "choice_b": "Financial stability",
    "choice_c": "References",
    "choice_d": "Vendor supportability",
    "correct_answer": "A",
    "explanation": "A software vendor’s choice of source code languages is of lesser concern when selecting and evaluating software vendors.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      152,
      117,
      130,
      102,
      116
    ],
    "source": "9781394290116"
  },
  {
    "id": 652,
    "question": "Which type of quality assurance method involves the users rather than IT or IS personnel?",
    "choice_a": "System testing",
    "choice_b": "Functional testing",
    "choice_c": "Quality assurance testing (QAT)",
    "choice_d": "User acceptance testing (UAT)",
    "correct_answer": "D",
    "explanation": "User acceptance testing (UAT) should consist of a formal, written body of specific tests that permits application users to determine whether the application will operate properly.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      121,
      123,
      105,
      119,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 653,
    "question": "All of the following are considered risks to a software development project <i>except</i>:",
    "choice_a": "The delivered software did not adequately meet business needs.",
    "choice_b": "The delivered software is not meeting efficiency needs.",
    "choice_c": "Termination of the project manager.",
    "choice_d": "Project falling behind schedule or exceeding budget.",
    "correct_answer": "C",
    "explanation": "Termination of the project manager is not an anticipated risk in a software development project.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      127,
      110,
      150,
      102,
      106
    ],
    "source": "9781394290116"
  },
  {
    "id": 654,
    "question": "Analysis of regulations and market conditions normally takes place during which activity of the SDLC?",
    "choice_a": "Testing phase",
    "choice_b": "Feasibility study",
    "choice_c": "Design phase",
    "choice_d": "Requirements definition phase",
    "correct_answer": "B",
    "explanation": "Changes in business conditions, including market changes and regulations, take place during the feasibility study, prior to requirements definition, design, and testing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      115,
      102,
      117,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 655,
    "question": "Which term describes a scrum project and is a focused effort to produce some portion of the total project deliverable?",
    "choice_a": "Milestone",
    "choice_b": "Objective",
    "choice_c": "Daily Scrum",
    "choice_d": "Sprint",
    "correct_answer": "D",
    "explanation": "A typical Scrum project consists of several “sprints,” which are focused efforts to produce some portion of the total project deliverable. A sprint usually lasts from two to four weeks.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      114,
      109,
      106,
      113,
      104
    ],
    "source": "9781394290116"
  },
  {
    "id": 656,
    "question": "For what reason would an Internet-based financial application record the IP addresses of users who log in?",
    "choice_a": "This permits application performance testing.",
    "choice_b": "This provides localization information to the application.",
    "choice_c": "This provides authentication information to the application.",
    "choice_d": "This provides forensic information that can be used later.",
    "correct_answer": "D",
    "explanation": "In an Internet-based financial application, it may be useful to record the IP address of each user who logs in. Although it may be infeasible to restrict access by IP address (especially for traveling users), recording IP address at the time of login can be useful later if there is a reason to believe that a user’s account has been hijacked.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      144,
      143,
      156,
      133,
      118
    ],
    "source": "9781394290116"
  },
  {
    "id": 657,
    "question": "In the context of logical access controls, the terms <i>subject</i> and <i>object</i> refer to:",
    "choice_a": "<i>Subject</i> refers to the person who is accessing the data, and <i>object</i> refers to the data being accessed.",
    "choice_b": "<i>Subject</i> refers to the data being accessed, and <i>object</i> refers to the file that contains the data.",
    "choice_c": "<i>Subject</i> refers to the security context, and <i>object</i> refers to the data.",
    "choice_d": "<i>Subject</i> refers to the data, and <i>object</i> refers to the person or entity accessing the data.",
    "correct_answer": "A",
    "explanation": "The terms <i>subject</i> and <i>object</i> are used in the context of access management. <i>Subject</i> refers to a person (or program or machine), and <i>object</i> refers to data (or other resource) being accessed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      144,
      156,
      133,
      145,
      149
    ],
    "source": "9781394290116"
  },
  {
    "id": 658,
    "question": "In the context of logical access control, what does the term <i>fail closed</i> mean?",
    "choice_a": "In the event of a power outage, all access points are closed.",
    "choice_b": "If access is denied, a database table will be closed or locked to changes.",
    "choice_c": "If an access control mechanism fails, all access will be denied.",
    "choice_d": "If an access control mechanism fails, all access will be allowed.",
    "correct_answer": "C",
    "explanation": "The correct definition of <i>fail closed</i> in an access control mechanism is one in which all requested accesses will be denied.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      144,
      145,
      156,
      155,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 659,
    "question": "When would you design an access control to fail open?",
    "choice_a": "In the case of fire suppression controls, which would need to activate immediately if a fire is detected",
    "choice_b": "In the case of building access controls, which would need to permit the evacuation of personnel in an emergency",
    "choice_c": "In the event of an emergency, where data access controls would need to allow anyone access to data so it could be backed up successfully and removed from the site",
    "choice_d": "In the case of an incident where outside investigators would require immediate and complete access to restricted data",
    "correct_answer": "B",
    "explanation": "A good example of an access control that fails open is the case of building access controls, which would need to permit the evacuation of personnel in an emergency.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      144,
      117,
      132,
      145,
      129
    ],
    "source": "9781394290116"
  },
  {
    "id": 660,
    "question": "What are the three levels of the Constructive Cost Model (COCOMO) method for estimating software development projects?",
    "choice_a": "Basic, Intermediate, and Detailed",
    "choice_b": "Levels I, II, and III",
    "choice_c": "Initial, Managed, and Optimized",
    "choice_d": "Organic, Semi-detached, and Embedded",
    "correct_answer": "A",
    "explanation": "The three levels of the COCOMO method for estimating software development projects are Basic, Intermediate, and Detailed.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      107,
      108,
      110,
      102,
      116
    ],
    "source": "9781394290116"
  },
  {
    "id": 661,
    "question": "The best source for requirements for an RFP project is:",
    "choice_a": "Published industry standards",
    "choice_b": "The incumbent system’s specifications",
    "choice_c": "Vendors and suppliers",
    "choice_d": "The organization’s own business, technical, and security requirements",
    "correct_answer": "D",
    "explanation": "An organization that is developing requirements for an RFP (request for proposals) for products or services from vendors needs to develop these requirements internally.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      130,
      152,
      151,
      142
    ],
    "source": "9781394290116"
  },
  {
    "id": 662,
    "question": "An organization wants to build a new application, but it has not yet defined precisely how end-user interaction will work. Which application development technique should be chosen to determine end-user interaction?",
    "choice_a": "Prototyping",
    "choice_b": "RAD",
    "choice_c": "Waterfall",
    "choice_d": "Scrum",
    "correct_answer": "A",
    "explanation": "The best development methodology in a situation where the organization is unable to determine (in the design phase) how end-user interaction will work in a system is to build prototypes of various kinds until the most suitable one can be chosen.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      124,
      119,
      117,
      121,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 663,
    "question": "A project manager regularly sends project status reports to executive management. Executives are requesting that status reports include visual diagrams showing the project schedule and project critical paths from week to week. Which type of chart should the project manager use?",
    "choice_a": "WBS",
    "choice_b": "PRINCE2",
    "choice_c": "PERT",
    "choice_d": "Gantt",
    "correct_answer": "C",
    "explanation": "A PERT chart shows the project status and critical path for a given project.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      108,
      110,
      112,
      106,
      113
    ],
    "source": "9781394290116"
  },
  {
    "id": 664,
    "question": "During which phase of the SDLC are functionality and design characteristics verified?",
    "choice_a": "Maintenance",
    "choice_b": "Implementation",
    "choice_c": "Testing",
    "choice_d": "Design",
    "correct_answer": "C",
    "explanation": "Testing is the phase of a development process where functionality and design are verified in the test plan.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      121,
      115,
      120,
      119,
      153
    ],
    "source": "9781394290116"
  },
  {
    "id": 665,
    "question": "Which kind of testing ensures that data is being formatted properly and inserted into the new application from the old application?",
    "choice_a": "Unit testing",
    "choice_b": "Migration testing",
    "choice_c": "Regression testing",
    "choice_d": "Functional testing",
    "correct_answer": "B",
    "explanation": "When one application is replacing another, data from the old application is often imported into the new application to eliminate the need for both old and new applications to function at the same time. Migration testing ensures that data is being properly formatted and inserted into the new application. This testing is often performed several times in advance of the real, live migration at cutover time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      153,
      158,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 666,
    "question": "Which entity commissions feasibility studies to support a business case?",
    "choice_a": "Project team",
    "choice_b": "Project manager",
    "choice_c": "CISO",
    "choice_d": "IT steering committee",
    "correct_answer": "D",
    "explanation": "An IT steering committee formally commissions the feasibility study, approves the project, assigns IT resources to the project, and approves the project schedule.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      102,
      101,
      105,
      116,
      103
    ],
    "source": "9781394290116"
  },
  {
    "id": 667,
    "question": "What is the purpose of a configuration management database?",
    "choice_a": "Storage of every change made to system components",
    "choice_b": "Storage of available configurations for system components",
    "choice_c": "Storage of approvals for configuration changes to a system",
    "choice_d": "Storage of the most recent change made to system components",
    "correct_answer": "A",
    "explanation": "A configuration management database (CMDB) stores all changes made to a system. This makes it possible for system managers to know the precise configuration of every component at any point in time. This often proves useful during system troubleshooting.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      134,
      132,
      133,
      154,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 668,
    "question": "When is the best time for an organization to measure the business benefits of a new system?",
    "choice_a": "During unit testing",
    "choice_b": "One year after implementation",
    "choice_c": "During requirements definition",
    "choice_d": "During user acceptance testing",
    "correct_answer": "B",
    "explanation": "The best time to measure the business benefits of a new system is after implementation and when enough time has passed for business measurements to be collected and measured.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      100,
      123,
      102,
      116,
      137
    ],
    "source": "9781394290116"
  },
  {
    "id": 669,
    "question": "Which of the following represents the components of the project in graphical or tabular form and is a visual or structural representation of the system, software, or application?",
    "choice_a": "Data flow diagram (DFD)",
    "choice_b": "Work breakdown structure (WBS)",
    "choice_c": "Zachman model",
    "choice_d": "Object breakdown structure (OBS)",
    "correct_answer": "D",
    "explanation": "An OBS is a visual or structural representation of the system, software, or application in a hierarchical form, from high level to fine detail.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      119,
      117,
      115,
      120,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 670,
    "question": "Which type of tests will determine whether there are any failures or errors in input, processing, or output controls in an application?",
    "choice_a": "Referential integrity tests",
    "choice_b": "Data conversion tests",
    "choice_c": "Data integrity tests",
    "choice_d": "Static data storage tests",
    "correct_answer": "C",
    "explanation": "Data integrity testing is used to confirm whether an application properly accepts, processes, and stores information. Data integrity tests will determine whether there are any failures or errors in input, processing, or output controls in an application.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      143,
      156,
      145,
      146,
      147
    ],
    "source": "9781394290116"
  },
  {
    "id": 671,
    "question": "Which quantitative method of sizing software projects is repeatable for traditional programming languages but is not as effective with newer, nontextual languages?",
    "choice_a": "Source lines of code (SLOC)",
    "choice_b": "Work breakdown structure (WBS)",
    "choice_c": "Object breakdown structure (OBS)",
    "choice_d": "Constructive Cost Model (COCOMO)",
    "correct_answer": "A",
    "explanation": "Sizing for software projects has traditionally relied on source lines of code (SLOC) estimates. A similar measuring unit is kilo lines of code (KLOC). The advantage of SLOC and KLOC is that they are quantitative and somewhat repeatable for a given computer language, such as COBOL, FORTRAN, or BASIC. However, these methods are falling out of favor because many of the languages in use today are not textual in nature.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      107,
      125,
      120,
      119,
      115
    ],
    "source": "9781394290116"
  },
  {
    "id": 672,
    "question": "Which type of testing, usually performed by developers during the coding phase of the software development project, is used to verify that the code in various parts of the application works properly?",
    "choice_a": "Unit testing",
    "choice_b": "Regression testing",
    "choice_c": "Functional testing",
    "choice_d": "User acceptance testing",
    "correct_answer": "A",
    "explanation": "Developers usually perform unit testing during the coding phase of the software development project. When each developer is assigned the task of building a section of an application, the specifications that are given to the developer should include test plans or test cases that the developer will use to verify that the code works properly.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      152,
      115,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 673,
    "question": "An organization is considering acquiring a key business application from a small software company. What business provision should the organization require of the software company?",
    "choice_a": "Bonding",
    "choice_b": "Liability insurance",
    "choice_c": "Developer background checks",
    "choice_d": "Place source code in escrow",
    "correct_answer": "D",
    "explanation": "Software escrow ensures that the customer organization will be able to continue using and maintaining an application even if the vendor goes out of business.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      117,
      152,
      160,
      126,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 674,
    "question": "Which phase of the SDLC is continually referenced during the development, acquisition, and testing phases to ensure that the system is meeting the required specifications?",
    "choice_a": "Testing",
    "choice_b": "Requirements definition",
    "choice_c": "Design",
    "choice_d": "Implementation",
    "correct_answer": "B",
    "explanation": "The requirements definition phase and the system requirements developed during this phase are continually referenced throughout the SDLC to ensure that the system meets the requirements that were agreed on.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      117,
      119,
      120,
      121,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 675,
    "question": "What is the purpose of the review process after each phase of the SDLC?",
    "choice_a": "To establish additional requirements",
    "choice_b": "To change existing requirements",
    "choice_c": "To ensure that project deliverables meet the agreed-on requirements",
    "choice_d": "To provide end users with a progress check on system development",
    "correct_answer": "C",
    "explanation": "Post-phase reviews are used to ensure that any project deliverables due at the end of each phase meet requirements. These reviews are sometimes called <i>gate reviews</i> because they represent a gating process where a project is not permitted to progress to a later phase until an earlier phase is reviewed and approved by management.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      115,
      151,
      152,
      150,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 676,
    "question": "The result of strategic planning, process development, and systems development is:",
    "choice_a": "Benefits actualization",
    "choice_b": "Benefits realization",
    "choice_c": "Business viability",
    "choice_d": "Business realization",
    "correct_answer": "B",
    "explanation": "Benefits realization is the result of strategic planning, process development, and systems development, which all contribute toward the launch of business operations to reach a set of business objectives.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      100,
      102,
      115,
      135,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 677,
    "question": "An organization of many large, complex activities that work together to fulfill one or more business objectives is known as:",
    "choice_a": "A program",
    "choice_b": "A repository",
    "choice_c": "A business unit",
    "choice_d": "A department",
    "correct_answer": "A",
    "explanation": "A program is an organization of many large, complex activities and can be thought of as a set of projects that work to fulfill one or more key business objectives or goals. A program is generally a multiyear effort that consists of many complex projects, each with its own project manager, project schedule, budget, and participants.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      101,
      103,
      102,
      106,
      111
    ],
    "source": "9781394290116"
  },
  {
    "id": 678,
    "question": "The document that defines and describes a program is known as a:",
    "choice_a": "WBS",
    "choice_b": "RACI",
    "choice_c": "Policy",
    "choice_d": "Charter",
    "correct_answer": "D",
    "explanation": "A charter is a formal document that defines the objectives of a program, its main timelines, the sources of funding, the names of its principal leaders and managers, and the names of the business executive or executives who are sponsoring the program.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      101,
      102,
      150,
      105,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 679,
    "question": "An organization’s business leader wants to develop a new business idea and needs to do some work to determine whether the idea is favorable. The business leader should conduct a:",
    "choice_a": "Feasibility analysis",
    "choice_b": "Business case",
    "choice_c": "Project proposal",
    "choice_d": "Project plan",
    "correct_answer": "A",
    "explanation": "A feasibility analysis defines the business problem and describes potential solutions.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      102,
      116,
      151,
      115,
      117
    ],
    "source": "9781394290116"
  },
  {
    "id": 680,
    "question": "An organization recently launched a new service, only to realize that costs were higher than expected, and there was a lack of consensus on whether the launch was successful. What should the organization have done first that might have resulted in a better outcome?",
    "choice_a": "Focus groups",
    "choice_b": "Project plan",
    "choice_c": "Business case",
    "choice_d": "Quantitative analysis",
    "correct_answer": "C",
    "explanation": "The organization should have first conducted a business case, a formal document that includes a definition of the business problem, the results of a feasibility analysis, a high-level project plan, a budget, metrics, risks, and success criteria.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      102,
      116,
      151,
      123,
      111
    ],
    "source": "9781394290116"
  },
  {
    "id": 681,
    "question": "An organization implemented a new business application that was two years in a feasibility study, business case, requirements, design, and development. A few weeks after implementation, the IT department conducted measurements to determine business benefits, and the benefits fell far short of expectations. What should the organization have done differently?",
    "choice_a": "Forego business benefit measurements as they are often misleading.",
    "choice_b": "Defined the business benefit measurements in the requirements phase of the project.",
    "choice_c": "Outsourced the business benefit study to eliminate any potential biases.",
    "choice_d": "Conducted business benefit measurements 6–12 months after implementation instead of right away.",
    "correct_answer": "D",
    "explanation": "Organizations should not conduct business benefit measurements immediately after implementing a new business application; it can take some time – even several calendar quarters – for IT and business users to learn how to fully utilize a new system.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      100,
      153,
      102,
      115,
      135
    ],
    "source": "9781394290116"
  },
  {
    "id": 682,
    "question": "A large organization with several departments has project managers in each department and subdepartment. An initiative to improve business efficiency is underway, and one idea proposed is to move all project managers into a centralized PMO. What is one distinct disadvantage of forming a centralized PMO?",
    "choice_a": "Project managers will be more isolated from the departments they serve and be less familiar with their practices.",
    "choice_b": "Project managers may be forced to adopt a single project management methodology.",
    "choice_c": "Some organizations struggle with implementing matrix management.",
    "choice_d": "Departments will have more difficulty controlling project managers.",
    "correct_answer": "A",
    "explanation": "A distinct advantage of departments having their own project managers is that those PMs will inherently be more familiar with their departments’ operations, personnel, and practices. When centralizing a PMO, the project managers will be less familiar with each department’s practices.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      103,
      101,
      141,
      135,
      137
    ],
    "source": "9781394290116"
  },
  {
    "id": 683,
    "question": "A software development organization has large numbers of software developers organized by the type of languages and systems used. The organization then organizes teams of developers that are dedicated to specific long-term projects. In this arrangement, each software developer has two supervisors: a supervisor for the team of like developers and a supervisor in the project they are assigned to. This type of structural arrangement is known as:",
    "choice_a": "Bifurcated teams",
    "choice_b": "RACI management",
    "choice_c": "Matrix management",
    "choice_d": "Agile methodology",
    "correct_answer": "C",
    "explanation": "In matrix management, staff members are organized by subject matter or domain expertise and also by project or program.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      103,
      101,
      105,
      113,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 684,
    "question": "The following figure is an example of:<img src=\"/question_assets/CISA/c03f001.png\" alt=\"Flowchart depicts the structure of V O I P Phone System, outlining Hardware, Software, and Infrastructure components.\"/>\n\n<figcaption>Flowchart depicts the structure of V O I P Phone System, outlining Hardware, Software, and Infrastructure components.</figcaption>",
    "choice_a": "Gate process",
    "choice_b": "Object breakdown structure",
    "choice_c": "Work breakdown structure",
    "choice_d": "Gantt chart",
    "correct_answer": "B",
    "explanation": "The figure is an example of an object breakdown structure (OBS), which represents the components of the project in graphical or tabular form.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      104,
      103,
      112,
      110,
      115
    ],
    "source": "9781394290116"
  },
  {
    "id": 685,
    "question": "The following figure is an example of:<img src=\"/question_assets/CISA/c03f002.png\" alt=\"Flowchart depicts implementing new V O I P system with five main sections, from ordering goods and services to removing the old system.\"/>\n\n<figcaption>Flowchart depicts implementing new V O I P system with five main sections, from ordering goods and services to removing the old system.</figcaption>",
    "choice_a": "Gate process",
    "choice_b": "Object breakdown structure",
    "choice_c": "Work breakdown structure",
    "choice_d": "Gantt chart",
    "correct_answer": "C",
    "explanation": "The figure is an example of a work breakdown structure, a logical representation of the high-level and detailed tasks that must be performed to complete the project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      104,
      110,
      101,
      103,
      105
    ],
    "source": "9781394290116"
  },
  {
    "id": 686,
    "question": "All of the following are typical responsibilities of a project manager <i>except</i>:",
    "choice_a": "Approving project changes",
    "choice_b": "Building the project schedule",
    "choice_c": "Tracking project costs",
    "choice_d": "Communicating project status",
    "correct_answer": "A",
    "explanation": "Project managers are generally <i>not</i> in a position to approve changes in a project, such as scope, cost, or resources.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      105,
      111,
      132,
      110,
      113
    ],
    "source": "9781394290116"
  },
  {
    "id": 687,
    "question": "A large, multiyear project in an organization is over time and over budget. Which of the following people is responsible for getting the project back on track?",
    "choice_a": "Program manager",
    "choice_b": "Project manager",
    "choice_c": "Department head",
    "choice_d": "Scrum master",
    "correct_answer": "C",
    "explanation": "A large, multiyear project that is over time and over budget requires a department head to make the kinds of changes needed to get the project back on track. A program manager, project manager, and ScrumMaster are likely not sufficiently empowered to make these changes, although they may play a significant role in figuring out what changes need to be made.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      103,
      105,
      102,
      111
    ],
    "source": "9781394290116"
  },
  {
    "id": 688,
    "question": "An organization has organized a group of individuals who are department head leaders or their delegates. The group meets monthly to discuss IT priorities and issues. This group is better known as:",
    "choice_a": "IT Leadership Team",
    "choice_b": "IT Standards Board",
    "choice_c": "IT Steering Committee",
    "choice_d": "IT Focus Group",
    "correct_answer": "C",
    "explanation": "An IT Steering Committee sets priorities and addresses IT department issues, thus ensuring improved business alignment for the IT department.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      105,
      110,
      102,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 689,
    "question": "While reviewing the status and schedule of a multiquarter project, the project manager realizes that the project is likely to be completed at least a month later than originally scheduled. Assuming there are no notification stipulations in place, the project manager should inform the project sponsor of this:",
    "choice_a": "Never",
    "choice_b": "At the next monthly project review",
    "choice_c": "At the next weekly project meeting",
    "choice_d": "Immediately",
    "correct_answer": "D",
    "explanation": "In the absence of any particular stipulations regarding the reporting of exceptions and risks, a project manager should immediately inform a project sponsor of a project delay of this magnitude.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      105,
      111,
      113,
      106
    ],
    "source": "9781394290116"
  },
  {
    "id": 690,
    "question": "What party should be responsible for creating cybersecurity requirements in a software development project?",
    "choice_a": "COO",
    "choice_b": "IT department",
    "choice_c": "Cybersecurity team",
    "choice_d": "Software engineers",
    "correct_answer": "C",
    "explanation": "An organization’s cybersecurity team should be responsible for developing standardized (for all projects) and bespoke (for specific projects) cybersecurity requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      151,
      103,
      124,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 691,
    "question": "What party should be responsible for implementing cybersecurity requirements in a software development project?",
    "choice_a": "CISO",
    "choice_b": "End users",
    "choice_c": "Cybersecurity team",
    "choice_d": "Software engineers",
    "correct_answer": "D",
    "explanation": "Software engineers and any others who are developing and configuring system components should be responsible for complying with cybersecurity requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      119,
      120,
      124,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 692,
    "question": "In a software development project, what party should be responsible for performing unit testing?",
    "choice_a": "Software developers",
    "choice_b": "Project manager",
    "choice_c": "Cybersecurity team",
    "choice_d": "Project sponsor",
    "correct_answer": "A",
    "explanation": "Unit testing consists of tests on software modules and other system components and should be performed by software developers.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      120,
      121,
      152,
      119,
      115
    ],
    "source": "9781394290116"
  },
  {
    "id": 693,
    "question": "Members of a project team have been exhibiting confusion over roles and responsibilities. To alleviate this situation, the project manager should develop a:",
    "choice_a": "ARCI model",
    "choice_b": "BMIS model",
    "choice_c": "Project plan",
    "choice_d": "Gantt chart",
    "correct_answer": "A",
    "explanation": "An ARCI model, more often known as a RACI model, depicts the parties responsible, accountable, informed, and consulted for each task and activity in a project.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      105,
      103,
      104,
      113,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 694,
    "question": "A large project team has been organized to carry out a significant systems development project. As a part of organizing the project, the project manager has developed a RACI chart. What purpose will the RACI chart serve?",
    "choice_a": "It defines requirements and standards.",
    "choice_b": "It defines requirements.",
    "choice_c": "It defines roles and responsibilities in detail.",
    "choice_d": "It defines the composition of the project team.",
    "correct_answer": "C",
    "explanation": "A RACI (Responsible, Accountable, Consulted, Informed) chart defines the four types of responsibilities of each party for every activity in a project. A RACI chart can also be used to define responsibilities in a business or technology operation.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      105,
      103,
      106,
      112,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 695,
    "question": "On a project team, which party is responsible for tracking the completion of individual tasks?",
    "choice_a": "The persons responsible for performing individual tasks",
    "choice_b": "The project manager",
    "choice_c": "The project sponsor",
    "choice_d": "None of these",
    "correct_answer": "B",
    "explanation": "A project manager is responsible for tracking the start and completion of each task so that project sponsors, department heads, and others can be kept informed of a project’s status and progress.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      105,
      103,
      111,
      104
    ],
    "source": "9781394290116"
  },
  {
    "id": 696,
    "question": "The purpose of a SLOC tool is:",
    "choice_a": "Estimate the effort required to develop source code.",
    "choice_b": "Identify defects in source code.",
    "choice_c": "Contain use cases for source code testing.",
    "choice_d": "Measure the efficiency of code.",
    "correct_answer": "A",
    "explanation": "SLOC, or source lines of code, has been traditionally used to estimate the level of effort required to develop the code.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      107,
      102,
      116,
      110,
      108
    ],
    "source": "9781394290116"
  },
  {
    "id": 697,
    "question": "The following diagram is an example of:<img src=\"/question_assets/CISA/c03f003.png\" alt=\"A 13-week project timeline with W B S 1 at 57 percent completion and W B S 2 at 0 percent completion.\"/>\n\n<figcaption>A 13-week project timeline with W B S 1 at 57 percent completion and W B S 2 at 0 percent completion.</figcaption>",
    "choice_a": "Gantt chart",
    "choice_b": "PERT chart",
    "choice_c": "COCOMO grid",
    "choice_d": "Project plan",
    "correct_answer": "A",
    "explanation": "The chart shown is a Gantt chart, a visual representation of a project in which individual tasks occupy rows on a worksheet and horizontal time bars depict the time required to complete each task relative to other tasks in the project. A Gantt chart can also show schedule dependencies and the percentage of completion of each task.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      108,
      104,
      106,
      109,
      113
    ],
    "source": "9781394290116"
  },
  {
    "id": 698,
    "question": "Which of the following tools is used to estimate the resources required for a software development project?",
    "choice_a": "RACI diagrams",
    "choice_b": "Gantt charts",
    "choice_c": "Function point analysis",
    "choice_d": "Intersectionality analysis",
    "correct_answer": "C",
    "explanation": "Function point analysis (FPA) is a time-proven estimation technique for larger software projects. Developed in the 1970s, it looks at the number of application functions and their complexity. FPA is not hindered by specific technologies or measuring techniques (such as lines of code).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      107,
      106,
      102,
      116,
      109
    ],
    "source": "9781394290116"
  },
  {
    "id": 699,
    "question": "The following diagram is an example of:<img src=\"/question_assets/CISA/c03f004.png\" alt=\"Flowchart depicts project timeline with tasks, durations, and dates from Development to Online Help.\"/>\n\n<figcaption>Flowchart depicts project timeline with tasks, durations, and dates from Development to Online Help.</figcaption>",
    "choice_a": "RACI chart",
    "choice_b": "Work breakdown structure",
    "choice_c": "Gantt chart",
    "choice_d": "PERT chart",
    "correct_answer": "D",
    "explanation": "The diagram is a PERT chart, which shows project tasks from left to right in time sequence, with connectors signifying dependencies.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      108,
      106,
      110,
      104,
      111
    ],
    "source": "9781394290116"
  },
  {
    "id": 700,
    "question": "A period in which a project or task must be completed is known as a:",
    "choice_a": "Timebox",
    "choice_b": "Taskbox",
    "choice_c": "Constraint",
    "choice_d": "Epoch",
    "correct_answer": "A",
    "explanation": "A timebox is a period in which a project (or a set of tasks within a project) must be completed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      109,
      106,
      108,
      114,
      113
    ],
    "source": "9781394290116"
  },
  {
    "id": 701,
    "question": "The name of the iterative and incremental process commonly used to manage agile software development projects is:",
    "choice_a": "Waterfall",
    "choice_b": "Scrum",
    "choice_c": "Agile",
    "choice_d": "PRINCE2",
    "correct_answer": "B",
    "explanation": "Scrum is an iterative and incremental process most commonly used to manage an agile software or system development effort.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      124,
      109,
      115,
      119
    ],
    "source": "9781394290116"
  },
  {
    "id": 702,
    "question": "In a scrum-managed project, which party should be assigned to the role of ScrumMaster?",
    "choice_a": "End user",
    "choice_b": "Product owner",
    "choice_c": "Project manager",
    "choice_d": "Project sponsor",
    "correct_answer": "C",
    "explanation": "The ScrumMaster is the role filled by a project manager or team leader who facilitates the scrum process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      103,
      105,
      113,
      106
    ],
    "source": "9781394290116"
  },
  {
    "id": 703,
    "question": "In a daily standup, the ScrumMaster describes the contents of the product backlog. What is the ScrumMaster doing?",
    "choice_a": "Describing the list of project deliverables that have not yet been approved",
    "choice_b": "Describing the list of required project deliverables that are late",
    "choice_c": "Describing the list of required project deliverables for the current sprint",
    "choice_d": "Describing the list of required project deliverables for the entire project",
    "correct_answer": "D",
    "explanation": "The product backlog is the list of required deliverables for the entire project (not just the current sprint).",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      114,
      113,
      110,
      103,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 704,
    "question": "The following diagram is a depiction of:<img src=\"/question_assets/CISA/c03f005.png\" alt=\"Flow diagram with steps Product Backlog, Sprint Backlog, and Sprint, leading to Deliverable.\"/>\n\n<figcaption>Flow diagram with steps Product Backlog, Sprint Backlog, and Sprint, leading to Deliverable.</figcaption>",
    "choice_a": "The sprint process",
    "choice_b": "The scrum process",
    "choice_c": "The agile process",
    "choice_d": "The waterfall process",
    "correct_answer": "B",
    "explanation": "The diagram depicts the scrum process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      109,
      113,
      110,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 705,
    "question": "The greatest strength of Kanban is:",
    "choice_a": "Its visual display of planned tasks, work in progress, and completed tasks",
    "choice_b": "Its visual depiction of project task interdependencies",
    "choice_c": "Its visual depiction of a project’s critical path(s)",
    "choice_d": "Its requirements traceability",
    "correct_answer": "A",
    "explanation": "The greatest strength of Kanban is its visual display of planned tasks, work in progress, and completed tasks – shown on a Kanban board.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      114,
      113,
      110,
      106,
      105
    ],
    "source": "9781394290116"
  },
  {
    "id": 706,
    "question": "The following diagram is:<img src=\"/question_assets/CISA/c03f006.png\" alt=\"Table with 6 columns labeled Backlog, In Progress, Peer Review, In Test, Done, Blocked and a Fast Track or Defect row with document icons.\"/>\n\n<figcaption>Table with 6 columns labeled Backlog, In Progress, Peer Review, In Test, Done, Blocked and a Fast Track or Defect row with document icons.</figcaption>",
    "choice_a": "A Kanban board",
    "choice_b": "A sprint backlog",
    "choice_c": "A Gantt chart",
    "choice_d": "A PERT chart",
    "correct_answer": "A",
    "explanation": "The diagram is a Kanban board, a visual display of planned tasks, work in progress, and completed tasks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      106,
      110,
      104,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 707,
    "question": "After reviewing the history of large processes in the past, a program manager wants to institute a gate process for future projects. What additional step will be present in future projects as a result?",
    "choice_a": "Approvals are required for requirements not met.",
    "choice_b": "Approvals are required before a project is completed.",
    "choice_c": "Approvals are required before projects may proceed to the next step.",
    "choice_d": "Approvals are required before a project is started.",
    "correct_answer": "C",
    "explanation": "Organizations often employ a gate-process approach to their SDLC by requiring that a formal review be held at the conclusion of each phase before the next phase is permitted to begin. The review is usually a formal meeting where project managers and other participants describe the status of the project; management, if satisfied that the current phase of the project has been completed successfully and that all requirements have been met, will permit the project to proceed to the next phase.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      115,
      119,
      110,
      151,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 708,
    "question": "What is meant by requirements traceability?",
    "choice_a": "Each requirement can be matched with the developer who will implement it.",
    "choice_b": "Each requirement can be matched with the person or team who will test it.",
    "choice_c": "Each requirement can be traced back to the law or standard.",
    "choice_d": "Each requirement can be traced back to the person who requested it.",
    "correct_answer": "D",
    "explanation": "Requirements traceability is the ability to trace a requirement back to the project team member who added it to the project. Requirements traceability is essential for larger projects containing hundreds of requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      151,
      150,
      111,
      136
    ],
    "source": "9781394290116"
  },
  {
    "id": 709,
    "question": "What is the proper interpretation of the following figure?<img src=\"/question_assets/CISA/c03f007.png\" alt=\"Six-panel cartoon with stages of a tree swing from “As proposed by the project sponsor” to “What the user wanted.”\"/>\n\n<figcaption>Six-panel cartoon with stages of a tree swing from “As proposed by the project sponsor” to “What the user wanted.”</figcaption>",
    "choice_a": "Project managers often lose control of projects.",
    "choice_b": "User requirements are often not stated clearly and with sufficient detail.",
    "choice_c": "Project teams often suffer from poor communication.",
    "choice_d": "Project members often disagree with how to implement requirements.",
    "correct_answer": "B",
    "explanation": "This figure, originally found in a textbook from the 1970s, depicts the fact that user requirements are often not stated clearly and with sufficient detail.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      117,
      115,
      151,
      112,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 710,
    "question": "The principal design characteristic of the waterfall process is:",
    "choice_a": "Formal approvals are required before one step may progress to the next.",
    "choice_b": "Each phase of the project must be fully complete before the next phase can begin.",
    "choice_c": "Multiple phases of a project can be performed in parallel.",
    "choice_d": "Projects move forward at great velocity and are difficult to control.",
    "correct_answer": "B",
    "explanation": "In the waterfall process, each phase of the project must be fully completed (sometimes with formal management approval) before the next phase is permitted to begin.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      115,
      119,
      120,
      122,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 711,
    "question": "A project sponsor contracts with a small software development firm to develop a custom business application. The software development firm is two years old. What mechanism should be put in place to ensure that the customer will be able to support the business application if the software development firm goes out of business?",
    "choice_a": "Source code escrow",
    "choice_b": "An open-source license agreement",
    "choice_c": "A beneficiary clause",
    "choice_d": "Symbol tables in all compiled software modules",
    "correct_answer": "A",
    "explanation": "Source code escrow involves the vendor delivering an electronic copy of its source code to a third-party software escrow firm, which keeps control of the software. If, however, the software vendor goes out of business, the organization will be able to obtain a copy of the vendor’s software for support purposes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      117,
      152,
      160,
      102,
      116
    ],
    "source": "9781394290116"
  },
  {
    "id": 712,
    "question": "What is one of the greatest challenges facing SaaS companies related to the multitenant nature of their systems?",
    "choice_a": "Managing system performance",
    "choice_b": "Managing software releases",
    "choice_c": "Disaster recovery planning",
    "choice_d": "Effectively segregating customer data",
    "correct_answer": "D",
    "explanation": "Effective segregation of customer data so that any individual customer is unable to access the data of other customers is one of the greatest challenges that SaaS companies face.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      126,
      144,
      117,
      118,
      133
    ],
    "source": "9781394290116"
  },
  {
    "id": 713,
    "question": "An organization has issued an RFP to replace a large business application. The organization has evaluated and scored RFP responses, resulting in three finalists. How should the organization proceed?",
    "choice_a": "Proceed to the request for information (RFI) phase.",
    "choice_b": "Select the finalist, and purchase the business application.",
    "choice_c": "Begin contract negotiations with two or three of the finalists prior to making the final award.",
    "choice_d": "Select the finalist, and begin contract negotiation.",
    "correct_answer": "C",
    "explanation": "For a significant RFP project, it’s often wise to begin contract negotiations with more than one finalist. Contract negotiations sometimes do not go well; if an organization begins negotiations with only a single vendor and the negotiation breaks down, more time is consumed than if two or three are begun simultaneously.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      152,
      142,
      110,
      102
    ],
    "source": "9781394290116"
  },
  {
    "id": 714,
    "question": "An organization plans to begin a project in which SaaS software will be used for a principal line-of-business application. The CISO argues that Secure SDLC processes should be utilized for this project, but IT is against it. For what reason should the organization utilize its Secure SDLC project in this instance?",
    "choice_a": "Other SDLC activities, including requirements, design, integration, testing, and implementation, still take place.",
    "choice_b": "Secure SDLC standards have always asserted that software development is not a requirement of SDLC.",
    "choice_c": "The organization should not utilize the SDLC process because no software development is being done for this project.",
    "choice_d": "Other SDLC activities, including requirements, design, integration, testing, and implementation, are not taking place.",
    "correct_answer": "A",
    "explanation": "In a general sense, Secure SDLC is applicable to IT projects in which new business applications are being developed in-house, developed by an outsider, or acquired in the form of COTS or SaaS. Any organization implementing COTS or SaaS software should still develop requirements, design (to the extent relevant), and testing to ensure that all requirements – security and otherwise – are met.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      126,
      117,
      119,
      121,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 715,
    "question": "Source code repositories should have all of the following safeguards implemented <i>except</i>:",
    "choice_a": "Compilation is required before check-in",
    "choice_b": "Multifactor authentication",
    "choice_c": "Code check-out only when associated with a bug-fix ticket",
    "choice_d": "Code check-in requires a completed static code scan",
    "correct_answer": "A",
    "explanation": "Source code repositories do not typically compile code on check-in. Instead, a continuous integration (CI) system will perform code compilation that is separate from (but may be triggered by) check-in.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      120,
      152,
      154,
      131,
      121
    ],
    "source": "9781394290116"
  },
  {
    "id": 716,
    "question": "How do unit testing and system testing differ?",
    "choice_a": "System testing is a test of an entire system, whereas unit testing is a single step in system testing.",
    "choice_b": "Unit testing is a test of software modules, whereas system testing is a test of an application’s supporting infrastructure.",
    "choice_c": "System testing is a test of an individual module, whereas unit testing is a test of an entire system.",
    "choice_d": "Unit testing is a test of an individual module, whereas system testing is a test of an entire system.",
    "correct_answer": "D",
    "explanation": "Usually performed by software developers and utilizing their integrated application development environment (IDE), unit testing is a test of individual software modules to identify and resolve defects in individual modules.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      125,
      119,
      153
    ],
    "source": "9781394290116"
  },
  {
    "id": 717,
    "question": "An organization’s CIO insists that all phases and aspects of testing of a new primary software environment are complete and that all relevant issues have been remedied. The CIO asserts that the organization should perform an “all at once” cutover versus a “parallel” cutover. What argument best refutes this approach?",
    "choice_a": "Parallel testing is different from unit testing.",
    "choice_b": "The CIO is right in saying that a parallel cutover is unnecessary because UAT went so well.",
    "choice_c": "The possibility of differences in processing results in parallel testing could uncover defects not detected in earlier testing.",
    "choice_d": "It is the role of the IT Steering Committee to dictate the test regimen for new applications.",
    "correct_answer": "C",
    "explanation": "Even when all earlier phases of application testing go well, parallel testing in a parallel cutover is prudent and considered an essential practice to further ensure that a new system processes transactions and arrives at the same results as the former application.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      158,
      121,
      153,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 718,
    "question": "How do DevOps and DevSecOps differ?",
    "choice_a": "They are not different; DevOps and DevSecOps are essentially the same thing.",
    "choice_b": "DevSecOps is DevOps with security testing as a part of the automated development platform.",
    "choice_c": "DevSecOps is DevOps with security integrated into the IDE.",
    "choice_d": "DevOps is DevSecOps minus secure coding policy.",
    "correct_answer": "B",
    "explanation": "DevSecOps is a DevOps environment with automated security scanning and other safeguards integrated with the automated development platform. For instance, a DevSecOps environment might include a source code scanner that examines recently checked-in code, as well as dynamic security scanning executed as a part of the daily build cycle.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      124,
      120,
      152,
      125,
      119
    ],
    "source": "9781394290116"
  },
  {
    "id": 719,
    "question": "Which of the following best describes web-based application development?",
    "choice_a": "The result is a web-based application.",
    "choice_b": "Application development tools are web-based.",
    "choice_c": "Application development tools can be run within a browser.",
    "choice_d": "The application’s detailed design resembles that of a web application.",
    "correct_answer": "A",
    "explanation": "Web-based application development is the development of web-based applications and not a characteristic of the tools used in such development.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      124,
      115,
      119,
      120,
      117
    ],
    "source": "9781394290116"
  },
  {
    "id": 720,
    "question": "The following figure is an example of:<img src=\"/question_assets/CISA/c03f008.png\" alt=\"Illustration depicts Customer and A W S detailing Customer Data, Software, Hardware, and A W S Global Infrastructure.\"/>\n\n<figcaption>Illustration depicts Customer and A W S detailing Customer Data, Software, Hardware, and A W S Global Infrastructure.</figcaption>",
    "choice_a": "An SDLC",
    "choice_b": "A Zachman architecture",
    "choice_c": "A cloud responsibility model",
    "choice_d": "A cloud architecture model",
    "correct_answer": "C",
    "explanation": "The figure is a cloud responsibility model; specifically, this model is from Amazon Web Services.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      126,
      129,
      117,
      152,
      160
    ],
    "source": "9781394290116"
  },
  {
    "id": 721,
    "question": "A device that forwards packets to their destination based on their destination IP address is known as a:",
    "choice_a": "Bridge",
    "choice_b": "Gateway",
    "choice_c": "Router",
    "choice_d": "Switch",
    "correct_answer": "C",
    "explanation": "A router is a network device that forwards packets toward their destination.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      215,
      216,
      209,
      213,
      210
    ],
    "source": "9781394290116"
  },
  {
    "id": 722,
    "question": "A manager is planning to implement a first-time use of a vulnerability scanning tool in an organization. What method should the security manager use to confirm that all assets are scanned?",
    "choice_a": "Compare the scan results with the accounting department’s asset inventory.",
    "choice_b": "Compare the scan results with the contents of the CMDB.",
    "choice_c": "Compare the scan results with a discovery scan performed by the vulnerability scanning tool.",
    "choice_d": "Compare the scan results with the latest network diagram.",
    "correct_answer": "B",
    "explanation": "The best option to confirm that a vulnerability scan is catching all known assets is to compare it with a well-managed configuration management database (CMDB). In organizations lacking a CMDB, reconciliation of the scan results can be performed against other tools, such as configuration management tools, antimalware tools, or network management tools.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      171,
      218,
      217,
      225
    ],
    "source": "9781394290116"
  },
  {
    "id": 723,
    "question": "Which of the following methods should be used to create a point-in-time copy of a large production database?",
    "choice_a": "Storage system snapshot",
    "choice_b": "Storage system replication",
    "choice_c": "E-vaulting",
    "choice_d": "Export to a flat file that is backed up to tape",
    "correct_answer": "A",
    "explanation": "A storage system snapshot is nearly instantaneous and is the best method for producing a “point-in-time” backup of a large database.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      239,
      183,
      203,
      247,
      250
    ],
    "source": "9781394290116"
  },
  {
    "id": 724,
    "question": "All of the following protocols are used for federated authentication <i>except</i>:",
    "choice_a": "OAuth",
    "choice_b": "SAML",
    "choice_c": "WSDL",
    "choice_d": "HMAC",
    "correct_answer": "C",
    "explanation": "WSDL is a protocol used to describe the functionality of a web service, not for authentication.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      215,
      216,
      207,
      208,
      222
    ],
    "source": "9781394290116"
  },
  {
    "id": 725,
    "question": "What is typically the most significant risk associated with end users being local administrators on their workstations?",
    "choice_a": "End users will have access to all confidential information.",
    "choice_b": "End users can install unauthorized software.",
    "choice_c": "Malware can run at the highest privilege level.",
    "choice_d": "End users can use tools to crack all domain passwords.",
    "correct_answer": "C",
    "explanation": "If malware is introduced by the end user in a phishing or watering hole attack, the malware will run as an administrator, which is the highest privilege level on the system. Malware would have access to all files, data, and devices on the machine.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      200,
      171,
      172,
      223,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 726,
    "question": "Which of the following people is best suited to approve users’ access to sensitive data in a customer database?",
    "choice_a": "Customer service manager",
    "choice_b": "IT service desk personnel",
    "choice_c": "Information security manager",
    "choice_d": "IT manager",
    "correct_answer": "A",
    "explanation": "The customer service manager is the best available choice because a business leader is almost always more familiar with business processes than IT and information security personnel. Further, because the customer service manager is responsible for customer service, this is the person who should be specifying which persons in the organization are permitted to access customer service data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      184,
      228,
      218,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 727,
    "question": "An organization is planning a new SaaS service offering and is uncertain about the resources required to support the service. How should the organization proceed?",
    "choice_a": "Calculate projected performance using CMMI tools.",
    "choice_b": "Calculate projected performance using Zachman tools.",
    "choice_c": "Measure actual performance metrics in production.",
    "choice_d": "Build a working prototype and perform load tests.",
    "correct_answer": "D",
    "explanation": "The best choice here is to build a prototype system that closely resembles the network, computing, and database activities and perform load testing. This will give the organization an idea of the capacity of the planned system. However, because this technique is imperfect, load tests should be performed throughout the development process.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      161,
      233,
      236,
      206
    ],
    "source": "9781394290116"
  },
  {
    "id": 728,
    "question": "What is the best definition of a problem in ITIL-based service management?",
    "choice_a": "Chronic exceptions in audits of IT systems.",
    "choice_b": "The same incident occurs repeatedly.",
    "choice_c": "Repeated unscheduled downtime.",
    "choice_d": "Unscheduled downtime that exceeds SLAs.",
    "correct_answer": "B",
    "explanation": "The definition of a problem in ITIL is a recurrence of the same type of incident. This indicates that there is something wrong with a business process or information system that needs to be corrected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      173,
      184,
      166,
      175
    ],
    "source": "9781394290116"
  },
  {
    "id": 729,
    "question": "Which of the following is the best relationship between system security and the use of vulnerability scanning tools?",
    "choice_a": "Vulnerability scanning is performed proactively, and it drives the security patching and hardening functions.",
    "choice_b": "Vulnerability scanning is performed proactively, and it drives the security patching function.",
    "choice_c": "Patching and hardening are performed proactively, and vulnerability scanning is used to verify their effectiveness.",
    "choice_d": "Patching is performed proactively, and vulnerability scanning is used to verify its effectiveness.",
    "correct_answer": "C",
    "explanation": "The best use of vulnerability scanning is its function as a quality assurance activity to ensure that security patching and system hardening are being performed effectively.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      171,
      172,
      183,
      181,
      226
    ],
    "source": "9781394290116"
  },
  {
    "id": 730,
    "question": "An SaaS provider and a customer are having a dispute about the availability of service, quality of service, and issue resolution provided by the SaaS provider. What type of legal agreement should the parties add to their contract to better define these problems and their resolution?",
    "choice_a": "Pricing table",
    "choice_b": "Exit clause",
    "choice_c": "Performance addendum",
    "choice_d": "Service-level agreement",
    "correct_answer": "D",
    "explanation": "A service-level agreement (SLA) is used to define the quantity and quality of service to be provided by a service provider to its customers. An SLA can cover issues such as transaction volume, service quality, issue resolution, and service availability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      176,
      165,
      162,
      175,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 731,
    "question": "What is the purpose of a business impact analysis?",
    "choice_a": "It defines the most critical business processes.",
    "choice_b": "It defines the most critical IT applications.",
    "choice_c": "It defines the most critical service providers.",
    "choice_d": "It defines the disaster recovery plan.",
    "correct_answer": "A",
    "explanation": "A business impact analysis (BIA) defines the most critical business processes in the organization. The BIA reveals which business processes warrant the development of emergency contingency planning and disaster recovery planning.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      231,
      235,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 732,
    "question": "An IT architect needs to increase the resilience of a single application server. Which of the following choices will <i>least</i> benefit the server’s resilience?",
    "choice_a": "Active–active cluster",
    "choice_b": "Active–passive cluster",
    "choice_c": "Geo-cluster",
    "choice_d": "Redundant power supply",
    "correct_answer": "D",
    "explanation": "A redundant power supply only addresses the problem of a power supply failure but does not address other failures, such as storage or CPU.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      231,
      163,
      197,
      186
    ],
    "source": "9781394290116"
  },
  {
    "id": 733,
    "question": "Which of the following backup schemes best protects an organization from ransomware?",
    "choice_a": "Storage system replication",
    "choice_b": "Storage system mirroring",
    "choice_c": "Storage system snapshots",
    "choice_d": "RAID-5",
    "correct_answer": "C",
    "explanation": "Storage system snapshots effectively store the state of a storage system from time to time; if ransomware destroys files in the storage system, the system can be rolled back to a recent snapshot, effectively restoring damaged files.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      240,
      236,
      250,
      247
    ],
    "source": "9781394290116"
  },
  {
    "id": 734,
    "question": "A mail order organization wants to develop procedures to be followed in the event that the main office building cannot be occupied, so that customer orders can still be fulfilled. What kind of a plan does the organization need to develop?",
    "choice_a": "Business impact analysis",
    "choice_b": "Business continuity plan",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Emergency evacuation plan",
    "correct_answer": "B",
    "explanation": "A business continuity plan is a document that describes procedures to be followed when events such as local and regional disasters prevent normal business operations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      231,
      233,
      240,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 735,
    "question": "An IT department is planning on implementing disaster recovery capabilities in some of its business systems. What means should be used to determine which applications require DR capabilities and to what level of recoverability?",
    "choice_a": "Business continuity plan",
    "choice_b": "Disaster recovery plan",
    "choice_c": "Risk assessment",
    "choice_d": "Business impact analysis",
    "correct_answer": "D",
    "explanation": "A business impact analysis (BIA) is used to determine which business processes are most critical, and this leads to the development of recovery objectives, which in turn lead to the development of DR capabilities that meet those objectives.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      240,
      246,
      235
    ],
    "source": "9781394290116"
  },
  {
    "id": 736,
    "question": "Which of the following is the most compelling reason for an organization to <i>not</i> automate its data purging jobs in support of data retention policies?",
    "choice_a": "DR planning",
    "choice_b": "Referential integrity",
    "choice_c": "Privacy breaches",
    "choice_d": "Legal holds",
    "correct_answer": "D",
    "explanation": "Legal holds in most organizations are manual processes and involve the cessation of data purging for arbitrary sets of information. A better approach would be a manually initiated data purging process that is started only after it is determined that no legal holds exist for the data to be purged.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      182,
      180,
      221,
      184,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 737,
    "question": "Which of the following schemes is most likely to be successful for workstations used by a mobile workforce?",
    "choice_a": "Automated patching followed by a system restart that the end user can control.",
    "choice_b": "Automated patching and restarts.",
    "choice_c": "End-user-initiated patching and restarts.",
    "choice_d": "Only those patches that do not require a system restart are applied.",
    "correct_answer": "A",
    "explanation": "Automated patching, together with giving end users some control over restarts, is most likely to be successful, as this gives users an option to defer restarts (for a while) so that important work is not interrupted.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      172,
      183,
      161,
      166,
      167
    ],
    "source": "9781394290116"
  },
  {
    "id": 738,
    "question": "An IT department completed a data discovery assessment and found that numerous users were saving files containing sensitive information on organization-wide readable file shares. Which of the following is the best immediate remediation for this matter?",
    "choice_a": "Remove the offending files from the org-wide share.",
    "choice_b": "Announce to users that the org-wide readable share is not for sensitive data.",
    "choice_c": "Change the org-wide readable share to read-only for most users.",
    "choice_d": "Change the org-wide readable share to write-only for most users.",
    "correct_answer": "A",
    "explanation": "In the short term, removing the offending files is the best first step. In the long run, in most organizations, few people truly need to write to the organization-wide readable share (for example, HR, legal, and IT). This will drive users to use department shares to save sensitive data, which will result in lower risk to the business because sensitive data will then be readable only by personnel in their respective departments instead of the entire organization. Further improvement opportunities may be found after that.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      180,
      202,
      166,
      167,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 739,
    "question": "For which users or groups should the SQL listener on a database management system be accessible?",
    "choice_a": "For the application accounts only",
    "choice_b": "For the application and DBA accounts only",
    "choice_c": "For DBA accounts only",
    "choice_d": "For DBA accounts plus all users of the application",
    "correct_answer": "B",
    "explanation": "Applications that need to access the database need to be able to access the SQL listener on a database server, as do DBAs who need to perform maintenance on the database management system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      227,
      178,
      189,
      228
    ],
    "source": "9781394290116"
  },
  {
    "id": 740,
    "question": "An organization’s financial accounting system crashes every Friday night after backups have been completed. In ITIL terms, what process should be invoked?",
    "choice_a": "Problem management",
    "choice_b": "Incident management",
    "choice_c": "Capacity management",
    "choice_d": "Business continuity management",
    "correct_answer": "A",
    "explanation": "Problem management is the correct ITIL process to be invoked when similar incidents are recurring.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      184,
      173,
      166,
      168
    ],
    "source": "9781394290116"
  },
  {
    "id": 741,
    "question": "An IT organization is investigating a problem in its change management process whereby many changes must be backed out because they could not be completed or because verifications failed. Which is the best remedy for this situation?",
    "choice_a": "Increase the size of change windows.",
    "choice_b": "Require a separate person to verify changes.",
    "choice_c": "Require change requests to have better backout procedures.",
    "choice_d": "Require more rigorous testing in a test environment prior to scheduling changes in production.",
    "correct_answer": "D",
    "explanation": "Repeated implementation failures should first call for more rigorous testing in a test or staging environment to iron out any issues that may occur when changes are applied in production environments.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      167,
      170,
      173,
      165,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 742,
    "question": "Which language is used to change the schema in a database management system?",
    "choice_a": "DDL",
    "choice_b": "SQL",
    "choice_c": "Stored procedures",
    "choice_d": "JCL",
    "correct_answer": "A",
    "explanation": "DDL (Data Definition Language) is commonly used to change the schema (or architecture of a database) in a database management system.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      177,
      178,
      169,
      166,
      172
    ],
    "source": "9781394290116"
  },
  {
    "id": 743,
    "question": "A DBA has been asked to limit the tables, rows, or columns that are visible to some users with direct database access. Which solution would best fulfill this request?",
    "choice_a": "Create alternate user accounts.",
    "choice_b": "Move those users into different AD groups.",
    "choice_c": "Create one or more views.",
    "choice_d": "Change the schema for those users.",
    "correct_answer": "C",
    "explanation": "A <i>view</i> provides the appearance of virtual tables that are parts of real tables.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      178,
      177,
      186,
      227,
      180
    ],
    "source": "9781394290116"
  },
  {
    "id": 744,
    "question": "An organization’s IT department developed DR capabilities for some business applications prior to a BIA ever being performed. Now that a BIA has been performed, it has been determined that some IT applications’ DR capabilities exceed what is called for in the BIA and that other applications fall short. What should be done to remedy this?",
    "choice_a": "Redo the BIA using existing DR capabilities as inputs.",
    "choice_b": "Make no changes, as this is the expected result.",
    "choice_c": "Change IT application DR capabilities to align with the BIA.",
    "choice_d": "Change the BIA to align with IT application DR capabilities.",
    "correct_answer": "C",
    "explanation": "DR capabilities need to align with the results of the BIA, including established recovery objectives.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      246,
      248,
      251,
      252
    ],
    "source": "9781394290116"
  },
  {
    "id": 745,
    "question": "What is the purpose of hot-pluggable drives in a storage system?",
    "choice_a": "Ability to replace drives that have crashed or overheated",
    "choice_b": "Ability to replace drives while the storage system is still running",
    "choice_c": "Ability to replace drives without the risk of harm to personnel",
    "choice_d": "Ability to install additional drives without powering down the system",
    "correct_answer": "B",
    "explanation": "The term <i>hot-pluggable drives</i> refers to the ability to remove and replace drives in a storage system while the system is still running. Together with RAID capabilities, there would be no interruption in the storage system’s ability to read and write data to the drives.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      238,
      183,
      203,
      163,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 746,
    "question": "What is the primary purpose of data restoration testing?",
    "choice_a": "To meet regulatory requirements",
    "choice_b": "To prove that bare-metal restores can be performed",
    "choice_c": "To see how long it takes to restore data from backup",
    "choice_d": "To ensure that backups are actually being performed",
    "correct_answer": "D",
    "explanation": "Restoration testing proves that data is actually being written to backup media. It also demonstrates that personnel know how to restore data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      236,
      249,
      239,
      183,
      252
    ],
    "source": "9781394290116"
  },
  {
    "id": 747,
    "question": "Which of the following should approve RTO and RPO targets?",
    "choice_a": "Senior business executives",
    "choice_b": "Board of directors",
    "choice_c": "CISO",
    "choice_d": "CIO",
    "correct_answer": "A",
    "explanation": "Senior business executives should approve RTO (recovery time objective) and RPO (recovery point objective) targets. As business leaders, senior executives are in the best position to decide how much downtime the organization will tolerate in the event of a minor or major disaster. Further, senior executives are going to be in the best position to fund and provide resources for IT to implement DR capabilities to meet these objectives.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      234,
      233,
      231,
      240,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 748,
    "question": "An organization has developed its first-ever disaster recovery plan. What is the best choice for the first round of plan testing?",
    "choice_a": "Cutover test",
    "choice_b": "Walkthrough",
    "choice_c": "Simulation",
    "choice_d": "Parallel test",
    "correct_answer": "B",
    "explanation": "The best choice here is for participants to walk through the plan and discuss all of the steps in detail.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      240,
      244,
      246,
      233
    ],
    "source": "9781394290116"
  },
  {
    "id": 749,
    "question": "Which of the following best describes the purpose of a hypervisor?",
    "choice_a": "It creates and manages virtual desktops.",
    "choice_b": "It creates and manages containers.",
    "choice_c": "It installs software on virtual machines.",
    "choice_d": "It creates and manages virtual machines.",
    "correct_answer": "D",
    "explanation": "A hypervisor, whether running in an OS or on bare metal, is used to create, manage, and run virtual machines.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      196,
      187,
      188,
      201,
      200
    ],
    "source": "9781394290116"
  },
  {
    "id": 750,
    "question": "Which of the following best fits the definition of a set of structured tables with indexes, primary keys, and foreign keys?",
    "choice_a": "Hierarchical database",
    "choice_b": "Object database",
    "choice_c": "Relational database",
    "choice_d": "Network database",
    "correct_answer": "C",
    "explanation": "A relational database is one with structured tables containing rows and columns, with indexes, primary keys, and foreign keys.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      177,
      186,
      227,
      180
    ],
    "source": "9781394290116"
  },
  {
    "id": 751,
    "question": "An organization uses its vulnerability scanning tool as its de facto asset management system. What is the biggest risk associated with this approach?",
    "choice_a": "Network engineers could build new IP networks not included in the scanning tool’s configuration.",
    "choice_b": "System engineers could implement new servers that the scanning tool won’t see.",
    "choice_c": "System engineers could implement new virtual machines that the scanning tool won’t see.",
    "choice_d": "IP source routing could prevent the scanning tool from seeing all networks.",
    "correct_answer": "A",
    "explanation": "The biggest risk of using a vulnerability scanning tool as a tool for tracking assets is that these tools are generally configured to scan a list of IP networks. If a network engineer creates a new network and does not inform the personnel who manage the scanning tool, the tool won’t detect the new network or any systems and devices that reside in it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      218,
      223,
      228,
      161,
      167
    ],
    "source": "9781394290116"
  },
  {
    "id": 752,
    "question": "Which of the following systems should be used to populate the IT asset database in an elastic cloud environment?",
    "choice_a": "Hypervisor",
    "choice_b": "Vulnerability scanning tool",
    "choice_c": "Patch management tool",
    "choice_d": "CMDB",
    "correct_answer": "A",
    "explanation": "The hypervisor is the system that manages the creation and use of virtual machines in an environment where virtual machines are created dynamically to support workload.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      198,
      218,
      169,
      201
    ],
    "source": "9781394290116"
  },
  {
    "id": 753,
    "question": "What is a typical frequency for running a job that checks Active Directory for unused user accounts?",
    "choice_a": "Every hour",
    "choice_b": "Every 24 hours",
    "choice_c": "Every 7 days",
    "choice_d": "Every 90 days",
    "correct_answer": "D",
    "explanation": "Ninety days is the most typical interval for checking for dormant user accounts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      230,
      228,
      214,
      221,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 754,
    "question": "The system interface standard that includes process control, IPC, and shared memory is known as:",
    "choice_a": "UNIX",
    "choice_b": "POSIX",
    "choice_c": "ActiveX",
    "choice_d": "Ultrix",
    "correct_answer": "B",
    "explanation": "POSIX is the system interface standard that includes several components, such as process control, interprocess communication (IPC), named pipes, and files and file systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      200,
      230,
      226,
      221,
      174
    ],
    "source": "9781394290116"
  },
  {
    "id": 755,
    "question": "An environment consisting of centralized servers running end-user operating systems that display on users’ computers is known as:",
    "choice_a": "Hosted hypervisor",
    "choice_b": "Bare-metal hypervisor",
    "choice_c": "Virtual desktop infrastructure",
    "choice_d": "Reverse Telnet",
    "correct_answer": "C",
    "explanation": "A virtual desktop infrastructure (VDI) consists of one or more centralized servers that run end-user desktop operating systems that display on users’ computers.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      189,
      196,
      201,
      188,
      187
    ],
    "source": "9781394290116"
  },
  {
    "id": 756,
    "question": "A data privacy officer recently commissioned a data discovery exercise to understand the extent to which sensitive data is present on the company’s world-readable file share. The exercise revealed that dozens of files containing large volumes of highly sensitive data were present on the file share. What is the best first step the data privacy officer should take?",
    "choice_a": "Remove all instances of files containing large volumes of highly sensitive data.",
    "choice_b": "Investigate each instance to see whether any files are a part of business processes.",
    "choice_c": "Sanction the users who placed the files there for violations of internal privacy policy.",
    "choice_d": "Do nothing, as this is an acceptable practice for files of this type.",
    "correct_answer": "B",
    "explanation": "The most prudent move is for the data privacy officer to investigate the files that were found, to better understand why they are there. Possibly, some are part of vital business processes (which, in many cases, would need to be adjusted to avoid exposing the information).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      180,
      184,
      219,
      182,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 757,
    "question": "A new IT manager is making improvements in the organization’s management of unplanned outages. The IT manager has built a new process where repeated cases of similar outages are analyzed to identify their cause. What process has the IT manager created?",
    "choice_a": "Problem management",
    "choice_b": "Incident management",
    "choice_c": "Root cause analysis",
    "choice_d": "Security event management",
    "correct_answer": "A",
    "explanation": "Analysis of repeated incidents is known as problem management.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      165,
      173,
      184,
      161,
      175
    ],
    "source": "9781394290116"
  },
  {
    "id": 758,
    "question": "A new IT manager is making improvements in the organization’s management of the detailed settings on servers and network devices. The process that the IT manager has made is a part of:",
    "choice_a": "Vulnerability management",
    "choice_b": "System hardening",
    "choice_c": "Configuration management",
    "choice_d": "Performance management",
    "correct_answer": "C",
    "explanation": "The IT manager is making improvements to the configuration management process.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      169,
      166,
      183,
      161,
      225
    ],
    "source": "9781394290116"
  },
  {
    "id": 759,
    "question": "A new IT manager is making improvements in the organization’s management of the detailed settings on servers and network devices. The process includes the creation of a repository for storing details about this information. This repository is known as:",
    "choice_a": "An asset management database",
    "choice_b": "A vulnerability management database",
    "choice_c": "A configuration management database",
    "choice_d": "A system hardening standard",
    "correct_answer": "C",
    "explanation": "A repository containing the configuration of systems is known as a configuration management database (CMDB).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      169,
      225,
      227,
      183,
      166
    ],
    "source": "9781394290116"
  },
  {
    "id": 760,
    "question": "A new IT manager is making improvements to the organization’s need to make its systems and devices more resilient to attacks. The IT manager should update:",
    "choice_a": "The vulnerability management process",
    "choice_b": "The system and device hardening standard",
    "choice_c": "The configuration management database",
    "choice_d": "The security incident response plan",
    "correct_answer": "B",
    "explanation": "A system and device hardening standard specifies the configurations to be used to make systems and devices more resistant to attack.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      226,
      183,
      172,
      169,
      166
    ],
    "source": "9781394290116"
  },
  {
    "id": 761,
    "question": "A customer of an SaaS provider is complaining about the SaaS provider’s lack of responsiveness in resolving security issues. What portion of the contract should the customer refer to when lodging a formal complaint?",
    "choice_a": "Service description",
    "choice_b": "System availability",
    "choice_c": "Service-level agreement",
    "choice_d": "Security controls",
    "correct_answer": "C",
    "explanation": "A service-level agreement (SLA) defines terms of responsiveness to various types of services and service issues.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      246,
      244,
      165,
      161,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 762,
    "question": "Computer code that is found within the contents of a database is known as a:",
    "choice_a": "Blob",
    "choice_b": "Function",
    "choice_c": "Stored procedure",
    "choice_d": "Subroutine",
    "correct_answer": "C",
    "explanation": "A stored procedure is computer code that is stored in a database and executed when called.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      177,
      178,
      227,
      186,
      200
    ],
    "source": "9781394290116"
  },
  {
    "id": 763,
    "question": "An organization is starting its first-ever effort to develop a business continuity and disaster recovery plan. What is the best first step to perform in this effort?",
    "choice_a": "Criticality analysis",
    "choice_b": "Business impact analysis",
    "choice_c": "Setting recovery targets",
    "choice_d": "Selecting a DR site",
    "correct_answer": "B",
    "explanation": "A business impact analysis (BIA) is used to enumerate business processes and their dependencies on other processes, assets, personnel, and service providers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      235,
      231,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 764,
    "question": "What is the purpose of connecting two redundant power supplies to separate electrical circuits?",
    "choice_a": "System resilience in case one electrical circuit fails",
    "choice_b": "To balance the electrical load between the circuits",
    "choice_c": "To balance the phasing between the circuits",
    "choice_d": "To avoid overloading a single electrical circuit",
    "correct_answer": "A",
    "explanation": "A system with redundant power supplies will be more resilient if the power supplies are connected to separate electrical circuits (and even more resilient if the circuits lead to separate PDUs, UPSs, electrical feeds, and generators). In the event of a failure in any of these components, the others will still supply power to the system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      162,
      206,
      246,
      183,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 765,
    "question": "An IT organization is modernizing its tape backup system by replacing its tape library system with a storage array while keeping its tape backup software system. What has the organization implemented?",
    "choice_a": "E-vaulting",
    "choice_b": "S-vaulting",
    "choice_c": "Virtual tape library",
    "choice_d": "Mirroring",
    "correct_answer": "C",
    "explanation": "A virtual tape library (VTL) is a storage system that emulates a tape library system. A VTL is used when an organization wishes to retain its tape backup software platform while modernizing the actual backup storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      203,
      239,
      182,
      246,
      196
    ],
    "source": "9781394290116"
  },
  {
    "id": 766,
    "question": "An IT organization is modernizing its tape backup system by sending data to a cloud storage provider. What has the organization implemented?",
    "choice_a": "Replication",
    "choice_b": "Mirroring",
    "choice_c": "Virtual tape library",
    "choice_d": "E-vaulting",
    "correct_answer": "D",
    "explanation": "E-vaulting is the process of backing up data to a cloud storage provider using backup software created for that purpose.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      250,
      239,
      246,
      247,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 767,
    "question": "A city government department that accepts payments for water use has developed a procedure to be followed by end users when the IT application for processing payments is unavailable. What type of procedure has been developed?",
    "choice_a": "Business continuity plan",
    "choice_b": "Disaster recovery plan",
    "choice_c": "Business impact analysis",
    "choice_d": "Backout plan",
    "correct_answer": "A",
    "explanation": "The procedure developed is a business continuity plan, which is an emergency operations procedure to be followed when one or more critical assets required for the business-as-usual procedure are unavailable.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      231,
      244,
      233,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 768,
    "question": "A city government IT department has developed a procedure to be followed when the primary application for accepting water usage payments has been incapacitated. The procedure, to be carried out by IT personnel, calls for the initiation of a secondary application in a different data center. What type of procedure has been developed?",
    "choice_a": "Business continuity plan",
    "choice_b": "Backout plan",
    "choice_c": "Security incident response plan",
    "choice_d": "Disaster recovery plan",
    "correct_answer": "D",
    "explanation": "The procedure created is a disaster recovery plan.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      240,
      248,
      247,
      235,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 769,
    "question": "What is the most important factor to consider in the development of a disaster recovery plan?",
    "choice_a": "The safety of personnel",
    "choice_b": "The availability of critical data",
    "choice_c": "Notification of civil authorities",
    "choice_d": "The continuity of critical operations",
    "correct_answer": "A",
    "explanation": "The safety of personnel should always be the highest priority in any disaster recovery plan.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      240,
      233,
      234,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 770,
    "question": "An SSD is most used as:",
    "choice_a": "Backup storage",
    "choice_b": "Removable storage",
    "choice_c": "Main storage",
    "choice_d": "Secondary storage",
    "correct_answer": "D",
    "explanation": "Solid-state drives (SSDs) are mostly used as secondary storage. Prior to SSDs, hard disk drives (HDDs) were used as secondary storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      187,
      183,
      197,
      200
    ],
    "source": "9781394290116"
  },
  {
    "id": 771,
    "question": "The phrase “you can’t protect what you don’t know about” refers to which key IT process?",
    "choice_a": "Vulnerability management",
    "choice_b": "License management",
    "choice_c": "Patching",
    "choice_d": "Asset management",
    "correct_answer": "D",
    "explanation": "Asset management is a critical process that other processes, such as vulnerability management, patch management, and license management, depend on. It is the author’s opinion that asset management is the #1 control objective in the CIS Critical Controls for this reason.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      218,
      169,
      171,
      172,
      198
    ],
    "source": "9781394290116"
  },
  {
    "id": 772,
    "question": "The SOAP protocol is related to:",
    "choice_a": "The patch management process",
    "choice_b": "The exchange of data through an API",
    "choice_c": "The vulnerability management process",
    "choice_d": "Memory garbage collection",
    "correct_answer": "B",
    "explanation": "SOAP (Simple Object Access Protocol) is a network API for exchanging data between systems over a network.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      222,
      230,
      208,
      209,
      217
    ],
    "source": "9781394290116"
  },
  {
    "id": 773,
    "question": "Restricting USB-attached storage on end-user workstations addresses all of the following <i>except</i>:",
    "choice_a": "Leakage of intellectual property",
    "choice_b": "Malware infection",
    "choice_c": "System capacity management",
    "choice_d": "Personal use of a workstation",
    "correct_answer": "C",
    "explanation": "Restrictions of USB storage often address leakage of intellectual property or personally sensitive information, malware infection, and personal uses of a workstation. Restricting USB has little or nothing to do with system capacity management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      225,
      223,
      199,
      182
    ],
    "source": "9781394290116"
  },
  {
    "id": 774,
    "question": "The primary purpose of a dynamic DLP system is:",
    "choice_a": "To detect unauthorized personal use of a workstation",
    "choice_b": "To detect unauthorized use of personal webmail",
    "choice_c": "To control unauthorized access to sensitive information",
    "choice_d": "To control unauthorized movement of sensitive information",
    "correct_answer": "D",
    "explanation": "The main purpose of dynamic DLP (data loss prevention) is the unauthorized movement of sensitive information. For example, a dynamic DLP solution can prevent sensitive information from being stored on an external USB-attached storage device or transmitted through email.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      164,
      205,
      222,
      218,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 775,
    "question": "What is the suitability for the use of a SIEM to alert personnel of system capacity and performance issues?",
    "choice_a": "If Syslog events are generated, use cases related to performance and capacity can be developed.",
    "choice_b": "A SIEM can only be used to alert personnel of security events.",
    "choice_c": "Use cases for non-security-related events do not function on a SIEM.",
    "choice_d": "Alerts for non-security-related events do not function on a SIEM.",
    "correct_answer": "A",
    "explanation": "A SIEM (system information and event management system) is a general-purpose system used to ingest log data from systems and devices and to create alerts when specific types of log entries are received. There is no limit to the types of log data and alerts that can be employed in a SIEM.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      174,
      161,
      198,
      164,
      225
    ],
    "source": "9781394290116"
  },
  {
    "id": 776,
    "question": "After analyzing events and incidents from the past year, an analyst has declared the existence of a problem. To what is the analyst referring?",
    "choice_a": "One or more controls are in a state of failure.",
    "choice_b": "The analyst is unable to access all incident data for the entire year.",
    "choice_c": "One or more high-criticality incidents have occurred.",
    "choice_d": "A specific type of incident is recurring.",
    "correct_answer": "D",
    "explanation": "In ITIL terminology, a problem is an incident that keeps occurring. This means that there is some root cause for these incidents that needs to be investigated, and a plan needs to be developed to eliminate the root cause so that the incidents no longer occur.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      165,
      173,
      166,
      168,
      164
    ],
    "source": "9781394290116"
  },
  {
    "id": 777,
    "question": "A DBA has determined that it is not feasible to directly back up a large database. What is the best remedy for this?",
    "choice_a": "Defragment the database to permit a linear backup.",
    "choice_b": "Change the database to read-only during a backup to preserve integrity.",
    "choice_c": "Compress the database to recover free space.",
    "choice_d": "Export the database to a flat file, and back up the flat file.",
    "correct_answer": "D",
    "explanation": "The best remedy when a database cannot be directly backed up is the creation of an export, which itself can be backed up.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      186,
      227,
      183,
      247,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 778,
    "question": "What is the feasibility of using the results of a BIA in the creation of a system classification plan?",
    "choice_a": "A BIA will indicate the sensitivity of specific data that is associated with critical business processes.",
    "choice_b": "A BIA will indicate the operational criticality of specific data that is associated with critical business processes.",
    "choice_c": "A BIA does not correlate to specific information systems.",
    "choice_d": "A BIA does not correlate to specific data sets.",
    "correct_answer": "B",
    "explanation": "A BIA identifies critical business processes in an organization, including the organization’s dependencies on IT systems and its data sets. Critical processes can be mapped to the systems they depend on, which can contribute to system classification.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      233,
      246,
      231,
      244,
      218
    ],
    "source": "9781394290116"
  },
  {
    "id": 779,
    "question": "A system engineer is reviewing critical systems in a data center and maps them to individual electrical circuits. The engineer identified a system with two power supplies that are connected to the same plug strip. What should the engineer conclude from this?",
    "choice_a": "It is an acceptable practice to connect both power supplies to the same circuit.",
    "choice_b": "It is an acceptable practice to connect both power supplies to the same plug strip.",
    "choice_c": "The two power supplies should not be connected to the same circuit.",
    "choice_d": "The two power supplies should not be connected to the same plug strip.",
    "correct_answer": "C",
    "explanation": "The main issue at stake here is that the power supplies are both connected to the same electrical circuit. If the electrical circuit fails, the system will be powered down. A better practice is to connect the two power supplies to separate circuits.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      233,
      206,
      246,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 780,
    "question": "An IT architect is proposing a plan for improving the resilience of critical data in the organization. The architect proposes that applications be altered so that they confirm that transactions have been successfully written to two different storage systems. What scheme has been proposed?",
    "choice_a": "Journaling",
    "choice_b": "Mirroring",
    "choice_c": "Data replication",
    "choice_d": "Two-phase commit",
    "correct_answer": "D",
    "explanation": "A two-phase commit is the act of writing a transaction to separate storage systems and not completing the transaction until confirmation of successful write operations has been received.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      238,
      239,
      231,
      183,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 781,
    "question": "A department has completed a review of its business continuity plan through a moderated discussion that followed a specific, scripted disaster scenario. What kind of a review was performed?",
    "choice_a": "Walkthrough",
    "choice_b": "Simulation",
    "choice_c": "Parallel test",
    "choice_d": "Peer review",
    "correct_answer": "B",
    "explanation": "A simulation is a type of review where a moderator reveals a realistic scenario, and test participants talk through the steps they would be taking should an actual disaster of this type occur. A simulation is more realistic than a walkthrough, as it helps to bring a disaster to life.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      235,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 782,
    "question": "What is the purpose of salvage operations in a disaster recovery plan?",
    "choice_a": "To identify the damage to, and recoverability of, critical equipment and assets",
    "choice_b": "To determine the scrap value of critical equipment and assets",
    "choice_c": "To ensure that all personnel are accounted for",
    "choice_d": "To identify business processes that can be resumed",
    "correct_answer": "A",
    "explanation": "The primary purpose of salvage is to determine the extent of damage to critical business equipment and to determine what is still functional, which assets can be repaired, and which are damaged beyond repair.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      248,
      247,
      235,
      234
    ],
    "source": "9781394290116"
  },
  {
    "id": 783,
    "question": "RAM is most used for:",
    "choice_a": "Secondary storage",
    "choice_b": "Main storage",
    "choice_c": "Virtual disk",
    "choice_d": "CPU instruction cache",
    "correct_answer": "B",
    "explanation": "RAM (random-access memory) is the primary technology used for a computer’s main storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      187,
      225,
      183,
      203
    ],
    "source": "9781394290116"
  },
  {
    "id": 784,
    "question": "All of the following are valid reasons for removing end users’ local administrator privileges on their workstations <i>except</i>:",
    "choice_a": "To reduce malware attack impact",
    "choice_b": "To prevent the use of personal webmail",
    "choice_c": "To prevent the installation of unauthorized software",
    "choice_d": "To reduce the number of service desk support calls",
    "correct_answer": "B",
    "explanation": "Removing local administrator access from an end user would not impact a user’s ability to access personal webmail in most cases.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      214,
      228,
      200,
      204
    ],
    "source": "9781394290116"
  },
  {
    "id": 785,
    "question": "The primary mission of data governance is:",
    "choice_a": "To ensure the availability of sensitive and critical information",
    "choice_b": "To ensure the integrity of sensitive and critical information",
    "choice_c": "To control and monitor all uses of sensitive or critical information",
    "choice_d": "To ensure compliance with applicable privacy laws",
    "correct_answer": "C",
    "explanation": "The primary mission of data governance is the control and monitoring of all uses of sensitive and/or critical information in an organization, in both structured and unstructured storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      180,
      182,
      183,
      184,
      185
    ],
    "source": "9781394290116"
  },
  {
    "id": 786,
    "question": "Many of the backout plans in the records of a change control process simply read, “Reverse previous steps.” What conclusion can be drawn from this?",
    "choice_a": "Backout plans are only relevant for emergency changes.",
    "choice_b": "Backout plans are not a part of a change management process.",
    "choice_c": "Backout plans are adequate.",
    "choice_d": "Backout plans are not as rigorous as they should be.",
    "correct_answer": "D",
    "explanation": "“Reverse previous steps” is wholly inadequate for most changes, as this represents unpreparedness for situations where changes are unsuccessful.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      167,
      166,
      168,
      235,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 787,
    "question": "The purpose of a business impact analysis (BIA) is primarily:",
    "choice_a": "To calculate risk in a risk assessment",
    "choice_b": "To determine the impact of a breach",
    "choice_c": "To determine process criticalities",
    "choice_d": "To determine process dependencies",
    "correct_answer": "D",
    "explanation": "The purpose of a business impact analysis (BIA) is to determine the dependencies of business processes – what assets, staff, and outside parties are required to sustain a process. Subsequent to a BIA is the criticality assessment (CA), which determines the criticality of business processes analyzed in the BIA.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      233,
      234,
      235,
      240,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 788,
    "question": "The purpose for prewriting public statements describing the impact of, response to, and recovery from a disaster includes all of the following <i>except</i>:",
    "choice_a": "During a disaster is not a good time to write such statements from scratch.",
    "choice_b": "Key personnel who would write such statements may not be available.",
    "choice_c": "Such public statements can be issued more quickly.",
    "choice_d": "Prewritten public statements are required by regulation.",
    "correct_answer": "D",
    "explanation": "Few, if any, regulations require organizations to prewrite their public statements describing a disaster and the details about impact, response, and recovery.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      243,
      235,
      241,
      242,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 789,
    "question": "An IT analyst is searching for a solution through which documents that have been emailed to outside parties can be made to self-destruct at a certain time. What kind of a solution is the IT analyst seeking?",
    "choice_a": "DRM",
    "choice_b": "DLP",
    "choice_c": "IPS",
    "choice_d": "IDS",
    "correct_answer": "A",
    "explanation": "The IT analyst is looking for a digital rights management (DRM) solution, which includes the ability for a document to “expire” or “self-destruct” after a specific date or time.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      205,
      182,
      183,
      218,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 790,
    "question": "An IT service desk person is discussing a problem with an end user. The IT service desk cites the user’s “personal area network.” What does the IT service desk person mean by this?",
    "choice_a": "The network in the user’s personal residence.",
    "choice_b": "The systems and devices the end user can access.",
    "choice_c": "The extent of devices in the same room as the user.",
    "choice_d": "The systems and devices owned by the end user.",
    "correct_answer": "C",
    "explanation": "A personal area network (PAN) is generally used by a single individual. Its reach ranges from a few centimeters up to 3 meters, and it is used to connect peripherals and communication devices for the user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      210,
      211,
      188,
      190,
      209
    ],
    "source": "9781394290116"
  },
  {
    "id": 791,
    "question": "All of the following are considered network-based services <i>except</i>:",
    "choice_a": "Print",
    "choice_b": "File storage",
    "choice_c": "Memory management",
    "choice_d": "Time synchronization",
    "correct_answer": "C",
    "explanation": "Memory management is not a network-based service but instead is a component of an operating system and/or a CPU.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      200,
      229,
      161,
      187
    ],
    "source": "9781394290116"
  },
  {
    "id": 792,
    "question": "Two network engineers are discussing aspects of their organization’s data network. One of the network engineers has cited the term <i>Layer 7</i>. What is the network engineer referring to?",
    "choice_a": "The Presentation layer of the OSI network model",
    "choice_b": "The Application layer of the OSI network model",
    "choice_c": "The Application layer of the TCP/IP network model",
    "choice_d": "The Transport layer of the TCP/IP network model",
    "correct_answer": "B",
    "explanation": "The term <i>Layer 7</i> refers to the Application (topmost) layer of the OSI network model.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      208,
      209,
      215,
      210,
      217
    ],
    "source": "9781394290116"
  },
  {
    "id": 793,
    "question": "All of the following protocols are a part of the Application layer of the TCP/IP network model <i>except</i>:",
    "choice_a": "ICMP",
    "choice_b": "SNMP",
    "choice_c": "DHCP",
    "choice_d": "DNS",
    "correct_answer": "A",
    "explanation": "ICMP (Internet Control Message Protocol) is a part of the Internet layer of the TCP/IP network model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      209,
      215,
      213,
      216,
      208
    ],
    "source": "9781394290116"
  },
  {
    "id": 794,
    "question": "The network device that is used to connect networks together is known as:",
    "choice_a": "Gateway",
    "choice_b": "Hub",
    "choice_c": "Switch",
    "choice_d": "Router",
    "correct_answer": "D",
    "explanation": "A router is a device used to connect networks together.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      215,
      209,
      208,
      207,
      228
    ],
    "source": "9781394290116"
  },
  {
    "id": 795,
    "question": "An organization’s IT operations manager has entered a new problem in the problem management log. What does this mean?",
    "choice_a": "A performance issue exists with a staff member.",
    "choice_b": "A security incident recently occurred.",
    "choice_c": "An IT incident recently occurred.",
    "choice_d": "Several similar incidents have recently occurred.",
    "correct_answer": "D",
    "explanation": "According to ITIL, a problem is defined as a cause of one or more incidents. In this case, several similar incidents have occurred, which is an indication of a problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      173,
      161,
      183,
      175
    ],
    "source": "9781394290116"
  },
  {
    "id": 796,
    "question": "An IT manager in an organization argues that release management is unnecessary for the organization’s SaaS-hosted applications. Is this position appropriate? Why or why not?",
    "choice_a": "Release management is necessary because the SaaS vendor regularly publishes releases and release notes.",
    "choice_b": "Release management is necessary because end users are using the application regardless of its location.",
    "choice_c": "Release management is unnecessary because the organization is not promoting newly updated code to production.",
    "choice_d": "Release management is unnecessary because the organization’s business application is not hosted on-premises.",
    "correct_answer": "A",
    "explanation": "Release management is essential, even when using an SaaS-based application, particularly when the SaaS provider makes regular software changes and publishes release notes describing the changes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      170,
      161,
      168,
      173,
      175
    ],
    "source": "9781394290116"
  },
  {
    "id": 797,
    "question": "What is the relationship between configuration management and system hardening?",
    "choice_a": "System hardening makes systems resilient to attack, whereas configuration management is the business process of ensuring correct configuration.",
    "choice_b": "Ransomware attacks alter a system’s hardening, which is corrected by configuration management.",
    "choice_c": "Configuration management procedures drive system hardening settings.",
    "choice_d": "The system hardening process drives configuration management settings.",
    "correct_answer": "A",
    "explanation": "Configuration management is a business process used to track the configuration settings of systems and devices. Often, configuration management tools are employed to automate the configuration and monitoring of system configuration settings. System hardening is the science of making configuration changes to systems and devices to make them more resilient to attack and compromise.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      169,
      226,
      172,
      167,
      166
    ],
    "source": "9781394290116"
  },
  {
    "id": 798,
    "question": "Configuration management is concerned with all of the following <i>except</i>:",
    "choice_a": "OS version and configuration",
    "choice_b": "OS performance",
    "choice_c": "Hardware complement",
    "choice_d": "Hardware configuration",
    "correct_answer": "B",
    "explanation": "Configuration management is concerned with hardware complement, hardware configuration, OS version and configuration, and software versions and configurations.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      169,
      225,
      226,
      227,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 799,
    "question": "Are change management and release management related? Why or why not?",
    "choice_a": "No; they are similar, but they are not related to each other.",
    "choice_b": "No; change management is concerned with configuration changes, whereas release management is concerned with software release.",
    "choice_c": "Yes; organizations can use one or the other to release software changes to production.",
    "choice_d": "Yes; both are concerned with software release to production.",
    "correct_answer": "D",
    "explanation": "Change management is concerned with all forms of changes to production IT environments, whereas release management is concerned with the promotion of new software releases to production.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      170,
      166,
      167,
      168,
      169
    ],
    "source": "9781394290116"
  },
  {
    "id": 800,
    "question": "The PCI DSS requires logfile retention as follows:",
    "choice_a": "3 months online",
    "choice_b": "12 months online",
    "choice_c": "3 months offline, 12 months online",
    "choice_d": "3 months online, 12 months offline",
    "correct_answer": "D",
    "explanation": "PCI DSS (Payment Card Industry Data Security Standard) requires logfiles to be retained for at least 3 months online and at least 12 months offline.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      182,
      180,
      181,
      220,
      184
    ],
    "source": "9781394290116"
  },
  {
    "id": 801,
    "question": "A new information security manager has examined the systems in the production environment and has found that their security-related configurations are inadequate and inconsistent. To improve this situation, the security manager should create a:",
    "choice_a": "Jump server",
    "choice_b": "Firewall rule",
    "choice_c": "Hardening standard",
    "choice_d": "CMDB",
    "correct_answer": "C",
    "explanation": "A hardening standard will define the security-related configurations applicable to information systems and devices. Note that automation may also need to be implemented if there are large numbers of servers.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      268,
      263,
      260,
      264,
      345
    ],
    "source": "9781394290116"
  },
  {
    "id": 802,
    "question": "Which US government agency enforces retail organizations’ information privacy policy?",
    "choice_a": "National Institute of Standards and Technology",
    "choice_b": "Federal Trade Commission",
    "choice_c": "Office of Civil Rights",
    "choice_d": "United States Secret Service",
    "correct_answer": "B",
    "explanation": "The US Federal Trade Commission (FTC) has historically enforced retail organizations’ information privacy policies and has brought legal suits against organizations knowingly violating these policies.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      294,
      297,
      262,
      259,
      325
    ],
    "source": "9781394290116"
  },
  {
    "id": 803,
    "question": "Although useful for detecting fires, what is one known problem associated with the use of smoke detectors under a raised computer room floor?",
    "choice_a": "False alarms due to the accumulation of dust",
    "choice_b": "Higher cost of maintenance",
    "choice_c": "Lack of visual reference",
    "choice_d": "Lower sensitivity due to stagnant air",
    "correct_answer": "A",
    "explanation": "Dust can accumulate under the raised floor in a computer room environment. Changes in airflow can cause the dust to circulate in the air, causing false-positive smoke detection.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      331,
      329,
      330,
      333,
      334
    ],
    "source": "9781394290116"
  },
  {
    "id": 804,
    "question": "An organization is seeking to establish a protocol standard for federated authentication. Which of the following protocols is <i>least</i> likely to be selected?",
    "choice_a": "OAuth",
    "choice_b": "SAML",
    "choice_c": "SOAP",
    "choice_d": "HMAC",
    "correct_answer": "C",
    "explanation": "SOAP is a protocol used for distributed object instantiation and communication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      319,
      273,
      282,
      288
    ],
    "source": "9781394290116"
  },
  {
    "id": 805,
    "question": "What is one distinct disadvantage of the use of on-premises web content filtering?",
    "choice_a": "End users can no longer inspect URLs in email messages.",
    "choice_b": "End users can easily circumvent it with a local IPS.",
    "choice_c": "Mobile devices are unprotected when off-network.",
    "choice_d": "It is labor-intensive to manage exceptions.",
    "correct_answer": "C",
    "explanation": "On-premises web content filtering protects devices on the internal network, as well as remote devices when they have established VPNs without split tunneling. Mobile devices connected to the Internet without a VPN receive no protection from on-premises web content filtering systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      319,
      273,
      269,
      265
    ],
    "source": "9781394290116"
  },
  {
    "id": 806,
    "question": "What is the purpose of data classification?",
    "choice_a": "To establish rules for data protection and use",
    "choice_b": "To discover sensitive data on unstructured shares",
    "choice_c": "To enforce file access rules",
    "choice_d": "To gather statistics on data usage",
    "correct_answer": "A",
    "explanation": "The purpose of a data classification program is to define the classes, or categories, of data and define usage guidelines for data at each classification level. This helps personnel to understand and follow handling guidelines, which results in improved data protection.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      295,
      262,
      303,
      294,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 807,
    "question": "Blockchain is best described as:",
    "choice_a": "A cryptographic algorithm",
    "choice_b": "A data confidentiality technique using cryptography",
    "choice_c": "A popular cryptocurrency",
    "choice_d": "A list of records that are linked using cryptography",
    "correct_answer": "D",
    "explanation": "A blockchain is a series of records that are linked using cryptography. Specifically, each successive record in a blockchain contains a hash of the previous record; this makes data in a blockchain resistant to alteration.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      285,
      282,
      283,
      301,
      288
    ],
    "source": "9781394290116"
  },
  {
    "id": 808,
    "question": "The private keys for a well-known website have been compromised. What is the best approach for resolving this matter?",
    "choice_a": "Change the IP address of the web server.",
    "choice_b": "Add an entry to a CRL for the website’s TLS/SSL keys.",
    "choice_c": "Recompile the website’s application.",
    "choice_d": "Reboot the web server.",
    "correct_answer": "B",
    "explanation": "Adding an entry to the certificate revocation list (CRL) is the most effective solution. The certificate authority (CA) that issued the original TLS/SSL keys would perform this action. Subsequent attempts to connect with the compromised keys would be unsuccessful – at least for all software that checks the CRL first.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      282,
      289,
      300
    ],
    "source": "9781394290116"
  },
  {
    "id": 809,
    "question": "A web application stores unique codes on each user’s system to track the activities of each visitor. What is a common term for these codes?",
    "choice_a": "HTTP-only cookie",
    "choice_b": "Super cookie",
    "choice_c": "Session cookie",
    "choice_d": "Persistent cookie",
    "correct_answer": "C",
    "explanation": "A session cookie is used to uniquely identify each visitor to a website and to manage user sessions.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      314,
      317,
      343,
      321,
      295
    ],
    "source": "9781394290116"
  },
  {
    "id": 810,
    "question": "The term <i>virtual memory</i> refers to what mechanism?",
    "choice_a": "The main storage allocated to a guest of a hypervisor",
    "choice_b": "Memory management that isolates running processes",
    "choice_c": "Memory that is shared between guests of a hypervisor",
    "choice_d": "Main storage space that exceeds physical memory and is extended to secondary storage",
    "correct_answer": "D",
    "explanation": "Virtual memory is the technique of creating memory space that exceeds the physical main memory of a system; memory is extended onto secondary storage.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      271,
      319,
      301,
      287,
      335
    ],
    "source": "9781394290116"
  },
  {
    "id": 811,
    "question": "What is the effect of suppressing the broadcast of SSID?",
    "choice_a": "Network is not listed, but no difference in security.",
    "choice_b": "Only registered users are able to connect.",
    "choice_c": "Stronger (AES vs. TKIP) cryptography.",
    "choice_d": "Administrators can track users more easily.",
    "correct_answer": "A",
    "explanation": "Suppressing the broadcast of SSID in a Wi-Fi network makes little difference in terms of the network’s security. Some believe that suppressing SSID is better for security, but there are numerous tools available that show all available networks, whether they are broadcasting SSID or not.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      320,
      306,
      268,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 812,
    "question": "What is the purpose of recordkeeping in a security awareness training program?",
    "choice_a": "It prevents users from repeating the training.",
    "choice_b": "Compliance with training provider licensing requirements.",
    "choice_c": "Recordkeeping is required by ISO 27001.",
    "choice_d": "Users cannot later claim no knowledge of content if they violate policy.",
    "correct_answer": "D",
    "explanation": "When a user completes security awareness training and there is evidence of this completion in business records, the user cannot easily refute knowledge of the training content if they later are found to violate policy. Competency quizzes as a part of security awareness training help even more in this regard.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      340,
      301,
      343,
      262
    ],
    "source": "9781394290116"
  },
  {
    "id": 813,
    "question": "An attack technique in which an attacker attempts to place arbitrary code into the instruction space of a running process is known as:",
    "choice_a": "Cross-site scripting",
    "choice_b": "A time-of-check to time-of-use attack",
    "choice_c": "A buffer-overflow attack",
    "choice_d": "A race condition",
    "correct_answer": "C",
    "explanation": "A buffer-overflow attack is a technique where the attacker attempts to overflow a running program’s input buffer, resulting in arbitrary code overwriting other instructions in the program. Successful exploitation of a buffer-overflow vulnerability gives the attacker complete control over the target program.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      322,
      268,
      306,
      300,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 814,
    "question": "A security analyst who is troubleshooting a security issue has asked another engineer to obtain a PCAP file associated with a given user’s workstation. What is the security analyst asking for?",
    "choice_a": "A copy of the workstation’s registry file",
    "choice_b": "A copy of the network traffic to and from the workstation",
    "choice_c": "An image of the workstation’s main memory (RAM)",
    "choice_d": "An image of the workstation’s secondary memory (hard drive)",
    "correct_answer": "B",
    "explanation": "A PCAP (packet capture) file is a file containing a copy of network traffic associated with one or more devices on a network.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      265,
      308,
      266,
      304,
      306
    ],
    "source": "9781394290116"
  },
  {
    "id": 815,
    "question": "A development lab employs a syslog server for security and troubleshooting issues. The information security office has recently implemented a SIEM and has directed that all log data be sent to the SIEM. How can the development lab continue to employ its local syslog server while complying with this request?",
    "choice_a": "Build a proxy server that will clone the log data.",
    "choice_b": "The development lab will have to shut down its syslog server.",
    "choice_c": "Export syslog data every hour, and send it to the SIEM.",
    "choice_d": "Direct servers to send their syslog data to the local server and to the SIEM.",
    "correct_answer": "D",
    "explanation": "Servers and devices can send syslog data to multiple destinations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      321,
      346,
      306,
      264,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 816,
    "question": "The best time to assign roles and responsibilities for computer security incident response is:",
    "choice_a": "During training",
    "choice_b": "During tabletop testing",
    "choice_c": "While responding to an incident",
    "choice_d": "While writing the incident response plan",
    "correct_answer": "D",
    "explanation": "The best time to establish and assign roles and responsibilities for computer security incident response is at the time of incident response plan development.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      256,
      300,
      347,
      262,
      254
    ],
    "source": "9781394290116"
  },
  {
    "id": 817,
    "question": "Chain of custody is employed in which business process?",
    "choice_a": "Internal investigation",
    "choice_b": "Asset management",
    "choice_c": "Access management",
    "choice_d": "Penetration testing",
    "correct_answer": "A",
    "explanation": "Chain of custody is employed whenever there is an investigation, including forensics and security incidents, where evidence needs to be collected and retained for later legal proceedings.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      347,
      300,
      302,
      346
    ],
    "source": "9781394290116"
  },
  {
    "id": 818,
    "question": "Canada’s ITSG-33 is like which standard?",
    "choice_a": "SSAE18",
    "choice_b": "HIPAA",
    "choice_c": "NIST SP 800-53",
    "choice_d": "ISO/IEC 27001",
    "correct_answer": "C",
    "explanation": "Canada’s ITSG-33 is effectively a clone of the US standard NIST SP 800-53.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      264,
      253,
      308,
      303,
      307
    ],
    "source": "9781394290116"
  },
  {
    "id": 819,
    "question": "The process of ensuring proper protection and use of PII is known as:",
    "choice_a": "Security",
    "choice_b": "Privacy",
    "choice_c": "Data loss prevention",
    "choice_d": "Data discovery",
    "correct_answer": "B",
    "explanation": "Privacy is primarily concerned with the protection of PII (personally identifiable information), as well as its uses in and by an organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      294,
      295,
      296,
      253,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 820,
    "question": "A CIO is investigating the prospect of a hosting center for its IT infrastructure. A specific hosting center claims to have “N+1 HVAC Systems.” What is meant by this term?",
    "choice_a": "The hosting center has one more HVAC system than is necessary for adequate cooling.",
    "choice_b": "The hosting center has the “N+1” brand of HVAC systems designed for hosting centers.",
    "choice_c": "The hosting center has recently installed a new HVAC system.",
    "choice_d": "The hosting center’s HVAC systems meet the N+1 reliability standard.",
    "correct_answer": "A",
    "explanation": "N+1 refers to any of several critical systems, including incoming power, HVAC, and Internet connectivity, where at least one additional component is available so that the failure of one component will not interrupt hosting center services.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      330,
      349,
      328,
      331,
      337
    ],
    "source": "9781394290116"
  },
  {
    "id": 821,
    "question": "An organization has updated its identity and access management infrastructure so that users use their AD credentials to log in to the network and internal business applications. What has the organization implemented?",
    "choice_a": "Credential vaulting",
    "choice_b": "Single sign-on",
    "choice_c": "Federated identity",
    "choice_d": "Reduced sign-on",
    "correct_answer": "D",
    "explanation": "Reduced sign-on is the result of integrating a central identity store such as Active Directory (AD) with applications and networks. The term <i>reduced sign-on</i> refers to the reduction in the number of login credentials users need to access networks and systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      314,
      320,
      311,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 822,
    "question": "The primary advantage of a firewall on a laptop computer is:",
    "choice_a": "Laptop computers are protected when outside the enterprise network.",
    "choice_b": "End users have more control over their network security.",
    "choice_c": "Improved performance of enterprise network firewalls.",
    "choice_d": "Redundancy in the event the enterprise firewall is overloaded.",
    "correct_answer": "A",
    "explanation": "The firewall on a laptop computer will provide some network protection in cases where the laptop is connected to the Internet at a location outside of the enterprise and its firewalls.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      268,
      306,
      270,
      264,
      309
    ],
    "source": "9781394290116"
  },
  {
    "id": 823,
    "question": "An organization’s data classification policy includes guidelines for placing footers with specific language in documents and presentations. What activity does this refer to?",
    "choice_a": "Digital signatures",
    "choice_b": "Digital envelopes",
    "choice_c": "Document marking",
    "choice_d": "Document tagging",
    "correct_answer": "C",
    "explanation": "Document marking is the process of placing human-readable text in a document that advises a reader of its sensitivity.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      295,
      296,
      266,
      262,
      298
    ],
    "source": "9781394290116"
  },
  {
    "id": 824,
    "question": "What technique does PGP use to permit multiple users to read an encrypted document?",
    "choice_a": "Key fingerprints",
    "choice_b": "Symmetric cryptography",
    "choice_c": "Digital envelope",
    "choice_d": "Digital signature",
    "correct_answer": "C",
    "explanation": "PGP uses a digital envelope to encapsulate multiple public keys that permit multiple users to read an encrypted document.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      284,
      289,
      285,
      286,
      287
    ],
    "source": "9781394290116"
  },
  {
    "id": 825,
    "question": "What feature permits enterprise users of Microsoft Outlook to digitally sign email messages?",
    "choice_a": "PGP",
    "choice_b": "PKI",
    "choice_c": "Local administrative privileges",
    "choice_d": "Password vaulting",
    "correct_answer": "B",
    "explanation": "The PKI capabilities in Active Directory facilitate the use of digital signatures and encryption of email messages in Outlook.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      284,
      287,
      282,
      288
    ],
    "source": "9781394290116"
  },
  {
    "id": 826,
    "question": "A URL starting with HTTPS:// signifies what technology?",
    "choice_a": "Self-signed content",
    "choice_b": "Encryption with 3DES",
    "choice_c": "Encryption with SSL or TLS",
    "choice_d": "SET, or Secure Electronic Transaction",
    "correct_answer": "C",
    "explanation": "HTTPS:// signifies the use of the TLS/SSL protocol to encrypt transmissions between the browser and the web server.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      282,
      287,
      288,
      285,
      314
    ],
    "source": "9781394290116"
  },
  {
    "id": 827,
    "question": "A recent audit of an IT operation included a finding stating that the organization experiences virtualization sprawl. What is the meaning of this term?",
    "choice_a": "The process related to the creation of new virtual machines is not effective.",
    "choice_b": "Virtual machines are contending for scarce resources.",
    "choice_c": "The organization has too many virtual machines.",
    "choice_d": "Resource requirements for virtual machines are growing.",
    "correct_answer": "A",
    "explanation": "Virtualization sprawl is the phenomenon whereby new virtual machines are created without adequate management control. Because new servers can be created in a virtual environment without requiring the purchase of server hardware, organizations without effective controls will find that they have far more virtual machines than management intends.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      280,
      263,
      264,
      303,
      307
    ],
    "source": "9781394290116"
  },
  {
    "id": 828,
    "question": "Reasons for placing all IoT-type devices on isolated VLANs include all of the following <i>except</i>:",
    "choice_a": "Use of a different network access method",
    "choice_b": "Compatibility with IPv4",
    "choice_c": "Risks associated with unpatched and unpatchable devices",
    "choice_d": "Protection from malware present in end-user environments",
    "correct_answer": "B",
    "explanation": "Compatibility with IPv4 is rarely, if ever, a reason for isolating IoT devices onto a separate VLAN.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      271,
      306,
      268,
      310
    ],
    "source": "9781394290116"
  },
  {
    "id": 829,
    "question": "What is the best reason for including competency quizzes in security awareness training courses?",
    "choice_a": "Quizzes are needed to improve users’ knowledge.",
    "choice_b": "Quizzes are required by regulations such as PCI and HIPAA.",
    "choice_c": "It gives users an opportunity to test their skills.",
    "choice_d": "It provides evidence of retention of course content.",
    "correct_answer": "D",
    "explanation": "Quizzes help to reinforce learning and provide evidence that users learned the content. Some online courses can require users to pass quizzes with an arbitrary minimum score to complete the course. Finally, a user accused of policy violation cannot rightfully claim their lack of understanding of policies if quiz scores demonstrate they did understand them at the time of their training.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      298,
      303,
      340,
      264,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 830,
    "question": "In the context of information technology and information security, what is the purpose of fuzzing?",
    "choice_a": "To assess a physical server’s resilience through a range of humidity settings",
    "choice_b": "To assess a physical server’s ability to repel static electricity",
    "choice_c": "To assess a program’s resistance to attack via the UI",
    "choice_d": "To assess a program’s performance",
    "correct_answer": "C",
    "explanation": "Fuzzing refers to techniques where numerous iterations of data input combinations are offered to input fields to assess the presence and exploitability of security vulnerabilities.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      263,
      258,
      300,
      301,
      302
    ],
    "source": "9781394290116"
  },
  {
    "id": 831,
    "question": "An attacker who is attempting to infiltrate an organization has decided to employ a DNS poison cache attack. What method will the attacker use to attempt this attack?",
    "choice_a": "Send forged query replies to a DNS server.",
    "choice_b": "Send forged query replies to end-user workstations.",
    "choice_c": "Send forged PTR replies to end-user workstations.",
    "choice_d": "Send forced PTR replies to DNS servers.",
    "correct_answer": "A",
    "explanation": "A DNS poison cache attack works by sending forged DNS query replies to a DNS server in an attempt to plant false information in the server’s cache. The purpose of this attack is to direct users to the wrong server when their workstations query the DNS server in attempts to obtain IP addresses for target servers. When the attacker has successfully poisoned the DNS server’s cache, the DNS server provides falsified replies, and users are sent to imposter servers.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      292,
      320,
      268,
      264,
      282
    ],
    "source": "9781394290116"
  },
  {
    "id": 832,
    "question": "What is the Unix command for dynamically viewing the end of a text logfile?",
    "choice_a": "tail -f",
    "choice_b": "tail -e",
    "choice_c": "less -f",
    "choice_d": "more -f",
    "correct_answer": "A",
    "explanation": "The “tail -f” command will dynamically display the end of a text logfile. When new entries appear in the logfile, “tail” will automatically show the new entries with no user intervention required.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      300,
      299,
      302,
      301,
      297
    ],
    "source": "9781394290116"
  },
  {
    "id": 833,
    "question": "In the US, what are organizations required to do when discovering child pornography on a user’s workstation?",
    "choice_a": "Contact law enforcement after the user has admitted to viewing child porn.",
    "choice_b": "Contact law enforcement when the user’s workstation has been retired.",
    "choice_c": "Contact law enforcement after terminating the user.",
    "choice_d": "Immediately contact law enforcement.",
    "correct_answer": "D",
    "explanation": "Organizations in the US are required to contact law enforcement immediately on discovery of child porn on any computer or workstation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      347,
      301,
      302,
      297,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 834,
    "question": "An organization suspects one of its employees of a security violation regarding the use of their workstations. The workstation is powered on and in the employee’s workspace. What is the first thing the expert should do?",
    "choice_a": "Remove the hard drive.",
    "choice_b": "Photograph the laptop.",
    "choice_c": "Power up the laptop.",
    "choice_d": "Remove the RAM from the laptop.",
    "correct_answer": "B",
    "explanation": "Prior to performing any action on the laptop, the forensic expert should first photograph the laptop to show its state prior to the start of the forensic analysis.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      301,
      300,
      299,
      302,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 835,
    "question": "Which of the following statements is true regarding the Payment Card Industry Data Security Standard (PCI DSS)?",
    "choice_a": "All organizations processing more than US$6,000,000 in credit card transactions annually must undergo an annual audit.",
    "choice_b": "Organizations using chip-and-PIN terminals are exempt from PCI requirements.",
    "choice_c": "Organizations processing fewer than 6 million merchant transactions annually are usually permitted to provide annual self-assessments.",
    "choice_d": "Organizations are permitted to opt out of low-risk controls via Compensating Control Worksheets.",
    "correct_answer": "C",
    "explanation": "Merchant organizations with fewer than 6 million credit card transactions annually are usually permitted to complete annual self-assessment questionnaires.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      295,
      263,
      324,
      325,
      303
    ],
    "source": "9781394290116"
  },
  {
    "id": 836,
    "question": "According to the European General Data Protection Regulation (GDPR), what is the requirement for organizations when a breach occurs?",
    "choice_a": "All organizations are required to notify supervisory authorities within 48 hours.",
    "choice_b": "All organizations are required to notify supervisory authorities within 72 hours.",
    "choice_c": "All organizations are required to notify affected parties within 24 hours.",
    "choice_d": "Only organizations based in Europe are required to notify supervisory authorities.",
    "correct_answer": "B",
    "explanation": "According to Article 33 of the GDPR, organizations are required to notify the supervisory authority within 72 hours of a breach.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      297,
      294,
      300,
      299,
      325
    ],
    "source": "9781394290116"
  },
  {
    "id": 837,
    "question": "What is the biggest risk associated with access badges that show the name of the organization?",
    "choice_a": "Someone who finds the badge may know where it can be used.",
    "choice_b": "An attacker can look up the organization’s public key and create forged badges.",
    "choice_c": "An attacker would know what brand of access badge technology is being used.",
    "choice_d": "Someone who finds a lost badge would be able to return it to the company.",
    "correct_answer": "A",
    "explanation": "An access badge bearing the name of the organization would give someone finding the badge valuable information about where the badge may be used. If the organization does not use multifactor access controls, anyone finding a badge may be able to enter buildings, parking garages, and even data centers.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      337,
      335,
      315,
      340,
      334
    ],
    "source": "9781394290116"
  },
  {
    "id": 838,
    "question": "A user at work logs on to a website that includes links to various business applications. Once the user logs on to the website, the user does not need to log on to individual business applications. What mechanism provides this capability?",
    "choice_a": "Public key infrastructure",
    "choice_b": "Reduced sign-on",
    "choice_c": "Single sign-on",
    "choice_d": "Key vaulting",
    "correct_answer": "C",
    "explanation": "The user has logged on to a single sign-on (SSO) portal, which provides easy access to many business applications without the user having to log on to each one.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      317,
      314,
      318,
      343,
      325
    ],
    "source": "9781394290116"
  },
  {
    "id": 839,
    "question": "What is the primary advantage of cloud-based web content filtering versus on-premises web content filtering?",
    "choice_a": "Cloud-based web content filtering systems are less expensive.",
    "choice_b": "Exceptions can be processed more quickly.",
    "choice_c": "Off-network users are protected just as in-office users are.",
    "choice_d": "Users are unable to circumvent this protection.",
    "correct_answer": "C",
    "explanation": "The primary advantage of cloud-based web content filtering is that all users are protected, whether they are on the organization’s internal network or off-network, either at home or traveling.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      278,
      277,
      319,
      320,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 840,
    "question": "An organization is investigating the use of an automated DLP solution that controls whether data files can be sent via email or stored on USB drives based on their tags. What is the advantage of using tags for such a solution?",
    "choice_a": "Users are easily able to tag files so that they can be properly handled in email.",
    "choice_b": "Data files are automatically processed based on tags instead of their data content.",
    "choice_c": "Tags are a better solution than the use of digital envelopes.",
    "choice_d": "Tags are human-readable and can be altered as needed.",
    "correct_answer": "B",
    "explanation": "Automated systems can take action based on the tags in a file. However, this is only as good as the mechanism used to apply tags in the first place, which could be accurate or inaccurate.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      266,
      295,
      264,
      298,
      262
    ],
    "source": "9781394290116"
  },
  {
    "id": 841,
    "question": "All of the following are appropriate uses of digital signatures <i>except</i>:",
    "choice_a": "Verification of message authenticity",
    "choice_b": "Verification of message integrity",
    "choice_c": "Verification of message confidentiality",
    "choice_d": "Verification of message origin",
    "correct_answer": "C",
    "explanation": "Verification of message confidentiality is <i>not</i> a use of digital signatures, as digital signatures do not provide confidentiality of a message by themselves.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      286,
      282,
      253,
      285,
      284
    ],
    "source": "9781394290116"
  },
  {
    "id": 842,
    "question": "The entity that accepts requests for new public keys in a PKI is known as the <i>:</i>",
    "choice_a": "Reservation authority (RA)",
    "choice_b": "Validation authority (VA)",
    "choice_c": "Registration authority (RA)",
    "choice_d": "Certificate authority (CA)",
    "correct_answer": "C",
    "explanation": "A registration authority (RA) is the entity that receives and accepts requests for new public keys or digital certificates in a PKI, such as an SSL certificate issuer, to secure website communication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      284,
      286,
      289,
      317
    ],
    "source": "9781394290116"
  },
  {
    "id": 843,
    "question": "What method is used by a transparent proxy filter to prevent a user from visiting a site that has been blacklisted?",
    "choice_a": "Proxy sends an HTTP 400 Bad Request to the user’s browser.",
    "choice_b": "User is directed to a “website blocked” splash page.",
    "choice_c": "Proxy filter simply drops the packets, and the user’s browser times out.",
    "choice_d": "User’s workstation is quarantined to prevent malware from spreading.",
    "correct_answer": "B",
    "explanation": "A transparent proxy server will usually direct a user to a “splash page,” informing the user that their request to access a forbidden website has been blocked. Some organizations include information on the splash page that can direct the user to make a request to unblock access to the desired site.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      306,
      264,
      268,
      272,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 844,
    "question": "In a virtualized environment, which method is the fastest way to ensure rapid recovery of servers at an alternate processing center?",
    "choice_a": "Copy snapshots of virtual machine images to alternate processing center storage system.",
    "choice_b": "Provide build instructions for all servers and make master server images available.",
    "choice_c": "Perform full and incremental backups of all servers on a daily basis.",
    "choice_d": "Perform grandfather–father–son backups of all servers on a daily basis.",
    "correct_answer": "A",
    "explanation": "Copying snapshots of actual server images ensures that recent server images are available at the alternate processing center for rapid restoration.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      321,
      349,
      328,
      300,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 845,
    "question": "In an environment where users are not local administrators of their workstations, which of the following methods ensures that end users are not able to use their mobile devices as mobile Wi-Fi hotspots for circumventing network security controls such as web content filters and IPS?",
    "choice_a": "Require employees to turn off their mobile devices at work.",
    "choice_b": "Jam the signals of unauthorized Wi-Fi networks.",
    "choice_c": "Create an allow list of permitted Wi-Fi networks.",
    "choice_d": "Create a deny list of forbidden Wi-Fi networks.",
    "correct_answer": "C",
    "explanation": "The best workable solution is to create an allow list (formerly known as a whitelist) of Wi-Fi networks that workstations are permitted to connect to. These networks would include all corporate Wi-Fi networks, as well as any trusted noncorporate networks.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      269,
      320,
      306,
      266,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 846,
    "question": "What is the most effective method for training users to detect and delete phishing messages more accurately?",
    "choice_a": "Block access to personal webmail and permit corporate email only.",
    "choice_b": "Include phishing information in regular security awareness training.",
    "choice_c": "Conduct phishing tests, and publicly inform offenders of their mistakes.",
    "choice_d": "Conduct phishing tests, and privately inform offenders of their mistakes.",
    "correct_answer": "D",
    "explanation": "Well-managed phishing testing campaigns can help employees learn how to spot phishing messages. Providing “I think this is a phish” capability gives end users the ability to affirm that test messages are phishing tests, and it’s also a good method for reporting actual phishing messages.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      303,
      308,
      256,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 847,
    "question": "An attacker has targeted an organization to steal specific information. The attacker has found that the organization’s defenses are strong and that very few phishing messages arrive at end-user inboxes. The attacker has decided to try a watering hole attack. What first steps should the hacker use to ensure a successful watering hole attack?",
    "choice_a": "Determine which websites are frequently visited by the organization’s end users.",
    "choice_b": "Determine which restaurants the organization’s end users visit after working hours.",
    "choice_c": "Determine which protocols are blocked by the organization’s Internet firewalls.",
    "choice_d": "Determine the IP addresses of public-facing web servers that can be attacked.",
    "correct_answer": "A",
    "explanation": "To conduct a successful watering hole attack, the attacker must first determine which websites are frequently visited by employees in the organization. This will include cloud-based applications used for primary business processes such as accounting, sales, human resources, and file storage.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      292,
      290,
      298,
      323,
      324
    ],
    "source": "9781394290116"
  },
  {
    "id": 848,
    "question": "Which of the following techniques most accurately describes a penetration test?",
    "choice_a": "Manual exploitation tools and techniques",
    "choice_b": "Vulnerability scan, with results tabulated into a formal report that includes an executive summary",
    "choice_c": "Vulnerability scan, with results validated to remove any false positives",
    "choice_d": "Vulnerability scan, followed by manual exploitation tools and techniques",
    "correct_answer": "D",
    "explanation": "A penetration test most commonly begins with a vulnerability scan that enumerates assets and provides a big-picture attack profile. This is followed by an array of manual attack techniques that attempt to exploit vulnerabilities in the systems and services identified by the security scan.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      308,
      322,
      313,
      306,
      274
    ],
    "source": "9781394290116"
  },
  {
    "id": 849,
    "question": "A security analyst spends most of her time on a system that collects log data and correlates events from various systems to deduce potential attacks in progress. What kind of a system is the security analyst using?",
    "choice_a": "SIEM",
    "choice_b": "IPS",
    "choice_c": "IDS",
    "choice_d": "AV console",
    "correct_answer": "A",
    "explanation": "The security analyst is using a SIEM, or security information and event management system. A SIEM collects log data from devices throughout the environment and then correlates seemingly disparate events to deduce potential attacks. When such attacks are discerned, the SIEM will produce an alert that directs the security analyst to investigate the matter further and take possible action.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      346,
      306,
      299,
      264,
      308
    ],
    "source": "9781394290116"
  },
  {
    "id": 850,
    "question": "The general counsel receives notifications of all security incidents, including minor ones, and is becoming annoyed by these notifications. This general counsel receiving all notifications is most likely due to:",
    "choice_a": "Careless users clicking on too many phishing emails",
    "choice_b": "Ineffective defenses allowing frequent attacks",
    "choice_c": "Improper classification of security incidents",
    "choice_d": "Lack of a security incident severity scheme",
    "correct_answer": "D",
    "explanation": "The most likely reason the general counsel is being notified of minor incidents is the lack of an incident classification scheme in the organization’s security incident response plan. Without a severity classification scheme, all incidents are treated as equal, regardless of their actual severity. In this case, the result is executives being notified of minor incidents that should be of little or no concern to them.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      300,
      347,
      256,
      259,
      297
    ],
    "source": "9781394290116"
  },
  {
    "id": 851,
    "question": "A forensic investigator is seen to be creating a detailed record of artifacts that are collected, analyzed, controlled, transferred to others, and stored for safekeeping. What kind of a written record is this?",
    "choice_a": "Storage inventory",
    "choice_b": "Investigation report",
    "choice_c": "Evidence collection log",
    "choice_d": "Chain of custody record",
    "correct_answer": "D",
    "explanation": "The recordkeeping described is a chain of custody record, which provides a detailed account of each artifact collected and analyzed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      347,
      310,
      262,
      346
    ],
    "source": "9781394290116"
  },
  {
    "id": 852,
    "question": "Which controls framework is suggested by the ISO/IEC 27001 standard?",
    "choice_a": "ISO/IEC 27001",
    "choice_b": "ISO/IEC 27002",
    "choice_c": "NIST SP800-53",
    "choice_d": "Any framework that is applicable to the organization",
    "correct_answer": "B",
    "explanation": "ISO/IEC 27001 suggests the use of the ISO/IEC 27002 standard for controls. Annex A of ISO/IEC 27001 contains a summary list of the controls found in the ISO/IEC 27002 standard. However, organizations following (or being certified to) ISO/IEC 27001 are free to select any control framework they want or build one of their own.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      264,
      263,
      303,
      340,
      345
    ],
    "source": "9781394290116"
  },
  {
    "id": 853,
    "question": "The default principle in the European General Data Protection Regulation for marketing communications from organizations to citizens is:",
    "choice_a": "Citizens are included but cannot opt out.",
    "choice_b": "Citizens are included until they explicitly opt out.",
    "choice_c": "Citizens are excluded until they explicitly opt in.",
    "choice_d": "Citizens are excluded and cannot opt in.",
    "correct_answer": "C",
    "explanation": "Under the GDPR, organizations are not permitted to market to individual citizens unless the citizens first opt in.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      294,
      295,
      325,
      340,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 854,
    "question": "The primary purpose of an access control vestibule (formerly known as a mantrap) is:",
    "choice_a": "To catch an individual attempting to enter a room without authorization",
    "choice_b": "To hold an offender in custody until charged or released",
    "choice_c": "To permit entry of one authorized person at a time",
    "choice_d": "To permit entry or exit of one authorized person at a time",
    "correct_answer": "D",
    "explanation": "An access control vestibule (formerly known as a mantrap) is a special controlled entrance or exit that permits only one person at a time to enter or exit an area.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      350,
      334,
      264,
      310,
      343
    ],
    "source": "9781394290116"
  },
  {
    "id": 855,
    "question": "What is the purpose of locking a user account that has not been used for long periods of time?",
    "choice_a": "Reduction of the risk of compromised credentials",
    "choice_b": "Free up space for others to use the system",
    "choice_c": "Avoidance of audit exceptions",
    "choice_d": "Recycle license keys and cost reduction",
    "correct_answer": "A",
    "explanation": "If a user has not logged in to an application for long periods of time, then perhaps the user account for that application can be locked. This would reduce the impact of compromised credentials by preventing an unauthorized party from logging in to a system.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      343,
      344,
      318,
      345,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 856,
    "question": "What is the best approach for implementing a new blocking rule in an IPS?",
    "choice_a": "First implement a firewall rule, and then activate the IPS rule.",
    "choice_b": "Use the change control process so that stakeholders are aware of the new rule.",
    "choice_c": "Implement a new rule during a change window.",
    "choice_d": "Put the rule in learn mode, and analyze the results.",
    "correct_answer": "D",
    "explanation": "The best approach is to first create the rule in learn mode, where the rule will detect and log rule activations but not actually block traffic. Analysis of the log will help analysts understand whether the new rule would inadvertently block legitimate traffic and disrupt system operation. If no such interference is observed, the rule can be safely put into block mode.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      346,
      264,
      300,
      299,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 857,
    "question": "A security leader needs to develop a data classification program. After developing the data classification and handling policy, what is the best next step to perform?",
    "choice_a": "Configure DLP systems to monitor and enforce compliance.",
    "choice_b": "Configure DLP systems to monitor compliance.",
    "choice_c": "Announce the new policy to the organization.",
    "choice_d": "Work with business departments to socialize the policy.",
    "correct_answer": "D",
    "explanation": "The best next step is to work with various business departments to discuss the new policy and handling guidelines to understand the potential impact of the policy. A badly implemented data classification program can cause business disruption and erode goodwill.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      254,
      295,
      262,
      298,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 858,
    "question": "An organization wants to implement an IPS that utilizes TLS inspection. What must first be implemented so that the IPS will function?",
    "choice_a": "A span port on the Internet switch must be configured.",
    "choice_b": "A new root certificate must be pushed to all user workstations.",
    "choice_c": "Users must sign a consent for their personal traffic to be monitored.",
    "choice_d": "All end-user private keys must be refreshed.",
    "correct_answer": "B",
    "explanation": "Unless the organization creates a root certificate and pushes it to all end-user workstations, users’ browsers will throw certificate errors.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      274,
      273,
      285,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 859,
    "question": "In what manner does a PKI support whole-disk encryption on end-user workstations?",
    "choice_a": "PKI stores the bootup passwords used on each end-user workstation.",
    "choice_b": "PKI detects unauthorized use of data on end-user workstations.",
    "choice_c": "PKI stores decryption keys in the event an end-user forgets their bootup password.",
    "choice_d": "PKI records encryption and decryption operations.",
    "correct_answer": "C",
    "explanation": "Although a PKI is not required to implement whole-disk encryption on end-user workstations, a PKI can be used to store administrative keys that can be used to unlock a workstation if the user has forgotten their bootup password.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      283,
      268,
      321,
      317
    ],
    "source": "9781394290116"
  },
  {
    "id": 860,
    "question": "A browser contacts a web server and requests a web page. The web server responds with a status code 200. What is the meaning of this status code?",
    "choice_a": "The user has been redirected to another URL on the same domain.",
    "choice_b": "The user has been redirected to another URL on a different domain.",
    "choice_c": "The requested page requires prior authentication.",
    "choice_d": "The request is valid and has been accepted.",
    "correct_answer": "D",
    "explanation": "A response code of 200 means the request is valid and has been responded to.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      305,
      306,
      320,
      319,
      276
    ],
    "source": "9781394290116"
  },
  {
    "id": 861,
    "question": "For what reason would an engineer choose to use a hosted hypervisor versus a bare-metal hypervisor?",
    "choice_a": "There are insufficient resources available for a bare-metal hypervisor.",
    "choice_b": "Features available only in a host operating system are required.",
    "choice_c": "Guest OS monitoring is required.",
    "choice_d": "The hypervisor is supporting a VDI environment.",
    "correct_answer": "B",
    "explanation": "An engineer would select a hosted hypervisor (that is, a hypervisor that runs on an operating system like Windows, Linux, or macOS) because one or more features or functions found only on the operating system are required.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      280,
      277,
      308,
      322,
      260
    ],
    "source": "9781394290116"
  },
  {
    "id": 862,
    "question": "The laboratory environment of a pharmaceutical research organization contains many scientific instruments that contain older versions of Windows and Linux operating systems that cannot be patched. What is the best remedy for this?",
    "choice_a": "Isolate the scientific instruments on a separate, protected network.",
    "choice_b": "Upgrade the OSs on the scientific instruments to current OS versions.",
    "choice_c": "Disconnect the OSs from the network.",
    "choice_d": "Audit user accounts on the OSs periodically.",
    "correct_answer": "A",
    "explanation": "The presence of older and/or unpatchable OSs on scientific equipment is a common problem that is not easily solved. Most often, the best approach is to isolate those systems through network segmentation and security controls to ensure that all attempts to attack those systems will be automatically detected and blocked.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      270,
      271,
      306,
      264,
      309
    ],
    "source": "9781394290116"
  },
  {
    "id": 863,
    "question": "Which of the following is the best policy for a security awareness training course?",
    "choice_a": "Users are not required to take competency quizzes.",
    "choice_b": "Users are required to repeat modules when they fail competency quizzes.",
    "choice_c": "Users are required to take competency quizzes only one time, regardless of score.",
    "choice_d": "Users can skip training if they pass competency quizzes.",
    "correct_answer": "B",
    "explanation": "When a user fails to achieve the minimum passing grade on a competency quiz, the user should be required to repeat the learning module and then take the quiz again.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      303,
      340,
      298,
      264,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 864,
    "question": "Guessing that an intended victim has a particular online banking session open, an attacker attempts to trick the victim into clicking on a link that will attempt to execute a transaction on the online banking site. This type of attack is known as:",
    "choice_a": "Cross-site scripting",
    "choice_b": "Cross-site request forgery",
    "choice_c": "On-path attack",
    "choice_d": "Man in the browser",
    "correct_answer": "B",
    "explanation": "A cross-site request forgery (CSRF) attack is one in which an attacker attempts to trick a victim into performing a transaction on another website (for example, a banking transaction in which the victim transfers money to the attacker).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      292,
      314,
      264,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 865,
    "question": "The purpose of the DAD Triad is:",
    "choice_a": "To model common application vulnerabilities",
    "choice_b": "To calculate risk levels",
    "choice_c": "To illustrate the opposites of the CIA triad",
    "choice_d": "To calculate security event severity",
    "correct_answer": "C",
    "explanation": "The DAD triad – Disclosure, Alteration, and Denial – portrays the opposites of the CIA triad – Confidentiality, Integrity, and Availability.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      257,
      253,
      258,
      282,
      299
    ],
    "source": "9781394290116"
  },
  {
    "id": 866,
    "question": "The purpose of file integrity monitoring tools is <i>:</i>",
    "choice_a": "Make changes to file permissions.",
    "choice_b": "Detect changes to file permissions.",
    "choice_c": "Detect changes to file contents.",
    "choice_d": "Detect changes to file contents and permissions.",
    "correct_answer": "D",
    "explanation": "File integrity monitoring (FIM) tools are used to detect changes to the contents and access permissions to files in a file system. FIM tools are commonly used to detect intrusions and unauthorized changes to systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      285,
      264,
      301,
      253,
      282
    ],
    "source": "9781394290116"
  },
  {
    "id": 867,
    "question": "Which of the following correctly describes the correct sequence for computer security incident response?",
    "choice_a": "Protect, detect, respond, recover",
    "choice_b": "Identify, protect, detect, respond, recover",
    "choice_c": "Evaluate, detect, eradicate, contain, recover, closure",
    "choice_d": "Detect, initiate, evaluate, contain, eradicate, recover, remediate",
    "correct_answer": "D",
    "explanation": "The correct sequence for organizing computer security incident response is detect, initiate, evaluate, contain, eradicate, recover, and remediate. This is often followed by a post-incident review.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      300,
      347,
      302,
      299,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 868,
    "question": "Which of the following devices is needed for the creation of a forensically identical hard disk drive?",
    "choice_a": "Diode",
    "choice_b": "Bit locker",
    "choice_c": "Read blocker",
    "choice_d": "Write blocker",
    "correct_answer": "D",
    "explanation": "A write blocker is a device used to read data from a hard drive whose contents are being evaluated. The write blocker makes it impossible for data to be written to the hard drive.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      301,
      321,
      300,
      299,
      297
    ],
    "source": "9781394290116"
  },
  {
    "id": 869,
    "question": "Which of the following statements about NIST CSF is true?",
    "choice_a": "NIST CSF is a security controls framework.",
    "choice_b": "NIST CSF is a policy framework for cybersecurity.",
    "choice_c": "NIST CSF is a computer security incident response framework.",
    "choice_d": "NIST CSF is a software development framework.",
    "correct_answer": "B",
    "explanation": "NIST CSF is a policy framework for cybersecurity that provides guidance for organizations that want to improve their cybersecurity capabilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      253,
      261,
      262,
      254,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 870,
    "question": "The “right to be forgotten” was first implemented by:",
    "choice_a": "GDPR",
    "choice_b": "Google",
    "choice_c": "NYDFS",
    "choice_d": "Facebook",
    "correct_answer": "A",
    "explanation": "The “right to be forgotten” is a concept that has been codified in the European General Data Protection Regulation (GDPR). A European citizen can make requests of online service providers and ask that records associated with them be anonymized or expunged.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      297,
      262,
      266,
      309,
      348
    ],
    "source": "9781394290116"
  },
  {
    "id": 871,
    "question": "The term <i>tailgating</i> most often refers to:",
    "choice_a": "Personnel who prop or shim doors so that others can enter a protected facility without authentication",
    "choice_b": "Personnel who permit others to follow them into a protected facility without authentication",
    "choice_c": "Personnel who follow others into a protected facility without authentication",
    "choice_d": "Personnel who loan their keycards to others to enter a protected facility",
    "correct_answer": "C",
    "explanation": "Tailgating refers to people who follow others into a protected facility without themselves authenticating with their keycard or other device.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      335,
      336,
      337,
      350,
      334
    ],
    "source": "9781394290116"
  },
  {
    "id": 872,
    "question": "A security manager in a large organization has found that the IT department has no central management of privileged user accounts. What kind of a tool should the security manager introduce to remedy this practice?",
    "choice_a": "FAM tools",
    "choice_b": "FIM tools",
    "choice_c": "PAM tools",
    "choice_d": "SIEM tools",
    "correct_answer": "C",
    "explanation": "Privileged access management (PAM) tools are used to centrally control the use of privileged accounts, both for administrative personnel and for service accounts.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      345,
      343,
      268,
      314
    ],
    "source": "9781394290116"
  },
  {
    "id": 873,
    "question": "An employee notes that a company document is marked “Confidential.” Is it acceptable for the employee to email the document to a party outside the company?",
    "choice_a": "Yes, but the document must be encrypted first.",
    "choice_b": "Yes, the document can be emailed to an outside party in plaintext.",
    "choice_c": "This cannot be determined without first consulting the data classification and handling policy.",
    "choice_d": "No, the document cannot be emailed to any inside or outside party.",
    "correct_answer": "C",
    "explanation": "A simple marking on a document such as “Confidential” does not by itself reveal what handling is permitted. An employee would need to consult a data classification and handling policy to see what actions are permitted.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      295,
      262,
      325,
      298,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 874,
    "question": "An auditor has completed an audit of an organization’s use of a tool that generates TLS certificates for its external websites. The auditor has determined that key management procedures are insufficient and that split custody of the key generation procedure is required. How might this be implemented?",
    "choice_a": "Of two engineers, one creates the certificate, and the other verifies its creation.",
    "choice_b": "Of two engineers, each performs half of the procedure used to create a new certificate.",
    "choice_c": "Of two engineers, each has one-half of the password required to create a new certificate.",
    "choice_d": "Of two engineers, one approves the creation of the certificate, and the other creates the certificate.",
    "correct_answer": "C",
    "explanation": "Split custody refers to the concept of splitting knowledge of a key task, such as two halves of a safe combination or two halves of a password. This requires that both parties cooperate to complete a sensitive task.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      310,
      287,
      284,
      303,
      345
    ],
    "source": "9781394290116"
  },
  {
    "id": 875,
    "question": "An organization that issues digital certificates recently discovered that a digital certificate was issued to an unauthorized party. What is the appropriate response?",
    "choice_a": "Suspend the certificate, and create a CRLF entry.",
    "choice_b": "Revoke the certificate, and create a CRL entry.",
    "choice_c": "Notify all certificate holders.",
    "choice_d": "Call a press conference.",
    "correct_answer": "B",
    "explanation": "Creating an entry in the certificate revocation list (CRL) is the appropriate response. In the future, when any party attempts to verify the integrity of the certificate, its presence in the CRL will render it invalid.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      288,
      287,
      286,
      284,
      282
    ],
    "source": "9781394290116"
  },
  {
    "id": 876,
    "question": "Why is it important for a web session cookie to be encrypted?",
    "choice_a": "Parties that can observe the communication will not be able to hijack the session.",
    "choice_b": "Parties that observe the communication will not be able to view the user’s password.",
    "choice_c": "Third parties will not be able to push unsolicited advertising to the user.",
    "choice_d": "The website operator will not be able to record the user’s session.",
    "correct_answer": "A",
    "explanation": "When a user’s session cookie is encrypted, another party that can observe the communication will not be able to hijack the user’s session.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      282,
      283,
      319,
      253,
      257
    ],
    "source": "9781394290116"
  },
  {
    "id": 877,
    "question": "Why would a hypervisor conceal its existence from a guest OS?",
    "choice_a": "To prevent the guest OS from breaking out of the container",
    "choice_b": "To improve the performance of the guest OS",
    "choice_c": "To avoid letting an intruder know that the OS is part of a virtualized environment",
    "choice_d": "To let an intruder know that the OS is part of a virtualized environment",
    "correct_answer": "C",
    "explanation": "Concealing the existence of the virtualized environment hides the fact of its existence. Hence, an intruder may be led to believe that the OS is running on bare metal. This is a security-by-obscurity tactic that does not prevent an intruder from attempting to break into the hypervisor.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      268,
      264,
      276,
      291,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 878,
    "question": "How can an organization prevent employees from connecting to the corporate Exchange email environment with personally owned mobile phones?",
    "choice_a": "Implement multifactor authentication.",
    "choice_b": "Permit only Outlook clients to connect to the Exchange server.",
    "choice_c": "Encrypt OWA traffic.",
    "choice_d": "Put the OWA server behind the firewall and VPN switch.",
    "correct_answer": "D",
    "explanation": "By putting the OWA server behind the firewall and the VPN switch, the organization prevents personally owned mobile devices from reaching the OWA server – provided the VPN switch is configured to permit only company-managed devices to connect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      273,
      320,
      269,
      309
    ],
    "source": "9781394290116"
  },
  {
    "id": 879,
    "question": "An organization is implementing a new SIEM. How must engineers get log data from systems and devices to the SIEM?",
    "choice_a": "Install agents on IoT devices.",
    "choice_b": "Send them via Windows event.",
    "choice_c": "Send them via syslog.",
    "choice_d": "Send them via syslog and Windows events.",
    "correct_answer": "D",
    "explanation": "Any SIEM can accept log entries sent via syslog and Windows events.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      306,
      305,
      321,
      346,
      309
    ],
    "source": "9781394290116"
  },
  {
    "id": 880,
    "question": "What should be the <i>first</i> step in correcting issues of SOC operators declaring incidents that turn out to be false positives?",
    "choice_a": "Additional training to improve their incident-handling skills",
    "choice_b": "Termination of employment",
    "choice_c": "Removal of incident declaration privileges",
    "choice_d": "No consequence, as false positives are a part of business as usual",
    "correct_answer": "A",
    "explanation": "If SOC operators chronically declare incidents where none exist, this suggests that they need additional training to better recognize and distinguish real incidents from false positives. A false positive now and then should not be a big deal.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      303,
      299,
      264,
      347
    ],
    "source": "9781394290116"
  },
  {
    "id": 881,
    "question": "Which area of an operating system is used to temporarily store data being sent to a hardware device?",
    "choice_a": "Register",
    "choice_b": "Buffer",
    "choice_c": "CPU",
    "choice_d": "DMA channel",
    "correct_answer": "B",
    "explanation": "A buffer is a temporary storage area designed to hold a small amount of data while it is being processed by the CPU or other hardware device such as a printer. <p>Register is incorrect because a register is a storage area within a CPU for short-term storage of instructions and variables. CPU is incorrect because a CPU is the main processor of a computer. DMA channel is incorrect because a DMA channel facilitates the transfer of data between the CPU and RAM.</p>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      200,
      191,
      193,
      203,
      161
    ],
    "source": "9781394290116"
  },
  {
    "id": 882,
    "question": "Which of the following is a critical element during the requirements definition phase of the SDLC?",
    "choice_a": "Skilled developers",
    "choice_b": "Management commitment",
    "choice_c": "User involvement",
    "choice_d": "Adequate funds",
    "correct_answer": "C",
    "explanation": "User involvement is crucial during the requirements definition phase of the SDLC because it ensures that the system being developed aligns with the users’ actual needs and requirements. Direct participation from users facilitates a more accurate and comprehensive understanding of the necessary functions and features, leading to a more successful system implementation. Management commitment, although important for project support and direction, is not specific to accurately defining requirements. Skilled developers are necessary for building a quality system, but their expertise does not guarantee that the system will meet user requirements without proper input. Adequate funds are essential for project completion but do not impact the accuracy and completeness of the requirements themselves. Without user input, even the best-funded project with skilled developers might not meet the intended objectives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      117,
      151,
      115,
      105,
      136
    ],
    "source": "9781394290116"
  },
  {
    "id": 883,
    "question": "What is the primary <i>security</i> advantage to switching from shared-media networks to switched networks?",
    "choice_a": "A node sees only packets sent explicitly to or from the node, as well as some broadcast traffic, reducing the risks of eavesdropping",
    "choice_b": "Elimination of collision domains",
    "choice_c": "Elimination of broadcast domains through the use of VLANs",
    "choice_d": "Improved throughput",
    "correct_answer": "A",
    "explanation": "Although these choices are all advantages to moving to a switched environment, the real security advantage is the reduction of eavesdropping; switched networks are difficult to sniff. <p>Elimination of collision domains is incorrect because this is not a security concern. Elimination of broadcast domains is incorrect because this is not a significant security concern. Improved throughput is incorrect because this is not a security concern.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      320,
      270,
      306,
      266,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 884,
    "question": "An IS auditor in a government organization has been requested to advise on whether the organization should prepare an Incident Response Plan (IRP). Which of the following is the purpose of the IRP?",
    "choice_a": "To enable the organization to effectively respond to cyber threats",
    "choice_b": "To monitor the potential impact of security threats",
    "choice_c": "To mitigate all threats and vulnerabilities affecting the organization",
    "choice_d": "To assist the organization in preventing all security incidents",
    "correct_answer": "A",
    "explanation": "The purpose of an Incident Response Plan (IRP) is to enable the organization to effectively respond to cyber threats. An IRP provides a structured approach for identifying, managing, and recovering from incidents, which is crucial for minimizing damage and ensuring a swift return to normal operations. Monitoring the potential impact of security threats is not the primary focus of an IRP, although impact assessment is part of the response process. Mitigating all threats and vulnerabilities is unrealistic and not the aim of an IRP, as its main goal is to manage and respond to incidents when they occur, rather than eliminating them entirely. Assisting the organization in preventing all security incidents is also not feasible; while elements of prevention are included in a comprehensive security strategy, the IRP is specifically focused on response and recovery efforts once an incident has occurred.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      347,
      300,
      299,
      256,
      259
    ],
    "source": "9781394290116"
  },
  {
    "id": 885,
    "question": "Which ISACA guideline would an auditor use to help prepare the final report for an audit?",
    "choice_a": "2401, Reporting",
    "choice_b": "1402, Follow-up Activities",
    "choice_c": "2402, Follow-up Activities",
    "choice_d": "1401, Reporting",
    "correct_answer": "A",
    "explanation": "An auditor would use ISACA guideline 2401, Reporting. Although the standards and guidelines listed for the other answer options may give some information on audit reporting, ISACA guideline 2401 describes how an IS auditor should comply with ISACA auditing standards on the development of audit findings, audit opinion, and audit reports. <p>The answers mentioning Follow-up Activities are incorrect because follow-up activities do not assist with final report preparation but instead are involved with post-audit activities. 1401, Reporting is incorrect because it is one of the ITAF required standards – not an optional guideline.</p>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      71,
      94,
      70,
      68,
      364
    ],
    "source": "9781394290116"
  },
  {
    "id": 886,
    "question": "Which of the following audit evidence collection methods involves the IS auditor asking management about the operation of IS controls?",
    "choice_a": "Inspection",
    "choice_b": "Reperformance",
    "choice_c": "Inquiries",
    "choice_d": "Interrogation",
    "correct_answer": "C",
    "explanation": "Inquiries are the appropriate audit evidence collection method that involves an IS auditor asking management about the operation of IS controls, as it specifically denotes a verbal or written request for information. Inquiries allow auditors to gain understanding, clarification, or explanations regarding the control environment directly from those who manage or understand it best. Reperformance involves the auditor independently executing the controls to ascertain their design and operational effectiveness, rather than seeking information from management. Inspection refers to examining records or tangible assets, which is more about verifying evidence than asking questions. Interrogation implies a more confrontational or adversarial form of questioning, which is not typical in standard audit evidence collection where professional and cooperative communication is maintained.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      90,
      89,
      88,
      360,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 887,
    "question": "Which component of the Zachman framework is described as conceptual, logical, or physical, depending on the functional model or context?",
    "choice_a": "Data",
    "choice_b": "Functional",
    "choice_c": "Network",
    "choice_d": "Strategy",
    "correct_answer": "A",
    "explanation": "Within the Zachman framework, the data component is described as conceptual, logical, or physical, depending upon the functional model used (enterprise, systems, or technology). <p>“Functional (application),” “network (technology),” and “strategy” are not Zachman framework components.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      39,
      41,
      1,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 888,
    "question": "IS auditors are permitted by the ISACA Standards to use the work of other experts in performing their work. Which of the following is not one of the aspects to be considered when relying on the work of other experts?",
    "choice_a": "The financial standing of the expert",
    "choice_b": "The adequacy of the expert’s work",
    "choice_c": "The independence of the expert",
    "choice_d": "The qualifications of the expert",
    "correct_answer": "A",
    "explanation": "Evaluating the financial standing of the expert is not a relevant consideration when relying on their work. IS auditors must focus on aspects directly related to the quality and reliability of the expert’s work, such as the adequacy of the work, the independence of the expert, and their qualifications. These aspects directly impact the credibility and impartiality of the expert’s contribution to the audit process. The financial standing of the expert, however, does not inherently affect their ability to perform quality work or maintain independence, and thus, it is not considered a significant factor by ISACA Standards in this context.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      69,
      90,
      99,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 889,
    "question": "Which overarching program includes monitoring project schedules, budgets, resource allocation, conflicts, and the preparation of status reports for senior management?",
    "choice_a": "Incident management",
    "choice_b": "IT management",
    "choice_c": "Program management",
    "choice_d": "Configuration management",
    "correct_answer": "C",
    "explanation": "Program management is the oversight of several projects and project teams. A program manager oversees project managers, who manage individual projects in a program that contributes to an organization’s objective. The program manager’s oversight includes monitoring project schedules, budgets, resource allocation, conflicts, and the preparation of status reports for senior management. <p>Incident management is incorrect because it is concerned with the detection and handling of operational or security incidents. IT management is incorrect because it is concerned with the management of the overall IT department mission and operations (including programs). Configuration management is incorrect because it is concerned with the configuration of systems and devices.</p>",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      101,
      110,
      150,
      103,
      102
    ],
    "source": "9781394290116"
  },
  {
    "id": 890,
    "question": "Quality management refers to the methods by which business processes are controlled, monitored, and managed to bring about continuous improvement. It involves key activities such as software development, software acquisition, service desk, IT operations, and security. What are some of the required components to build and operate an effective quality management system?",
    "choice_a": "Presence of skilled personnel",
    "choice_b": "Sound financial planning",
    "choice_c": "Documented processes and key measurements",
    "choice_d": "Thorough customer surveys",
    "correct_answer": "C",
    "explanation": "Documented processes and key measurements are critical components of an effective quality management system because they provide a clear framework for how tasks should be performed and allow for the tracking and analysis of performance against established benchmarks. This aids in identifying areas for improvement and supports continuous improvement efforts by providing a consistent method to measure success. Sound financial planning, while important for overall business operations, is not specific to quality management systems and does not directly impact how processes are controlled or improved. The presence of skilled personnel is essential for implementing and executing quality management processes, but without documented processes and measurements, skilled personnel may not be able to effectively contribute to improving quality. Thorough customer surveys provide valuable feedback but are just one tool among many in understanding customer needs and do not encompass the full scope of process control and monitoring inherent in quality management systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      39,
      48,
      3,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 891,
    "question": "Which of the following access management techniques is <i>single</i>-factor only?",
    "choice_a": "Fingerprint and PIN",
    "choice_b": "Smartcard and PIN",
    "choice_c": "RSA token and PIN",
    "choice_d": "User ID and password",
    "correct_answer": "D",
    "explanation": "User ID and password combinations are single-factor only, whereas the other listed methods are multifactor forms of access management. <p>Fingerprint and PIN, smartcard and PIN, and RSA token and PIN are all examples of multifactor authentication.</p>",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      315,
      314,
      343,
      344,
      316
    ],
    "source": "9781394290116"
  },
  {
    "id": 892,
    "question": "During a systems audit review, an IS auditor seeks to determine whether an organization has defined a logical representation of detailed tasks to be undertaken to complete a software project. Which of the following describes the software development approach under review during this exercise?",
    "choice_a": "Work breakdown structure (WBS)",
    "choice_b": "Gantt chart",
    "choice_c": "PERT analysis",
    "choice_d": "Critical Path Methodology (CPM)",
    "correct_answer": "A",
    "explanation": "The software development approach under review is a work breakdown structure (WBS) because it provides a logical representation of detailed tasks, breaking the project into manageable components and tasks necessary to complete the software project. A Gantt chart visually represents the schedule and timelines of tasks but does not focus on task decomposition. PERT analysis emphasizes identifying task dependencies and estimating project duration using probabilistic time estimates. Critical Path Methodology determines the sequence of tasks that cannot be delayed without affecting the project timeline but does not specifically detail all tasks like a WBS does.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      104,
      106,
      105,
      150,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 893,
    "question": "An organization has hired a CIO to build and run an IT organization. The new CIO is building a document that states the mission, objectives, roles, and responsibilities for IT. This document is commonly known as a:",
    "choice_a": "Charter",
    "choice_b": "RACI model",
    "choice_c": "Policy",
    "choice_d": "Standard",
    "correct_answer": "A",
    "explanation": "A charter defines a program and its mission, objectives, roles, and responsibilities. <p>RACI is incorrect because RACI is a responsibility matrix. Policy is incorrect because a policy defines business rules of expected behavior. Standard is incorrect because standards define technologies and techniques to be employed.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      18,
      54,
      15,
      8,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 894,
    "question": "An IS auditor selects a web application for a penetration test. Which of the following should the penetration tester do first?",
    "choice_a": "Obtain permission from management",
    "choice_b": "Draft preliminary findings",
    "choice_c": "Select the tools and commence the test",
    "choice_d": "Identify relevant personnel to interview",
    "correct_answer": "A",
    "explanation": "Obtaining permission from management is crucial before beginning a penetration test to ensure that the testing is authorized and legal. This step is essential for ensuring that the penetration tester has documented approval to assess the security of the web application, which helps prevent any legal issues or misunderstandings about the activities to be performed. Drafting preliminary findings cannot be done effectively until the test is conducted. Selecting tools and commencing the test jumps ahead without ensuring proper authorization and scope, potentially creating legal and ethical issues. Identifying relevant personnel to interview might be a useful part of understanding the application environment but is secondary to ensuring that necessary permissions are in place before any testing begins.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      357,
      84,
      89,
      359,
      60
    ],
    "source": "9781394290116"
  },
  {
    "id": 895,
    "question": "What is the purpose of the ISACA IT Audit Framework?",
    "choice_a": "To define ethical behavior and required audit standards",
    "choice_b": "To define procedures for the audit of IT systems",
    "choice_c": "To define guidance on ethical behavior",
    "choice_d": "To define ethical behavior and optional audit standards",
    "correct_answer": "A",
    "explanation": "The ITAF, published by ISACA in <i>ITAF. A Professional Practices Framework for IT Audit</i>, consists of the entire set of ISACA Auditing Standards, the Code of Professional Ethics, Audit Standards, Audit Guidelines, and IS Audit and Assurance Tools and Techniques. Compliance with the Code of Professional Ethics and Audit Standards is required. Audit Guidelines and IS Audit and Assurance Tools and Techniques provide further optional guidance to IS auditors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      69,
      71,
      70,
      355
    ],
    "source": "9781394290116"
  },
  {
    "id": 896,
    "question": "An IS auditor performing a review of the organization’s infrastructure management processes notes the operation of various systems without proper vetting from the IT department. Which of the following represents an IT area that the IS auditor is reviewing?",
    "choice_a": "Shadow IT",
    "choice_b": "Bring your own device (BYOD)",
    "choice_c": "Unauthorized systems",
    "choice_d": "Systems misconfiguration",
    "correct_answer": "A",
    "explanation": "Shadow IT is the area being reviewed by the IS auditor because it involves the use of information technology systems, devices, software, applications, and services without explicit organizational approval. The issue highlighted in the scenario reflects systems operating without proper vetting from the IT department, a classic characteristic of Shadow IT. Bring Your Own Device (BYOD) is about the personal devices employees bring into the workplace, which may or may not be aligned with IT policies but are not inherently unauthorized or unvetted systems themselves. Unauthorized systems simply refer to any systems that are not authorized, but this doesn’t specifically address the process or involvement of IT in their operation, lacking the nuance of operation without IT knowledge. Systems misconfiguration pertains to technical errors in system setup, unrelated to whether or not the systems were approved by the IT department.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      223,
      161,
      185,
      166,
      224
    ],
    "source": "9781394290116"
  },
  {
    "id": 897,
    "question": "An organization that is interested in implementing a data loss prevention capability might consider all of the following techniques <i>except</i>:",
    "choice_a": "Intrusion prevention system (IPS)",
    "choice_b": "Control of removable storage devices",
    "choice_c": "Internet website access filtering",
    "choice_d": "Email quarantine system",
    "correct_answer": "A",
    "explanation": "An organization that wants to implement data loss controls would consider implementing tools to control the use of removable devices (for example, USB drives), Internet website access filtering, and an email quarantine system. An IPS would likely not be considered. <p>The control of removable storage devices, Internet website access filtering, and email quarantine are all DLP capabilities that organizations may consider using to provide visibility and/or control of the transfer of sensitive information.</p>",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      266,
      292,
      295,
      274,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 898,
    "question": "Which of the following controls only serves to alert the organization of unwanted events but has no inherent capability to enforce any activity?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Deterrent",
    "choice_d": "Compensating",
    "correct_answer": "A",
    "explanation": "Detective controls are designed to identify and alert an organization to unwanted or unauthorized activities after they have occurred. They do not have the capacity to prevent or enforce any activity but rather serve to notify the organization so that corrective actions can be taken. Preventive controls are intended to stop unwanted events before they happen, actively enforcing security measures to prevent errors or incidents. Deterrent controls aim to discourage potential threats or unauthorized actions through the display of consequences but do not actively detect or prevent specific actions once attempted. Compensating controls are established to mitigate risks when primary controls are not adequate, providing alternatives to reduce risk levels but not merely alerting to occurrences. Thus, only detective controls simply alert organizations without enforcing activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      94,
      71,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 899,
    "question": "Who is the primary user of utility software, and what is its purpose?",
    "choice_a": "End user; to enhance productivity",
    "choice_b": "IT specialist; system development, support, or operations",
    "choice_c": "End user; system development, support, or operations",
    "choice_d": "IT specialist; to enhance productivity",
    "correct_answer": "B",
    "explanation": "Utility software is primarily used by IT specialists whose responsibilities include some aspect of system development, support, or operations. End users, on the other hand, most often use software applications instead of utilities. <p>Answers mentioning the end user are incorrect because end users do not typically use utilities. The answer stating that the IT specialist used the software to enhance productivity is incorrect because IT specialists do not typically use utilities solely to enhance productivity.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      203,
      204,
      161,
      183,
      185
    ],
    "source": "9781394290116"
  },
  {
    "id": 900,
    "question": "An IS auditor is reviewing capacity management activities at a software development firm. Which of the following activities assists in predicting future capacity requirements by identifying trends in system usage?",
    "choice_a": "Adequate resource allocations",
    "choice_b": "Effective change processes",
    "choice_c": "Periodic measurements",
    "choice_d": "Timely incident logging",
    "correct_answer": "C",
    "explanation": "Periodic measurements assist in predicting future capacity requirements because they involve the collection and analysis of data over time, allowing patterns and trends in system usage to be identified and thereby informing future capacity planning. Effective change processes ensure that changes are implemented smoothly but do not directly focus on identifying usage trends. Adequate resource allocations address current needs but do not predict future demand, as they are about managing the present load effectively rather than forecasting. Timely incident logging is crucial for troubleshooting and corrective actions, but it does not provide a view into future capacity needs or usage patterns.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      225,
      227,
      198,
      185
    ],
    "source": "9781394290116"
  },
  {
    "id": 901,
    "question": "An IS auditor is examining a document that describes the required configuration components for network devices. The auditor is examining which kind of document?",
    "choice_a": "Control",
    "choice_b": "Procedure",
    "choice_c": "Standard",
    "choice_d": "Policy",
    "correct_answer": "C",
    "explanation": "A standard is a document that describes required protocols, configurations, architectures, vendors, methodologies, or technologies to be used in an organization. <p>“Control” is incorrect because a control is a means for achieving a specific desired outcome. “Procedure” is incorrect because a procedure is a sequence of steps to be followed to accomplish a task. “Policy” is incorrect because a policy is a statement of business rules.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      54,
      53,
      9
    ],
    "source": "9781394290116"
  },
  {
    "id": 902,
    "question": "Why should an organization classify its IT assets as part of its risk management program?",
    "choice_a": "To ensure proper valuation of its assets",
    "choice_b": "To eliminate the need for maintaining an asset register",
    "choice_c": "To enhance the effectiveness of risk assessments",
    "choice_d": "To assign and mitigate risks associated with the assets",
    "correct_answer": "C",
    "explanation": "Enhancing the effectiveness of risk assessments is the correct answer because classifying IT assets helps identify their criticality, vulnerabilities, and associated risks, enabling targeted and efficient risk management. Eliminating the need for maintaining an asset register is incorrect, as classification complements, not replaces, the asset register. Ensuring proper valuation of assets is not the primary goal of classification, as valuation focuses on financial worth rather than risk. Assigning and mitigating risks associated with assets is a subsequent step in risk management that relies on classification but is not the direct purpose of the classification itself.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      19,
      20,
      18,
      16,
      24
    ],
    "source": "9781394290116"
  },
  {
    "id": 903,
    "question": "Which of the following technologies is an XML-based API specification that facilitates real-time communications between applications using the HTTP and HTTPS protocols?",
    "choice_a": "RPC",
    "choice_b": "SQL",
    "choice_c": "XML",
    "choice_d": "SOAP",
    "correct_answer": "D",
    "explanation": "SOAP, or Simple Object Access Protocol, is an XML-based API specification that facilitates real-time communications between applications using the HTTP and HTTPS protocols. Functionally, SOAP operates similarly to RPC (Remote Procedure Call), wherein one application transmits a query to another application, and the other application responds with a query result. SOAP messages are based on the XML (eXtensible Markup Language) standard. <p>RPC is incorrect because it is a specification used for inter-process communications between computers. SQL is incorrect because it is a database query language. XML is incorrect because it is a markup language for encoding documents.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      222,
      230,
      215,
      216,
      224
    ],
    "source": "9781394290116"
  },
  {
    "id": 904,
    "question": "Which of the following is a crucial feature of rapid application development (RAD)?",
    "choice_a": "Slow, iterative development",
    "choice_b": "Large development team",
    "choice_c": "Development of prototypes",
    "choice_d": "Tight cost control",
    "correct_answer": "C",
    "explanation": "Development of prototypes is a crucial feature of Rapid Application Development (RAD) because RAD focuses on quickly developing software through iterative prototyping and user feedback. This process allows for rapid adjustments in response to user input and changing requirements, ensuring the final product is closely aligned with user needs. Unlike traditional methodologies, a large development team is not a defining characteristic of RAD; rather, the approach prioritizes small, efficient teams to facilitate fast decision-making and rapid prototyping. Since RAD emphasizes speed, slow, iterative development does not align with its principles, which aim for fast completion through multiple iterations. Additionally, while controlling costs is desirable in any development process, RAD is primarily focused on speed and flexibility, with cost control being a secondary benefit of reduced development time rather than a core feature.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      124,
      125,
      115,
      119,
      121
    ],
    "source": "9781394290116"
  },
  {
    "id": 905,
    "question": "Which of the following logical access controls is designed to permit or deny network traffic based on specific type, origin, or destination?",
    "choice_a": "Screening router",
    "choice_b": "Permissions",
    "choice_c": "Smart cards",
    "choice_d": "Switch",
    "correct_answer": "A",
    "explanation": "A screening or border router is designed to permit or deny messages of specific types (and possibly will also permit or deny based upon origin and destination) to pass. A firewall can also make pass/block decisions based upon the type of traffic, origin, and destination. <p>Permissions is incorrect because access permissions are not likely to be associated with network traffic filtering based on type, origin, or destination. Smart cards is incorrect because smart cards have little or no association with the filtering of network traffic based on type, origin, or destination. Switch is incorrect because a switch is not typically deployed as a network ingress/egress filter as described in the question.</p>",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      306,
      270,
      309,
      272,
      320
    ],
    "source": "9781394290116"
  },
  {
    "id": 906,
    "question": "IS auditors should consider new organizational initiatives in audit planning. Which of the following is the rationale for adopting this approach?",
    "choice_a": "Organizational initiatives are linked to the organization’s objectives.",
    "choice_b": "It leads to a reduction in audit costs.",
    "choice_c": "It simplifies audit management processes.",
    "choice_d": "Organizational initiatives reduce audit coverage.",
    "correct_answer": "A",
    "explanation": "Organizational initiatives are directly related to the organization’s objectives, which is why considering these initiatives is crucial in audit planning. These initiatives often signify changes or developments in the organization that could impact the risk profile and audit priorities. Auditors need to be aware of these to ensure that their audit efforts are aligned with the current goals and potential risk areas of the organization. Reducing audit costs is not the primary reason for incorporating organizational initiatives into audit planning, as the focus is more on relevance and risk coverage rather than cost efficiency. Simplifying audit management processes is not a direct result of considering organizational initiatives; the process might require additional complexity to accommodate new objectives. Additionally, organizational initiatives do not inherently reduce audit coverage; instead, they might necessitate broader or more focused coverage to address emerging risks and objectives effectively.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      61,
      359,
      62,
      84,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 907,
    "question": "Which resilience technology is appropriate to use where the recovery point objective and recovery time objective are not as time sensitive?",
    "choice_a": "Server clusters",
    "choice_b": "Replication",
    "choice_c": "SAN or NAS",
    "choice_d": "Backup and restore from media",
    "correct_answer": "D",
    "explanation": "Server clusters and replication technologies would be used when the RTO and RPO values are extremely time sensitive or do not allow for significant data loss. Backing up and restoring from media require time and may result in data loss since the last backup and therefore may be used when the RTO and RPO values allow. <p>The answers giving server clusters and replication are incorrect because these are performed when recovery time objectives are more time sensitive. The answer mentioning SAN and NAS technologies is incorrect because these technologies are used to store data that can be accessed over a network.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      234,
      238,
      237,
      231
    ],
    "source": "9781394290116"
  },
  {
    "id": 908,
    "question": "During a hiring process review, an IS auditor discovers that a prospective candidate falsified holding a graduate degree. Which steps in the background verification process could have discovered this anomaly?",
    "choice_a": "Credit check",
    "choice_b": "Certificate check",
    "choice_c": "Education check",
    "choice_d": "Employment check",
    "correct_answer": "C",
    "explanation": "An education check is specifically designed to verify the authenticity of a candidate’s educational background, which directly addresses the issue of falsified academic credentials. The education check involves directly contacting institutions to confirm degrees or certifications claimed by the candidate. A certificate check could encompass verifying professional certifications but may not cover general educational history unless specifically directed. A credit check focuses on the candidate’s financial history and does not reveal discrepancies in education claims. An employment check verifies past job experiences and roles, which, although important, do not directly address discrepancies in educational qualifications. Therefore, only the education check is directly aligned with identifying falsifications in a candidate’s educational background.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      54,
      55,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 909,
    "question": "What is the purpose of a risk analysis that is performed at the start of an audit project?",
    "choice_a": "To know how long the audit should take",
    "choice_b": "To know which staff members should perform the audit",
    "choice_c": "To know which areas require the greatest amount of attention",
    "choice_d": "To know which areas should be mentioned first in the audit report",
    "correct_answer": "C",
    "explanation": "A risk analysis will generally not be used to determine the level of effort in an audit, or which staff members should perform the audit. It plays no role in determining the sequence of findings in the audit report. Instead, a risk analysis helps auditors understand which controls and processes have higher risk, which are the areas that require greater attention. <p>The answer mentioning duration is incorrect because a risk analysis does not determine the length of the audit. The answer specifying staff members is incorrect because a risk analysis does not determine who performs an audit. The answer specifying the order of different areas is incorrect because other factors such as findings, or the control framework organization, will determine the sequence of findings in the audit report.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      84,
      74,
      75,
      359
    ],
    "source": "9781394290116"
  },
  {
    "id": 910,
    "question": "Why is it essential for an IS auditor to have considerable technical expertise when auditing IT operations?",
    "choice_a": "To understand the technology fully and reduce reliance on interviewees.",
    "choice_b": "IS auditors just need minimum knowledge of IT operations.",
    "choice_c": "To eliminate interviews from the audit process.",
    "choice_d": "To impress the IT staff of the client.",
    "correct_answer": "A",
    "explanation": "Possessing considerable technical expertise is crucial for an IS auditor during IT operations audits because it enables the auditor to understand the technology thoroughly and reduces reliance on interviewees. This knowledge allows auditors to independently verify information, assess risks, and evaluate controls effectively without solely depending on information received from others, which might be biased or incomplete. Relying solely on interviews can be risky if auditors lack the necessary technical understanding to fully comprehend and verify the responses they receive. Having just a minimum knowledge of IT operations is insufficient because audits require a deep and comprehensive understanding to identify potential issues properly. Eliminating interviews altogether from the audit process is impractical, as auditors must still engage with personnel to gather insights and contextual information; interviews supplement the auditor’s technical knowledge. Additionally, impressing the IT staff of the client should not be a goal for auditors; their primary objective is to accurately assess IT operations and ensure compliance with standards and practices.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      63,
      90,
      74,
      89,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 911,
    "question": "A cybersecurity committee is discussing items in the risk register and is making decisions about their disposition. The types of decisions being made are known as:",
    "choice_a": "Risk dashboard",
    "choice_b": "Quantified risk",
    "choice_c": "Qualified risk",
    "choice_d": "Risk treatment",
    "correct_answer": "D",
    "explanation": "The decisions about items in the risk register and the follow-on activities are together known as risk treatment. <p>“Risk dashboard” is not a type of decision. “Quantified risk” and “qualified risk” are not types of risk decisions but instead risks that are calculated that may <i>lead</i> to risk decisions.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      24,
      16,
      20,
      21
    ],
    "source": "9781394290116"
  },
  {
    "id": 912,
    "question": "Which of the following controls should an organization implement if it desires to ensure that high-value transactions are approved by multiple managers?",
    "choice_a": "Segregation of duties",
    "choice_b": "Two-person integrity",
    "choice_c": "Two-person control",
    "choice_d": "Transaction verification",
    "correct_answer": "C",
    "explanation": "Two-person control is the correct answer because it requires two or more individuals to approve or authorize high-value transactions, ensuring an added layer of oversight and reducing the risk of fraud or error. Two-person integrity focuses on ensuring data accuracy and integrity by requiring collaboration but does not specifically mandate approval for high-value transactions. Segregation of duties involves dividing responsibilities to prevent a single individual from controlling all aspects of a process but does not necessarily require multiple approvals. Transaction verification involves checking the accuracy of transaction details but does not enforce multiple levels of managerial approval.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      80,
      81,
      361,
      91,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 913,
    "question": "Which authentication method renders replay attacks ineffective?",
    "choice_a": "Simple password",
    "choice_b": "Complex password",
    "choice_c": "Token",
    "choice_d": "Cipher lock",
    "correct_answer": "C",
    "explanation": "Tokens display one-time values used during authentication. The advantage of tokens is that the displayed value will change frequently, making a “replay attack” more difficult to conduct. <p>The answers referring to simple or complex passwords are incorrect because password quality does little, if anything, to block a replay attack. Cipher lock is incorrect because a cipher lock is a hardware device and is not relevant to the question.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      315,
      319,
      343,
      282,
      316
    ],
    "source": "9781394290116"
  },
  {
    "id": 914,
    "question": "The following figure illustrates a diagramming method that is used to support IS auditing. Which of the following terms refers to the diagramming method?<img src=\"/question_assets/CISA/cpt01f001.png\" alt=\"Flow diagram from Working hours database to Billing database to Invoices.\"/>\n\n<figcaption>Flow diagram from Working hours database to Billing database to Invoices.</figcaption>",
    "choice_a": "Maturity capability diagram",
    "choice_b": "Audit process diagram",
    "choice_c": "Data flow diagram",
    "choice_d": "Procedure flow diagram",
    "correct_answer": "C",
    "explanation": "The diagramming method referred to in the figure is a data flow diagram because it visually represents how data flows through a system, highlighting the inputs, processes, and outputs in a structured format that supports IS auditing. This method is commonly used to understand and audit information systems by providing a clear depiction of data processes and identifying potential security and process inefficiencies. The term “audit process diagram” is incorrect because it generally refers to diagrams that map out the auditing process steps rather than data interactions. A “maturity capability diagram” is incorrect as it represents the maturity level of processes or capabilities within an organization, unrelated to data flows. A “procedure flow diagram” typically depicts business or system procedures rather than the specific flow of data, distinguishing itself from the specific purpose of a data flow diagram.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      359,
      360,
      89,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 915,
    "question": "Which method of testing disaster recovery plans will enable an organization to fully exercise and evaluate its disaster recovery capabilities?",
    "choice_a": "Walkthrough",
    "choice_b": "Parallel test",
    "choice_c": "Cutover test",
    "choice_d": "Simulation",
    "correct_answer": "C",
    "explanation": "A “cutover test” also known as a “full interruption test” is the most intrusive type of disaster recovery test. It will also provide the most reliable results in terms of answering the question of whether backup systems have the capacity to shoulder the real workload properly. <p>“Walkthrough” is incorrect because a walkthrough does not exercise recovery systems at all but is instead a facilitated discussion about a recovery effort. “Parallel test” is incorrect because a parallel test is less rigorous than a cutover test in that it continues operations at the primary site rather than requiring that all operations take place at the alternate facility. “Simulation” is incorrect because a simulation is little more than an orchestrated discussion of a disaster scenario for incident responders.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      249,
      245,
      237,
      251
    ],
    "source": "9781394290116"
  },
  {
    "id": 916,
    "question": "During an organization’s systems development audit, an IS auditor discovered that the application development project lacks a business case. At which stage of the systems development life cycle is the business case developed?",
    "choice_a": "Implementation",
    "choice_b": "Requirements definition",
    "choice_c": "Verification and validation",
    "choice_d": "Feasibility study",
    "correct_answer": "D",
    "explanation": "The business case for an application development project is created during the feasibility study phase of the systems development life cycle. This stage involves assessing the viability, risks, costs, and benefits of a project to determine if it makes sense to proceed. Therefore, a business case is typically developed here to justify moving forward with the project. The requirements definition stage, in contrast, focuses on gathering and analyzing the needs and specifications for the system rather than justifying its existence. Verification and validation occur later in the process to ensure the system meets its requirements and functions as intended, not to develop planning documents such as the business case. Finally, the implementation stage involves deploying the system into a live environment, which occurs long after the justification for the project has been established.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      116,
      102,
      115,
      151,
      117
    ],
    "source": "9781394290116"
  },
  {
    "id": 917,
    "question": "Which activity represents an organization’s effort to measure the effectiveness of its controls?",
    "choice_a": "Benchmarking",
    "choice_b": "Compliance audit",
    "choice_c": "Control self-assessment",
    "choice_d": "External audit",
    "correct_answer": "C",
    "explanation": "Control self-assessment (CSA) is the activity undertaken by organizations that want to measure the effectiveness of their own controls. Although the activities listed in the other answer options can be beneficial for an organization, they serve other purposes or are performed by other parties. <p>Benchmarking is incorrect because it is used to compare an organization’s costs (or other factors) with that of other organizations. Compliance audit is incorrect because this is generally performed by an external entity. External audit is incorrect because this is performed by an external entity.</p>",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      94,
      355,
      353,
      88,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 918,
    "question": "A large financial institution seeks to improve its IT service delivery and has approached you for specialist advice. Which of the following frameworks would you advise its management to adopt to achieve the institution’s objectives?",
    "choice_a": "COSO",
    "choice_b": "ISO/IEC 27001:2022",
    "choice_c": "COBIT",
    "choice_d": "ITIL",
    "correct_answer": "D",
    "explanation": "To improve IT service delivery processes, ITIL is the most suitable framework because it is specifically designed to provide a comprehensive set of best practices for IT service management, focusing on aligning IT services with the needs of the business and improving efficiency and effectiveness. ISO/IEC 27001:2022 is focused on information security management systems and is not specifically tailored for improving IT delivery processes. COBIT is a framework for developing, implementing, monitoring, and improving IT governance and management practices, but it is broader and more governance-focused rather than delivery-focused. COSO deals with enterprise risk management and internal control, not specifically with IT service delivery processes. Therefore, ITIL is the most appropriate framework for improving IT delivery.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      2,
      37,
      41,
      27,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 919,
    "question": "Which of the following terms refers to changing each application’s authentication from stand-alone to centralized and the resulting reduction in the number of user ID–password pairs that each user is required to remember?",
    "choice_a": "Authorization",
    "choice_b": "Reduced sign-on",
    "choice_c": "Authentication",
    "choice_d": "Single sign-on",
    "correct_answer": "B",
    "explanation": "Although single sign-on is centralized, it also includes the ability to manage user sessions across applications. Reduced sign-on does not manage user sessions using a user’s logged-on state, but it does allow a user to authenticate to an application using the same logon credentials, which are verified centrally. <p>Authorization is incorrect because it refers to the access rights associated with a user account. Authentication is incorrect because this refers to the process of asserting a user ID and password (and potentially other steps associated with multifactor authentication) to gain access to a system. Single sign-on is incorrect because single sign-on, while closely related to reduced sign-on, extends reduced sign-on by permitting participating applications to share a user’s logged-in state with each other or with a central authority.</p>",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      317,
      314,
      315,
      318,
      343
    ],
    "source": "9781394290116"
  },
  {
    "id": 920,
    "question": "There is a very narrow distinction between an intrusion prevention system (IPS) and an intrusion detection system (IDS), which is that an IPS:",
    "choice_a": "Eliminates the need for a firewall",
    "choice_b": "Performs penetration tests",
    "choice_c": "Detects novel attacks only",
    "choice_d": "Prevents attacks",
    "correct_answer": "D",
    "explanation": "An intrusion prevention system (IPS) is designed to not only detect potential threats like an intrusion detection system (IDS) but also take proactive steps to prevent those threats from causing harm, which is why it prevents attacks. Both systems may detect known and unknown threats, but prevention is the key function that differentiates IPS from an IDS. Performing penetration tests is unrelated to the direct functionality of IPS or IDS; penetration tests are controlled, authorized attacks used to evaluate security systems. Detecting novel attacks is not exclusive to an IPS; both IDS and IPS can potentially identify anomalies or new threats using heuristic methods. Finally, an IPS does not eliminate the need for a firewall, as firewalls and IPS serve different roles in a layered security strategy; firewalls primarily control traffic based on pre-established rules, whereas an IPS focuses on analyzing traffic for malicious activity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      274,
      306,
      264,
      265,
      312
    ],
    "source": "9781394290116"
  },
  {
    "id": 921,
    "question": "The elements of the business continuity planning (BCP) process life cycle include all of the following <i>except</i>:",
    "choice_a": "Conduct business impact analysis (BIA).",
    "choice_b": "Perform criticality analysis.",
    "choice_c": "Establish recovery targets.",
    "choice_d": "Transition operations back to the original site.",
    "correct_answer": "D",
    "explanation": "Transitioning operations back to the original site is a part of disaster recovery and not a part of the BCP life cycle. <p>BIA, criticality analysis, and establishing recovery targets are all incorrect because these processes <i>are</i> all part of the BCP life cycle.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      233,
      234,
      231,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 922,
    "question": "While reviewing an organization’s system conversion methods, the IS auditor notes that the organization runs both the old and new systems at the same time. Which of the following represents this form of cutover?",
    "choice_a": "Module-by-module",
    "choice_b": "All-at-once",
    "choice_c": "Geographical",
    "choice_d": "Parallel",
    "correct_answer": "D",
    "explanation": "Running both the old and new systems simultaneously represents a parallel cutover, as this approach allows for comparison of outputs from both systems to ensure the new system is functioning correctly before fully decommissioning the old one. All-at-once refers to an immediate switchover from the old system to the new system without overlap. Geographical refers to implementing the system in specific locations or regions in stages. Module-by-module involves implementing the system one component or module at a time, rather than running both systems in their entirety concurrently.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      122,
      158,
      123,
      150,
      121
    ],
    "source": "9781394290116"
  },
  {
    "id": 923,
    "question": "Which of the following standards is applied for the protection of cardholder data?",
    "choice_a": "PCI DSS",
    "choice_b": "PA-DSS",
    "choice_c": "PCI",
    "choice_d": "FIPS 199",
    "correct_answer": "A",
    "explanation": "PCI DSS, or Payment Card Industry Data Security Standard, is an international standard concerned with the protection of cardholder data (CHD). <p>PA-DSS is incorrect because it is a standard for the security of payment applications. PCI is incorrect because it is an organization, not a standard. FIPS 199 is incorrect because it is a standard for security categorization.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      40,
      39,
      2,
      10,
      11
    ],
    "source": "9781394290116"
  },
  {
    "id": 924,
    "question": "You are the IS auditor of a small financial institution, and you are reviewing the IT strategic planning process. What would you expect to find during your review?",
    "choice_a": "The presence of qualified IT personnel",
    "choice_b": "Adopted software development practices",
    "choice_c": "The adequacy of operational controls",
    "choice_d": "Vision and mission of IT",
    "correct_answer": "D",
    "explanation": "During the review of the IT strategic planning process at a small financial institution, it is essential to find the vision and mission of the IT department. This is because the strategic planning process should align the IT objectives with the broader organizational goals, making the vision and mission central components. The adopted software development practices, while important for IT process effectiveness, are more relevant to operational or tactical planning rather than the broader strategic vision. The adequacy of operational controls focuses on specific procedures and measures to manage day-to-day IT operations, rather than the strategic direction of IT within the organization. The presence of qualified IT personnel is crucial for implementing the strategy effectively, but it does not directly pertain to the process of strategic planning, which should outline the high-level aims and direction before considering resource allocation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      7,
      1,
      54,
      53,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 925,
    "question": "The period from the onset of an outage until the resumption of service is known as the:",
    "choice_a": "Recovery time objective (RTO)",
    "choice_b": "Recovery response time (RRT)",
    "choice_c": "Recovery point objective (RPO)",
    "choice_d": "Time to recovery (TTR)",
    "correct_answer": "A",
    "explanation": "The RTO is a key target that is the period from the onset of an outage until the resumption of service, usually measured in hours or days. <p>RRT is incorrect because “recovery response time” is not a standard recovery target. RPO is incorrect because “recovery point objective” is an expression of the maximum data loss, not the time to restore service. TTR is incorrect because “time to recovery” is not a standard recovery target.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      233,
      247,
      248,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 926,
    "question": "Which of the following is the most relevant feature of a unified threat management (UTM) system?",
    "choice_a": "UTMs can only be operated manually.",
    "choice_b": "UTMs focus on intrusion detection.",
    "choice_c": "UTMs are expensive and difficult to maintain.",
    "choice_d": "UTMs perform several different security functions.",
    "correct_answer": "D",
    "explanation": "UTMs perform several different security functions, combining tools like firewalls, intrusion prevention systems, antivirus, and content filtering into one platform, making them highly effective for comprehensive threat management. They do not focus solely on intrusion detection but cover a broader range of security functions. They are typically cost effective compared to deploying multiple separate solutions, contrary to the idea that they are expensive and difficult to maintain. UTMs often include automation and centralized management features, so they do not rely solely on manual operation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      268,
      265,
      263,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 927,
    "question": "What factor significantly contributes to the success of malware?",
    "choice_a": "Password compromise",
    "choice_b": "Exploitable vulnerabilities",
    "choice_c": "False rejection rate",
    "choice_d": "Unencrypted traffic",
    "correct_answer": "B",
    "explanation": "Unpatched systems can allow known vulnerabilities that can be exploited, which is what most malware targets. <p>Password compromise is incorrect because although it is a factor that can aid the success and spread of malware, it is not as significant a factor as is exploitable vulnerabilities. False rejection is incorrect because FRR, the measure of a biometric system’s failure to recognize legitimate subjects’ biometrics, does not contribute to malware success. Unencrypted traffic is incorrect because although it is a poor practice because of adversaries being able to eavesdrop, it does not significantly contribute to the success of malware.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      322,
      312,
      293,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 928,
    "question": "Which of the following should project team members representing business owners review to confirm that the system design aligns with the owners’ concept?",
    "choice_a": "Only the major components of high-level design",
    "choice_b": "Only the high-level design",
    "choice_c": "Only the low-level design",
    "choice_d": "Both the high-level and low-level designs",
    "correct_answer": "D",
    "explanation": "Both the high-level and low-level design documents are crucial for project team members representing business owners to review. The high-level design provides an overview of the system architecture and addresses the major components that align with the business objectives. At the same time, the low-level design delves into the technical and detailed aspects, ensuring that the implementation of the system aligns with the business owners’ needs and future requirements. Not considering both levels of design can lead to discrepancies between the conceptual understanding of the system and its technical implementation. Reviewing only the high-level design or only its major components might miss critical implementation details that could affect the system’s functionality. Just reviewing the low-level design without understanding the overarching goals and architecture would leave gaps in ensuring the system functions as desired by the business.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      152,
      117,
      112,
      105
    ],
    "source": "9781394290116"
  },
  {
    "id": 929,
    "question": "A financial services organization needs to solicit external auditors to perform audits of its services on behalf of its customers and would like to use the most current and relevant standard. Which type of audit should the organization choose?",
    "choice_a": "ISO 27001",
    "choice_b": "SAS 70",
    "choice_c": "SSAE 18",
    "choice_d": "AUP",
    "correct_answer": "C",
    "explanation": "The SSAE 18 audit standard is used for audits of financial service organizations. Audit reports can be delivered to the customers of those organizations. The other types of audits fulfill other purposes. <p>ISO 27001 is incorrect because it is not as applicable for financial services as SSAE 18. SAS 70 is incorrect because it has been superseded by SSAE 18. The answer mentioning an AUP audit is incorrect because an AUP audit is not as good a choice as SSAE 18.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      363,
      86,
      97,
      87,
      364
    ],
    "source": "9781394290116"
  },
  {
    "id": 930,
    "question": "An IS auditor reviewing coding practices at a pharmaceutical firm discovers that the organization sends a vendor’s electronic copy to a third-party organization for safekeeping in case the vendor goes out of business. Which of the following terms does this practice represent?",
    "choice_a": "Code review",
    "choice_b": "Code storage",
    "choice_c": "Source code subcontract",
    "choice_d": "Source code escrow",
    "correct_answer": "D",
    "explanation": "The practice of sending a vendor’s electronic copy to a third-party organization for safekeeping in case the vendor goes out of business is known as source code escrow. Source code escrow is a critical practice in software development and procurement that ensures the customer continues to have access to the source code if the vendor can no longer provide support. This helps in business continuity and risk management associated with vendor lock-in. Code storage, in this context, would generally refer to the practice of saving code securely within a company or project but doesn’t imply a third-party is involved for business continuity reasons. The source code sub-contract suggests that a secondary vendor is engaged in working with the code, which is not the scenario described where safeguarding is the primary motive. Code review is the process of systematically examining source code to identify bugs and improve quality, which is unrelated to the practice of preparing for potential vendor failure.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      56,
      33,
      34,
      57,
      59
    ],
    "source": "9781394290116"
  },
  {
    "id": 931,
    "question": "HTTP is generally associated with which layer in the TCP/IP model?",
    "choice_a": "3",
    "choice_b": "7",
    "choice_c": "6",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "HTTP is a part of the TCP/IP Application layer, which is Layer 4. <p>3 is incorrect because HTTP is not a part of the TCP/IP Transport layer, which is Layer 3. 7 and 6 are incorrect because the TCP/IP model has only four layers.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      305,
      306,
      342,
      320,
      319
    ],
    "source": "9781394290116"
  },
  {
    "id": 932,
    "question": "An IS auditor performing a systems development review encounters the widespread use of sprint retrospectives in a software development project that follows the Scrum methodology. Which of the following is the purpose of a sprint retrospective?",
    "choice_a": "To formulate new sprint objectives",
    "choice_b": "To define the backlog sprint",
    "choice_c": "To approve the just-completed sprint",
    "choice_d": "To reflect on the recently completed sprint",
    "correct_answer": "D",
    "explanation": "The purpose of a sprint retrospective is to reflect on the recently completed sprint, allowing the team to review what went well, what didn’t, and how processes can be improved in future sprints. It does not involve defining the backlog, as that is handled during backlog refinement or sprint planning. It is not about approving the completed sprint, which is the focus of the sprint review, where stakeholders evaluate the deliverables. Formulating new sprint objectives happens during sprint planning, not the retrospective.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      109,
      150,
      138,
      113
    ],
    "source": "9781394290116"
  },
  {
    "id": 933,
    "question": "An organization may elect to voluntarily undergo an annual ISO 27001 audit for any of the following reasons <i>except</i>:",
    "choice_a": "To compensate for poor PCI audit results",
    "choice_b": "To improve its market competitiveness",
    "choice_c": "To give business customers greater confidence in the organization’s security controls",
    "choice_d": "For the prestige value",
    "correct_answer": "A",
    "explanation": "An ISO 27001 audit would do little to compensate for poor PCI audit results. <p>The answers mentioning market competitiveness, confidence in controls, and prestige are all reasons for undertaking ISO 27001 audits.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      2,
      40,
      14,
      34,
      23
    ],
    "source": "9781394290116"
  },
  {
    "id": 934,
    "question": "Which of the following features of cloud computing allows users to pay only for those resources they consume at any given time?",
    "choice_a": "Scalability",
    "choice_b": "Convenience",
    "choice_c": "Ubiquitous",
    "choice_d": "Measured service",
    "correct_answer": "D",
    "explanation": "Measured service is the feature of cloud computing that allows users to pay only for the resources they consume, as it inherently involves monitoring and optimizing resource usage, enabling clients to be charged based on their actual consumption. Convenience refers to the ease of access or use of cloud services, which does not directly relate to the cost structure or billing. Ubiquitous implies that cloud services can be accessed from anywhere, emphasizing availability and accessibility rather than billing models. Scalability refers to the ability of cloud services to increase or decrease resources as needed; while it relates to resource management, it does not specifically address the pay-as-you-go billing aspect that measured service offers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      277,
      279,
      281,
      278
    ],
    "source": "9781394290116"
  },
  {
    "id": 935,
    "question": "An IS auditor is examining an organization’s third-party risk management (TPRM) process and has found that the 600+ vendors were assessed with the same questionnaire during onboarding. No assessments are conducted after onboarding. What should the auditor conclude from this?",
    "choice_a": "The TPRM process should be outsourced.",
    "choice_b": "The TPRM process is properly designed.",
    "choice_c": "Critical service providers should be audited annually.",
    "choice_d": "Multiple questionnaires should be used.",
    "correct_answer": "C",
    "explanation": "The biggest problem with the process is that no service providers are assessed after onboarding. <p>Outsourcing the TPRM process is not necessarily the best remedy. The TPRM process is not necessarily designed properly (it may be properly designed and improperly implemented). The use of multiple questionnaires is not the most significant defect in this process.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      5,
      16,
      20
    ],
    "source": "9781394290116"
  },
  {
    "id": 936,
    "question": "Which of the following is the reason an IS auditor may recommend that an organization benchmark its key IT processes?",
    "choice_a": "To reduce the cost of procuring IT equipment",
    "choice_b": "To copy competitors’ strategies",
    "choice_c": "To compare its processes with those of competitors and determine methods to maintain these processes",
    "choice_d": "To compare how similar organizations solve challenges and determine improvements",
    "correct_answer": "D",
    "explanation": "An IS auditor may recommend an organization to benchmark its key IT processes to compare how similar organizations solve challenges and determine improvements. Benchmarking allows an organization to assess its performance against industry standards or peers, providing insights into areas that require enhancements or innovations. Copying competitors’ strategies is not the primary intent of benchmarking, as it focuses on adopting best practices rather than direct imitation, which might not suit an organization’s unique operational context. Comparing processes solely to maintain them neglects the potential for identifying areas that require improvement and can lead to stagnation rather than growth. Finally, benchmarking is about performance improvement rather than directly reducing the cost of procuring IT equipment, which involves different strategies such as negotiating with vendors or optimizing asset management.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      34,
      41,
      3,
      1,
      27
    ],
    "source": "9781394290116"
  },
  {
    "id": 937,
    "question": "Which of the following is a verification of system specifications and technologies as performed by individual developers?",
    "choice_a": "Design review",
    "choice_b": "User acceptance testing (UAT)",
    "choice_c": "Quality assurance testing (QAT)",
    "choice_d": "Unit testing",
    "correct_answer": "D",
    "explanation": "Unit testing is performed by individual developers, to verify correct options of the sections of code they are developing. <p>Design review is incorrect because it is permitted by a development team (along with customers or users), not by individual developers. User acceptance testing (UAT) is incorrect because it is performed by end users, not individual developers. Quality assurance testing (QAT) is incorrect because it is performed by test personnel, not individual developers.</p>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      119,
      153,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 938,
    "question": "The IS auditor seeks to analyze digital evidence while avoiding the alteration of the original evidence. Which of the following methods will assist the IS auditor in achieving this goal?",
    "choice_a": "Document the evidence collection process.",
    "choice_b": "Use original evidence for analysis.",
    "choice_c": "Prepare original evidence work papers.",
    "choice_d": "Use a copy of the original evidence for analysis purposes.",
    "correct_answer": "D",
    "explanation": "Using a copy of the original evidence for analysis is the best method to ensure that the original evidence remains unaltered. This approach allows the IS auditor to perform all necessary examinations and manipulations on the duplicate rather than risking changes to the primary source, thereby preserving its integrity for subsequent verifications or legal inquiries. Using the original evidence for analysis increases the risk of accidental alteration, compromising the evidence’s integrity. Preparing original evidence work papers involves creating documentation based on the evidence, but this does not prevent alteration during the analysis itself. Documenting the evidence collection process is crucial for maintaining a chain of custody and understanding context but does not inherently protect the original evidence from alteration during analysis.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      362,
      70,
      89,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 939,
    "question": "All of the following are attack methods that can be used to bypass physical security controls and cause conditions such as tailgating and piggybacking <i>except</i>:",
    "choice_a": "Disabled video surveillance equipment",
    "choice_b": "Stolen access card",
    "choice_c": "Social engineering",
    "choice_d": "Bribery",
    "correct_answer": "A",
    "explanation": "Disabled video surveillance equipment is not a method that can be used to bypass physical security controls. <p>Stolen access cards, social engineering, and bribery are all incorrect because they are methods that <i>can</i> be used to bypass physical security controls.</p>",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      335,
      336,
      337,
      334,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 940,
    "question": "Which of the following should the IS auditor recommend for inclusion in restoration procedures after a disaster has occurred?",
    "choice_a": "Closing the primary site",
    "choice_b": "Keeping IT operations permanently at the disaster recovery site",
    "choice_c": "Training employees for future disasters",
    "choice_d": "Transitioning IT operations back to the primary site",
    "correct_answer": "D",
    "explanation": "Transitioning IT operations back to the primary site should be included in restoration procedures after a disaster. This step ensures that the organization returns to its normal operating environment and maximizes the efficiency and resource allocation initially intended for the primary site setup. Keeping IT operations permanently on the disaster recovery site is not advisable since disaster recovery sites are typically designed for temporary use and might not support long-term operations with the same efficiency. Training employees for future disasters, while important, is a proactive measure rather than a restoration procedure. Similarly, closing the primary site is not a feasible option unless it is completely irreparable, as it contradicts the purpose of restoring operations to their original state.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      240,
      235,
      248,
      251,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 941,
    "question": "Which kind of testing ensures that data is being formatted properly as it moves from one application to another?",
    "choice_a": "Unit testing",
    "choice_b": "Integration testing",
    "choice_c": "Regression testing",
    "choice_d": "Functional testing",
    "correct_answer": "B",
    "explanation": "Integration testing is correct because when data is transferred from one system to another, it is important to verify that the transference of data occurs correctly, and that data represented in the source system is properly represented in the destination system. This can help the source and destination systems work as an integrated whole. <p>Unit testing is incorrect because it is the testing of sections of code by the developers who write or update them. Regression testing is incorrect because it is the testing of functionality of software to ensure that it operates as expected. Functional testing is incorrect because it is used to confirm the correct operation of a system.</p>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      156,
      158,
      153,
      148
    ],
    "source": "9781394290116"
  },
  {
    "id": 942,
    "question": "Encapsulation is a key aspect of object-oriented (OO) system development. Which of the following represents the main purpose of encapsulation?",
    "choice_a": "To eliminate the need for code reuse",
    "choice_b": "To increase code complexities",
    "choice_c": "To improve inheritance",
    "choice_d": "To hide the internal details of an object",
    "correct_answer": "D",
    "explanation": "The main purpose of encapsulation in object-oriented system development is to hide the internal details of objects. It allows a class to hide its internal data and behavior and expose only certain interfaces, keeping implementation details private and protecting the integrity of the data. This enhancement of method interaction simplifies the complexity of the system for end users while truly linking behavior with data in a controlled manner. Increasing code complexities contradicts the purpose of encapsulation, which is intended to manage complexity by hiding unnecessary details. Enhancing inheritance is unrelated to encapsulation, as encapsulation focuses on data protection and method accessibility rather than class hierarchy. Lastly, encapsulation does not eliminate the need for code reuse; rather, it facilitates code reuse by providing well-defined interfaces and protecting the internal data structures.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      119,
      120,
      152,
      105,
      112
    ],
    "source": "9781394290116"
  },
  {
    "id": 943,
    "question": "An IS auditor sends a questionnaire to the Finance Director to investigate the circumstances surrounding unreconciled sales accounts. After a week of thorough review, the auditor discovers that the Finance Department did not have a policy in place to guide sales reconciliation. What is the most appropriate next step for the IS auditor in this scenario?",
    "choice_a": "Expand the scope of audit testing to obtain sufficient evidence.",
    "choice_b": "Issue a report stating that the controls in the Finance Department are inadequate.",
    "choice_c": "Request a written management representation from the Finance Director regarding the unreconciled accounts.",
    "choice_d": "Abandon the audit until the sales policy is in place.",
    "correct_answer": "A",
    "explanation": "After discovering the absence of a policy guiding sales reconciliation, the most appropriate next step for the IS auditor is to expand the scope of audit testing to obtain sufficient evidence. This approach helps to better understand the extent and impact of the issue and gather the necessary information to support the audit findings, ensuring a comprehensive assessment of the internal control environment. Issuing a report stating that the controls in the Finance Department are inadequate without further evidence could lead to an incomplete or biased report. Requesting a written management representation from the Finance Director might provide some insight, but it would not substitute for proper audit evidence and analysis. Abandoning the audit until a sales policy is in place would leave the unresolved issues and potential risks unexamined, failing to fulfill the auditor’s responsibility to provide assurance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      360,
      359,
      363,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 944,
    "question": "During the verification of digital certificates, which of the following is one of the crucial steps that the IS auditor must perform?",
    "choice_a": "Confirm the date the certificate was issued.",
    "choice_b": "Confirm whether a registration authority (RA) was involved in certificate issuance.",
    "choice_c": "Check whether the certificate contains the organization’s name.",
    "choice_d": "Confirm the certificate was issued by a trusted certificate authority (CA).",
    "correct_answer": "D",
    "explanation": "Confirming that the certificate was issued by a trusted Certificate Authority (CA) is essential because the trustworthiness of a digital certificate relies heavily on the credibility of the issuing CA. This ensures that the certificate can be validated and that the entity presenting the certificate can be trusted. While checking if a Registration Authority (RA) was involved in the issuance process could be informative regarding the chain of trust, it is not as critical as validating the CA itself. Verifying whether the certificate contains the organization’s name is relevant for identifying the certificate holder but does not attest to the certificate’s validity or trust level. Although confirming the date the certificate was issued helps check if the certificate is within its valid period, it does not directly impact the essential trust the CA provides.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      287,
      288,
      282,
      314,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 945,
    "question": "A new CISO has observed that personnel in the organization are not using the specific safeguards that should be followed to protect a particular information type found in the company’s sensitive documents and email. What is the organization apparently missing?",
    "choice_a": "Document shredders",
    "choice_b": "Security policy",
    "choice_c": "Data classification",
    "choice_d": "Acceptable use policy",
    "correct_answer": "C",
    "explanation": "A data classification policy, along with its data-handling guidelines, is the most specific item that is apparently missing from the organization. <p>“Document shredders” is incorrect because the absence of shredders, while possible, is not the most likely scenario. “Security policy” is incorrect because the absence of a security policy is not a probable cause. “Acceptable use policy” is incorrect because the absence of an acceptable use policy is not a probable cause.</p>",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      10,
      15,
      9,
      44,
      29
    ],
    "source": "9781394290116"
  },
  {
    "id": 946,
    "question": "The key purpose of initial access provisioning for new employees in an organization is:",
    "choice_a": "To assess employees’ technical skills",
    "choice_b": "To review employee access",
    "choice_c": "To provide employee training",
    "choice_d": "To provide the appropriate access privileges",
    "correct_answer": "D",
    "explanation": "The primary aim of initial access provisioning for new employees is to provide the appropriate access privileges. Ensuring that employees have the necessary access rights from the start is crucial for them to perform their job functions efficiently and securely. Reviewing employee access is a separate process that typically occurs periodically to ensure that access levels remain appropriate over time rather than being the primary goal of initial provisioning. Providing employee training is a fundamental aspect of onboarding, but it is distinct from provisioning access and deals more with familiarizing employees with their roles and responsibilities. Assessing employees’ technical skills is unrelated to access provisioning, since it is typically done during recruitment or evaluation phases, not during the process of setting up access rights.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      345,
      317,
      340,
      311,
      343
    ],
    "source": "9781394290116"
  },
  {
    "id": 947,
    "question": "An auditor is performing an audit of a company’s financial operations, including the outsourced expense management service. The expense management service has an SSAE 18 audit report. Can the auditor use this audit report?",
    "choice_a": "The auditor may rely on the SSAE 18 report but will have to confirm whether it covers all areas of interest.",
    "choice_b": "The auditor may rely on the SSAE 18 report, which will cover all areas of interest.",
    "choice_c": "The auditor may not rely on the SSAE 18 report but instead must audit the outsourced expense management service directly.",
    "choice_d": "The auditor does not need to audit the expense management service because it is outsourced.",
    "correct_answer": "A",
    "explanation": "There is no guarantee that an SSAE 18 audit (or any other external audit report) covers all areas of interest. Generally, an auditor will not be required to audit a service provider, particularly when it has an SSAE 18 report. The fact that a service is outsourced does not determine a lack of need to audit it. <p>The answer stating that the SSAE 18 audit will cover all areas of interest is incorrect because the SSAE 18 audit report may not cover all areas of interest. The answer stating that the auditor may not rely on the SSAE 18 audit is incorrect because the auditor may rely upon the SSAE 18 audit report. The answer stating that the external report service provider need not be audited is incorrect because the auditor does need to audit, or view an audit of, the expense report service provider.</p>",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      97,
      363,
      94,
      89,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 948,
    "question": "Which of the following training techniques can assist users to better recognize and respond appropriately to phishing attacks?",
    "choice_a": "On-the-job training",
    "choice_b": "Role-based training",
    "choice_c": "Targeted training",
    "choice_d": "Phishing simulations",
    "correct_answer": "D",
    "explanation": "Phishing simulations are an effective training technique to assist users in recognizing and responding to phishing attacks because they provide realistic scenarios where users can practice identifying and managing phishing attempts in a safe environment. By simulating real phishing threats, users can gain practical experience and immediate feedback, which helps reinforce learning and improve their ability to recognize phishing attempts in actual situations. Role-based training, while valuable, focuses on specific roles within an organization and may not specifically cover phishing for all users. Targeted training, although aimed at specific groups, may not offer the hands-on experience that simulations provide. On-the-job training is more general and might not specifically address phishing threats or provide the interactive practice needed to effectively prepare users to contend with phishing attacks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      340,
      303,
      292,
      293
    ],
    "source": "9781394290116"
  },
  {
    "id": 949,
    "question": "The international standard for standard IT service management processes is known as:",
    "choice_a": "ISO 9000",
    "choice_b": "SABSA",
    "choice_c": "ITIL",
    "choice_d": "ISO 27001",
    "correct_answer": "C",
    "explanation": "ITIL is the correct choice because it is a globally recognized framework that provides best practices for IT service management, focusing on aligning IT services with business needs. ISO 9000 is unrelated to IT service management, as it deals with quality management systems. SABSA focuses on security architecture and does not address IT service management processes. ISO 27001 pertains to information security management, not the broader scope of IT service management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      2,
      37,
      34,
      1,
      39
    ],
    "source": "9781394290116"
  },
  {
    "id": 950,
    "question": "An IS auditor carried out a review of a recently implemented application and discovered that many design changes were made after implementation. Which of the following should the IS auditor conclude?",
    "choice_a": "The application was subjected to inadequate testing.",
    "choice_b": "The application met its performance targets.",
    "choice_c": "Application testing was properly conducted.",
    "choice_d": "The application had inadequate requirements.",
    "correct_answer": "D",
    "explanation": "The application had inadequate requirements is the correct conclusion because numerous design changes after implementation typically indicate that the initial requirements were incomplete or poorly defined, leading to unforeseen adjustments. Meeting performance targets would not explain the need for extensive post-implementation design changes. Properly conducted application testing would likely have identified issues earlier, reducing the need for major changes after deployment. Inadequate testing could lead to unaddressed defects, but it does not account for fundamental design changes, which are more closely tied to requirements gathering and analysis.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      151,
      117,
      119,
      123,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 951,
    "question": "Which of the following auditing standards provides guidance to ensure that all IS audit tasks are performed within the required competence levels?",
    "choice_a": "Due Professional Care",
    "choice_b": "Performance and Supervision",
    "choice_c": "Organizational Independence",
    "choice_d": "Proficiency",
    "correct_answer": "B",
    "explanation": "Performance and Supervision provides guidance to ensure that all IS audit tasks are performed within the required competence levels because it involves overseeing audit activities and reviewing work to ensure that tasks are completed effectively and within the set standards. It focuses on the roles of supervisors and managers in making sure the audit team adheres to professional standards and fulfills their responsibilities competently. Due Professional Care is more about ensuring that auditors exercise professional skepticism and diligence in their work, but it doesn’t directly address competence levels. Organizational Independence refers to the auditor’s ability to remain unbiased and free from influence from the organization being audited, which is important for impartiality but not related to competence levels. Proficiency refers to the skills and knowledge required for the job, but it doesn’t inherently provide a framework for ensuring tasks are performed at required competence levels, unlike Performance and Supervision which incorporates oversight mechanisms.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      69,
      68,
      99,
      85,
      60
    ],
    "source": "9781394290116"
  },
  {
    "id": 952,
    "question": "During the review of the business continuity plan (BCP), the IS audit team discovers a missing critical hardware component. Which of the following issues represents this scenario?",
    "choice_a": "Syntax error",
    "choice_b": "Recovery delay",
    "choice_c": "Resumption effect",
    "choice_d": "Walkthrough error",
    "correct_answer": "B",
    "explanation": "A missing critical hardware component directly impacts the ability to restore systems promptly after a disruption, which implies a recovery delay issue. Without this component, the time taken to get systems back online would be longer than planned, thereby delaying the recovery process. Syntax error refers to mistakes in the documentation or code, unrelated to physical components. Resumption effect is the impact of restarting operations on a system, focusing more on processes rather than missing physical components. Walkthrough error involves mistakes found during a read-through or step-by-step review of procedures, primarily related to executing the plan correctly, not missing components.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      235,
      248,
      246,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 953,
    "question": "An IS auditor is reviewing the classification levels at a financial institution. Which of the following would the IS auditor not expect to find?",
    "choice_a": "Tags",
    "choice_b": "Public",
    "choice_c": "Confidential",
    "choice_d": "Secret",
    "correct_answer": "A",
    "explanation": "The IS auditor would not expect to find “Tags” as a classification level at a financial institution because it is not a standard classification level. Instead, “Tags” generally refers to labels or metadata used for organizing and identifying data but not for classifying its confidentiality or sensitivity. “Public,” “Confidential,” and “Secret” are established classification levels used to designate the sensitivity of information. “Public” refers to information intended for public distribution without restrictions. “Confidential” indicates data that contains sensitive information intended for restricted access, while “Secret” typically signifies a higher level of sensitivity, requiring stringent access controls. These terms are commonly used across various organizations to ensure appropriate data protection and access control based on sensitivity levels, whereas “Tags” lacks the specificity of security classification.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      10,
      11,
      9,
      15,
      39
    ],
    "source": "9781394290116"
  },
  {
    "id": 954,
    "question": "An organization needs to prevent users from being able to access Internet sites whose contents violate organization policy. What should be implemented to accomplish this?",
    "choice_a": "Intrusion prevention system",
    "choice_b": "Cloud access security broker",
    "choice_c": "Web content filtering",
    "choice_d": "Advanced antimalware",
    "correct_answer": "C",
    "explanation": "Web content filtering is the appropriate solution for preventing users from accessing sites that violate organization policy. For example, web content filters can block access to gambling, weapons, and pornography sites. <p>Intrusion prevention system is incorrect because the role of an IPS isn’t to block user access to websites that violate organization policy. An IPS can, however, be used to block user access to malicious websites. Cloud access security broker is incorrect because a CASB is used to provide visibility and control of end user access to specific cloud service providers. Advanced antimalware is incorrect because its role is to block advanced malware from successfully executing on a system.</p>",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      306,
      309,
      320,
      298,
      322
    ],
    "source": "9781394290116"
  },
  {
    "id": 955,
    "question": "During a recent audit review, the IS audit team discovered that one individual could create supplier accounts, request payments, and make payments. Which of the following principles was being violated?",
    "choice_a": "Aggregation of duties (AODs)",
    "choice_b": "Segregation of duties (SODs)",
    "choice_c": "Dual control",
    "choice_d": "Process workflow",
    "correct_answer": "B",
    "explanation": "Segregation of Duties (SODs) is the principle being violated in this scenario. SOD requires that critical tasks be divided among different individuals to reduce the risk of error and inappropriate actions, such as fraud. By allowing one person the ability to create supplier accounts, request payments, and make payments, the organization fails to separate these responsibilities, which compromises the integrity of financial processes. Aggregation of Duties is not a recognized control principle like Segregation of Duties and therefore does not apply. Dual control refers to a system wherein two individuals are required to complete a task together as an additional layer of security, but this does not specifically address the separation of tasks. Process workflow generally refers to the sequence and management of processes within an organization, which doesn’t directly relate to the issue of overlapping duties being highlighted in the scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      133,
      155,
      144,
      105
    ],
    "source": "9781394290116"
  },
  {
    "id": 956,
    "question": "An IS auditor reviewing an organization’s information security practices discovers that vulnerabilities are not being formally tracked and assigned for remediation. Which of the following processes should the organization implement to address this finding?",
    "choice_a": "Penetration testing",
    "choice_b": "Vulnerability management",
    "choice_c": "Patch management",
    "choice_d": "Change management",
    "correct_answer": "B",
    "explanation": "Vulnerability management is the correct process to implement because it involves identifying, assessing, prioritizing, and tracking vulnerabilities for remediation in a structured manner. Penetration testing focuses on simulating attacks to identify vulnerabilities but does not address the ongoing tracking and remediation process. Patch management ensures that software updates and patches are applied but does not encompass the broader scope of identifying and tracking vulnerabilities. Change management oversees the proper implementation of changes to systems and processes but does not directly handle vulnerability tracking and remediation.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      322,
      308,
      267,
      313,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 957,
    "question": "What is the business purpose of a configuration management database?",
    "choice_a": "Provide information about the configurations of IT systems",
    "choice_b": "Create a record of approvals for changes made to a system",
    "choice_c": "Create a record of every configuration change made to IT systems",
    "choice_d": "Create a record of the most recent change made to IT system components",
    "correct_answer": "C",
    "explanation": "In business terms, a configuration management database (CMDB) is a record of all of the configuration changes made to IT systems. <p>Information about the configurations of IT systems is incorrect because this only partly explains the purpose of a CMDB. Record of approvals for changes made to a system is incorrect as a record of approvals for changes would reside in a change management business record. Record of the most recent change made to IT system components is incorrect because configuration management is not only concerned with the most recent changes made to a system but all changes.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      169,
      173,
      166,
      167,
      168
    ],
    "source": "9781394290116"
  },
  {
    "id": 958,
    "question": "Various reasons are often cited for why organizations implement IT governance frameworks, such as the Control Objectives for Information and Related Technologies (COBIT). Which of the following is the most important aim of implementing an IT governance framework for a pharmaceutical firm?",
    "choice_a": "Improving transparency",
    "choice_b": "Increasing sales and profitability levels",
    "choice_c": "Aligning IT strategy with business strategies",
    "choice_d": "Improving managerial performance",
    "correct_answer": "C",
    "explanation": "Aligning IT strategy with business strategies is the most important aim of implementing an IT governance framework for a pharmaceutical firm because it ensures that the IT initiatives support the organization’s overall goals and objectives, thus facilitating better decision-making and efficient resource allocation. By aligning IT with the business strategy, the firm can better support its unique needs, such as research and development, regulatory compliance, and market responsiveness. While increasing sales and profitability levels is crucial, it is a consequence rather than a direct goal of IT governance. Improving transparency is essential, but it primarily supports accountability and does not directly align IT with business strategies. Improving managerial performance is also beneficial, but it is typically a byproduct of better alignment and processes, not the primary goal of implementing such a framework. Therefore, aligning IT strategy with business strategies remains the most significant aim of IT governance in this context.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      1,
      2,
      7,
      3,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 959,
    "question": "Which of the following parts of a BIA includes a qualitative or quantitative description of the consequences of an incapacitated process or system?",
    "choice_a": "Criticality analysis",
    "choice_b": "Inventory of key processes and systems",
    "choice_c": "Statement of impact",
    "choice_d": "Risk analysis",
    "correct_answer": "C",
    "explanation": "A statement of impact is a qualitative or quantitative description of the impact if the process or system were incapacitated for a time. <p>Criticality analysis, an inventory of processes and systems, and risk analysis are all incorrect because they are activities performed during a BIA but for other purposes.</p>",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      233,
      246,
      244,
      247,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 960,
    "question": "As part of its security practices, an organization configured a device that has the primary purpose of ensuring that only authorized traffic enters the network from the Internet. It can perform application-layer inspection of all traffic entering the network. What term best describes this device?",
    "choice_a": "Web application firewall",
    "choice_b": "Intrusion detection system",
    "choice_c": "Next generation firewall",
    "choice_d": "Intrusion prevention system",
    "correct_answer": "C",
    "explanation": "A device that ensures only authorized traffic enters the network from the Internet while performing application-layer inspection is best described as a next-generation firewall. This type of firewall combines traditional firewall capabilities with advanced features like application-layer inspection, intrusion prevention, and deep packet inspection. A web application firewall focuses specifically on protecting web applications by filtering and monitoring HTTP traffic, which is narrower in scope. An intrusion detection system is a passive device that monitors and alerts on potential threats but does not block traffic. An intrusion prevention system actively blocks malicious traffic but lacks the comprehensive application-layer inspection and broader feature set of a next-generation firewall.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      306,
      274,
      270,
      309,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 961,
    "question": "An IT leader who wants to build IT processes according to a standard model should adopt which standard?",
    "choice_a": "ISO/IEC 27701",
    "choice_b": "ISO/IEC 27002",
    "choice_c": "ISO/IEC 20000",
    "choice_d": "NIST 800-53",
    "correct_answer": "C",
    "explanation": "ISO/IEC 20000 is the international standard for IT service management, a process model adaptable to most any IT organization. <p>ISO/IEC 27701 is incorrect because it is a privacy standard. ISO 27002 is incorrect because it is a security controls standard. NIST 800-53 is incorrect because it is a security and privacy controls standard.</p>",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      37,
      2,
      39,
      15,
      12
    ],
    "source": "9781394290116"
  },
  {
    "id": 962,
    "question": "An auditor is auditing a purchase order process and needs to select individual purchases to audit. There is a small number of high-value purchase orders. Which sampling technique is best suited for this audit?",
    "choice_a": "Stratified sampling",
    "choice_b": "Statistical sampling",
    "choice_c": "Variable sampling",
    "choice_d": "Discovery sampling",
    "correct_answer": "A",
    "explanation": "The stratified sampling technique permits auditors to select samples with very low or high values, or any other rarity, whereas the other sampling techniques are not likely to provide the needed samples. <p>Statistical sampling is incorrect because it will probably result in few or no high-value purchase orders being selected. Variable sampling is incorrect because it will probably result in few or no high-value purchase orders being sampled. Discovery sampling is incorrect because it is used when an auditor is looking for at least one exception in a given population.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      360,
      72,
      85,
      90
    ],
    "source": "9781394290116"
  },
  {
    "id": 963,
    "question": "A collection of servers that appear as a single server and provide high availability is known as (a):",
    "choice_a": "Resilience",
    "choice_b": "Backup",
    "choice_c": "Cluster",
    "choice_d": "Virtualization",
    "correct_answer": "C",
    "explanation": "A collection of servers that appear as a single entity and provide high availability is known as a cluster. Clustering involves linking multiple servers together to work as a unit, ensuring that if one server in the group fails, the others can take over, thereby enhancing uptime and reliability. Backup refers to the process of copying data to safeguard against loss, which is not directly related to improving server availability as it is more about data recovery. Resilience generally refers to the ability of a system to withstand failures and continue operating, but it does not specifically describe the composition of multiple servers working together. Virtualization involves running multiple virtual instances on a single physical server to maximize resource utilization, rather than focusing on high availability through multiple servers appearing as one entity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      201,
      195,
      238,
      162,
      187
    ],
    "source": "9781394290116"
  },
  {
    "id": 964,
    "question": "What is the most compelling security reason for isolating IoT devices from other systems on a network?",
    "choice_a": "IoT devices communicate via an insecure multicast protocol.",
    "choice_b": "Many IoT devices cannot be patched in the field.",
    "choice_c": "Many IoT devices generate excessive syslog messages.",
    "choice_d": "IoT devices cannot be field upgraded.",
    "correct_answer": "B",
    "explanation": "Many IoT devices cannot be patched once they have been manufactured. This means that vulnerabilities that have been identified after their manufacture cannot be easily fixed, making them vulnerable to attack. For this reason, IoT devices as a rule should occupy separate networks with strict access controls so that compromised IoT devices cannot bring harm to the rest of the organization. <p>The answer mentioning an insecure multicast protocol is incorrect because it is not a fact that IoT devices usually communicate via multicast. The answer referring to high volumes of syslog messages is incorrect because it is not a fact that IoT devices produce a high volume of syslog messages. The answer stating that many IoT devices cannot be field upgraded is incorrect because, while the statement is true, the larger problem is that they cannot be patched (which may or may not be a part of a field upgrade).</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      306,
      313,
      320,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 965,
    "question": "During an audit review, an IS auditor recommends that the organization develop a policy to provide guidance regarding its handling of personally identifiable information (PII). Which of the following policies should the organization develop?",
    "choice_a": "Strategic",
    "choice_b": "Operations",
    "choice_c": "Privacy",
    "choice_d": "Personnel",
    "correct_answer": "C",
    "explanation": "A privacy policy is the appropriate choice for guiding an organization in handling Personal Identifiable Information (PII) because it specifically addresses the protocols and procedures associated with collecting, storing, managing, and protecting personal data. Privacy policies are designed to cover rules and guidelines on how PII is processed, ensuring legal compliance and maintaining trust with individuals whose information is being managed. Operations policies generally pertain to the internal processes and procedures that support business functions, typically unrelated to privacy concerns. Strategic policies are typically concerned with the long-term direction and goals of the organization, focusing on broad objectives rather than the specifics of PII handling. Personnel policies deal with human resources aspects, covering employee-related concerns rather than data management or privacy issues. Therefore, only a privacy policy directly relates to the management and protection of PII.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      8,
      9,
      1,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 966,
    "question": "An IT operations manager has observed that a specific application server chronically exhausts its available memory space. What should the IT operations manager do next?",
    "choice_a": "Open a new incident.",
    "choice_b": "Open a new problem.",
    "choice_c": "Reboot the server.",
    "choice_d": "Report a security incident.",
    "correct_answer": "B",
    "explanation": "A problem is defined as an incident that is recurring on a system. <p>“Open a new incident” is incorrect because opening incidents repeatedly does not help the organization get to the root cause of this chronic condition. “Reboot the server” is incorrect because rebooting the server is not necessarily going to resolve this problem. “Report a security incident” is incorrect because this situation is not a security problem but an operations problem.</p>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      165,
      173,
      184,
      175,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 967,
    "question": "Which of the following types of tools is best for reading PCAP files?",
    "choice_a": "Web application scanner",
    "choice_b": "Password cracker",
    "choice_c": "Fuzzer",
    "choice_d": "Network sniffer",
    "correct_answer": "D",
    "explanation": "A PCAP file contains information generated by a packet-capturing tool. A network sniffer is the best tool for reading a PCAP file. <p>Web application scanner is incorrect because this does not typically include the ability to read a PCAP file. Password cracker is incorrect because this does not typically include the ability to read a PCAP file. Fuzzer is incorrect because a fuzzer does not typically include the ability to read a PCAP file.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      308,
      342,
      307
    ],
    "source": "9781394290116"
  },
  {
    "id": 968,
    "question": "Which of the following testing methods ensures that the individual software modules work properly?",
    "choice_a": "Integration",
    "choice_b": "Unit",
    "choice_c": "System",
    "choice_d": "Penetration",
    "correct_answer": "B",
    "explanation": "Unit testing ensures that individual software modules work properly. It focuses on examining the smallest parts of an application, like functions or methods, to verify their correctness in isolation from other parts of the program. Integration testing, in contrast, deals with testing the interaction between combined modules to identify any compatibility issues. System testing is broader, encompassing the entire application, and aims to validate the end-to-end functionality. Penetration testing is unrelated to module verification as it focuses on evaluating the security of the application and discovering vulnerabilities that could be exploited by malicious actors. Therefore, only unit testing is directly concerned with validating the functionality of individual modules.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      121,
      120,
      153,
      156,
      157
    ],
    "source": "9781394290116"
  },
  {
    "id": 969,
    "question": "An auditor has audited a business process and its business records. After performing sampling, the auditor has determined that the confidence coefficient is 70%. How should the auditor proceed?",
    "choice_a": "The auditor should select more samples.",
    "choice_b": "The auditor may stop sampling.",
    "choice_c": "The auditor should switch to judgmental sampling.",
    "choice_d": "The auditor should start over.",
    "correct_answer": "A",
    "explanation": "A confidence coefficient of 70% is considered low, meaning the samples do not accurately represent the entire population. More samples should be selected. <p>Stopping sampling will not improve this low confidence coefficient. Switching to judgmental sampling is not likely to improve it either. Starting over is unnecessary as this would represent greater expenditure of time and effort.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      360,
      96,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 970,
    "question": "Why is it important for the IS auditor to examine user account lockout settings during a review of identity and access management practices?",
    "choice_a": "To assess the locking and unlocking of accounts after unsuccessful login attempts",
    "choice_b": "To remove all unlocked accounts",
    "choice_c": "To determine the complexity of passwords",
    "choice_d": "To determine the sharing of passwords among users",
    "correct_answer": "A",
    "explanation": "Examining user account lockout settings is essential in assessing how the system handles repeated unsuccessful login attempts, which can indicate potential security breaches or brute force attack attempts. By evaluating these settings, an auditor can determine whether accounts are appropriately locked after a certain number of failed attempts and ensure that unlocking procedures are secure and effectively manage risks. Removing all unlocked accounts is not a viable option, as user accounts need to remain active for legitimate access, and locking all accounts could disrupt business operations. Determining the complexity of passwords is a separate issue related to password policies, not directly related to lockout configurations, as lockout settings deal with failed login attempts rather than password characteristics. Similarly, determining password sharing among users is another aspect of identity management concerned with user behavior and policy compliance, not directly assessed by examining lockout settings.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      343,
      344,
      346,
      318,
      345
    ],
    "source": "9781394290116"
  },
  {
    "id": 971,
    "question": "Which is usually the best argument for a CISO not reporting to a CIO?",
    "choice_a": "Personality conflict",
    "choice_b": "Conflict of interest",
    "choice_c": "Separation of duties",
    "choice_d": "Regulation",
    "correct_answer": "B",
    "explanation": "A CISO should not ordinarily report to a CIO for conflict of interest reasons. The CISO will not be able to act with independence regarding IT personnel, controls, and processes. <p>Personality conflict is not necessarily a reason to change reporting lines. Separation of duties would not ordinarily be a reason to separate the CISO and CIO. Few, if any, regulations require the CIO and CISO to be in different reporting lines.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      9,
      45,
      47,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 972,
    "question": "Analysis of competitive information normally takes place during which phase of the systems development life cycle?",
    "choice_a": "Testing phase",
    "choice_b": "Design phase",
    "choice_c": "Requirements definition phase",
    "choice_d": "Feasibility study",
    "correct_answer": "D",
    "explanation": "Competitive analysis takes place during the feasibility study, prior to requirements definition, design, and testing phases. <p>Testing, design, and requirements definition are all incorrect because competitive analysis should take place prior to these phases.</p>",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      116,
      115,
      102,
      151,
      117
    ],
    "source": "9781394290116"
  },
  {
    "id": 973,
    "question": "Why would an IS auditor advise an organization to have a functional contingency plan in place during a cutover test?",
    "choice_a": "To provide guidance for personnel involved in the cutover process",
    "choice_b": "To speed up the cutover process",
    "choice_c": "To ensure rapid recovery of primary systems in the event of a cutover failure",
    "choice_d": "To enhance the organization’s ability to identify system bottlenecks",
    "correct_answer": "C",
    "explanation": "Ensuring rapid recovery of primary systems in the event of a cutover failure is the best answer because a functional contingency plan ensures that the organization can quickly restore operations if the cutover does not proceed as planned. Speeding up the cutover process is not the primary purpose of a contingency plan, as its focus is on managing risks, not efficiency. Providing guidance for personnel is a valid concern but is typically addressed through training or process documentation rather than a contingency plan. Enhancing the ability to identify system bottlenecks is unrelated to contingency planning and pertains more to performance testing and optimization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      153,
      132,
      121,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 974,
    "question": "In order to meet the BIA objective of creating a detailed list of all identifiable processes and systems, which method is usually used to gather process and system information?",
    "choice_a": "Network diagram review",
    "choice_b": "Documentation review",
    "choice_c": "Criticality analysis",
    "choice_d": "Questionnaire or intake form",
    "correct_answer": "D",
    "explanation": "A questionnaire or intake form is the instrument used to collect data so that all processes and systems may be identified. Other methods, such as documentation and network diagram review, may be helpful but will probably not capture all relevant data. <p>Network diagram review is incorrect because a network diagram is unlikely to reveal all business processes. Documentation review is incorrect because this is unlikely to reveal all business processes, particularly in less mature organizations that do not document all of their processes. Criticality analysis is incorrect because this examines business processes already identified by other means.</p>",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      233,
      246,
      235,
      240,
      185
    ],
    "source": "9781394290116"
  },
  {
    "id": 975,
    "question": "Which of the following entities retains ownership of internal IS audit engagements?",
    "choice_a": "Management",
    "choice_b": "Internal auditors",
    "choice_c": "Chief audit executive",
    "choice_d": "External auditors",
    "correct_answer": "C",
    "explanation": "The Chief Audit Executive (CAE) retains ownership of internal IS audit engagements because the CAE is responsible for overseeing and managing the internal audit function, including the planning, execution, and reporting of audit activities. This centralization of ownership ensures accountability and strategic oversight aligned with organizational objectives. Management does not retain ownership, as their role is to be the subject of audits and use the audit reports to improve processes and controls. Internal auditors conduct the audits but operate under the direction and ownership of the CAE. External auditors are independent of the internal audit process and focus on external assessments; hence, they do not own internal audit engagements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      357,
      352,
      61,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 976,
    "question": "Which of the following should be the final authority for notifying law enforcement in the event of a security breach?",
    "choice_a": "Chief information security officer",
    "choice_b": "General counsel",
    "choice_c": "Chief privacy officer",
    "choice_d": "Internal audit",
    "correct_answer": "B",
    "explanation": "The general counsel, whose job is to understand and interpret applicable laws and regulations, should have the final say in whether the organization notifies law enforcement in the event of a security breach. <p>The CISO, CPO, or IA should not be the party that approves notification of law enforcement.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      4,
      44,
      14,
      5,
      29
    ],
    "source": "9781394290116"
  },
  {
    "id": 977,
    "question": "Which of the following is out of scope for media management and destruction?",
    "choice_a": "Main memory",
    "choice_b": "Hard drive",
    "choice_c": "Hard copy",
    "choice_d": "Optical media",
    "correct_answer": "A",
    "explanation": "Main memory is out of scope for media management and destruction because it is volatile and typically does not require the same management and destruction processes as non-volatile storage mediums like hard drives, optical media, or hard copies. Main memory loses its contents when power is lost, making it less of a concern for long-term data exposure. In contrast, hard drives and optical media are forms of non-volatile storage that retain information even without power, necessitating careful management and secure destruction to prevent unauthorized data recovery. Similarly, hard copies represent physical documentation that can contain sensitive information, requiring established processes for their secure disposal to protect data confidentiality.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      182,
      183,
      193,
      203,
      250
    ],
    "source": "9781394290116"
  },
  {
    "id": 978,
    "question": "The CIS Benchmarks are an example of what kind of a document?",
    "choice_a": "Encryption standards",
    "choice_b": "Incident case history",
    "choice_c": "Hardening standard",
    "choice_d": "Maturity standard",
    "correct_answer": "C",
    "explanation": "The CIS Benchmarks are well-known hardening standards for common types of information systems. <p>The answer mentioning encryption is incorrect because CIS Benchmarks are not encryption standards but rather system-hardening standards. The answer referring to incident case history is incorrect because CIS Benchmarks are not an incident case history but rather system-hardening standards. The answer referring to maturity is incorrect because CIS Benchmarks are not maturity standards but rather system-hardening standards.</p>",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      313,
      264,
      336,
      305,
      350
    ],
    "source": "9781394290116"
  },
  {
    "id": 979,
    "question": "A network-based DLP should be deployed to prevent the loss of sensitive organizational information during email transmission through:",
    "choice_a": "Applying labels to information",
    "choice_b": "Monitoring all hosts for attack attempts",
    "choice_c": "Automatically applying encryption",
    "choice_d": "Allowing unencrypted transmissions to pass through",
    "correct_answer": "C",
    "explanation": "Automatically applying encryption is the correct approach for a network-based Data Loss Prevention (DLP) system to prevent the loss of sensitive information during email transmission. Encryption ensures that sensitive data remains unreadable to unauthorized parties, thus securing email contents as they traverse the network. Monitoring all hosts for attack attempts is more relevant to intrusion detection or prevention systems rather than DLP, which focuses on data protection. Applying labels to information is more associated with data classification and management; while important, it doesn’t actively prevent data loss during transmission. Allowing unencrypted transmissions to pass through runs counter to the objective of a DLP aimed at protecting sensitive information, as it would not prevent data interception by malicious actors.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      266,
      306,
      283,
      294,
      296
    ],
    "source": "9781394290116"
  },
  {
    "id": 980,
    "question": "The design of a database is known as its:",
    "choice_a": "Index",
    "choice_b": "View",
    "choice_c": "B-tree",
    "choice_d": "Schema",
    "correct_answer": "D",
    "explanation": "The design of a database is known as its schema. <p>Index is incorrect because an index is a structure that facilitates the rapid retrieval of data in a database. View is incorrect because a view is a mechanism that reveals data as a result of a search, as though it was persistent data. B-tree is incorrect because a B-tree is a type of binary search tree that facilitates the rapid retrieval of data in a database.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      177,
      186,
      180,
      179,
      206
    ],
    "source": "9781394290116"
  },
  {
    "id": 981,
    "question": "Which of the following IT risk assessment methods should an IS auditor employ if the goal involves the analysis of IT risk based on specific dollar figures?",
    "choice_a": "Critical path analysis",
    "choice_b": "Qualitative risk analysis",
    "choice_c": "Quantitative risk analysis",
    "choice_d": "Business impact analysis",
    "correct_answer": "C",
    "explanation": "Quantitative risk analysis is the appropriate method when analyzing IT risk based on specific dollar figures because it uses numerical data to estimate the financial impact of risks, often involving calculations of probability and potential loss. Qualitative risk analysis focuses on subjective assessments using categories such as high, medium, or low and does not provide specific monetary values. Business impact analysis identifies the effects of disruptions on business processes but is not primarily focused on financial quantification of IT risks. Critical path analysis is a project management tool for identifying the longest sequence of dependent tasks, unrelated to assessing IT risk in dollar terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      96,
      72,
      75,
      359,
      73
    ],
    "source": "9781394290116"
  },
  {
    "id": 982,
    "question": "What is the minimum standard interval for the retention of video surveillance data at a data center?",
    "choice_a": "28 days",
    "choice_b": "7 days",
    "choice_c": "30 days",
    "choice_d": "90 days",
    "correct_answer": "D",
    "explanation": "The standard interval for the retention of video security surveillance data is 90 days. <p>The answer options referring to 7 days, 28 days, and 30 days all are incorrect because they are shorter than the typical 90-day retention practice.</p>",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      296,
      350,
      346,
      304,
      349
    ],
    "source": "9781394290116"
  },
  {
    "id": 983,
    "question": "Which of the following is an important reason an IS auditor should recommend that the organization establish the maximum tolerable downtime (MTD) for each of its critical processes?",
    "choice_a": "To set the maximum level of tolerable risk",
    "choice_b": "To set the maximum acceptable data loss",
    "choice_c": "To ensure the continued survival of the organization during a disaster",
    "choice_d": "To assist in coordinating recovery efforts",
    "correct_answer": "C",
    "explanation": "Establishing the maximum tolerable downtime (MTD) for each critical process is crucial to ensure the organization’s continued survival during a disaster. This is because understanding the MTD allows the organization to prioritize its recovery efforts and allocate resources effectively to ensure that mission-critical processes are restored within a timeline that prevents severe operational or financial impact. Setting the MTD does not directly set the maximum acceptable data loss, as that is more related to recovery point objectives (RPOs) rather than MTD. Similarly, it is not about setting a maximum level of tolerable risk, which is more of an overarching risk management strategy rather than a focus on downtime. While MTD can assist in coordinating recovery efforts, its primary purpose is more about preventing organizational failure during disruptive events than the broader coordination of recovery efforts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      231,
      246,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 984,
    "question": "Which of the following is the best method for recovering a server whose root file system has become corrupted?",
    "choice_a": "Full restore",
    "choice_b": "Data restore",
    "choice_c": "Transaction log restore",
    "choice_d": "Rebuild from scratch",
    "correct_answer": "A",
    "explanation": "A full restore is the best method for recovering a server with a corrupted root file system because it restores the entire system, including the operating system, applications, and configurations, to a known good state. A data restore only recovers user files and does not address system-level corruption. A transaction log restore applies changes to a database but does not restore the operating system or file system. Rebuilding from scratch is time consuming and requires reconfiguring everything manually, making it less efficient than restoring from a full backup.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      239,
      183,
      226,
      202,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 985,
    "question": "Which of the following is one of the primary goals of a digital signature?",
    "choice_a": "To encrypt the message in transit",
    "choice_b": "To ensure fast arrival of the message",
    "choice_c": "To assure nonrepudiation by the sender",
    "choice_d": "To prove message ownership",
    "correct_answer": "C",
    "explanation": "A primary goal of a digital signature is to assure nonrepudiation by the sender. Digital signatures provide proof of the origin of a message, allowing the recipient to confirm that the message was indeed sent by the purported sender and preventing the sender from denying their involvement later. This is crucial for accountability and trust in digital communications. Ensuring the fast arrival of the message is not a function of digital signatures; that aspect pertains to the efficiency of the communication channel itself. Encrypting a message in transit is related to confidentiality, which is achieved through encryption methods, while digital signatures focus on authenticity and integrity. Proving message ownership is similar to nonrepudiation, but digital signatures specifically emphasize identity verification and real-time consent by the sender, rather than indicating ownership.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      286,
      282,
      284,
      285,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 986,
    "question": "Why would an auditor contact an audit client months after an audit has been completed?",
    "choice_a": "To inform the audit client that it is time for another audit",
    "choice_b": "To remind the audit client to complete its audit remediation",
    "choice_c": "To ask the audit client for a reference",
    "choice_d": "To show concern for the audit client and an interest in its success",
    "correct_answer": "D",
    "explanation": "Showing concern for the audit client and an interest in its success improves the auditor-auditee relationship. <p>It is generally not an auditor’s role to remind the client of an upcoming audit. Neither reminding an audit client of any needed audit remediation nor asking for a reference is the best answer.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      364,
      89,
      352,
      357,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 987,
    "question": "Why would an organization decide to discontinue using an older information system?",
    "choice_a": "The system has serious incompatibilities with new applications.",
    "choice_b": "The system complies with new laws and regulations.",
    "choice_c": "The system has recently been updated.",
    "choice_d": "The system has sufficient data storage space.",
    "correct_answer": "A",
    "explanation": "An organization might choose to discontinue an older information system if it has serious incompatibilities with new applications. This creates challenges in integrating with current technology and can hinder overall operational efficiency, making the system less viable in a modern IT environment. In contrast, compliance with new laws and regulations is generally a reason to keep or upgrade a system rather than discontinue it. If a system has recently been updated, it would likely improve its functionality and extend its lifespan, negating the need to discontinue it. A system with sufficient data storage space typically means it can continue to handle data needs effectively, which wouldn’t necessitate discontinuation. Incompatibility with new applications is the most stress-inducing factor, leading to potential system failure and increased costs, outweighing the reasons provided by the other options.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      13,
      1,
      16,
      7,
      42
    ],
    "source": "9781394290116"
  },
  {
    "id": 988,
    "question": "An auditor has observed that a process that lacks procedure documentation is performed by five persons and is performed consistently. What should the auditor conclude from this?",
    "choice_a": "Minor finding due to lack of process documentation",
    "choice_b": "Major finding due to lack of process documentation",
    "choice_c": "No finding",
    "choice_d": "Material weakness due to lack of process documentation",
    "correct_answer": "A",
    "explanation": "Because the process is performed consistently, an auditor would probably cite only a minor finding due to the lack of business process documentation. <p>Major finding is incorrect because the process is being performed consistently. No finding is incorrect because the lack of documentation should be considered a finding. Lack of process documentation is rarely grounds for a material weakness finding.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      74,
      75,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 989,
    "question": "DWT Limited seeks to ensure that its internal IS auditor can act independently when conducting audits. Which of the following ISACA standards addresses the IS auditor’s placement within the organizational structure to achieve this independence?",
    "choice_a": "Organizational independence",
    "choice_b": "Audit charter",
    "choice_c": "Reasonable expectation",
    "choice_d": "Objectivity",
    "correct_answer": "A",
    "explanation": "The concept of organizational independence is crucial for ensuring that an internal IS auditor can conduct audits independently. This ISACA standard specifically addresses where the IS auditor should be placed within the organization to maintain independence and unbiased auditing processes. An internal auditor’s organizational independence ensures that they are free from influence and can provide objective assessments of the entity’s controls, without interference from those being audited. An audit charter, while important, primarily defines the overarching purpose, authority, and responsibility of the audit function rather than focusing on independence per se. Reasonable expectation pertains more to the expectations placed on audit outcomes and deliverables, ensuring they are in line with stakeholder needs, rather than the structural independence of the auditing function. Objectivity relates to the auditor’s mindset and approach to performing audits free from bias but does not specifically handle the auditor’s placement within the organization, which directly impacts independence.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      358,
      60,
      99,
      68
    ],
    "source": "9781394290116"
  },
  {
    "id": 990,
    "question": "An employee is reading a document that describes levels of protection for information, along with handling guidelines. What kind of a document is the employee reading?",
    "choice_a": "Information security policy",
    "choice_b": "Data classification policy",
    "choice_c": "Data privacy policy",
    "choice_d": "Data disposal procedure",
    "correct_answer": "B",
    "explanation": "A document that instructs users on the levels of protection of information along with handling guidelines is better known as a data classification policy. <p>The answer referring to information security policy is incorrect because although such a policy may indeed contain levels of protection and handling guidelines, the best answer is a data classification policy. The answer mentioning data privacy policy is incorrect because, while a data privacy policy may indeed contain levels of protection and handling guidelines, the best answer is a data classification policy. Data disposal procedure is incorrect because this procedure describes the steps to be taken to destroy data.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      15,
      9,
      11,
      12
    ],
    "source": "9781394290116"
  },
  {
    "id": 991,
    "question": "As an IS auditor, which of the following do you expect to find from a review of an organizational chart?",
    "choice_a": "Lines of reporting and responsibility",
    "choice_b": "Key risk indicators",
    "choice_c": "Audit objectives",
    "choice_d": "Key performance indicators",
    "correct_answer": "A",
    "explanation": "An organizational chart is a visual representation of an organization’s structure, showing roles, responsibilities, and reporting lines. It is designed to clarify lines of reporting and responsibility, which are fundamental elements of organizational structure. Key risk indicators, while important for monitoring risks, do not pertain to structural relationships or hierarchy. Audit objectives are specific to the goals and focus areas of audits, unrelated to the depiction of organizational roles. Key performance indicators track progress toward strategic or operational goals and are also not part of an organizational chart’s purpose.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      54,
      43,
      44,
      4,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 992,
    "question": "The protocol data unit for the UDP protocol is:",
    "choice_a": "Datagram",
    "choice_b": "Checksum",
    "choice_c": "MTU",
    "choice_d": "Header",
    "correct_answer": "A",
    "explanation": "Protocol data unit (PDU) is the term used to describe a single unit of information transmitted through the protocol, and the PDU for the UDP protocol is the datagram. <p>Checksum is incorrect because a checksum is not a PDU but rather a part of a frame (or packet) used to ensure the integrity of the frame (or packet). MTU is incorrect because MTU (maximum transmission unit) is a specification of the largest frame or packet that may be transmitted on a network. Header is incorrect because a header is a part of a frame or packet that contains information about the source and/or destination of the frame or packet.</p>",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      320,
      305,
      306,
      319,
      283
    ],
    "source": "9781394290116"
  },
  {
    "id": 993,
    "question": "Which of the following cryptosystems uses a single shared secret key to enforce confidentiality?",
    "choice_a": "Symmetric cryptosystems",
    "choice_b": "Asymmetric cryptosystems",
    "choice_c": "Quantum cryptosystems",
    "choice_d": "Homomorphic cryptosystems",
    "correct_answer": "A",
    "explanation": "Symmetric cryptosystems use a single shared secret key to enforce confidentiality, where the same key is used for both encryption and decryption. Asymmetric cryptosystems use a pair of keys – public and private – making them different from symmetric cryptosystems. Quantum cryptosystems employ quantum properties for secure communication but do not rely on a single shared secret key. Homomorphic cryptosystems enable computations on encrypted data without decrypting it, focusing on data privacy during processing rather than simple confidentiality through a shared key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      283,
      289,
      282,
      284,
      286
    ],
    "source": "9781394290116"
  },
  {
    "id": 994,
    "question": "The CMMI is an example of what kind of a model?",
    "choice_a": "Control",
    "choice_b": "Risk",
    "choice_c": "Maturity",
    "choice_d": "Infrastructure",
    "correct_answer": "C",
    "explanation": "The CMMI, or Capability Maturity Model Integration, is a well-known maturity model used by organizations to understand the maturity of their business processes. <p>CMMI is not a control model. CMMI is not a risk model. CMMI is not an infrastructure model.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      39,
      53,
      17,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 995,
    "question": "Which of the following is the reason for validating the length of input data in each field?",
    "choice_a": "To prevent buffer-overflow attacks",
    "choice_b": "To spell-check the data",
    "choice_c": "To ensure accurate totals",
    "choice_d": "To produce hash totals",
    "correct_answer": "A",
    "explanation": "Validating the length of input data is primarily aimed at preventing buffer overflow attacks. Buffer overflow attacks occur when more data is entered into a field than it can handle, potentially leading to arbitrary code execution or system crashes, making length validation a critical security measure. Spell-checking the data would relate more to text correctness rather than security concerns, thus irrelevant for validation focused on input length. Ensuring accurate totals is related to data integrity but not specifically to input length validation, as it involves cross-verifying summation or similar operations. Producing hash totals is a method used for verifying data integrity but does not address the need to control input size specifically, making it unrelated to input length validation.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      264,
      266,
      322,
      285,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 996,
    "question": "The types of quality assurance methods involving IT personnel instead of end users include all of the following <i>except</i>:",
    "choice_a": "System testing",
    "choice_b": "Functional testing",
    "choice_c": "User acceptance testing (UAT)",
    "choice_d": "Quality assurance testing (QAT)",
    "correct_answer": "C",
    "explanation": "IT personnel perform system testing, functional testing, and quality assurance testing. End users perform user acceptance testing (UAT). <p>System testing, functional testing, and quality assurance testing are all incorrect because they are all performed by IT personnel and not by end users.</p>",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      121,
      153,
      105,
      120,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 997,
    "question": "Which category of government data classification requires data to have the highest degree of protection due to the potential for exceptionally grave damage if the data is disclosed?",
    "choice_a": "Top secret",
    "choice_b": "Secret",
    "choice_c": "Private",
    "choice_d": "Confidential",
    "correct_answer": "A",
    "explanation": "Top secret data classification requires the highest degree of protection because its unauthorized disclosure could lead to exceptionally grave damage to national security or organizational interests. This is a common classification in military and government contexts, indicating the critical nature of the information. Secret classification, while still significant, suggests that the release of information could cause serious damage, but not to the same extent as top secret. Private data classification typically refers to personal or sensitive information that should be protected from public viewing but does not necessitate the same high-level controls as top secret. Confidential data is generally considered sensitive and proprietary within an organization, with its unauthorized disclosure potentially causing damage; however, it is deemed less critical than top secret in terms of potential impact.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      11,
      9,
      40,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 998,
    "question": "A systems engineer is asserting to an auditor that patching a specific vulnerability in a base operating system also protects guest operating systems from the same vulnerability. How should the auditor respond?",
    "choice_a": "Agree, because only host OSs listen on the network",
    "choice_b": "Agree, because hypervisors pass immunity to their guests",
    "choice_c": "Disagree, because closing host OS vulnerabilities does not close guest OS vulnerabilities",
    "choice_d": "Disagree, because host OSs are not patched; only guest OSs are",
    "correct_answer": "C",
    "explanation": "Host and guest operating systems all need to be patched. <p>The answer stating that only host OSs listen on the network is incorrect; guest OSs also listen on the network. The answer stating that hypervisors pass immunity to their guests is incorrect because hypervisors do not pass immunity to their guests. The answer stating that only guest OSs are patched is incorrect because host OSs also need to be patched, in order to prevent their compromise by attackers.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      172,
      226,
      183,
      224
    ],
    "source": "9781394290116"
  },
  {
    "id": 999,
    "question": "During an audit, an IS auditor needs to verify that only authorized systems can establish communication with APIs. Which of the following safeguards is least relevant to this objective?",
    "choice_a": "Data controls",
    "choice_b": "Interface controls",
    "choice_c": "Access controls",
    "choice_d": "Firewalls",
    "correct_answer": "A",
    "explanation": "Data controls are the least relevant safeguard because they primarily focus on ensuring the accuracy, completeness, and integrity of data rather than restricting system communication with APIs. Interface controls are relevant as they manage how systems interact with APIs. Access controls are critical because they enforce authentication and authorization for systems connecting to APIs. Firewalls are also important as they help restrict unauthorized network-level access to the APIs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      309,
      314,
      306,
      324,
      310
    ],
    "source": "9781394290116"
  },
  {
    "id": 1000,
    "question": "An IT department has started performing a new procedure during which the IT manager reviews the central identity management system to review and approve privileged users. What kind of a control is this procedure?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Administrative",
    "choice_d": "Recovery",
    "correct_answer": "A",
    "explanation": "The privileged access review is a detective control because it is used to detect potentially unauthorized privileged access assignments. <p>“Preventive” is incorrect because this procedure does not prevent unwanted outcomes. “Administrative” is incorrect because an administrative control is generally implemented in the form of a policy. “Recovery” is incorrect because this procedure is not being used to recover a system.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      88,
      95,
      81,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 1001,
    "question": "An IS auditor in a large multinational mining company wishes to apply a risk-based auditing approach to all audits across various companies located around the globe. What is the <i>first</i> step the IS auditor should take in rolling out this program?",
    "choice_a": "Understand existing internal controls.",
    "choice_b": "Gather relevant information.",
    "choice_c": "Identify potential risks.",
    "choice_d": "Develop a risk-based audit program.",
    "correct_answer": "B",
    "explanation": "Gathering relevant information is the first step in applying a risk-based auditing approach because it lays the foundation for understanding the context in which the audit will occur, which includes company objectives, processes, and external factors. This understanding is crucial before identifying potential risks, which can only be accurately assessed with comprehensive background information. Understanding existing internal controls comes after identifying and assessing risks to evaluate how these controls mitigate identified risks. Developing a risk-based audit program is a subsequent step that relies on the information and analysis gathered from the previous steps, ensuring the program is effectively tailored to address specific risks. Identifying potential risks should follow the initial gathering phase, as it requires an understanding of both the external and internal environments of the auditing entity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      359,
      84,
      96,
      74,
      75
    ],
    "source": "9781394290116"
  },
  {
    "id": 1002,
    "question": "What is the purpose of requiring a third-party service provider to provide detailed metrics of its services?",
    "choice_a": "To ensure compliance with GDPR",
    "choice_b": "For purposes of reporting to regulator",
    "choice_c": "To understand how much to pay the service provider every month",
    "choice_d": "To ensure the third-party service provider meets quality standards",
    "correct_answer": "D",
    "explanation": "Third-party service providers are often required to produce metrics to ensure that quality standards are met. <p>GDPR does not necessarily require detailed metrics of the third-party service provider. Reporting to a regulator is a vague answer and would not necessarily require third-party metrics. Understanding how much to pay the service provider is incorrect because it would be more important to have this information for the purposes of determining the quality of the provider’s services rather than using this information to help determine monthly cost.</p>",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      34,
      56,
      51,
      37,
      33
    ],
    "source": "9781394290116"
  },
  {
    "id": 1003,
    "question": "Network devices can sometimes be identified based on the layer of the Open Systems Interconnection (OSI) Model at which they operate. Which of the following network devices typically operates at Layer 2?",
    "choice_a": "Firewall",
    "choice_b": "Switch",
    "choice_c": "Proxy",
    "choice_d": "Repeater",
    "correct_answer": "B",
    "explanation": "Switches operate at Layer 2 of the OSI Model, known as the Data Link Layer, where they use MAC addresses to forward data to the appropriate destination within a local area network (LAN). This functionality allows switches to efficiently manage traffic within a network by making forwarding decisions based on the devices connected to their ports. Firewalls, on the other hand, typically operate at Layers 3 (Network Layer) and above, inspecting and filtering traffic based on IP addresses and other criteria for security purposes. Proxies also operate at higher layers, typically the Application Layer (Layer 7), where they manage requests and responses between clients and servers, often for the purpose of anonymity or caching. Repeaters work at Layer 1, the Physical Layer, where they regenerate signals to extend the distance a network can cover without any data re-routing capabilities associated with Layer 2 devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      272,
      306,
      320,
      271,
      309
    ],
    "source": "9781394290116"
  },
  {
    "id": 1004,
    "question": "During which phase of the infrastructure development life cycle are systems verified for correct operation?",
    "choice_a": "Testing",
    "choice_b": "Maintenance",
    "choice_c": "Design",
    "choice_d": "Implementation",
    "correct_answer": "A",
    "explanation": "The testing phase is used to confirm correct design, implementation, and operation of a system. <p>Maintenance is incorrect because the maintenance phase is the entire period in which changes are made to a system in production. Design is incorrect because the design phase is used to create the makeup of the system; the system cannot at this time be verified because it has not been built. Implementation is incorrect because systems are verified not only during the testing portion of implementation, but in all testing after implementation.</p>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      153,
      115,
      120,
      122
    ],
    "source": "9781394290116"
  },
  {
    "id": 1005,
    "question": "The balanced scorecard (BSC) is used to measure how well an organization fares in meeting its objectives. Which of the following is <i>not</i> one of these perspectives?",
    "choice_a": "Internal processes",
    "choice_b": "External processes",
    "choice_c": "Financial",
    "choice_d": "Customer",
    "correct_answer": "B",
    "explanation": "The balanced scorecard (BSC) includes multiple perspectives to provide a comprehensive evaluation of an organization’s performance toward its objectives. The Financial perspective is a crucial component of the BSC as it measures the financial performance and profitability of the organization, which is fundamental for understanding the economic impact of its strategies. The Customer perspective is also a key component, focusing on customer satisfaction and relationships, which link directly to market performance. Internal processes are captured within the Internal perspective, a core element of BSC that examines internal operational goals and how well business processes align with organizational objectives. External processes, however, are not explicitly considered within the conventional BSC framework. Instead, the BSC focuses on factors that the organization can directly control and improve, emphasizing internal parameters over external.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      3,
      41,
      51,
      39,
      37
    ],
    "source": "9781394290116"
  },
  {
    "id": 1006,
    "question": "A security architect is developing a network design wherein end-user computers are regarded the same as end-user devices on the Internet. The security architect is using which model?",
    "choice_a": "Least privilege",
    "choice_b": "VDI",
    "choice_c": "Implicit trust",
    "choice_d": "Zero trust",
    "correct_answer": "D",
    "explanation": "The zero trust model assumes that, in this context, end-user devices are not to be trusted, and may even be hostile. <p>Least privilege is incorrect because this is related to access control. VDI is incorrect because this stands for virtual desktop infrastructure, which is not an architecture but a technology. Implicit trust is incorrect because “implicit trust” is not an information security architecture term.</p>",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      268,
      270,
      306,
      320,
      308
    ],
    "source": "9781394290116"
  },
  {
    "id": 1007,
    "question": "An IS auditor has completed a security posture review in an organization and discovered incidents of identity theft. After further investigation, the auditor discovers that those attacks were primarily the result of credential theft. Which of the following is effective in mitigating this risk?",
    "choice_a": "CASB",
    "choice_b": "MFA",
    "choice_c": "IPS",
    "choice_d": "IDS",
    "correct_answer": "B",
    "explanation": "MFA (Multi-Factor Authentication) is effective in mitigating the risk of identity theft because it requires users to provide multiple forms of verification (e.g., something they know, have, or are) to access systems, making it much harder for attackers to compromise accounts even if credentials are stolen. CASB (Cloud Access Security Broker) focuses on securing cloud applications and may help with broader security but does not directly prevent identity theft. IPS (Intrusion Prevention System) detects and blocks suspicious activities but is not specifically designed to address credential misuse. IDS (Intrusion Detection System) only identifies potential threats without actively mitigating them, making it less effective for directly addressing identity theft.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      315,
      319,
      281,
      298,
      345
    ],
    "source": "9781394290116"
  },
  {
    "id": 1008,
    "question": "An auditor has found that servers in the DMZ are using the RIP protocol. What should the auditor conclude from this?",
    "choice_a": "The server is dual-homed.",
    "choice_b": "The network is using archaic protocols.",
    "choice_c": "There are multiple paths to the Internet.",
    "choice_d": "The server’s NICs are operating in promiscuous mode.",
    "correct_answer": "B",
    "explanation": "RIP, or Routing Information Protocol, is an obsolete routing protocol that is not secure and not suitable for DMZ environments. <p>The answer mentioning a dual-homed server is incorrect because RIP is not associated with whether a server is dual-homed. The answer referring to multiple paths to the Internet is incorrect because the presence of RIP does not necessarily indicate multiple paths to the Internet; RIP could be in use because of the architecture of the internal network. The answer mentioning promiscuous mode is incorrect because promiscuous mode is related to network sniffing, not routing protocols.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      270,
      306,
      272,
      305,
      313
    ],
    "source": "9781394290116"
  },
  {
    "id": 1009,
    "question": "The key difference between business continuity planning (BCP) and disaster recovery planning (DRP) is that the DRP focuses more on:",
    "choice_a": "Less critical business functions",
    "choice_b": "Restoring of systems after a disaster",
    "choice_c": "Operational functions",
    "choice_d": "Human resources aspects of a recovery effort",
    "correct_answer": "B",
    "explanation": "Disaster Recovery Planning (DRP) focuses more on the restoring of systems after a disaster, as it specifically addresses the recovery of IT infrastructure, data, and technical operations to ensure business continuity. Less critical business functions are not the primary focus of DRP, as it prioritizes critical systems. Operational functions and human resources aspects of a recovery effort are covered more broadly under Business Continuity Planning (BCP), which ensures overall organizational resilience and continuity beyond just IT systems.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      240,
      231,
      235,
      234,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 1010,
    "question": "What is the essential minimum practice for administering security awareness training?",
    "choice_a": "At the time of hire",
    "choice_b": "Annually",
    "choice_c": "At the time of hire and quarterly thereafter",
    "choice_d": "At the time of hire and annually thereafter",
    "correct_answer": "D",
    "explanation": "The minimum essential practice for administering security awareness training is to require training at the time of hire and annually thereafter. <p>At the time of hire is incorrect because the standard for training is not only at the time of hire but also annually thereafter. Annually is incorrect because the standard for training is not only annually but also at the time of hire. At the time of hire and quarterly is incorrect because the standard for training is not quarterly but instead annually. Quarterly is, however, a good practice.</p>",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      298,
      303,
      340,
      345,
      300
    ],
    "source": "9781394290116"
  },
  {
    "id": 1011,
    "question": "An IS auditor would like to gain an understanding of a client’s operating procedures. Which of the following should the IS auditor perform to realize this goal?",
    "choice_a": "Review available instruction manuals.",
    "choice_b": "Conduct walkthroughs.",
    "choice_c": "Review management procedure documentation.",
    "choice_d": "Utilize control checklists.",
    "correct_answer": "B",
    "explanation": "Conducting walkthroughs is the most effective way for an IS auditor to gain an understanding of a client’s operating procedures as it allows for real-time observation of processes and provides an opportunity to ask questions and obtain clarifications from personnel performing the tasks. This interactive approach gives insight into the actual execution of operations compared to the theoretical or documented procedures. Reviewing instruction manuals and management procedure documentation can offer some level of understanding but may not reflect real practices or informal controls that are not documented. Utilizing control checklists is a useful tool to ensure that specific controls are in place or to assess compliance, but it does not provide a holistic overview of operating procedures or their practical implementation.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      91,
      90,
      74,
      359,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 1012,
    "question": "What is the purpose of assigning severity levels to security incidents?",
    "choice_a": "To apply an appropriate level of reporting",
    "choice_b": "To determine the method of evidence collection",
    "choice_c": "To apply an appropriate level and type of response",
    "choice_d": "To determine the method of evidence protection",
    "correct_answer": "C",
    "explanation": "The purpose of assigning severity levels to a security incident is to bring the right level of resources to respond to the incident, and to notify specific personnel according to severity level. <p>The answer referring to an appropriate level of reporting is incorrect because severity levels are not only about reporting levels but also for determining the level and type of response. The answer that mentions the method of evidence collection is incorrect because severity levels are not related only to levels or types of evidence collection. The answer that refers to evidence protection is incorrect because severity levels are not related only to evidence protection but instead are mainly about response procedures overall.</p>",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      300,
      299,
      256,
      347,
      263
    ],
    "source": "9781394290116"
  },
  {
    "id": 1013,
    "question": "An employee at a large retail organization receives an unexpected email requesting them to update their account details. A link is also included in the email. Which of the following represents the <i>best</i> approach the employee should take in this scenario?",
    "choice_a": "Open the email link.",
    "choice_b": "Report to ICT, and delete the mail.",
    "choice_c": "Forward the email link to ICT.",
    "choice_d": "Store the link in the email archive.",
    "correct_answer": "B",
    "explanation": "Reporting the email to your Information and Communications Technology (ICT) department and deleting it is the best course of action because it minimizes the risk of falling for a phishing attempt while allowing the IT department to investigate and potentially mitigate any threat to the organization. Opening the email link is risky because it could lead to a phishing website designed to steal personal information or install malware. Forwarding the email link to ICT could potentially spread the phishing content or malicious link further, depending on the email software and company policies regarding such content. Storing the link in the email archive is not advisable because it preserves the potential threat, possibly compromising future email security or inadvertently leading to the malicious link being accessed later.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      300,
      264,
      256,
      258
    ],
    "source": "9781394290116"
  },
  {
    "id": 1014,
    "question": "An auditor is conducting a walkthrough of security configurations on production servers. Flat files are not available because the configuration data exists in an encrypted file. Which of the following is the best method for collecting evidence of security configurations?",
    "choice_a": "Ask the engineer to take screenshots during the walkthrough, which are given to the auditor during the session.",
    "choice_b": "Ask the engineer to take screenshots during the walkthrough, which can be sent via email.",
    "choice_c": "Ask the engineer to take screenshots after the walkthrough, which can be sent via email.",
    "choice_d": "Ask the engineer to write a narrative that lists the requested security configurations.",
    "correct_answer": "A",
    "explanation": "Obtaining screenshots that capture requested security configurations and then giving those screenshots to the auditor during the walkthrough nearly eliminates the possibility that the interviewee might falsify the information. <p>It is incorrect to ask the engineer to take screenshots during the walkthrough and send them via email because he could manipulate or substitute screenshots before mailing them to the auditor. It is incorrect to ask the engineer to take screenshots after the walkthrough because he could take screenshots of a different system or manipulate the screenshots. It is incorrect to ask the engineer to write a narrative because a narrative does not represent direct evidence from the system being audited.</p>",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      90,
      91,
      89,
      360,
      84
    ],
    "source": "9781394290116"
  },
  {
    "id": 1015,
    "question": "As an IS auditor, which of the following would you consider the <i>most</i> critical determinant in allocating resources for an audit engagement?",
    "choice_a": "The availability of skilled personnel",
    "choice_b": "The purpose and scope of the audit",
    "choice_c": "The extent of the organization’s geographic footprint",
    "choice_d": "The availability of automated audit tools",
    "correct_answer": "B",
    "explanation": "The purpose and scope of the audit are the most critical determinant in the allocation of resources for an audit engagement because they define the audit’s objectives, breadth, and depth, ensuring resources are allocated effectively and efficiently to address the most crucial areas. Without a clear understanding of what the audit aims to achieve and how broad it will be, it’s difficult to allocate resources such as time, personnel, and tools appropriately. While the availability of skilled personnel is important, it follows the determination of scope and purpose, as the necessary skill set is based on these factors. The extent of the organization’s geographic footprint is a logistical consideration that affects the audit plan rather than the initial allocation of resources based on criticality. The availability of automated audit tools, while beneficial for efficiency, is secondary to defining what needs to be achieved through the audit, as tools should be selected based on the audit’s specific requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      85,
      367,
      61,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 1016,
    "question": "A new IT leader in an organization wants to introduce quality management into the IT organization. Which is the best standard to use as a reference?",
    "choice_a": "ISO 9000",
    "choice_b": "ISO 27001",
    "choice_c": "ISO 27002",
    "choice_d": "IT BSC",
    "correct_answer": "A",
    "explanation": "ISO 9000 is the world-recognized standard for quality management systems. While initially targeting manufacturing, software development and IT organizations are known to employ ISO 9000 as well. <p>ISO 27001 is incorrect because it is a security management standard. ISO 27002 is incorrect because it is a security controls framework. IT BSC is incorrect because it is the IT balanced scorecard, a reporting methodology.</p>",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      37,
      2,
      27,
      39,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 1017,
    "question": "Which of the following represents a key component in commencing a program?",
    "choice_a": "Appointing a nontechnical program manager",
    "choice_b": "Development of a program charter",
    "choice_c": "Appointing the CEO as the program sponsor",
    "choice_d": "Setting a tight program timeline",
    "correct_answer": "B",
    "explanation": "The development of a program charter is critical in commencing a program because it serves as a formal document that defines the program’s objectives, scope, stakeholders, and high-level requirements. This foundational document provides guidance and benchmarks for decision-making and aligns stakeholders with the program’s purpose and direction. Appointing a non-technical program manager might not cater to all programs, especially those needing technical expertise. Although appointing the CEO as a program sponsor can be valuable for support and visibility, it may not always be practical or necessary for every program, depending on its size or strategic importance. Setting a tight program timeline can add unnecessary pressure and may compromise the quality and feasibility of the program deliverables.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      102,
      103,
      116,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 1018,
    "question": "Which of the following is a process model <i>not</i> developed by ISACA?",
    "choice_a": "COBIT",
    "choice_b": "The Risk IT Framework",
    "choice_c": "Val IT",
    "choice_d": "CMMI",
    "correct_answer": "D",
    "explanation": "CMMI was developed by Carnegie-Mellon University. <p>COBIT, the Risk IT Framework, and Val IT were developed by ISACA.</p>",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      41,
      24,
      39,
      37,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 1019,
    "question": "An organization plans to establish terms and conditions in its use of external audit services. Which of the following is the primary consideration for establishing audit terms on turnaround time for requests from external auditors?",
    "choice_a": "Schedule of IT upgrades",
    "choice_b": "Availability of key personnel",
    "choice_c": "Availability of the CEO",
    "choice_d": "Terms for payment of audit fees",
    "correct_answer": "B",
    "explanation": "The primary consideration for establishing audit terms on turnaround time for requests from external auditors is the availability of key personnel, as they are essential for providing information and support during the audit process. The schedule of IT upgrades, while important for system stability, is not directly tied to meeting audit requests. The availability of the CEO is rarely relevant for routine audit requests, as these are typically handled by operational or financial personnel. Terms for payment of audit fees pertain to the financial agreement but do not influence the turnaround time for handling auditor requests.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      357,
      85,
      354,
      89,
      367
    ],
    "source": "9781394290116"
  },
  {
    "id": 1020,
    "question": "A security manager has implemented hidden-camera video surveillance at the data center ingress and egress points. What type of control is this surveillance?",
    "choice_a": "Stealth",
    "choice_b": "Deterrent",
    "choice_c": "Preventive",
    "choice_d": "Detective",
    "correct_answer": "D",
    "explanation": "Video surveillance where cameras and other apparatus are hidden serves as a detective control. When video surveillance equipment is visible, it acts as a deterrent and detective control. <p>“Stealth” is incorrect because “stealth” is not a control category. “Deterrent” is incorrect because the video surveillance system cannot be seen by personnel. “Preventive” is incorrect because a video surveillance system does not prevent unwanted events.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      81,
      83,
      84
    ],
    "source": "9781394290116"
  },
  {
    "id": 1021,
    "question": "Which of the following is the primary purpose of migration testing during the IT system testing phase of the SDLC?",
    "choice_a": "To validate system functionalities",
    "choice_b": "To verify that data is properly imported from an old system onto the new system",
    "choice_c": "To verify whether user requirements were met",
    "choice_d": "To verify that individual modules interface properly",
    "correct_answer": "B",
    "explanation": "Migration testing’s primary purpose during the IT system testing phase is to ensure that data is correctly transferred from an old system to a new one. This testing is crucial because it helps verify data integrity and consistency during the transition process, addressing potential issues such as data loss or corruption that may arise during migration. Validating system functionalities pertains to functional testing rather than migration testing, as it focuses on whether the system performs specific functions as intended. Assessing whether user requirements are met falls under acceptance testing, where the implemented system is verified against the initial requirements specified by the users or stakeholders. Verifying the proper interface of individual modules is part of integration testing, which examines how different components of a system work together, rather than focusing on data migration from a previous system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      153,
      158,
      156
    ],
    "source": "9781394290116"
  },
  {
    "id": 653,
    "question": "All of the following are considered risks to a software development project <i>except</i>:",
    "choice_a": "Delivered software not adequately meeting business needs",
    "choice_b": "Delays in software escrow",
    "choice_c": "Purchased software not meeting efficiency needs",
    "choice_d": "Key design personnel resigning from the organization",
    "correct_answer": "B",
    "explanation": "Delay of software escrow is not considered a risk to a project. <p>Delivered software not adequately meeting business needs, purchased software not meeting efficiency needs, and key design personnel resigning from the organization are all incorrect because they are all considered risks to a software development project.</p>",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      127,
      110,
      102,
      116,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 1022,
    "question": "Which of the following is the main reason for an organization to implement a “gate process” approach in its systems development life cycle (SDLC) processes?",
    "choice_a": "To remove the need for project reviews",
    "choice_b": "To review and approve each phase before proceeding",
    "choice_c": "To address project challenges during each phase",
    "choice_d": "To assess the amount of funds utilized at each phase",
    "correct_answer": "B",
    "explanation": "Implementing a “gate process” in the systems development life cycle (SDLC) is primarily to review and approve each phase before proceeding. This structured approach ensures that all requirements and assessments are satisfied before advancing to the next phase, which helps maintain project integrity and alignment with organizational goals. Removing the need for project reviews contradicts the purpose of a gate process, which is inherently about periodic evaluation and assessment. Addressing project challenges during each phase is broader than what a gate process specifically targets, as the primary focus of the gate process is approval based on meeting specific criteria rather than resolving issues. Assessing the amount of funds utilized at each phase may be a component of the gate process but is not the main reason for its implementation, as the focus is more on project verification and viability than solely financial tracking.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      115,
      116,
      117,
      151,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 1023,
    "question": "An auditor is performing a walkthrough of a server environment. Regarding a set of production servers, the systems engineer has told the auditor that the systems are operating in an “active-active” configuration. What can the auditor conclude from this?",
    "choice_a": "The servers occupy different VLANs.",
    "choice_b": "The servers are part of a cluster.",
    "choice_c": "The servers employ multiple power supplies and NICs.",
    "choice_d": "These are database management systems.",
    "correct_answer": "B",
    "explanation": "“Active-active” refers to a specific server cluster architecture in which all servers are actively performing production tasks. <p>The answer referring to different VLANs is incorrect because active-active is related to server clustering, not their association with VLANs. The answer mentioning multiple power supplies and NICs is incorrect because active-active is unrelated to multiple power supplies and NICs. The answer referring to database management systems is incorrect because other types of servers besides database servers can be in a cluster in active-active configuration.</p>",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      201,
      195,
      187,
      183,
      224
    ],
    "source": "9781394290116"
  },
  {
    "id": 1024,
    "question": "Why would an IS auditor perform qualitative risk analysis before undertaking quantitative risk analysis?",
    "choice_a": "To be precise on the financial impacts of threats",
    "choice_b": "To identify the most critical risks quickly before undertaking risk quantification",
    "choice_c": "To reduce the extent of risk analysis",
    "choice_d": "To measure risk in numerical terms",
    "correct_answer": "B",
    "explanation": "Performing qualitative risk analysis before quantitative risk analysis allows an IS auditor to quickly identify the most critical risks. This step is essential because it provides a clear understanding of areas that require immediate focus and helps prioritize risks based on factors like impact and likelihood without delving into complex calculations. Identifying critical risks promptly sets a foundation for more detailed analysis. This approach does not strive for precision in the financial impacts of threats, which is a goal of quantitative analysis. It does not aim to reduce the extent of risk analysis; rather, it ensures that the subsequent quantitative analysis is more directed and efficient. Measuring risk in numerical terms is the essence of quantitative risk analysis, not qualitative.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      72,
      96,
      84,
      75,
      359
    ],
    "source": "9781394290116"
  },
  {
    "id": 1025,
    "question": "What is the purpose of an MDM platform?",
    "choice_a": "Active management and protection of smartphones, tablets, and laptop computers",
    "choice_b": "Monitoring of data exfiltration",
    "choice_c": "Prevention of data exfiltration",
    "choice_d": "User self-service password reset",
    "correct_answer": "A",
    "explanation": "An MDM (mobile device management) system is used to manage and protect mobile devices, including smartphones, tablets, and laptop computers. <p>Monitoring of data exfiltration is incorrect because an MDM system is not used to monitor data exfiltration but rather to manage mobile endpoints. Prevention of data exfiltration is incorrect because an MDM is not used to prevent data exfiltration but instead is used to manage mobile endpoint systems. User self-service password reset is incorrect because an MDM is not used for self-service password reset but rather to manage mobile endpoint systems.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      269,
      266,
      268,
      265,
      313
    ],
    "source": "9781394290116"
  },
  {
    "id": 1026,
    "question": "An IS auditor is evaluating the procedures used to set up and manage systems in an organization. They are most concerned about ensuring that security settings are properly deployed on various systems. Which of the following items would be most appropriate to examine?",
    "choice_a": "Systems operations procedures",
    "choice_b": "Systems configuration standards",
    "choice_c": "Disaster recovery procedures",
    "choice_d": "Systems update processes",
    "correct_answer": "B",
    "explanation": "Systems configuration standards are critical for an IS auditor to examine because these standards provide the baseline for how systems should be configured to ensure consistency, security, and compliance across the organization’s IT infrastructure. Configuration standards help prevent unauthorized changes and secure the environment against vulnerabilities. Systems operations procedures focus on the day-to-day functioning of the system, which, while important, do not specifically address the configuration settings. Disaster recovery procedures are concerned with restoring systems after a disruption, not with their initial setup and configuration. Systems update processes pertain to how software updates are handled, which, while part of system maintenance, do not provide the comprehensive view needed for initial configuration settings. Therefore, configuration standards directly relate to ensuring the correct settings are applied initially, which is why they are the aspect the auditor should examine.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      183,
      169,
      226,
      225,
      173
    ],
    "source": "9781394290116"
  },
  {
    "id": 1027,
    "question": "Which form of attack always involves the exploitation of a previously unknown vulnerability?",
    "choice_a": "Evil twin attack",
    "choice_b": "Zero-day attack",
    "choice_c": "DDoS attack",
    "choice_d": "Social engineering attack",
    "correct_answer": "B",
    "explanation": "A zero-day attack always involves exploiting a previously unknown vulnerability because it targets software flaws that developers are unaware of and have not yet patched. Evil twin attacks involve setting up fake wireless networks to trick users into connecting, which does not depend on exploiting unknown vulnerabilities. DDoS attacks overwhelm a system with traffic to disrupt its operations, relying on resource exhaustion rather than undisclosed flaws. Social engineering attacks manipulate individuals into revealing sensitive information or performing actions, focusing on human behavior rather than exploiting software vulnerabilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      293,
      292,
      312,
      322,
      308
    ],
    "source": "9781394290116"
  },
  {
    "id": 1028,
    "question": "Which of the following is used to illustrate the flow of information, in business terms, between IT applications?",
    "choice_a": "Zachman model",
    "choice_b": "OSI model",
    "choice_c": "Data flow diagram (DFD)",
    "choice_d": "Clark-Wilson model",
    "correct_answer": "C",
    "explanation": "A data flow diagram (DFD) is used to illustrate the flow of information between IT applications in business terms. It visually represents how data moves through a system, including inputs, processes, storage, and outputs. The Zachman model is a framework for enterprise architecture that organizes information about an organization but does not specifically illustrate data flow. The OSI model describes networking layers and how data is transmitted over a network, rather than how information flows between business applications. The Clark-Wilson model is a security model focused on maintaining data integrity through well-formed transactions and separation of duties, not on illustrating data movement.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      13,
      43,
      54,
      19,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 1029,
    "question": "An IS auditor has observed that the software development team and the operations team are often involved in conflict, leading to the development of insecure software. Which of the following is effective in resolving such conflicts and ensuring the development of secure software?",
    "choice_a": "DevSecOps",
    "choice_b": "Agile",
    "choice_c": "Scrum",
    "choice_d": "DevOps",
    "correct_answer": "A",
    "explanation": "DevSecOps is effective in resolving conflicts between software development and operations teams while ensuring the development of secure software, as it integrates security practices into every part of the software development life cycle. This approach fosters collaboration among development, security, and operations teams, emphasizing the importance of security from the outset. The focus is on automating security checks and processes, which helps in early detection and resolution of security issues. Agile, although it promotes collaboration among cross-functional teams and can include security practices, primarily concentrates on delivering iterative and incremental project progress and may not inherently emphasize security. Scrum focuses on the management and organization of team tasks within a framework that supports Agile processes but does not explicitly include security considerations in its practice. DevOps enhances collaboration between development and operations teams for faster and more reliable software delivery but, similarly, does not explicitly integrate security considerations throughout the development life cycle. Therefore, although Agile, Scrum, and DevOps improve general collaboration and efficiency, they do not specifically address security integration as DevSecOps does.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      124,
      114,
      120,
      152,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 1030,
    "question": "In the context of routers and firewalls, which of the following best describes the use of access control lists (ACLs)?",
    "choice_a": "Access control lists audit network traffic for certain characteristics but allow it to pass unfiltered.",
    "choice_b": "Access control lists are packet-filtering rules that make allow/deny decisions based on IP address, port, service, and other criteria.",
    "choice_c": "Access control lists determine who has administrative access to the router or firewall.",
    "choice_d": "Access control lists filter inbound network traffic only.",
    "correct_answer": "B",
    "explanation": "In the context of network border devices, such as routers and firewalls, ACLs filter network traffic by criteria such as port, protocol, service, and host/destination IP address. <p>The answer stating that ACLs allow network traffic to pass unfiltered is incorrect because ACLs do not “audit” network traffic. The answer referring to administrative access to the router or firewall is incorrect because ACLs do not determine who has administrator access to a router or firewall (however, ACLs can be used to limit the origins of administrator logons to network devices). The answer stating that only inbound traffic is filtered is incorrect because ACLs can be used to filter both inbound and outbound traffic, or either, or neither.</p>",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      314,
      309,
      306,
      270,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 1031,
    "question": "An IS auditor provides advice to management to apply for cyber-risk insurance coverage in response to some of its cyber risks. Which of the following forms of risk treatment does this advice represent?",
    "choice_a": "Risk transference",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk mitigation",
    "correct_answer": "A",
    "explanation": "Applying for cyber-risk insurance represents risk transference because the financial impact of cyber risks is shifted to the insurance provider. Risk avoidance involves eliminating the risk entirely, such as by discontinuing a risky activity. Risk acceptance means acknowledging the risk and choosing not to act, accepting any potential losses. Risk mitigation involves reducing the likelihood or impact of the risk through controls or measures, which is not the case with transferring financial liability via insurance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      24,
      16,
      20,
      21
    ],
    "source": "9781394290116"
  },
  {
    "id": 1032,
    "question": "All of the following are top-level processes in the PRINCE2 project management framework <i>except</i>:",
    "choice_a": "Defining Requirements (DR)",
    "choice_b": "Starting Up a Project (SU)",
    "choice_c": "Directing a Project (DP)",
    "choice_d": "Managing Product Delivery (MP)",
    "correct_answer": "A",
    "explanation": "Defining Requirements is not one of the top-level processes in the PRINCE2 project management framework. <p>Starting Up a Project (SU), Directing a Project (DP), and Managing Product Delivery (MP) are all part of PRINCE2 top-level processes.</p>",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      113,
      115,
      111,
      106,
      105
    ],
    "source": "9781394290116"
  },
  {
    "id": 1033,
    "question": "Which of the following artifacts is not part of effective IT governance?",
    "choice_a": "Audit program",
    "choice_b": "Resource management",
    "choice_c": "Standards",
    "choice_d": "Policy",
    "correct_answer": "A",
    "explanation": "An audit program is not considered a core artifact of effective IT governance. IT governance focuses on establishing structures, policies, and processes to ensure that IT aligns with business objectives, typically involving resource management, standards, and policies. Resource management ensures optimal use of IT resources, standards provide consistent practices, and policies establish rules and guidelines. An audit program, although important for evaluating compliance and effectiveness, is a tool for assessment rather than a foundational element of governance itself.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      1,
      2,
      15,
      12,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 1034,
    "question": "What is a technique used to distribute a problem or task to several computers at the same time, taking advantage of the processing power of each, to solve the problem or complete the task in less time?",
    "choice_a": "Server clusters",
    "choice_b": "Grid computing",
    "choice_c": "Cloud computing",
    "choice_d": "Network-attached storage",
    "correct_answer": "B",
    "explanation": "Grid computing is a technique used to distribute a problem or task to several computers at the same time, taking advantage of each computer’s processing power to solve the problem or complete the task in less time. Grid computing is a form of distributed computing, but in grid computing the computers are coupled more loosely and the number of computers participating in the solution of a problem can be dynamically expanded or contracted at will. <p>“Server clusters” is incorrect because computers in server clusters perform individual tasks. “Cloud computing” is incorrect because this represents the use of virtual servers or services that are hosted by external organizations. “Network-attached storage” is incorrect because this is used to store information and is accessed over a network.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      201,
      195,
      188,
      196,
      206
    ],
    "source": "9781394290116"
  },
  {
    "id": 1035,
    "question": "Which of the following situations is most likely to impair an IS auditor’s independence and internal audit objectivity?",
    "choice_a": "The IS auditor operated a payroll system subject to audit in the past month.",
    "choice_b": "The IS auditor provides advice on the implementation of an ERP system.",
    "choice_c": "The IS auditor does not hold the CISA qualification.",
    "choice_d": "The IS auditor did not report CPE credits in the past year.",
    "correct_answer": "A",
    "explanation": "An IS auditor’s independence and internal audit objectivity are most likely impaired if they operated a payroll system subject to audit in the past month, as this directly involves them in the operations they are supposed to audit, creating a conflict of interest and a bias due to their prior involvement. Advising on the implementation of an enterprise resource planning (ERP) system does not inherently impair independence or objectivity because providing advice is different from making decisions; auditors can still independently review the system after implementation. Not holding the CISA qualification does not directly impair independence or objectivity, as it is a credential for demonstrating knowledge rather than a requirement for unbiased auditing work. Failing to report CPE credits affects professional credentials and continuous education but does not impact the ability to remain independent or objective in auditing tasks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      358,
      69,
      60,
      357,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 1036,
    "question": "Which of the following does <i>not</i> describe ethical standards for auditors?",
    "choice_a": "2005, Due Professional Care",
    "choice_b": "1207, Irregularities and Illegal Acts",
    "choice_c": "1204, Performance and Supervision",
    "choice_d": "ISACA Code of Professional Ethics",
    "correct_answer": "C",
    "explanation": "1204, Performance and Supervision because it addresses the operational aspects of conducting an audit, focusing on how audit work should be performed and overseen rather than outlining ethical behavior. In contrast, Due Professional Care (2005) directly relates to ethical standards by emphasizing the responsibility of auditors to apply skill and diligence in their work. Standard 1207, Irregularities and Illegal Acts pertains to the auditor’s duty to recognize and respond to unethical or unlawful behavior, aligning closely with ethical obligations. The ISACA Code of Professional Ethics explicitly defines the ethical principles auditors must follow, such as integrity, objectivity, and confidentiality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      70,
      358,
      71,
      94
    ],
    "source": "9781394290116"
  },
  {
    "id": 1037,
    "question": "During an exit meeting, the IT audit director reported that the requirements specification document did not include all the security requirements. All of the following should form part of the security requirements <i>except</i>:",
    "choice_a": "IT value delivery",
    "choice_b": "Encryption",
    "choice_c": "Authentication",
    "choice_d": "Authorization",
    "correct_answer": "A",
    "explanation": "IT value delivery should not form part of the security requirements because it focuses on ensuring that IT investments deliver business value, which is a strategic and governance concern rather than a security-specific requirement. Encryption is critical for protecting data confidentiality. Authentication ensures that only authorized users can access systems or data. Authorization determines what actions authenticated users are allowed to perform, ensuring that appropriate access controls are in place. These elements are fundamental to a security requirements specification.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      117,
      118,
      151,
      152,
      149
    ],
    "source": "9781394290116"
  },
  {
    "id": 1038,
    "question": "Which software development methodology is characterized by small, highly experienced development teams; integrated development tools; and frequent design sessions with end users?",
    "choice_a": "Data-oriented system development (DOSD)",
    "choice_b": "Rapid application development (RAD)",
    "choice_c": "Object-oriented (OO) system development",
    "choice_d": "Component-based development",
    "correct_answer": "B",
    "explanation": "RAD is a response to the slower and more structured application development methodologies (such as waterfall) that were developed in the 1970s. Among its characteristics are small, highly experienced development teams; integrated development and design tools; and frequent design and analysis sessions with end users. <p>DOSD is incorrect because data-oriented system development is a data-centric design often found in large environments such as airline reservation systems. OO is incorrect because object-oriented system development is a concept that is based on objects, methods, classes, and inheritance. Component-based development is incorrect because this is based on a system architecture consisting of components that operate separately in support of the whole.</p>",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      124,
      125,
      115,
      120,
      121
    ],
    "source": "9781394290116"
  },
  {
    "id": 1039,
    "question": "Which of the following represents a valid reason for hiring contractors or consultants during seasonal periods?",
    "choice_a": "Varying demand",
    "choice_b": "Financial discipline",
    "choice_c": "Lack of skills",
    "choice_d": "High labor turnover",
    "correct_answer": "A",
    "explanation": "Hiring contractors or consultants during seasonal periods is typically due to varying demand. Seasonal fluctuations can greatly affect workload, necessitating a temporary increase in the workforce that contractors and consultants can fulfill, offering the flexibility to scale up or down as needed. This is distinct from issues like financial discipline, which relates more to internal fiscal management practices rather than staffing decisions aligned with demand fluctuations. A lack of skills relates to a shortage of specific expertise rather than the cyclical nature of work volume; if skills were consistently absent, hiring permanent staff could be a better solution. High labor turnover also would not typically justify employing temporary workers, as this is an ongoing issue, whereas contractors are more suited to addressing temporary peaks in workload rather than persistent staffing problems.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      27,
      34,
      42,
      57
    ],
    "source": "9781394290116"
  },
  {
    "id": 1040,
    "question": "In a risk-based audit:",
    "choice_a": "Auditors perform a risk assessment while performing an audit.",
    "choice_b": "The results of a risk assessment determine which areas warrant additional audit scrutiny.",
    "choice_c": "Auditors determine which audit findings constitute the highest risks.",
    "choice_d": "Management determines which areas warrant additional audit scrutiny.",
    "correct_answer": "B",
    "explanation": "A risk assessment performed prior to an audit helps auditors better understand which processes, systems, or locations should receive greater scrutiny in an upcoming audit. <p>The answer that refers to performing a risk assessment during the audit is incorrect because auditors perform a risk assessment prior to the audit. The answer that states that auditors determine the highest risks is incorrect because risks are determined prior to the audit. The answer referring to determination by management is incorrect because management should not direct the course of the audit.</p>",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      72,
      359,
      84,
      70,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 1041,
    "question": "Which of the following categories of utility software encompasses tools that are used to manipulate, query, and import and export data in an organization?",
    "choice_a": "Data management",
    "choice_b": "Data manipulation",
    "choice_c": "Systems health",
    "choice_d": "Software testing",
    "correct_answer": "A",
    "explanation": "Data management is the most suitable category of utility software for tools that are used to manipulate, query, import, and export data in an organization. These tools are specifically designed to handle data-related tasks, facilitating organization-wide data handling and integration processes. Data manipulation, although seemingly similar, typically refers to the specific act of altering data to achieve a desired format or structure, not encompassing the full range of data management activities. Systems health tools relate to monitoring and maintaining the performance and integrity of IT systems, not managing or processing data. Software testing involves verifying and validating software functionality and performance, which is unrelated to the direct handling of organizational data for import, export, or manipulation purposes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      180,
      177,
      203,
      204,
      184
    ],
    "source": "9781394290116"
  },
  {
    "id": 1042,
    "question": "Which network device uses only physical (hardware) addresses to forward traffic?",
    "choice_a": "Gateway",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "A switch will listen to traffic, learn the MAC address(es) associated with each port (connector), and send packets only to destination ports. <p>“Gateway” is incorrect because a gateway does not so much forward traffic as it does translate or transform traffic. “Router” is incorrect because a router uses IP addresses to forward traffic from one network to another. “Firewall” is incorrect because firewalls are used to block packets based on the firewall’s rules.</p>",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      272,
      270,
      320,
      269,
      271
    ],
    "source": "9781394290116"
  },
  {
    "id": 1043,
    "question": "You have been requested to perform an application vulnerability analysis. Which of the following strategies would you deploy to effectively manage a large number of applications?",
    "choice_a": "Prioritize the analysis of critical applications.",
    "choice_b": "Analyze each application individually.",
    "choice_c": "Perform a single analysis for all applications.",
    "choice_d": "Prioritize the analysis of all intangible assets.",
    "correct_answer": "A",
    "explanation": "Prioritizing the analysis of critical applications is the most effective strategy for managing a large number of applications because it allows the organization to focus its resources on the most important systems that could have the biggest impact if compromised. These critical applications typically handle sensitive data or key operations that support business continuity. Analyzing each application individually is impractical for a large number of applications due to resource constraints and could lead to delays, leaving some critical vulnerabilities unaddressed for extended periods. Performing a single analysis for all applications may miss specific vulnerabilities unique to certain applications, reducing the overall effectiveness of the analysis. Focusing on intangible assets does not directly address application vulnerability management, as vulnerabilities reside within the applications themselves, not within intangible assets. Prioritizing critical applications ensures that the highest risks are mitigated more promptly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      75,
      359,
      367,
      85
    ],
    "source": "9781394290116"
  },
  {
    "id": 1044,
    "question": "Which mode must be used by IPsec to establish a secure connection between networks?",
    "choice_a": "Encryption mode",
    "choice_b": "Authentication mode",
    "choice_c": "Transport mode",
    "choice_d": "Tunnel mode",
    "correct_answer": "D",
    "explanation": "Tunnel mode is used by IPsec to create a secure link between two networks, especially across a insecure network (such as the Internet). <p>Both “encryption mode” and “authentication mode” are incorrect because these are not IPsec modes. “Transport mode” is incorrect because it is typically used within a local network.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      273,
      319,
      306,
      287,
      283
    ],
    "source": "9781394290116"
  },
  {
    "id": 1045,
    "question": "Which of the following sections of an IS audit engagement letter addresses invoicing for services rendered in the IS audit?",
    "choice_a": "Scope of non-audit work",
    "choice_b": "Executive summary",
    "choice_c": "Report distribution list",
    "choice_d": "Confidentiality and nondisclosure",
    "correct_answer": "A",
    "explanation": "Invoicing for services rendered in the IS audit is addressed under the scope of non-audit work, as this section typically includes details about financial arrangements, including billing practices, fees, and payment terms. The executive summary provides an overview of the engagement and does not cover invoicing. The report distribution list specifies who will receive the audit report and is unrelated to invoicing. “Confidentiality and nondisclosure” addresses the protection of sensitive information but does not pertain to billing or payment matters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      357,
      84,
      85,
      89,
      364
    ],
    "source": "9781394290116"
  },
  {
    "id": 1046,
    "question": "The ISACA model for enterprise risk management is known as:",
    "choice_a": "Zachman",
    "choice_b": "NIST 800-30",
    "choice_c": "COBIT",
    "choice_d": "The Risk IT Framework",
    "correct_answer": "D",
    "explanation": "The Risk IT Framework is the risk management framework developed and maintained by ISACA. <p>“Zachman” is incorrect because it is an enterprise architecture model. “NIST 800-30” is incorrect because this is a risk management standard created by the National Institute of Standards and Technology (NIST), not ISACA. “COBIT” is incorrect because this is an IT process framework.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      2,
      18,
      16,
      17
    ],
    "source": "9781394290116"
  },
  {
    "id": 1047,
    "question": "Which of the following is the primary objective of availability management in IT systems?",
    "choice_a": "Sustaining IT services to support organizational objectives",
    "choice_b": "Allocating skilled human resources to the IT program",
    "choice_c": "Increasing monitoring of IT systems performance",
    "choice_d": "Ensuring that IT assets are properly safeguarded",
    "correct_answer": "A",
    "explanation": "The primary objective of availability management in IT systems is sustaining IT services to support organizational objectives, as this function ensures that IT services are consistently available and reliable to meet the needs of the business, aligning with the overall goals and objectives of the organization. Allocating skilled human resources to IT programs, although important, focuses more on personnel management rather than ensuring system availability. Increasing the monitoring of IT systems performance is part of availability management, but it serves more as a means to an end rather than the primary objective itself. Finally, ensuring that IT assets are properly safeguarded relates more to security and asset management than directly addressing service availability or its primary objective.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      162,
      161,
      176,
      165,
      163
    ],
    "source": "9781394290116"
  },
  {
    "id": 1048,
    "question": "Which of the following is true regarding how application software is managed in terms of recovery site planning?",
    "choice_a": "Application software must already be running at a cold site.",
    "choice_b": "Application software should be installed at the hot site.",
    "choice_c": "Application software is not normally installed at a cold site.",
    "choice_d": "Application software is not normally installed at a warm site.",
    "correct_answer": "C",
    "explanation": "Application software should be managed with the recovery site type in mind. For cold sites, it is not normally installed. Warm sites have application software installed but not running; and at hot sites, application software must be up and running to minimize transition time. <p>The answer referring to software running at a cold site is incorrect because application software will not be running at a cold site; there may not even be computers for applications to run on. The answer referring to installation at a hot site is incorrect because application software MUST, be running at a hot site. The answer referring to a warm site is incorrect because application software may be installed at a warm site.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      251,
      248,
      246,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 1049,
    "question": "Which of the following represents the effect of mergers and acquisitions on IS audit programs?",
    "choice_a": "They introduce business integration, which increases audit complexities.",
    "choice_b": "They create a stable environment for IS audit operations.",
    "choice_c": "They reduce the audit budget.",
    "choice_d": "They increase the need for more skilled IS auditors.",
    "correct_answer": "A",
    "explanation": "Mergers and acquisitions introduce business integration objectives, which increases audit complexities because integrating disparate systems and processes often presents significant challenges that can complicate the audit environment. As these complexities arise, auditors need to address new risks and ensure that controls are effectively designed and implemented across merged entities. The option suggesting that mergers and acquisitions create a stable environment for IS audit operations is incorrect because such activities typically result in substantial changes rather than stability. The suggestion that they reduce the audit budget is incorrect as, in reality, the need for thorough audits generally increases costs rather than decreasing them. Finally, although mergers and acquisitions do increase the demand for audits, which may suggest a need for more skilled IS auditors, this is a consequence of the complexity introduced and not a direct effect they have on audit programs.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      62,
      359,
      85,
      367,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 1050,
    "question": "What is the purpose of a preaudit?",
    "choice_a": "To permit an audit client to prepare for an upcoming initial audit",
    "choice_b": "To provide the client with examples of evidence it will request in an upcoming audit",
    "choice_c": "To coach the client on answering questions in a way that will prevent auditors from discovering unfavorable information",
    "choice_d": "To provide training to new auditors",
    "correct_answer": "A",
    "explanation": "A preaudit is generally performed on an audit client that has not been audited before, as a means for helping it prepare for an upcoming audit. A preaudit can be considered a “practice” audit or a “dry run.” <p>The answer mentioning examples of evidence is incorrect because a preaudit is not used to provide examples of evidence. The answer referring to coaching the client is incorrect because a preaudit should not be used for unethical activity, such as guiding auditees to deceive auditors. The answer mentioning training for new auditors is incorrect because preaudits are not used for training auditors.</p>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      366,
      356,
      359,
      357,
      84
    ],
    "source": "9781394290116"
  },
  {
    "id": 1051,
    "question": "Why is it critical for an organization to notify its key stakeholders, including authorities, during a disaster?",
    "choice_a": "To inform them of the disaster status and any changes in operations",
    "choice_b": "Professional courtesy",
    "choice_c": "To ensure that they stop the processing of transactions for the organization",
    "choice_d": "To comply with laws and regulations",
    "correct_answer": "A",
    "explanation": "Informing key stakeholders and authorities of the disaster status and any changes in operations is critical because it ensures effective communication, helps manage expectations, and supports coordinated responses to minimize disruptions. It is not merely a matter of courtesy, as timely notification has practical and strategic importance. Stopping the processing of transactions for the organization is not typically the primary reason for such notifications unless explicitly required by the situation. Although compliance with laws and regulations is important, it is only one aspect of stakeholder communication and does not encompass the broader necessity of keeping stakeholders informed during a disaster.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      240,
      244,
      233,
      248
    ],
    "source": "9781394290116"
  },
  {
    "id": 1052,
    "question": "All of the following are considered good password protection measures <i>except</i>:",
    "choice_a": "Using passwords meeting complexity requirements",
    "choice_b": "Using default passwords",
    "choice_c": "Using unique passwords in each environment",
    "choice_d": "Using electronic password vaulting",
    "correct_answer": "B",
    "explanation": "One of the easiest ways for an intruder to attack a system is through known default passwords. Before being connected to a network, every system should be changed so that all accounts have organizationally assigned passwords instead of the default passwords. <p>Complex passwords, unique passwords, and password vaulting are incorrect answers because they are all good password protection measures.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      313,
      344,
      268,
      308,
      322
    ],
    "source": "9781394290116"
  },
  {
    "id": 1053,
    "question": "After completing a vulnerability analysis, an IS auditor needs to rank the severity of the identified vulnerabilities. Which of the following is a key factor used to determine vulnerability severity?",
    "choice_a": "Likelihood of threat realization",
    "choice_b": "The duration of time the vulnerability has existed",
    "choice_c": "Effectiveness of IT controls implemented",
    "choice_d": "Cost of mitigating the vulnerabilities",
    "correct_answer": "A",
    "explanation": "The likelihood of threat realization is the key factor for determining vulnerability severity because it directly assesses how probable it is that a threat will exploit the vulnerability, combined with its potential impact. The duration of time the vulnerability has existed is not a direct indicator of severity, as older vulnerabilities may still be low-risk or mitigated. The effectiveness of IT controls implemented relates to the current defenses in place but does not prioritize the inherent severity of the vulnerabilities themselves. The cost of mitigating vulnerabilities is a consideration for planning remediation but does not affect the ranking of severity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      96,
      80,
      95,
      73
    ],
    "source": "9781394290116"
  },
  {
    "id": 1054,
    "question": "An organization’s HR department is writing a job description for a new CRO position. Which of the following best describes the CRO’s role?",
    "choice_a": "Build and manage the ERM program",
    "choice_b": "Build and manage the information security program",
    "choice_c": "Build and manage IT governance",
    "choice_d": "Build and manage product development",
    "correct_answer": "A",
    "explanation": "A CRO (chief risk officer) is most often responsible for building and managing an organization’s enterprise risk management (ERM) program and processes. <p>The answer referring to the information security program is incorrect because a CISO would build and manage an information security program. The answer referring to IT governance is incorrect because a CIO would build and manage IT governance. The answer mentioning product development is incorrect because a development leader (sometimes a CTO) would build and manage product development.</p>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      45,
      18,
      44,
      17,
      24
    ],
    "source": "9781394290116"
  },
  {
    "id": 1055,
    "question": "In an audit of IS problem management operations, which of the following represents the importance of examining IT problem management records?",
    "choice_a": "To determine the effectiveness of problem management activities",
    "choice_b": "To rectify all problems",
    "choice_c": "To enhance media control",
    "choice_d": "To improve the effectiveness of recovery efforts",
    "correct_answer": "A",
    "explanation": "Examining IT problem management records is crucial in determining the effectiveness of problem management activities. This allows auditors to assess whether issues are identified, analyzed, and resolved efficiently, ensuring that the problem management process is functioning as intended and contributing to overall IT service management goals. Rectifying all problems is unrealistic for an audit focus, as the goal is to evaluate processes rather than fix individual issues. Enhancing media control is unrelated to the purpose of reviewing problem management records because media control is more about managing storage and data access. Improving the effectiveness of recovery efforts is more related to disaster recovery and business continuity plans, rather than routine problem management records, which focus on the ongoing handling of incidents and problems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      184,
      165,
      173,
      161,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 1056,
    "question": "What is the reason an organization might use internal firewalls in addition to its border firewalls?",
    "choice_a": "To create separate zones of trust within the network",
    "choice_b": "To prevent communication between two departments",
    "choice_c": "To assist border firewalls in stopping external threats",
    "choice_d": "To prevent malware from propagating throughout the network",
    "correct_answer": "A",
    "explanation": "Modern LAN environments are protected from outside threats with firewalls. Many larger organizations also employ internal firewalls that create separate zones of trust within the organization, thus separating sensitive information assets from users who do not require access. <p>The answer referring to communication between two departments is incorrect because although preventing communication between two departments is a potential objective for internal firewalls, this explanation is too narrow. The answer citing external threats is incorrect because although operating in a defense-in-depth posture to slow down Internet threats is a potential reason for layers of firewalls, internal firewalls typically do not serve to assist border firewalls in stopping external threats. The answer referring to the prevention of propagation of malware throughout a network is incorrect because although blocking malware from moving laterally through a network is a common objective for internal firewalls, this is not the best available answer, as there are often additional reasons for internal firewalls.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      270,
      306,
      271,
      342,
      305
    ],
    "source": "9781394290116"
  },
  {
    "id": 1057,
    "question": "Which of the following is the purpose of implementing an employee policy manual in an organization?",
    "choice_a": "To specify the terms and conditions of employment",
    "choice_b": "To train employees",
    "choice_c": "To advertise internal vacancies",
    "choice_d": "To train employees in controls",
    "correct_answer": "A",
    "explanation": "Implementing an employee policy manual in an organization primarily serves to specify the terms and conditions of employment. This is correct because such manuals typically outline company rules, employee rights, roles, responsibilities, and organizational procedures, providing a comprehensive guide to the employment relationship and expectations. The other options are not the primary purposes of a policy manual. Although a manual may include some guidance related to training, it is not specifically designed to train employees; separate documents and programs are typically used for thorough employee training and development. Advertising internal vacancies is generally managed through different communication channels like emails, notice boards, or HR portals, not the employee policy manual. Training employees in controls is typically addressed through specific compliance or control training programs and not a general policy manual.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      29,
      54,
      8,
      44,
      30
    ],
    "source": "9781394290116"
  },
  {
    "id": 1058,
    "question": "Management in an organization is considering making changes to enhance the ownership in the quality of its processes. What new activity would most effectively achieve this?",
    "choice_a": "Control self-assessment",
    "choice_b": "Internal audit",
    "choice_c": "External audit",
    "choice_d": "Balanced scorecard",
    "correct_answer": "A",
    "explanation": "Control self-assessments help process owners see how effective their controls are (or are not) through a structured assessment program. This can help process owners take more ownership in their controls and be more receptive to improvements. The other activities are not as effective at accomplishing this objective. <p>“Internal audit” and “external audit” are incorrect because although internal and external audits will identify improvement opportunities, these are not as effective as a control self-assessment, where control owners have more involvement in control evaluation and improvement. “Balanced scorecard” is incorrect because the balanced scorecard is used for strategy measurement and management.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      366,
      98,
      71,
      87
    ],
    "source": "9781394290116"
  },
  {
    "id": 1059,
    "question": "Which of the following is the <i>main</i> purpose of data minimization in the early stages of the information life cycle?",
    "choice_a": "To collect the least amount of data necessary to meet business requirements",
    "choice_b": "To ensure that data is collected for multiple purposes",
    "choice_c": "To maximize the extent of data sources",
    "choice_d": "To speed up the data collection process",
    "correct_answer": "A",
    "explanation": "Data minimization in the early stages of the information life cycle focuses on collecting only the amount of data necessary to meet specific business requirements. This approach helps reduce storage costs, limits exposure to data breaches, and ensures compliance with data protection regulations by not retaining unnecessary personal or sensitive information. Collecting data for multiple purposes could lead to over-collection, increasing the risk of mismanagement and compliance issues. Maximizing the extent of data sources is contrary to the concept of data minimization, which aims to restrict data collection to what is strictly needed. Speeding up the data collection process is not a principle of data minimization; instead, it emphasizes purpose-driven, prudent data handling rather than focusing on efficiency in collection.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      10,
      23,
      9,
      40,
      15
    ],
    "source": "9781394290116"
  },
  {
    "id": 1060,
    "question": "Which of the following wireless network attacks enables attackers to steal logon credentials and redirect traffic?",
    "choice_a": "MAC address spoofing",
    "choice_b": "Rogue access point",
    "choice_c": "Wireless sniffing",
    "choice_d": "MAC address filtering",
    "correct_answer": "B",
    "explanation": "It is relatively easy for an intruder to establish a rogue access point with the same name as a legitimate access point (evil twin). The intruder can use this rogue access point as a gateway to forward legitimate traffic in both directions while watching for and intercepting any sensitive information that may pass by. Or the intruder may use the rogue access point to steal logon credentials from users trying to connect to the real access point. <p>“MAC address spoofing” is incorrect because although this is a method for gaining access to a network that uses MAC address filtering, by itself it does nothing to help an intruder steal authentication credentials. “Wireless sniffing” is incorrect because it does not redirect traffic. Additionally, sniffing by itself it does little these days to help an intruder steal login credentials; this is because the vast majority of authentication is performed via encrypted channels such as TLS and other encrypted protocols. “MAC address filtering” is incorrect because this is not an attack on a network but instead a defensive measure.</p>",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      292,
      306,
      320,
      272,
      314
    ],
    "source": "9781394290116"
  },
  {
    "id": 1061,
    "question": "Which of the following describes the hybrid model for end-user computing?",
    "choice_a": "The organization provides some computing resources, with employees permitted to access certain resources on their personal devices.",
    "choice_b": "The organization provides all computing resources.",
    "choice_c": "The organization restricts the use of personal end-user devices.",
    "choice_d": "Employees provide all computing devices and software.",
    "correct_answer": "A",
    "explanation": "The hybrid model for end-user computing involves the organization providing some computing resources while allowing employees to use their personal devices to access specific resources. This approach balances control and flexibility, enabling employees to use personal devices for work while maintaining security over key systems. Providing all computing resources is a fully managed approach, not a hybrid one. Restricting the use of personal devices represents a strict corporate-controlled model rather than a hybrid approach. Requiring employees to provide all devices and software describes a bring-your-own-device (BYOD) model without corporate provisioning, which differs from a hybrid setup that includes both personal and corporate resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      190,
      206,
      161,
      164
    ],
    "source": "9781394290116"
  },
  {
    "id": 1062,
    "question": "Which of the following tools will enable an organization to better understand the depth and performance capabilities of its business processes?",
    "choice_a": "Control framework",
    "choice_b": "Risk assessment",
    "choice_c": "Maturity model",
    "choice_d": "Clark-Wilson model",
    "correct_answer": "C",
    "explanation": "A maturity model helps an organization better understand the integrity and reliability of a business process. <p>“Control framework” is incorrect because this would be used to organize specific desired outcomes. “Risk assessment” is incorrect because this is used to identify risk, not measure the integrity of a process. “Clark-Wilson model” is incorrect because this is a data integrity model.</p>",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      41,
      3,
      16,
      53,
      1
    ],
    "source": "9781394290116"
  },
  {
    "id": 1063,
    "question": "Which of the components of the ISACA Information Technology Audit Framework (ITAF) is optional?",
    "choice_a": "IT audit and assurance guidelines",
    "choice_b": "IT audit standards",
    "choice_c": "Code of Ethics",
    "choice_d": "All of them are optional.",
    "correct_answer": "A",
    "explanation": "IT audit and assurance guidelines are the optional component of the ITAF because they serve as recommendations to support auditors in implementing the IT audit standards effectively but are not mandatory to follow. IT audit standards and the Code of Ethics are not optional because they establish mandatory requirements for the audit profession and outline the professional conduct expected of ISACA members and certification holders, respectively. These standards ensure the quality and rigor of IT audits, and adherence to the Code of Ethics maintains the integrity and professionalism of practitioners, making them essential components of the framework. Thus, guidelines provide flexibility and support, whereas standards and the Code of Ethics are foundational and compulsory.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      68,
      71,
      69,
      70,
      60
    ],
    "source": "9781394290116"
  },
  {
    "id": 1064,
    "question": "A business user is creating a document that will describe a new system and the benefits that will be realized. This document is better known as a:",
    "choice_a": "Business case",
    "choice_b": "Financial stability",
    "choice_c": "Budget request",
    "choice_d": "Migration plan",
    "correct_answer": "A",
    "explanation": "A business case defines the business problem, feasibility study results, budget, metrics, and risks associated with a new business initiative. <p>“Financial stability” is incorrect because this is not a document used by IT. “Budget request” is incorrect because it does not usually take this form. “Migration plan” is incorrect because this is a description of the steps to move from one system to another.</p>",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      102,
      116,
      151,
      100,
      123
    ],
    "source": "9781394290116"
  },
  {
    "id": 1065,
    "question": "During which of the following BCP stages does an organization implement architecture improvements?",
    "choice_a": "Development",
    "choice_b": "Analysis",
    "choice_c": "Training",
    "choice_d": "Testing",
    "correct_answer": "A",
    "explanation": "Architecture improvements are typically implemented during the Development stage of the business continuity planning (BCP) process life cycle. This stage involves the creation and updating of plans and procedures to enhance the organization’s capability to maintain operations or quickly resume them following an interruption. Development focuses on creating detailed plans and implementing improvements to existing infrastructure and processes. The Analysis stage is primarily concerned with understanding potential risks, impacts, and requirements without altering the architecture. Training is about educating employees on their roles within the BCP, not developing or improving systems. Testing evaluates the effectiveness of the BCP and validates the plans without incorporating changes at that point, focusing instead on identifying gaps and areas that need improvement, which would then lead back to further development work.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      235,
      233,
      236,
      231,
      246
    ],
    "source": "9781394290116"
  },
  {
    "id": 1066,
    "question": "An IS auditor is auditing firewall change records, which contain the date of the change, the type of configuration change, and the name of the person who performed the change. What conclusion should the auditor draw from this observation?",
    "choice_a": "Records are incomplete, as they do not contain the change approval.",
    "choice_b": "Records are complete.",
    "choice_c": "Records are incomplete, as they do not contain a business reason for the change.",
    "choice_d": "Records are incomplete, as they do not contain the backout plan.",
    "correct_answer": "C",
    "explanation": "Firewall change records should contain a business reason for the change so that the auditor will have an idea of why each firewall rule exists. It would be useful (but not necessary) if the firewall change records contained references to a record number in the organization’s change management system. <p>The answer stating that the change approval is absent is incorrect because the change approval information usually resides in the change management system. The answer stating that the records are complete is incorrect because they are not complete: there is no reference to a business reason for the change. The answer stating that the backout plan is lacking is incorrect because the presence or absence of a backout plan is not relevant.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      173,
      167,
      169,
      166,
      183
    ],
    "source": "9781394290116"
  },
  {
    "id": 1067,
    "question": "An organization is considering connecting its systems to facilitate online transactions. Which of the following firewalls would protect this arrangement?",
    "choice_a": "Stateless firewall",
    "choice_b": "NGFW",
    "choice_c": "Stateful firewall",
    "choice_d": "Packet filtering firewall",
    "correct_answer": "B",
    "explanation": "An NGFW (next-generation firewall) is the best option for protecting systems facilitating online transactions because it combines the capabilities of stateful inspection with advanced features like intrusion prevention, deep packet inspection, and application-layer filtering. These capabilities provide robust protection against sophisticated threats in transactional environments. Stateful firewalls track the state of connections and are effective for general use but lack the advanced features of NGFWs. Stateless firewalls and packet-filtering firewalls only analyze individual packets without context, making them less effective against modern, complex attacks targeting online transactions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      270,
      306,
      274,
      309,
      312
    ],
    "source": "9781394290116"
  },
  {
    "id": 1068,
    "question": "Which of the following is an email security protocol that provides sender and recipient authentication and encryption of message content and attachments?",
    "choice_a": "POP",
    "choice_b": "S-HTTP",
    "choice_c": "S/MIME",
    "choice_d": "HTTPS",
    "correct_answer": "C",
    "explanation": "Secure Multipurpose Internet Mail Extensions (S/MIME) is an email security protocol that provides sender and recipient authentication and encryption of message content and attachments. <p>“POP” is incorrect because Post Office Protocol does not encrypt its transmissions. “S-HTTP” is incorrect because this is not an email security protocol but is instead the deprecated secure HTTPS protocol. “HTTPS” is incorrect because this is not an email security protocol but is instead the popular TLS-encrypted HTTP protocol.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      282,
      285,
      319,
      273
    ],
    "source": "9781394290116"
  },
  {
    "id": 1069,
    "question": "Which of the following is classified as a natural disaster?",
    "choice_a": "Theft",
    "choice_b": "Volcanic eruption",
    "choice_c": "Hacking attempts",
    "choice_d": "Insider threat",
    "correct_answer": "B",
    "explanation": "Volcanic eruptions are classified as a natural disaster because they are natural events that can cause significant disruption and damage to both human life and the environment. Unlike human-induced actions, natural disasters arise from geological processes that are beyond human control. Theft, hacking attempts, and insider threats, however, are all examples of human-related incidents rather than natural disasters. Theft involves the illegal taking of property, hacking attempts refer to unauthorized efforts to access computer systems, and insider threats refer to individuals within an organization who might misuse their access for personal gain or other reasons. Each of these involves deliberate or negligent human action instead of natural, nonhuman phenomena.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      232,
      231,
      240,
      236,
      233
    ],
    "source": "9781394290116"
  },
  {
    "id": 1070,
    "question": "In the context of a business impact analysis, a statement of impact:",
    "choice_a": "Outlines how much downtime the organization could suffer before production is affected",
    "choice_b": "Details the expense in resources an organization would have to spend to recover from a particular disaster",
    "choice_c": "Is a qualitative or quantitative description of the impact if the process or system were incapacitated for a defined period",
    "choice_d": "Is used to determine financial losses in the event of a natural disaster",
    "correct_answer": "C",
    "explanation": "The other choices all describe activities that could be important to the organization during the BCP and DRP processes; however, they are not statements of impact as defined by ISACA. A statement of impact describes the impact on the organization if the process or system were incapacitated for a predefined period. <p>The answer referring to an outline of downtime is incorrect because this answer closely describes maximum tolerable downtime (MTD). The answer referring to the cost of recovery is incorrect because recovery expense is only part of a complete statement of impact. The answer mentioning financial losses due to a natural disaster is incorrect because financial losses in the event of a natural disaster are only part of a complete statement of impact.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      246,
      235,
      231,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 1071,
    "question": "Which of the following types of tests is used to confirm that the application is communicating effectively with other applications?",
    "choice_a": "Regression",
    "choice_b": "Interface",
    "choice_c": "Unit",
    "choice_d": "Functional",
    "correct_answer": "B",
    "explanation": "Interface testing is used to confirm that an application is communicating effectively with other applications. It focuses specifically on the interactions between systems, ensuring that data is exchanged accurately and efficiently. In contrast, regression testing is conducted to verify that new code changes do not adversely affect the existing functionality of an application, rather than monitoring communication between applications. Unit testing involves examining individual components or functions of the software, primarily focusing on their independent operation rather than their interaction with other systems. Functional testing assesses whether the software performs its intended functions but does not specifically address application-to-application communication. Thus, interface testing is the most appropriate choice for verifying communication effectiveness between applications.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      121,
      120,
      157,
      153,
      145
    ],
    "source": "9781394290116"
  },
  {
    "id": 1072,
    "question": "The practice of managing budgets, equipment, and personnel is collectively known as:",
    "choice_a": "Capacity planning",
    "choice_b": "Internal audit",
    "choice_c": "Benchmarking",
    "choice_d": "Resource management",
    "correct_answer": "D",
    "explanation": "Resource management is the practice of managing budgets, personnel, and equipment in an organization. <p>“Capacity planning” is incorrect because this is the practice of ensuring that there is sufficient processing capacity to meet current and future needs. “Internal audit” is incorrect because this is used to independently confirm the effectiveness of processes and controls. “Benchmarking” is incorrect because this is used to compare one organization’s processes to another organization’s processes (or an individual organization’s processes over time).</p>",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      27,
      1,
      44,
      41,
      43
    ],
    "source": "9781394290116"
  },
  {
    "id": 1073,
    "question": "According to ISACA, all of the following documents are critical to the operation of the IS audit function <i>except</i>:",
    "choice_a": "Audit charter",
    "choice_b": "Management representations",
    "choice_c": "Audit objectives",
    "choice_d": "Audit scope",
    "correct_answer": "B",
    "explanation": "Management representations are not critical to the operation of the IS audit function because they are statements provided by management to auditors and serve as evidence during audits rather than foundational documents for the audit function itself. The audit charter defines the authority, purpose, and responsibility of the audit function, making it essential. Audit objectives outline the goals of the audit, ensuring alignment with organizational needs. Audit scope specifies the boundaries and focus areas of the audit, ensuring clarity and direction. These documents are critical for defining and guiding the audit function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      69,
      84,
      357,
      99
    ],
    "source": "9781394290116"
  },
  {
    "id": 1074,
    "question": "What is the term used for a section of code in a program that permits someone to bypass access controls and access data or functions?",
    "choice_a": "Trojan horse",
    "choice_b": "Bot",
    "choice_c": "Logic bomb",
    "choice_d": "Back door",
    "correct_answer": "D",
    "explanation": "A back door is a section of code that permits someone to bypass access controls and access data or functions. Back doors are commonly placed in programs during development but are removed before programming is complete. Sometimes, however, back doors are deliberately planted so that the developer (or someone else) can access data and functions. <p>“Trojan horse” is incorrect because this is a program that is promoted as having one function but also (or instead) has a malicious function. “Bot” is incorrect because a bot is not a section of code but rather an autonomous program designed with one or more purposes. A logic bomb is code inserted into a system that triggers a malicious action when specific conditions are met, but it doesn’t inherently provide unauthorized access like a back door does.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      312,
      342,
      313,
      343,
      346
    ],
    "source": "9781394290116"
  },
  {
    "id": 1075,
    "question": "Which of the following RAID approaches splits data evenly across two or more disks with the objective of improving performance?",
    "choice_a": "RAID-1",
    "choice_b": "RAID-0",
    "choice_c": "RAID-2",
    "choice_d": "RAID-10",
    "correct_answer": "B",
    "explanation": "RAID-0 is the correct option because it implements disk striping, where data is distributed across multiple disks without redundancy, which enhances performance by allowing simultaneous read/write operations. However, it offers no fault tolerance, so a single disk failure results in data loss. RAID-1 provides mirroring, where data is duplicated across two or more disks, which improves fault tolerance rather than performance. RAID-2 is an outdated method that uses Hamming codes for error correction and interleaves data at the bit level across multiple disks, which is not efficient for modern systems. RAID-10 combines mirroring and striping of data, which offers both increased performance and fault tolerance but does not solely focus on performance improvement due to its redundant configuration.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      238,
      193,
      239,
      206,
      197
    ],
    "source": "9781394290116"
  },
  {
    "id": 1076,
    "question": "Who are the most appropriate personnel to perform control self-assessments?",
    "choice_a": "Process owners",
    "choice_b": "Internal auditors",
    "choice_c": "External auditors",
    "choice_d": "Chief Audit Executive",
    "correct_answer": "A",
    "explanation": "Process owners themselves are the right persons to perform control self-assessments. The primary objective of a control self-assessment program is ownership of the results of self-assessments; what better way to achieve this than to have process owners performing them? <p>The answers mentioning auditors and the Chief Audit Executive are incorrect because self-assessments are performed by control owners, not auditors.</p>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      354,
      353,
      360,
      361,
      366
    ],
    "source": "9781394290116"
  },
  {
    "id": 1077,
    "question": "An IS auditor should provide assurance that processes for a quality management system are periodically monitored and measured to ensure that they are designed properly and operating effectively. Why is management review of key measurements an important step in quality management?",
    "choice_a": "It helps to identify data leakages in the organization.",
    "choice_b": "It allows management to assess performance expectations.",
    "choice_c": "It encourages the organization to focus on developing new quality processes.",
    "choice_d": "It helps the organization to prevent the development of poor-quality products.",
    "correct_answer": "B",
    "explanation": "Management review of key measurements is crucial in quality management because it allows management to assess performance expectations. This ensures that the processes meet the set performance and quality standards, thereby facilitating continuous improvement and alignment with organizational goals. Identifying data leakages would be more related to information security audits than quality management processes. Focusing solely on developing new quality processes may lead to neglect of existing ones that may also require enhancement or adjustments. Preventing poor-quality product development is an outcome of effective quality management, for which management reviews performance metrics as a crucial input; however, it is not the primary reason for conducting such reviews.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      41,
      3,
      51,
      50
    ],
    "source": "9781394290116"
  },
  {
    "id": 1078,
    "question": "A company performing due diligence on a cloud-based service provider has requested an audit report. The service provider provided an audit report for its data center hosting provider. How should the company proceed?",
    "choice_a": "Thank the service provider for providing the audit report.",
    "choice_b": "Examine the audit report for significant deficiencies and material weaknesses.",
    "choice_c": "Request an audit report for the service provider’s own operations.",
    "choice_d": "File the report in its due diligence recordkeeping.",
    "correct_answer": "C",
    "explanation": "Although it’s appropriate to examine the hosting provider’s audit report for audit findings and file the report for future reference, the company really needs an audit report for the cloud service provider itself, not just its hosting provider. However, cloud service providers sometimes do not have audits of their own development and operations. Sending the data center hosting provider’s audit report is useful, but that report probably does not include the service provider’s systems and processes. <p>The answer referring to thanking the service provider is incorrect because the data center audit report is not the report that was requested. The answer referring to examining the audit report is incorrect because the company is expecting an audit report for its service provider, not its service provider’s hosting provider. The answer that mentions filing the report is incorrect because although the service provider’s hosting provider audit report may be interesting, the company is expecting the service provider’s audit report and did not receive it.</p>",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      56,
      57,
      33,
      34,
      59
    ],
    "source": "9781394290116"
  },
  {
    "id": 1079,
    "question": "A recent IS access management review at a bank revealed a high incidence of identity theft, with fraudsters accessing customers’ financial transactions through a mobile application platform. Which of the following is the <i>best</i> solution the organization should adopt to protect against this threat?",
    "choice_a": "Regularly rotating passwords",
    "choice_b": "Implementing multifactor authentication (MFA)",
    "choice_c": "Enforcing the use of ATMs",
    "choice_d": "Conducting staff training and development sessions.",
    "correct_answer": "B",
    "explanation": "Implementing multifactor authentication (MFA) is the best solution because it adds an additional layer of security beyond just a password, making it more difficult for fraudsters to gain unauthorized access to customer accounts even if they have stolen credentials. Regularly rotating passwords can help to a degree, but it is not foolproof against sophisticated phishing or hacking methods that can capture the new password immediately. Enforcing the use of ATMs does not address the threat as it does not mitigate risks associated with mobile platforms, which is where the identity theft is occurring. Conducting staff training and development sessions is beneficial for raising awareness and improving practices, but it does not directly safeguard against immediate threats of identity theft through technical controls as effectively as MFA.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      318,
      309,
      319,
      269,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 1080,
    "question": "The least intrusive type of disaster recovery test is the:",
    "choice_a": "Cutover test",
    "choice_b": "Walkthrough",
    "choice_c": "Documentation review",
    "choice_d": "Parallel test",
    "correct_answer": "C",
    "explanation": "A documentation review does not interfere with business operations. <p>The answers referring to either cutover or parallel tests are incorrect because these tests involve organization personnel, and there is some risk of disruption of business operations as well. “Walkthrough” is incorrect because this involves several people, taking them away from business operations.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      252,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 1081,
    "question": "Which of the following is a visual representation tool that can be used to depict IT project tasks, timelines, and dependencies in a left-to-right time sequence?",
    "choice_a": "Project timeline",
    "choice_b": "Gantt chart",
    "choice_c": "Program evaluation and review technique (PERT)",
    "choice_d": "Critical path analysis (CPA)",
    "correct_answer": "B",
    "explanation": "A Gantt chart is the correct choice because it is specifically designed to display project tasks along a timeline, showing the start and end dates for each task while also visualizing dependencies between tasks. This makes it an ideal tool for managing and planning project schedules in a clear and sequential format. PERT focuses on the analysis and representation of a project’s tasks and their timelines using a network diagram to calculate the time needed to complete tasks. Although PERT is useful for depicting project execution activities and identifying the most critical path, it lacks the straightforward visual clarity of a Gantt chart regarding time sequencing. A project timeline, in the general context, merely refers to a list of dates without necessarily showing task dependencies, which is a limitation when aiming to visually manage a complex project’s dynamics. CPA identifies the sequence of essential tasks to determine project duration, using network diagrams similar to PERT.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      367,
      89,
      85,
      84,
      72
    ],
    "source": "9781394290116"
  },
  {
    "id": 1082,
    "question": "A method where the first personnel involved in a disaster begin notifying others in the organization to inform them of the developing disaster and to enlist their assistance is called a:",
    "choice_a": "Direct notification",
    "choice_b": "Call tree",
    "choice_c": "Conference call",
    "choice_d": "Wide-area alert",
    "correct_answer": "B",
    "explanation": "The call tree is a pyramid-style notification system used to quickly notify as many key personnel as possible and get assistance in dealing with the disaster. <p>“Direct notification” is incorrect because this is not a common term for the notifications described here. “Conference call” is incorrect because it is not the method being used in this example. “Wide area alert” is incorrect because it is not a common term for the notifications described here.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      235,
      248,
      244,
      252
    ],
    "source": "9781394290116"
  },
  {
    "id": 1083,
    "question": "Which of the following models would you recommend to a client seeking to determine the level of maturity of its governance processes?",
    "choice_a": "Capability maturity model integration (CMMI)",
    "choice_b": "COBIT 2019",
    "choice_c": "Agile methodology",
    "choice_d": "Val IT",
    "correct_answer": "B",
    "explanation": "COBIT 2019 is the recommended model for determining the maturity of governance processes because it includes a detailed maturity assessment framework specifically designed for IT governance and management. CMMI focuses on process improvement for software development and engineering rather than governance. Agile methodology is a project management approach for software development and is not designed to assess governance maturity. Val IT is focused on the value delivery of IT investments rather than governance maturity assessments.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      2,
      41,
      39,
      53,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 1084,
    "question": "How much unscheduled downtime is permitted for an IT organization that commits to 99.9% uptime?",
    "choice_a": "88 hours",
    "choice_b": "8.76 hours",
    "choice_c": "52 minutes",
    "choice_d": "52 seconds",
    "correct_answer": "B",
    "explanation": "99.9% uptime means that out of 8,760 hours in a year, an organization can experience no more than 0.1%, or 8.76 hours, of unscheduled downtime. <p>88 hours, 52 minutes, and 52 seconds are all incorrect because these values do not represent 99.9% uptime.</p>",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      162,
      233,
      246,
      240,
      163
    ],
    "source": "9781394290116"
  },
  {
    "id": 1085,
    "question": "Which of the following represents the impact of capacity issues on IT systems service-level agreements (SLAs)?",
    "choice_a": "Reduce system response times",
    "choice_b": "Lead to SLA violations due to overutilized IT systems",
    "choice_c": "Optimize system performance",
    "choice_d": "Reduce the need for incident monitoring",
    "correct_answer": "B",
    "explanation": "Capacity issues on IT systems often result in SLA violations due to overutilized IT systems. Overutilization can lead to slower system performance, increased response times, and, ultimately, failure to meet the agreed-on service levels defined in SLAs. Reduced system response times might occur if capacity issues were managed or optimized, which isn’t the case when discussing problems with capacity. Optimizing system performance would imply that capacity issues are being effectively managed, rather than creating problems. Reducing the need for incident monitoring would suggest fewer issues or incidents, which is contrary to the challenges posed by capacity constraints, which often lead to more frequent monitoring and incident management to ensure SLA compliance.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      176,
      163,
      162,
      165,
      198
    ],
    "source": "9781394290116"
  },
  {
    "id": 1086,
    "question": "Integrity can be ensured by which type of cryptographic process?",
    "choice_a": "Session encryption",
    "choice_b": "Symmetric encryption",
    "choice_c": "Asymmetric encryption",
    "choice_d": "Hashing functions",
    "correct_answer": "D",
    "explanation": "Hashing is the process of applying a cryptographic algorithm on a block of information that results in a compact, fixed-length “digest.” The purpose of hashing is to provide a unique “fingerprint” for a message or file – even if it is large. A message digest can be used to verify the integrity of a large file, thus ensuring that the file has not been altered. <p>“Session encryption” is incorrect because this is not a cryptographic function that is used to confirm the integrity of a message. Session encryption instead is used to ensure the confidentiality of a message. Both “symmetric encryption” and “asymmetric encryption” are incorrect because these actions are used to encrypt a message to ensure its confidentiality, not its integrity.</p>",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      285,
      286,
      282,
      253,
      257
    ],
    "source": "9781394290116"
  },
  {
    "id": 1087,
    "question": "Which of the following entities is responsible for starting the first phase of the systems development life cycle (SDLC)?",
    "choice_a": "Functional users",
    "choice_b": "Management",
    "choice_c": "Developers",
    "choice_d": "IS auditors",
    "correct_answer": "B",
    "explanation": "Management is responsible for starting the first phase of the SDLC because they identify business needs, set priorities, and approve the initiation of projects. Functional users provide input regarding requirements but do not initiate the process. Developers execute the technical aspects of the life cycle once it begins but are not responsible for initiating it. IS auditors review and evaluate the processes but do not play a role in starting the SDLC.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      115,
      105,
      110,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 1088,
    "question": "An IT service desk is planning an implementation of BitLocker for corporate desktop computers. What should be implemented that will provide the service desk with a method to access the contents of computers when users forget their passwords or leave the organization?",
    "choice_a": "Key escrow via Active Directory",
    "choice_b": "Password hints",
    "choice_c": "Back doors",
    "choice_d": "Password recovery",
    "correct_answer": "A",
    "explanation": "Active Directory provides key escrow capabilities to facilitate administrative access to encrypted hard drives in the event end users forget their passwords or leave the organization. <p>“Password hints” is incorrect because these do not provide a service desk with a method of accessing a BitLocker encrypted hard drive when the end user has left the organization. “Back doors” is incorrect because using a back door, generally referred to as a malicious or accidental pathway for bypassing controls, is not an appropriate method for administrators to access an encrypted hard drive. “Password recovery” is incorrect because this is not an available mechanism when passwords are protected appropriately with one-way hashes.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      341,
      340,
      345,
      309,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 1089,
    "question": "During an audit of the user access provisioning process, which of the following should the IS auditor examine regarding access request processes?",
    "choice_a": "Whether access requests are always denied or approved",
    "choice_b": "Whether access requests are consistent",
    "choice_c": "Whether access requests are encrypted",
    "choice_d": "Whether all users have requested access",
    "correct_answer": "B",
    "explanation": "When auditing the user access provisioning process, the IS auditor should examine whether access requests are consistent. This means verifying that the process for requesting and granting access is uniform across the organization, adhering to established policies and procedures. Consistent access requests ensure that users are provisioned with permissions appropriate to their roles and responsibilities, mitigating the risk of unauthorized access. Examining whether access requests are always denied or approved does not address the core issue of consistency and does not ensure compliance with access control policies. Ensuring that access requests are encrypted primarily concerns data confidentiality during transmission and does not relate directly to the provisioning process’s integrity. Finally, verifying whether all users have requested access is irrelevant to evaluating the adequacy and consistency of the provisioning process itself, as not all users may need or have reasons to request access regularly.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      345,
      343,
      309,
      311,
      324
    ],
    "source": "9781394290116"
  },
  {
    "id": 1090,
    "question": "Which of the following make up the best selection of members for an IT steering committee?",
    "choice_a": "Senior executives and department heads",
    "choice_b": "Board members",
    "choice_c": "End users",
    "choice_d": "Customers",
    "correct_answer": "A",
    "explanation": "The best choice for members of an IT steering committee in an organization are senior executives and department heads. <p>“Board members” is incorrect because these are not the best choice for an IT steering committee. “End users” is incorrect because although their input is valuable, end users are not suited for a steering committee. “Customers” is incorrect because they should instead be part of a customer advisory board, if the organization values their input.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      7,
      6,
      27,
      44,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 1091,
    "question": "An IS auditor reviewing an organization’s risk management processes encounters a statement of impact on the documentation provided for the audit. What is the rationale for including this statement as part of the impact analysis?",
    "choice_a": "To show the results of risk analysis",
    "choice_b": "To clearly present business impact in relatable terms",
    "choice_c": "To show threats that have no impact on operations",
    "choice_d": "To ensure that risk analysis addresses all impacts",
    "correct_answer": "B",
    "explanation": "Including a statement of impact as part of impact analysis is essential to clearly present business impact in relatable terms. This ensures that stakeholders can understand the potential consequences of various risks in the context of their specific business environment, facilitating better decision-making and prioritization. Simply showing the results of risk analysis is insufficient because it does not contextualize those results in terms of their actual relevance or severity for the business. Stating threats that have no impact would not be a rationale as this would undermine the focus of risk management processes by cluttering them with irrelevant information. Finally, ensuring that risk analysis addresses all impacts is a broad objective of risk management, but the statement of impact specifically aids in communicating the implications of those risks, rather than ensuring comprehensive risk coverage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      16,
      24,
      54,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 1092,
    "question": "Which of the following areas is business continuity operations most concerned with?",
    "choice_a": "Business processes",
    "choice_b": "IT operations",
    "choice_c": "Disaster recovery",
    "choice_d": "Data restoration",
    "correct_answer": "A",
    "explanation": "Procedures for continuing operations have more to do with business processes than they do with IT operations. All other operations (disaster recovery, data restoration, and so on) support the ultimate goal of continuing the business processes that enable the organization to survive. <p>“IT operations” is incorrect because business continuity operations are not primarily focused on IT operations but on business processes. “Disaster recovery” is incorrect because business continuity operations are focused on business processes, not on disaster recovery. That said, in some situations, business continuity operations may need to be <i>aware</i> of disaster recovery operations so that business processes can obtain IT system support for critical processes. “Data restoration” is incorrect because data restoration is part of IT disaster recovery, not business continuity.</p>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      231,
      235,
      233,
      240,
      243
    ],
    "source": "9781394290116"
  },
  {
    "id": 1093,
    "question": "Don would like to digitally sign a message he is sending to Zara. What key should he use to sign the message?",
    "choice_a": "Don’s public key",
    "choice_b": "Don’s private key",
    "choice_c": "Zara’s private key",
    "choice_d": "Zara’s public key",
    "correct_answer": "B",
    "explanation": "Don should use his private key to digitally sign the message. A digital signature is created using the sender’s private key to ensure authenticity and nonrepudiation, as only Don has access to his private key. Don’s public key is used by Zara to verify the signature, not to sign the message. Zara’s private key is unrelated to the signing process, as it is used by Zara for her own encrypted communication. Zara’s public key would be used by Don to encrypt messages for Zara but not for signing.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      286,
      284,
      282,
      289,
      287
    ],
    "source": "9781394290116"
  },
  {
    "id": 1094,
    "question": "Advantages of control self-assessment (CSA) include all of the following <i>except</i>:",
    "choice_a": "Risks can be detected earlier.",
    "choice_b": "Process owners have more of a stake in the effectiveness of their processes.",
    "choice_c": "Improvements can be made more quickly.",
    "choice_d": "CSA is a viable substitute for internal audit.",
    "correct_answer": "D",
    "explanation": "CSA is not a viable substitute for internal audit, although it is sometimes perceived that way. <p>The answers referring to detecting risks, the stake of process orders, and the speed of improvements are incorrect. These <i>are</i> all advantages of a control self-assessment.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      354,
      359,
      355,
      98,
      87
    ],
    "source": "9781394290116"
  },
  {
    "id": 1095,
    "question": "During the development of an online registration form, a systems developer would like to ensure that each field accepts only valid dates within a specific range. Which of the following types of input validation should the systems developer implement?",
    "choice_a": "Typing checking",
    "choice_b": "Value and range checking",
    "choice_c": "Validity checking",
    "choice_d": "Check digit",
    "correct_answer": "B",
    "explanation": "Value and range checking is the appropriate type of input validation to ensure that each field on an online registration form accepts only valid dates within a specific range. This method assesses whether the input data falls within the defined lower and upper boundaries, making it suitable for verifying date ranges. Typing checking simply verifies that the input is of the correct data type (e.g., integer, date) but does not enforce specific range limits. Validity checking generally ensures that input values adhere to predetermined standards or formats, but it may not necessarily enforce range restrictions. Check-digit validation is a technique often used in identifiers like credit card numbers to verify authenticity and does not apply to date range validation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      143,
      146,
      148,
      119
    ],
    "source": "9781394290116"
  },
  {
    "id": 1096,
    "question": "A systems analyst is troubleshooting a chronic batch program malfunction, where the software application is aborting because alphanumeric data is being copied to a numeric date field. What kind of solution would resolve these incidents?",
    "choice_a": "Range and value checking",
    "choice_b": "Type checking",
    "choice_c": "Spell checking",
    "choice_d": "Batch totals",
    "correct_answer": "B",
    "explanation": "Type checking examines input data to see if the characters are of the proper type. For instance, a person’s name field would contain lowercase and uppercase letters, as well as an apostrophe and a hyphen. <p>“Range and value checking” is incorrect because this is used to confirm the correct values of input data of the expected type. “Spell checking” is incorrect because this is used to confirm the correct spelling of words. “Batch totals” is incorrect because these are used to confirm numeric values of batches of transactions.</p>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      143,
      148,
      144,
      149
    ],
    "source": "9781394290116"
  },
  {
    "id": 1097,
    "question": "Which of the following is the immediate action an IS auditor should recommend to an organization that has suffered a data breach?",
    "choice_a": "Disconnect all network connections and devices.",
    "choice_b": "Activate the incident response plan.",
    "choice_c": "Notify law enforcement agents.",
    "choice_d": "Evacuate people from the premises.",
    "correct_answer": "B",
    "explanation": "Activating the incident response plan is the immediate action an IS auditor should recommend because this plan provides a structured procedure for addressing and managing the aftermath of a security breach, ensuring that the organization responds efficiently and effectively. This plan typically includes steps for containment, eradication, and recovery, as well as communication strategies, both internal and external. Disconnecting all network connections and devices may be necessary in some situations, but as an initial step, it could disrupt essential ongoing operations and prevent the collection of forensic evidence. Notifying law enforcement agents is important but should follow the activation of the response plan to ensure that any communication is done through proper channels and with accurate information. Evacuating people from the premises is generally unnecessary for a data breach, as these incidents typically do not endanger physical safety.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      347,
      300,
      301,
      297,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 1098,
    "question": "An organization has just completed the implementation of a new business system. The CIO wants to measure and report on the new system’s business benefits. Why should the CIO not report on business benefits right away?",
    "choice_a": "To provide time to collect and measure meaningful data.",
    "choice_b": "Benefits will improve after the shakedown period.",
    "choice_c": "Benefits will improve after post-implementation issues are resolved.",
    "choice_d": "Metrics will improve after external resources have rolled off.",
    "correct_answer": "A",
    "explanation": "It is advisable to wait for some time to report on business benefits, mainly to provide time for transaction data, response times, and other measurements to accumulate and be reported on. <p>The answer referring to the shakedown period is incorrect because the metrics captured during the shakedown period may not accurately reflect system activities. The answer referring to post-implementation issues is incorrect because waiting for these issues to be resolved may still not provide sufficient time for enough stats to be collected. The answer referring to external resources is incorrect because the use of external resources should not be a factor.</p>",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      100,
      123,
      137,
      102,
      116
    ],
    "source": "9781394290116"
  },
  {
    "id": 1099,
    "question": "During an IS security review, you note that your client organization experienced ransomware during the period under review. Which of the following types of threat actors is <i>most</i> likely behind this attack?",
    "choice_a": "Nation-states",
    "choice_b": "Criminal syndicates",
    "choice_c": "Hacktivists",
    "choice_d": "Script kiddies",
    "correct_answer": "B",
    "explanation": "Criminal syndicates are the most likely threat actors behind a ransomware attack because these groups primarily seek financial gain, which aligns with the typical motive for deploying ransomware to extort money from victims. Nation-states are generally involved in cyber espionage or politically motivated attacks rather than seeking direct financial compensation. Hacktivists, although motivated by ideological purposes, typically aim to make a statement or promote an agenda, not necessarily to gain financial profit. Script kiddies are usually less skilled attackers using premade tools without a deep understanding of how they work, making them unlikely to execute a sophisticated and potentially financially lucrative attack like ransomware.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      291,
      290,
      259,
      260,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 1100,
    "question": "Which of the following methods is most suitable for monitoring the performance of servers in a server farm?",
    "choice_a": "Egress filtering",
    "choice_b": "Network monitoring",
    "choice_c": "Event logging",
    "choice_d": "Hardware monitoring",
    "correct_answer": "D",
    "explanation": "Hardware monitoring is the best available solution for monitoring the performance of servers in a server farm. <p>“Egress filtering” is incorrect because this is an activity performed by firewalls that do not reveal server performance. “Network monitoring” is incorrect because this does not reveal server performance. “Event logging” is incorrect because event logging does not reveal server performance.</p>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      41,
      51,
      3,
      50,
      58
    ],
    "source": "9781394290116"
  },
  {
    "id": 1101,
    "question": "The following diagram shows the steps that are ordinarily performed by IS auditors in the determination of the audit scope. Which of the following represents the initial input into the process as represented by the letter X?<img src=\"/question_assets/CISA/cpt02f001.png\" alt=\"Flowchart depicts X leading to Audit objectives, then to Audit scope.\"/>\n\n<figcaption>Flowchart depicts X leading to Audit objectives, then to Audit scope.</figcaption>",
    "choice_a": "Management input",
    "choice_b": "Risk assessment",
    "choice_c": "Prior audit reports",
    "choice_d": "Strategic plan",
    "correct_answer": "B",
    "explanation": "Risk assessment is the initial input into determining the audit scope because it helps to identify the areas with the greatest potential for material impact or the highest likelihood of issues, thereby guiding the allocation of audit resources effectively. This step ensures that the audit focuses on significant risks, aligning the audit objectives with areas of potential vulnerability or noncompliance. Management input, although important, typically informs the process after key risks have been identified to ensure alignment with organizational priorities. Prior audit reports may offer historical insights into problem areas but are retrospective and do not necessarily identify current risks. The strategic plan guides organizational goals and long-term objectives but does not specifically identify risks that should drive the audit focus.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      359,
      96,
      61,
      89,
      74
    ],
    "source": "9781394290116"
  },
  {
    "id": 1102,
    "question": "An IS auditor has developed an audit plan to review the BCP processes as shown in the following diagram. Which of the following represents the next step after specifying the business objectives, indicated by the letter X?<img src=\"/question_assets/CISA/cpt02f002.png\" alt=\"Step-down process connects Business objectives, X, Criticality analysis, and Response and recovery documentation in sequence.\"/>\n\n<figcaption>Step-down process connects Business objectives, X, Criticality analysis, and Response and recovery documentation in sequence.</figcaption>",
    "choice_a": "Risk analysis",
    "choice_b": "Business impact analysis (BIA)",
    "choice_c": "Testing",
    "choice_d": "Maintenance",
    "correct_answer": "B",
    "explanation": "After specifying the business objectives in the BCP process, the next logical step is to conduct a BIA. This step involves identifying critical business functions and assessing the impact that a disruption could have on them, which is essential for developing effective continuity plans. Risk analysis, although crucial, typically follows the BIA as it involves evaluating risks that could affect those identified critical areas. Testing and maintenance are further down the process; testing ensures that the plan works as expected, and maintenance ensures that the plan remains relevant and up to date. Therefore, BIA precedes risk analysis, testing, and maintenance in the progression of developing a comprehensive business continuity plan.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      233,
      246,
      235,
      236,
      231
    ],
    "source": "9781394290116"
  },
  {
    "id": 1103,
    "question": "Which of the following approaches is best regarding virtualization security?",
    "choice_a": "Patch the base OS only.",
    "choice_b": "Patch the hypervisor only.",
    "choice_c": "Patch the base OS and hypervisor.",
    "choice_d": "Patch the base OS, the hypervisor, and all guest OSs.",
    "correct_answer": "D",
    "explanation": "It is essential that all primary components be patched to reduce the likelihood that vulnerabilities will be exploited in an attack. This includes the base OS, the hypervisor, as well as all guest operating systems. <p>The answer referring to patching the base OS only is incorrect because this does not protect guest OSs from all attacks. The answer mentioning patching only the hypervisor is incorrect because this does not protect guest OSs from all attacks. The answer referring to patching both the base OS and the hypervisor is incorrect because this does not protect guest OSs from all attacks.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      183,
      166,
      167,
      200
    ],
    "source": "9781394290116"
  },
  {
    "id": 1104,
    "question": "During an audit review, the IS auditor seeks to collect sufficient evidence in preparation for legal proceedings. Which of the following types of IS audits is the IS auditor undertaking?",
    "choice_a": "Operational audit",
    "choice_b": "Financial audit",
    "choice_c": "Forensic audit",
    "choice_d": "Legal audit",
    "correct_answer": "C",
    "explanation": "In the scenario described, the IS auditor is undertaking a forensic audit. Forensic audits are specifically designed to gather and maintain evidence that can be used in legal proceedings, which matches the IS auditor’s goal of collecting evidence for legal purposes. A financial audit, on the other hand, focuses on the accuracy and integrity of financial records and statements, not on collecting evidence for legal cases. Operational audits aim to evaluate the effectiveness and efficiency of operations within an organization, rather than preparing for litigation. There is no specific “legal audit” in the context of IS auditing; thus, it doesn’t align accurately with the objective of collecting evidence for legal proceedings. Therefore, forensic audit is the only option explicitly tied to the legal evidence-gathering process.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      86,
      90,
      95,
      89,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 1105,
    "question": "An IT document describes the technique used to set up and manage a new firewall. What type of document is this?",
    "choice_a": "Procedure",
    "choice_b": "Standard",
    "choice_c": "Process",
    "choice_d": "Policy",
    "correct_answer": "A",
    "explanation": "A procedure document describes steps to be taken to accomplish a task. <p>“Standard” is incorrect because a standard defines specific protocols, techniques, or brands to be used. “Process” is incorrect because a process is a set of procedures, not a single procedure. “Policy” is incorrect because a policy is a statement of expected behavior.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      15,
      12,
      8,
      53,
      54
    ],
    "source": "9781394290116"
  },
  {
    "id": 1106,
    "question": "As an IS auditor, you have been asked to advise on a device to purchase to solve the issue of signal attenuation. Which of the following network devices would you recommend?",
    "choice_a": "Firewall",
    "choice_b": "Switch",
    "choice_c": "Repeater",
    "choice_d": "Router",
    "correct_answer": "C",
    "explanation": "A repeater would be the recommended device to solve the issue of signal attenuation because it serves the primary function of receiving a network signal and retransmitting it at a higher power level, thereby extending the signal distance within the network. This helps in overcoming the degradation or weakening of a signal as it travels over longer distances. A switch, although useful for connecting multiple devices within a network and segmenting traffic, does not address signal attenuation directly. A firewall is designed to provide security by controlling incoming and outgoing network traffic based on predetermined security rules, without the capability to amplify signals. A router directs data packets between networks, determining the best pathway for data transfer, but does not enhance or amplify signals. Therefore, only a repeater has the specific functionality needed to combat signal attenuation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      215,
      207,
      228,
      208,
      209
    ],
    "source": "9781394290116"
  },
  {
    "id": 1107,
    "question": "A customer of an SaaS company has claimed that the SaaS company has violated the SLA. What does this mean?",
    "choice_a": "The SaaS company’s software is not functioning properly.",
    "choice_b": "The SaaS company’s sales have not met agreed-on levels.",
    "choice_c": "The SaaS company’s services are not meeting minimum performance targets.",
    "choice_d": "The SaaS company is overcharging for its services.",
    "correct_answer": "C",
    "explanation": "An SLA, or service-level agreement, is a statement that defines minimum service levels to be provided by an entity to other entities. <p>The answer referring to improper function is incorrect because this is not a measure of service level but of service quality. The answer mentioning agreed sales levels is incorrect because sales are not related to SaaS operations. The answer referring to overcharging is incorrect because this is not a service-level problem but a billing problem.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      176,
      246,
      165,
      161,
      175
    ],
    "source": "9781394290116"
  },
  {
    "id": 1108,
    "question": "Which of the following protocols is insecure and should not be used for sensitive communications?",
    "choice_a": "SFTP",
    "choice_b": "TLS",
    "choice_c": "HTTP",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "HTTP is the insecure protocol in this list as it transmits data in plain text, making it vulnerable to interception by malicious actors. Its lack of encryption means sensitive information, like passwords and personal data, can be easily accessed if intercepted. TLS, on the other hand, is a secure protocol used for encrypting communications over a network, providing confidentiality and integrity, which ensures that data is not tampered with or exposed to unauthorized parties. SFTP (Secure File Transfer Protocol) also uses encryption to secure data transfer, safeguarding information during file uploads and downloads. Similarly, SSH (Secure Shell) provides secure access to remote systems through encrypted communication channels, ensuring privacy and data integrity in remote administration tasks.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      273,
      319,
      282,
      283,
      253
    ],
    "source": "9781394290116"
  },
  {
    "id": 1109,
    "question": "An auditor is auditing a retail store chain and needs to select individual stores to audit. There are newer stores with newer technology and older stores with older technology. Which sampling technique is best suited for this audit?",
    "choice_a": "Statistical sampling",
    "choice_b": "Judgmental sampling",
    "choice_c": "Attribute sampling",
    "choice_d": "Discovery sampling",
    "correct_answer": "B",
    "explanation": "Judgmental sampling enables the auditor to select some stores with older technology and some stores with newer technology. The other answer options are not sampling techniques that are best suited for this audit. <p>“Statistical sampling” is incorrect because this is not the best sampling choice, as it might not reflect the distribution of older and newer technologies. “Attribute sampling” is incorrect because it is not the best sampling technique to be used. “Discovery sampling” is incorrect because this is the method to be used when an auditor is looking for at least one exception in a given population.</p>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      92,
      85,
      89,
      360,
      96
    ],
    "source": "9781394290116"
  },
  {
    "id": 1110,
    "question": "The Transport Layer Security (TLS) provides message confidentiality capabilities through:",
    "choice_a": "Asymmetric encryption only",
    "choice_b": "Symmetric encryption only",
    "choice_c": "Both symmetric and asymmetric encryption",
    "choice_d": "Neither symmetric nor asymmetric encryption",
    "correct_answer": "C",
    "explanation": "TLS provides message confidentiality by using both symmetric and asymmetric encryption. At the start of a TLS session, asymmetric encryption is used for key establishment or key agreement, followed by the usage of symmetric encryption for the actual data transmission, ensuring efficient and secure message confidentiality. Symmetric encryption alone would not provide a secure way to initially establish encryption keys, which is why asymmetric encryption is also necessary. On the other hand, asymmetric encryption alone would not be efficient for encrypting large volumes of data due to its computational intensity. Claiming that TLS uses neither form of encryption contradicts its fundamental purpose, which is to secure data through encryption.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      289,
      283,
      284,
      273,
      282
    ],
    "source": "9781394290116"
  },
  {
    "id": 1111,
    "question": "An auditor is auditing an employee termination process. The auditor wants to select groups of samples until an exception is found. What type of sampling should be used?",
    "choice_a": "Stratified sampling",
    "choice_b": "Statistical sampling",
    "choice_c": "Variable sampling",
    "choice_d": "Discovery sampling",
    "correct_answer": "D",
    "explanation": "Discovery sampling enables the auditor to examine records until an exception is found, whereas the other sampling techniques are not likely to provide the needed samples. <p>“Stratified sampling” is incorrect because this method is used to ensure that samples from various value ranges (such as purchase order amount) are selected. “Statistical sampling” is incorrect because this method is used for randomly selecting samples from an entire population. “Variable sampling” is incorrect because it is used to calculate the total value represented by the samples.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      88,
      84,
      89,
      95
    ],
    "source": "9781394290116"
  },
  {
    "id": 1112,
    "question": "Which of the following is a statement by the IS auditor confirming the results of an audit?",
    "choice_a": "Audit program",
    "choice_b": "Interim report",
    "choice_c": "Attestation",
    "choice_d": "Audit test results",
    "correct_answer": "C",
    "explanation": "Attestation is a formal statement in which the IS auditor confirms the results of an audit as it involves providing assurance regarding the subject matter audited, ensuring stakeholders that the findings are accurate and reliable. “Interim report” is incorrect because it is typically a progress report provided during the audit process and does not serve as a confirmation of final audit results. “Audit program” refers to the plan and procedures that outline how an audit is conducted rather than the confirmation of findings. “Audit test results” are the outcomes of specific tests or procedures conducted during an audit, but they do not constitute a final statement of confirmation of audit results.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      364,
      94,
      356,
      89,
      357
    ],
    "source": "9781394290116"
  },
  {
    "id": 1113,
    "question": "What is the best evidence for determining the effectiveness of security awareness training?",
    "choice_a": "Attendance records",
    "choice_b": "Competency quiz results",
    "choice_c": "Length of time spent in training",
    "choice_d": "Gartner MQ rating of content",
    "correct_answer": "B",
    "explanation": "Competency quiz results reveal the most about user comprehension of security awareness training content. <p>“Attendance records” is incorrect because attendance alone may not improve efficacy at all, particularly if the content is outdated or irrelevant. The answer referring to duration of training is incorrect because the length of time spent in training with outdated or irrelevant content does nothing but waste users’ time and does not contribute to better security practices. The answer referring to the Gartner MQ rating is incorrect because a rating of a security awareness program by an advisory firm may not necessarily mean that the program is well socialized or relevant to any particular organization.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      298,
      303,
      340,
      264,
      294
    ],
    "source": "9781394290116"
  },
  {
    "id": 1114,
    "question": "Performance optimization entails the continual improvement of IT processes and systems. Which of the following is the main objective of performance optimization?",
    "choice_a": "To enhance the complexity of the organization’s IT processes",
    "choice_b": "To develop new systems in a cost-effective way",
    "choice_c": "To obtain maximum benefit from the use of IT services with minimum resources",
    "choice_d": "To enhance employee productivity",
    "correct_answer": "C",
    "explanation": "Performance optimization primarily aims to obtain maximum benefit from the use of IT services with minimum resources. This focus ensures that organizations leverage their IT investments to deliver maximum value while conserving resources, aligning perfectly with the core goal of performance optimization. Cost effectively developing new systems is more related to project or system development objectives than the ongoing process of optimizing existing systems. Enhancing the complexity of IT processes would be counterproductive to optimization, as it typically seeks to simplify and streamline. Enhancing employee productivity, although beneficial, is a secondary outcome of optimized IT processes rather than a primary focus. The main goal of performance optimization revolves around maximizing efficiency and effectiveness in IT resource utilization.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      41,
      51,
      27,
      38,
      3
    ],
    "source": "9781394290116"
  },
  {
    "id": 1115,
    "question": "In the context of logical access controls, how are the terms “subject” and “object” related?",
    "choice_a": "“Subject” refers to the data being accessed, and “object” refers to the file that contains the data.",
    "choice_b": "“Subject” refers to a person or thing that is accessing the data, and “object” refers to the resource being accessed.",
    "choice_c": "“Subject” refers to the security context, and “object” refers to the data.",
    "choice_d": "“Subject” refers to a person who is accessing the data, and “object” refers to the person who created the data.",
    "correct_answer": "B",
    "explanation": "A “subject” is the person, system, or thing accessing a resource (often, but not always, data), and “object” is the resource being accessed. <p>The answer defining “object” as the file containing the data is incorrect because “object” refers to the resource being accessed. The answer defining “subject” as the security context is incorrect because “subject” refers to the person or thing accessing the data. The answer defining “subject” as a person accessing the data and “object” as the person who created the file is incorrect because the person who created the file does not factor into the subject/object model.</p>",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      309,
      314,
      262,
      323,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 1116,
    "question": "Watermarking is a key method used in DLP systems to prevent data loss. How does the practice of watermarking in DLP systems assist in preventing data losses in an organization?",
    "choice_a": "Detecting data corruption",
    "choice_b": "Identifying and blocking the exfiltration of encrypted information",
    "choice_c": "Identifying and blocking the exfiltration of unencrypted information",
    "choice_d": "Serving as a honeypot",
    "correct_answer": "C",
    "explanation": "Watermarking in DLP systems helps prevent data loss by identifying and blocking the exfiltration of unencrypted information. Watermarks are embedded identifiers that allow DLP systems to recognize and control sensitive data when it is moved or shared. DLP systems cannot decrypt encrypted information, so watermarking does not assist in managing encrypted data. It also does not detect data corruption, which involves verifying data integrity rather than tracking its movement. Watermarking is not used as a honeypot, which is a decoy system designed to attract and study attackers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      266,
      306,
      295,
      264,
      257
    ],
    "source": "9781394290116"
  },
  {
    "id": 1117,
    "question": "A central antivirus system console is preferred by organizations for all of the following reasons <i>except</i>:",
    "choice_a": "Smaller agent footprint",
    "choice_b": "Centralized monitoring and reporting",
    "choice_c": "Consistent agent configuration",
    "choice_d": "Bulk scan and update capabilities",
    "correct_answer": "A",
    "explanation": "A smaller agent footprint is not a result of a centralized console. <p>“Centralized monitoring and reporting” is incorrect because this practice facilitates organization-wide visibility into the health and configuration of protected endpoints. “Consistent agent configuration” is incorrect because this practice permits consistent organization-wide actions. “Bulk scan and update capabilities” is incorrect because these practices facilitate consistent organization-wide actions.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      267,
      308,
      303,
      346,
      306
    ],
    "source": "9781394290116"
  },
  {
    "id": 1118,
    "question": "Which of the following is the primary reason an organization should have an IT disaster declaration procedure in place?",
    "choice_a": "To train employees for the disaster recovery process",
    "choice_b": "To provide guidelines for evacuation efforts",
    "choice_c": "To clarify conditions for declaring a disaster",
    "choice_d": "To eliminate the need for disaster recovery plan testing",
    "correct_answer": "C",
    "explanation": "An organization should have an IT disaster declaration procedure primarily to clarify conditions for declaring a disaster. This ensures that all stakeholders understand the specific criteria and thresholds that trigger the disaster recovery plan, facilitating a swift and coordinated response during critical incidents. Without clear criteria, there could be confusion and delays in mobilizing resources when a disaster occurs. Providing guidelines for evacuation is not the primary purpose of an IT disaster declaration procedure, as evacuation pertains more to physical safety and may be managed by another protocol. Training employees in the disaster recovery process is important but typically happens separately as part of broader disaster recovery planning and drills. Eliminating the need for disaster recovery plan testing would be detrimental, as testing is essential to validate and improve the recovery strategies put in place.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      240,
      235,
      241,
      252,
      244
    ],
    "source": "9781394290116"
  },
  {
    "id": 1119,
    "question": "An information security analyst who is trained in forensics is continuing an investigation into a possible criminal act by an employee through the use of a computer. The analyst is retrieving a hard drive from the evidence locker to examine it some more. What business record should the analyst update to ensure the integrity of the hard drive?",
    "choice_a": "Chain of custody",
    "choice_b": "Evidence log",
    "choice_c": "Hash file",
    "choice_d": "Time sheet",
    "correct_answer": "A",
    "explanation": "A chain of custody is a business record that is used to track the safeguarding and transfer of evidence as part of the overall record to demonstrate the protection and integrity of evidence. <p>“Evidence log” is incorrect because this is typically a business record showing what items reside in an evidence repository, but not any details about the handling of evidence. “Hash file” is incorrect because this should not be updated, because the hard drive itself should not be altered. “Time sheet” is incorrect because this does nothing to ensure the integrity of a hard drive in evidence.</p>",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      301,
      302,
      300,
      285,
      334
    ],
    "source": "9781394290116"
  },
  {
    "id": 1120,
    "question": "An IS auditor is assigned to review the effectiveness of unit testing procedures at a software development firm. During which of the following phases of software development would the IS auditor expect unit testing to have been performed?",
    "choice_a": "Migration phase",
    "choice_b": "User acceptance testing phase",
    "choice_c": "Coding phase",
    "choice_d": "Design phase",
    "correct_answer": "C",
    "explanation": "Unit testing is typically performed during the coding phase of the software development life cycle. This is because unit testing involves testing individual components or pieces of code to ensure that they function correctly before being integrated with other components. The coding phase is where these components are being actively developed and written, making it the most suitable time for unit testing to occur. In contrast, user acceptance testing focuses on validating the overall functionality of the application against user requirements and takes place after unit testing. The migration phase involves moving software into a production environment, which is well after unit testing has taken place. The design phase is more abstract and focuses on planning the architecture and design of the software, rather than on the actual writing and testing of code, which happens later during the coding phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      152,
      153,
      115
    ],
    "source": "9781394290116"
  },
  {
    "id": 1121,
    "question": "A security steering committee consisting of senior executives has refused to consider a risk recently added to the risk register by the CISO. What risk treatment has been taken?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Residual risk",
    "choice_d": "Risk transfer",
    "correct_answer": "A",
    "explanation": "By refusing to deliberate over a risk matter, an organization has – by default – accepted the risk. <p>“Risk avoidance” is incorrect because this involves cessation of the activity that introduced the risk. “Residual risk” is incorrect because this term does not refer to a type of risk treatment but is instead leftover risk after risk treatment has been completed. “Risk transfer” is incorrect because this is the act of acquiring insurance for a risk – or outsourcing the activity, where the outsourcer agrees to share the risk.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      4,
      24,
      16,
      5
    ],
    "source": "9781394290116"
  },
  {
    "id": 1122,
    "question": "Which of the following techniques should an IS auditor recommend an organization use in recovering deleted files from a physical disk?",
    "choice_a": "Live analysis",
    "choice_b": "Hardware analysis",
    "choice_c": "Media analysis",
    "choice_d": "Network analysis",
    "correct_answer": "C",
    "explanation": "Media analysis is the appropriate technique for recovering deleted files from a physical disk because it involves examining the storage media directly to retrieve lost files. This method focuses on the data storage aspects and file existence within the medium, making it ideal for file recovery. Hardware analysis does not specifically address file recovery as it focuses on the physical components of the computer, which is more related to hardware diagnostics. Live analysis generally involves analyzing running systems and processes, not focusing on previously stored and deleted data in nonvolatile storage, which makes it unsuitable for this specific task. Network analysis pertains to examining network traffic and communications, which is unrelated to the recovery of deleted files from a physical disk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      304,
      321,
      350
    ],
    "source": "9781394290116"
  },
  {
    "id": 1123,
    "question": "When auditing a business process, what types of evidence should the auditor examine?",
    "choice_a": "Written process documents and business records",
    "choice_b": "Written process documents and interviews of process owners",
    "choice_c": "Written process documents, interviews of process owners, and business records",
    "choice_d": "Business records and interviews of process owners",
    "correct_answer": "C",
    "explanation": "The answer referring to written process documents, interviews of process owners, and business records is correct because gathering all three types of evidence will give the auditor a more complete picture of the state of the business process. <p>The answer referring to process documents and business records is incorrect because these items alone are insufficient; interviews should also be performed. The answer mentioning written process documents and interviews of process owners is incorrect because business records should also be examined. The answer referring to business records and interviews of process owners is incorrect because process documents should also be examined.</p>",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      90,
      74,
      89,
      88,
      91
    ],
    "source": "9781394290116"
  },
  {
    "id": 1124,
    "question": "Which of the following is least directly related to IT governance from the perspective of an IS auditor?",
    "choice_a": "IS risk management",
    "choice_b": "IS strategic planning",
    "choice_c": "IS skills development",
    "choice_d": "IS laws and regulations",
    "correct_answer": "C",
    "explanation": "IS skills development is least directly related to IT governance because it focuses on enhancing individual capabilities rather than addressing organizational policies, processes, and controls. IS strategic planning is a core component of IT governance, ensuring alignment of IT with business goals. IS risk management is integral to governance, addressing threats to IT systems and data. IS laws and regulations are directly tied to governance as they establish compliance requirements and guide governance frameworks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1,
      7,
      16,
      17,
      14
    ],
    "source": "9781394290116"
  },
  {
    "id": 1125,
    "question": "Hardware monitoring can be used for all of the following purposes <i>except</i>:",
    "choice_a": "Resource availability",
    "choice_b": "OS patch levels",
    "choice_c": "System health",
    "choice_d": "CPU utilization",
    "correct_answer": "B",
    "explanation": "OS patch levels are not included in hardware monitoring. <p>The answers referring to resource availability, system health, and CPU utilization are all incorrect because hardware monitoring assists with all three functions, as well as other aspects of hardware capacity and utilization.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      50,
      39,
      3,
      34
    ],
    "source": "9781394290116"
  },
  {
    "id": 1126,
    "question": "Why would an IS auditor use a standard report template from similar engagements?",
    "choice_a": "To reduce the length of the report",
    "choice_b": "To avoid having to rewrite the report",
    "choice_c": "To ensure consistency in audit reporting",
    "choice_d": "To include client responses in the report",
    "correct_answer": "C",
    "explanation": "Using a standard report template from similar engagements ensures consistency in audit reporting, which is critical for maintaining uniformity and clarity across various audit reports. This consistency allows for easier comparison between reports, facilitates understanding among stakeholders, and upholds the auditor’s professional standards. The other options do not directly address the primary benefit of a standard reporting format. Reusing a template is not primarily about avoiding the need to rewrite a report, but about maintaining a consistent structure and language. Reducing the length of the report is not a fundamental reason to use a template, as clarity and completeness are typically more important. Although including client responses is part of the reporting process, it is not a reason for utilizing a standard template, which focuses on the report’s format and consistency rather than its content.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      94,
      364,
      70,
      357,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 1127,
    "question": "An auditor has observed that a systems engineer does not possess the necessary qualifications for the position. What is the auditor’s best course of action?",
    "choice_a": "Train the systems engineer in the basics of the job.",
    "choice_b": "Recommend that the systems engineer receive training.",
    "choice_c": "Note this as a finding in the audit report.",
    "choice_d": "Immediately notify audit client management.",
    "correct_answer": "C",
    "explanation": "Noting a lack of staff qualifications is a legitimate finding in an audit. <p>Training the systems engineer is incorrect because it would be inappropriate for an auditor to train anyone in the client organization. Recommending training for the systems engineer is incorrect because this is not the most important responsibility of an auditor in this situation. The auditor must include a finding in the audit report and should also go on to recommend the solution of training the engineer. Immediately notifying audit client management is incorrect because this is not an emergency situation warranting immediate notification.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      94,
      89,
      354,
      99,
      367
    ],
    "source": "9781394290116"
  },
  {
    "id": 1128,
    "question": "An IS auditor reviewing an organization’s systems development methodologies is informed of the use of data-oriented system development (DOSD). Which of the following serves as the central focus around other development activities in DOSD?",
    "choice_a": "Information",
    "choice_b": "People",
    "choice_c": "Data",
    "choice_d": "Evidence",
    "correct_answer": "C",
    "explanation": "Data serves as the central focus in DOSD, so it is the correct choice. This approach emphasizes the significance of data in shaping and guiding system development processes, ensuring that the system can effectively manage data resources throughout its life cycle. People, although crucial to development processes, are not the core focus in DOSD methodologies. Information is the outcome of effectively managing data, but it isn’t the primary focus of developing the system. Evidence, although essential for supporting conclusions and findings, is not the main component around which DOSD activities are structured. Therefore, data remains the pivotal element in DOSD, distinguishing it from other methodologies focused on different aspects.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      115,
      119,
      117,
      152,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 1129,
    "question": "The unauthorized collection and aggregation of data is a concern of the:",
    "choice_a": "Chief risk officer",
    "choice_b": "Chief information security officer",
    "choice_c": "Data protection officer",
    "choice_d": "Chief marketing officer",
    "correct_answer": "C",
    "explanation": "The data protection officer, who is responsible for privacy, is concerned about data collection and aggregation. <p>The answers citing the chief risk and chief information security officers are incorrect because the CRO and CISO, although concerned about the unauthorized collection and aggregation of data, are not the roles that are <i>most</i> concerned about this practice. “Chief marketing officer” is incorrect because the CMO is the least concerned with the unauthorized collection and aggregation of data.</p>",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      45,
      4,
      10,
      5,
      44
    ],
    "source": "9781394290116"
  },
  {
    "id": 1130,
    "question": "Once an organization has received a digital certificate, steps should be taken to verify its authenticity. Which of the following is essential to verify a digital certificate?",
    "choice_a": "The last date the certificate was audited",
    "choice_b": "The registration authority’s (RA) signature",
    "choice_c": "The certificate authority’s (CA) signature",
    "choice_d": "The certificate’s encryption algorithm",
    "correct_answer": "C",
    "explanation": "To verify the authenticity of a digital certificate, it is essential to check the CA signature because the CA is the trusted entity that issues and digitally signs the certificate, confirming its validity and authenticity. The RA signature is not relevant in this context because the RA primarily handles the process of accepting requests for digital certificates and verifying the entity’s identity but does not issue or sign the certificate itself. The last date the certificate was audited is unrelated to the authenticity of the certificate; auditing pertains more to security management practices rather than verifying certificate integrity. The certificate’s encryption algorithm, although critical for ensuring secure communications, does not directly confirm the authenticity of the certificate itself; it merely indicates the method used to encrypt the data.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      287,
      286,
      282,
      288,
      285
    ],
    "source": "9781394290116"
  },
  {
    "id": 1131,
    "question": "The act of asserting one’s identity is known as:",
    "choice_a": "Authorization",
    "choice_b": "Authentication",
    "choice_c": "Identification",
    "choice_d": "Logging",
    "correct_answer": "C",
    "explanation": "Identification is the act of asserting one’s identity without providing proof. Once proof is provided, this is authentication. <p>“Authorization” is incorrect because this refers to the granting of permission to objects, not the act of asserting your identity. “Authentication” is incorrect because this refers to the assertion of your identity after some kind of proof, such as a password, is provided. “Logging” is incorrect because this is the recording of events, not the assertion of your identity.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      320,
      344,
      313,
      346
    ],
    "source": "9781394290116"
  },
  {
    "id": 1132,
    "question": "When the transaction count and control totals do not match the expected values, an application should:",
    "choice_a": "Reprocess the entire batch.",
    "choice_b": "Accept the entire batch and create an error report.",
    "choice_c": "Reject the entire batch.",
    "choice_d": "Accept the entire batch and create a warning.",
    "correct_answer": "C",
    "explanation": "An application should reject the entire batch when transaction counts and control totals do not match expected values. This approach prevents incorrect or invalid data from being processed, maintaining data integrity and accuracy. Accepting the entire batch and creating an error report or warning would mean that potentially erroneous data could still be processed, which is undesirable for maintaining accurate records. Reprocessing the entire batch is not an immediate solution as it does not address the root cause of the mismatch; the data still needs to be examined for errors before reprocessing. Rejection ensures the issue is identified and corrected before any further processing takes place.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      148,
      143,
      146,
      145,
      156
    ],
    "source": "9781394290116"
  },
  {
    "id": 1133,
    "question": "The purpose of load balancers is:",
    "choice_a": "To ensure a balanced load across process threads",
    "choice_b": "To ensure a balanced load across servers",
    "choice_c": "To measure network utilization",
    "choice_d": "To test network utilization",
    "correct_answer": "B",
    "explanation": "Load balancers are used to evenly distribute work across a collection of servers. This ensures better resilience through the redundancy of servers performing work. <p>The answer referring to process threads is incorrect because load balancers are not used to ensure a balanced load across process threads. The answer mentioning measurement of network utilization is incorrect because load balancers are not used to measure network utilization. The answer referring to testing of network utilization is incorrect because load balancers are not used to test network utilization.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      163,
      228,
      198
    ],
    "source": "9781394290116"
  },
  {
    "id": 1134,
    "question": "You are an IS auditor at an external auditor firm, and you need to track your evidence collection. Which of the following evidence collection methods would you adopt?",
    "choice_a": "Inspection",
    "choice_b": "Email",
    "choice_c": "PBC list",
    "choice_d": "Document review",
    "correct_answer": "C",
    "explanation": "Utilizing a “PBC list” (Prepared/Provided by Client list) for tracking evidence collection is essential because it is a tool specifically designed to organize and manage requests for client-provided documents and information, ensuring clarity, accountability, and a structured approach. Although email can be used for communication about evidence, it is not a dedicated evidence tracking tool and can lead to disorganization and missed requests. “Inspection” refers to physically examining assets or documents but does not provide a method of tracking what evidence has been collected or is still needed. “Document review” pertains to analyzing the evidence for auditing purposes but lacks the systematic process to track and manage ongoing requests and collections throughout the audit. Thus, a PBC list aligns directly with the purpose of tracking and managing evidence collection efficiently.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      360,
      89,
      365,
      90,
      362
    ],
    "source": "9781394290116"
  },
  {
    "id": 1135,
    "question": "A security manager has noted that a recent security scan shows two devices not present in the asset inventory system. What should the security manager do next?",
    "choice_a": "Remove the two devices from the vulnerability scan database.",
    "choice_b": "Keep the two devices in the vulnerability scan database but stop scanning them.",
    "choice_c": "Reconcile the vulnerability management and asset management databases.",
    "choice_d": "Wait until asset inventory agents true up the asset inventory system.",
    "correct_answer": "C",
    "explanation": "Reconciling the two databases is the best first step; this will help identify the reason the scanning and inventory systems differ. <p>The answer referring to removal of the devices from the vulnerability scan database is incorrect because this exacerbates the problem by permitting these previously unknown devices to continue to reside on the network, and without knowing what vulnerabilities may exist in them. The answer referring to stopping scanning the devices is incorrect because the new devices should continue to be scanned, like all other devices on the network. The answer mentioning waiting for the asset inventory system to be trued up is incorrect because any time delay related to the installation of inventory agents could represent a window of time where serious exploitable vulnerabilities may exist, endangering the environment.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      218,
      171,
      223,
      183,
      198
    ],
    "source": "9781394290116"
  },
  {
    "id": 1136,
    "question": "During an IS security review, an IS auditor discovers that an attack was carried out by an individual using automated tools, targeting various vulnerable organization systems indiscriminately. Which of the following types of threat actors does this describe?",
    "choice_a": "Hacktivists",
    "choice_b": "Advanced persistent threat (APT) actors",
    "choice_c": "Script kiddies",
    "choice_d": "Insiders",
    "correct_answer": "C",
    "explanation": "“Script kiddies” best describes the threat actor in this scenario because they rely on automated tools to exploit vulnerabilities without deep technical knowledge, often targeting systems indiscriminately. APT actors are highly skilled and typically conduct targeted, sophisticated attacks over extended periods, which is not the case here. Hacktivists are motivated by ideological or political goals and typically target specific organizations or causes. Insiders are individuals within the organization who misuse their access, which does not align with the description of external, indiscriminate attacks using automated tools.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      291,
      290,
      292,
      260,
      305
    ],
    "source": "9781394290116"
  },
  {
    "id": 1137,
    "question": "The advantage of cloud-based web content filtering versus on-premises web content filtering is:",
    "choice_a": "Laptops are protected while off-premises.",
    "choice_b": "Laptops are protected while on-premises.",
    "choice_c": "GDPR compliance.",
    "choice_d": "End users cannot circumvent cloud-based web content filtering.",
    "correct_answer": "A",
    "explanation": "Cloud-based web content filtering will protect laptop computers regardless of their location – on network or off network. <p>The answer referring to on-premises protection is incorrect because this is not an advantage of cloud-based web content filtering. “GDPR compliance” is incorrect because cloud versus on-premises web content filtering has little, if any, bearing in GDPR compliance. The answer referring to circumvention of filtering by end users is incorrect because the ability of users to circumvent web content filtering does not correlate with whether web-based content filtering is cloud-based or on-premises.</p>",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      319,
      276,
      277,
      320,
      264
    ],
    "source": "9781394290116"
  },
  {
    "id": 1138,
    "question": "The following diagram shows the Systems development life cycle, which is subject to review by an IS auditor. Which of the following is represented by X in the diagram?<img src=\"/question_assets/CISA/cpt02f003.png\" alt=\"Step-down process connects X, Design, Development, Testing and Implementation in sequence.\"/>\n\n<figcaption>Step-down process connects X, Design, Development, Testing and Implementation in sequence.</figcaption>",
    "choice_a": "Project charter",
    "choice_b": "Project plan",
    "choice_c": "Requirements development",
    "choice_d": "Risk assessment",
    "correct_answer": "C",
    "explanation": "Requirements development is represented by X in the systems development life cycle (SDLC) diagram because it is typically the initial phase of the SDLC where the organization determines the needs for the project. A project plan would not be represented by X as it is typically developed after the feasibility study when the project is deemed feasible. The project charter is developed before requirements development, serving as a formal authorization of the project once feasibility is established. Risk assessment is an ongoing process throughout the SDLC rather than a distinct phase at the very beginning; thus it is inappropriate to label it as X in the context of the SDLC phases.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      117,
      115,
      151,
      116,
      119
    ],
    "source": "9781394290116"
  },
  {
    "id": 1139,
    "question": "The GDPR is an example of:",
    "choice_a": "Maturity model",
    "choice_b": "OSI model",
    "choice_c": "US State privacy regulation",
    "choice_d": "International privacy regulation",
    "correct_answer": "D",
    "explanation": "GDPR, or General Data Protection Regulation, is an example of an international privacy regulation. <p>“Maturity model” is incorrect because GDPR is not a maturity model. “OSI model” is incorrect because GDPR is not an OSI model. “US State privacy regulation” is incorrect because GDPR is not a US State regulation but instead a European regulation.</p>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      17,
      33,
      9,
      10
    ],
    "source": "9781394290116"
  },
  {
    "id": 1140,
    "question": "An organization is planning to implement an information security management system (ISMS) to improve its IT security governance posture. Which of the following frameworks should the IS auditor recommend as the most appropriate for this exercise?",
    "choice_a": "TOGAF",
    "choice_b": "COBIT 2019",
    "choice_c": "NIST CSF",
    "choice_d": "ISO/IEC 27001:2022",
    "correct_answer": "D",
    "explanation": "ISO/IEC 27001:2022 should be recommended for implementing an ISMS because it specifically provides requirements for establishing, implementing, maintaining, and continually improving an ISMS within the organizational context. This framework is internationally recognized and focuses on managing and safeguarding information security risks effectively. COBIT 2019, although useful, is primarily aimed at IT governance and management rather than specifically focused on information security management. NIST CSF is designed as a voluntary framework to guide organizations in improving their cybersecurity posture but does not specifically provide a structured approach for implementing an ISMS like ISO/IEC 27001. TOGAF is an enterprise architecture framework and not specifically tailored to the implementation of management systems, including those for information security, making it less suitable for this purpose compared to ISO/IEC 27001.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      260,
      263,
      262,
      303,
      256
    ],
    "source": "9781394290116"
  },
  {
    "id": 1141,
    "question": "The purpose of an encrypted session cookie is:",
    "choice_a": "To distinguish users from each other",
    "choice_b": "To encrypt responses sent to a user",
    "choice_c": "To encrypt queries sent by a user",
    "choice_d": "To comply with credit card security standards",
    "correct_answer": "A",
    "explanation": "A session cookie is used to uniquely identify each user visiting a website. When encrypted, a session cookie is difficult to hijack. <p>The answer mentioning responses sent to a user is incorrect because an encrypted session cookie does not itself force the encryption of responses sent to a user. The answer mentioning queries sent by a user is incorrect because an encryption session cookie does not by itself force the encryption of queries sent by a user. Credit card security standard compliance may require the use of secure cookies, but there is no mention of the use of credit cards in this question and many systems do not involve credit card processing.</p>",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      282,
      283,
      319,
      317,
      343
    ],
    "source": "9781394290116"
  },
  {
    "id": 1142,
    "question": "Which of the following sampling techniques involves the use of professional expertise by the IS auditor to select a sample for testing?",
    "choice_a": "Systematic sampling",
    "choice_b": "Discovery sampling",
    "choice_c": "Stratified sampling",
    "choice_d": "Judgmental sampling",
    "correct_answer": "D",
    "explanation": "Judgmental sampling (also known as nonstatistical sampling) involves the use of professional judgments by the IS auditor to select a sample for testing, making it suitable for situations where the auditor has specific expertise or where random selection is not feasible or appropriate. Unlike judgmental sampling, discovery sampling relies on a predetermined method to identify at least one occurrence of a critical error, mainly used when the presence of an error would have significant consequences. Stratified sampling is a statistical method used to divide a population into separate groups, or strata, to ensure that each subgroup is adequately represented, and does not involve professional judgment for selecting individual samples within those groups. Systematic sampling involves selecting samples based on a fixed interval from a random starting point, which is more structured and doesn’t rely on the auditor’s judgment for individual selections.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      361,
      90,
      359,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 1143,
    "question": "ABC Ltd. outsources its data center to a third-party cloud service provider (CSP). The IS auditor wants to determine the extent of the CSP’s adherence to agreed-on service-level agreements (SLAs). Which of the following engagements would be the <i>most</i> appropriate to assess whether the CSP is adhering to the stipulated SLAs?",
    "choice_a": "Operational audit",
    "choice_b": "Compliance audit",
    "choice_c": "Quality audit",
    "choice_d": "Integrated audit",
    "correct_answer": "A",
    "explanation": "An operational audit is the most appropriate engagement to assess whether the CSP is adhering to the stipulated SLAs. This type of audit focuses on evaluating an organization’s operations to ensure that they are efficient and effective and will specifically examine if the service delivery processes and procedures align with the agreed standards in the SLAs. A compliance audit, although relevant to adhering to regulations and standards, may not delve deeply into the service levels provided by the CSP. A quality audit focuses on maintaining product or service quality standards, which is narrower in scope than operational efficiency and effectiveness related to SLAs. An integrated audit, although comprehensive and covering multiple aspects such as IT, operational, and financial facets, is broader in scope and may not specifically emphasize the SLA adherence as an operational audit would.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      97,
      89,
      90,
      359
    ],
    "source": "9781394290116"
  },
  {
    "id": 1144,
    "question": "Which of the following standards is a highly effective non-law standard widely adopted by financial institutions across the world?",
    "choice_a": "CSF",
    "choice_b": "ISO/IEC 27001:2022",
    "choice_c": "NIST",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "PCI DSS is the highly effective non-law standard that is widely adopted by financial institutions globally. It is specifically designed to secure credit/debit card and financial transactions and has become a crucial part of compliance for financial organizations. ISO/IEC 27001:2022 is a global standard for information security management systems, but it is not exclusively tailored for financial institutions. NIST provides a comprehensive framework for cybersecurity but is primarily used within the United States, limiting its global adoption compared to PCI DSS. The CSF, or Cybersecurity Framework, developed by NIST, is a robust framework for managing cybersecurity-related risks but lacks the specific and widespread industry application focus seen in PCI DSS for financial institutions worldwide.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      23,
      14,
      2,
      40,
      39
    ],
    "source": "9781394290116"
  },
  {
    "id": 1145,
    "question": "Test plan development is key to which phase of the SDLC?",
    "choice_a": "Requirements definition phase",
    "choice_b": "Maintenance phase",
    "choice_c": "Deployment phase",
    "choice_d": "Testing phase",
    "correct_answer": "A",
    "explanation": "Test plan development is key to the requirements definition and design phases because it ensures that testing objectives and strategies align with the defined requirements, establishing a clear foundation for evaluating whether the system meets those needs. It is not central to the maintenance phase, which focuses on updates and fixes after deployment. The deployment phase involves delivering the system to users, not planning tests. Although testing occurs in the testing phase, the development of the test plan must precede it to guide the testing activities effectively.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      119,
      117,
      121,
      115,
      151
    ],
    "source": "9781394290116"
  },
  {
    "id": 1146,
    "question": "Which of the following is the first stage in the incident response process?",
    "choice_a": "Incident response",
    "choice_b": "Incident analysis",
    "choice_c": "Incident detection",
    "choice_d": "Incident preparation",
    "correct_answer": "D",
    "explanation": "Incident preparation is the first stage in the incident response process as it involves developing policies, procedures, and plans necessary to effectively manage and respond to incidents before they occur. This stage sets the foundation, ensuring that the organization is ready to deal with potential security events. Incident detection, on the other hand, occurs after preparation and involves identifying potential security events that might affect the organization. Incident analysis is the process where detected incidents are further assessed to understand their impact and severity, typically following detection. Incident response involves the actions taken to manage and mitigate the effects of a security incident and is executed after detection and analysis have provided sufficient information about the incident at hand.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      300,
      299,
      347,
      256,
      258
    ],
    "source": "9781394290116"
  },
  {
    "id": 1147,
    "question": "What is the purpose of using a non-exportable digital certificate on a company-owned workstation in the context of a VPN?",
    "choice_a": "It permits personally owned devices to connect to the VPN.",
    "choice_b": "It prevents personally owned devices from connecting to the VPN.",
    "choice_c": "It encrypts all traffic over the VPN.",
    "choice_d": "It hashes all traffic over the VPN.",
    "correct_answer": "B",
    "explanation": "A non-exportable digital certificate on company-owned workstations can be used to automatically enforce the “company computers only” policy regarding the use of a VPN. <p>The answer stating that personally owned devices are permitted to connect to the VPN is incorrect because the practice of using non-exportable certificates on company-owned workstations does not relate to whether personally owned devices can connect to a VPN. It is the role of the VPN switch, through mechanisms such as embedded digital certificates, to make that determination. The answers which refer to either encrypting or hashing all traffic over the VPN are incorrect because non-exportable digital certificates do not influence the encryption or hashing of VPN traffic.</p>",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      319,
      287,
      264,
      273,
      268
    ],
    "source": "9781394290116"
  },
  {
    "id": 1148,
    "question": "Which of the following is the <i>most</i> important objective behind the implementation of an IT governance framework in an organization?",
    "choice_a": "To enhance productivity",
    "choice_b": "To enforce accountability",
    "choice_c": "To reduce operating costs",
    "choice_d": "To ensure IT alignment with the business strategy",
    "correct_answer": "D",
    "explanation": "Ensuring IT alignment with the business strategy is the most critical objective of implementing an IT governance framework in an organization because its primary purpose is to support and extend the organization’s strategies and objectives. This alignment ensures that IT resources are used effectively and efficiently to drive business success, creating value for the enterprise. Although enforcing accountability is an important aspect of governance, it is more of a mechanism to achieve alignment rather than the primary objective itself. Reducing operating costs and enhancing productivity are potential outcomes of successful IT governance, but they are more tactical objectives. If IT is not aligned with business goals, cost reduction and productivity improvements may not contribute positively to realizing overall business strategies.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      1,
      7,
      6,
      3,
      17
    ],
    "source": "9781394290116"
  },
  {
    "id": 1149,
    "question": "Which monitoring processes take place after the implementation phase of the SDLC?",
    "choice_a": "Maintenance management and change management",
    "choice_b": "Service management and configuration management",
    "choice_c": "Problem management",
    "choice_d": "Event management and capacity management",
    "correct_answer": "D",
    "explanation": "Event management and capacity management are monitoring processes performed on a production system after it has been implemented. <p>The answer referring to maintenance and change management is incorrect because these activities are not related to monitoring. The answer referring to service and configuration management is incorrect because these activities are not related to monitoring. “Problem management” is incorrect because this is not related to monitoring.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      164,
      163,
      165,
      175,
      185
    ],
    "source": "9781394290116"
  },
  {
    "id": 1150,
    "question": "You have been requested by the CEO of your organization to advise on the differences between a vulnerability assessment and a penetration test. You should explain that the main difference is that a vulnerability assessment:",
    "choice_a": "Requires the scanner to have a valid security certification",
    "choice_b": "Is similar to a penetration test",
    "choice_c": "Is only applicable to physical assets",
    "choice_d": "Only detects vulnerabilities and does not exploit them",
    "correct_answer": "D",
    "explanation": "A vulnerability assessment primarily involves the identification and detection of vulnerabilities within a system or network without actually exploiting those vulnerabilities. It aims to provide a list of potential security weaknesses that could be targeted by an attacker, allowing organizations to address these vulnerabilities proactively. This contrasts with a penetration test, which goes beyond detection to actively exploiting vulnerabilities to determine the real-world impact and potential risks posed by those vulnerabilities. The suggestion that vulnerability assessment is similar to a penetration test is misleading because the two processes differ fundamentally in their approach and goals, with penetration testing involving active exploitation. The notion that vulnerability assessment is only applicable to physical assets is incorrect because it targets a wide range of assets, including network and software components. Finally, although vulnerability assessments may benefit from experienced professionals, there is no strict requirement for a scanner to possess a security certification to perform an assessment; however, certifications can enhance credibility.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      322,
      308,
      268,
      313,
      260
    ],
    "source": "9781394290116"
  },
  {
    "id": 1151,
    "question": "Performing a bare-metal restore of a production server is an example of what type of control?",
    "choice_a": "Compensating",
    "choice_b": "Restorative",
    "choice_c": "Recovery",
    "choice_d": "Automatic",
    "correct_answer": "C",
    "explanation": "A recovery control is a control that is used to return a system to a previous state. <p>“Compensating” is incorrect because a compensating control is used when another primary control cannot be used. “Restorative” is incorrect because this is not a control category. “Automatic” is incorrect because automatic is not a type of control and a bare-metal restore of a server is not typically an automatic activity but instead one that is human initiated.</p>",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      79,
      81,
      94,
      361,
      360
    ],
    "source": "9781394290116"
  },
  {
    "id": 1152,
    "question": "Which of the following represents a vital step that should be considered after the design reviews to ensure that the design phase remains stable?",
    "choice_a": "Performing a requirements analysis",
    "choice_b": "Developing system test plans",
    "choice_c": "Conducting storyboarding sessions with all staff",
    "choice_d": "Implementing a design freeze",
    "correct_answer": "D",
    "explanation": "Implementing a design freeze is crucial after design reviews as it signifies that the design is finalized, preventing further modifications that could destabilize the project. This step ensures stability as it locks the design specifications, allowing the team to progress to the next development phase with a clear and unchangeable guideline. Developing system test plans, although important for verifying and validating the system, is more relevant in the requirements definition and design phases stages where testing is paramount to system quality rather than maintaining design stability. Storyboarding sessions with staff are useful for clarifying and illustrating design concepts but occur earlier to gather requirements or refine designs, rather than after freezing them. Performing requirements analysis is generally done before design development and reviews and is meant to ensure that the correct needs and specifications are captured; this should not be confused with maintaining design stability post-review.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      119,
      115,
      121,
      151,
      152
    ],
    "source": "9781394290116"
  },
  {
    "id": 1153,
    "question": "A new CIO is finding it difficult to understand the effectiveness of IT processes in the organization. What should the CIO implement to provide better visibility?",
    "choice_a": "Zachman scorecard",
    "choice_b": "Balanced scorecard",
    "choice_c": "Benchmarks",
    "choice_d": "Control self-assessments",
    "correct_answer": "B",
    "explanation": "The balanced scorecard (BSC) is a management tool used to measure the performance and effectiveness of an organization. <p>“Zachman scorecard” is incorrect because there is no such thing as a Zachman scorecard. Benchmarks compare performance to external standards or peers but don’t inherently offer insight into internal process effectiveness or alignment with strategic goals. “Control self-assessments” is incorrect because CSAs may be subjective and biased; the CIO should obtain unbiased information.</p>",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      3,
      41,
      1,
      6,
      51
    ],
    "source": "9781394290116"
  },
  {
    "id": 1154,
    "question": "An IS auditor has recommended that an organization consider implementing a control to warn and discourage unauthorized persons from accessing sensitive information. Which of the following types of controls is the IS auditor referring to?",
    "choice_a": "Logical",
    "choice_b": "Preventive",
    "choice_c": "Detective",
    "choice_d": "Deterrent",
    "correct_answer": "D",
    "explanation": "Deterrent controls are specifically designed to warn and discourage potential unauthorized access before it occurs, making them suitable when the aim is to prevent individuals from attempting to breach systems. Preventive controls, although also aimed at stopping unauthorized access, do so by blocking unauthorized actions rather than merely warning or discouraging them. Detective controls, on the other hand, identify and alert the system to unauthorized access attempts after they have happened, allowing for a response to the breach. Logical controls involve software-based measures like authentication and encryption, which are more closely aligned with preventing access rather than warning against it. Therefore, a deterrent control is most aligned with the auditor’s recommendation in this context.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      80,
      79,
      363,
      359,
      75
    ],
    "source": "9781394290116"
  },
  {
    "id": 1155,
    "question": "The most effective method of deploying patches to a large server farm is:",
    "choice_a": "A software distribution system",
    "choice_b": "Gold images",
    "choice_c": "Hardened images",
    "choice_d": "Auto-update",
    "correct_answer": "A",
    "explanation": "A software distribution system is the best method to be used to distribute and install patches to a large server environment. <p>“Gold images” and “hardened images” are incorrect because images are not advised, as they are only used to build, not maintain, servers. “Auto-update” is incorrect because automatic updates are not advised, as some patches may impair operation.</p>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      172,
      167,
      166,
      183,
      169
    ],
    "source": "9781394290116"
  },
  {
    "id": 1156,
    "question": "A major advantage of cloud computing compared to traditional computing is that in cloud computing, multiple users can share resources without their knowledge or interaction. This is referred to as:",
    "choice_a": "Scalability",
    "choice_b": "Measured service",
    "choice_c": "On-demand access",
    "choice_d": "Multitenancy",
    "correct_answer": "D",
    "explanation": "Multitenancy is the term used to describe a major advantage of cloud computing where multiple users share resources without knowing or interacting with each other. This allows for efficient resource utilization and cost-effectiveness, which is a fundamental aspect of cloud services. “Measured service” refers to the cloud computing feature that allows for monitoring and controlling resource usage, which is essential for billing but not directly related to the simultaneous sharing of resources. On-demand access involves users obtaining resources as needed, which facilitates flexibility and rapid provisioning but doesn’t inherently describe shared resource use among multiple users. Scalability pertains to the ability of a cloud service to handle increasing or decreasing workloads, allowing organizations to adapt resource use to demand levels, but it doesn’t directly address the idea of resources being shared among multiple users without awareness.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      276,
      277,
      279,
      278,
      280
    ],
    "source": "9781394290116"
  },
  {
    "id": 1157,
    "question": "A CIO is finding it difficult to align the IT group with the greater organization. What should the CIO implement to resolve this?",
    "choice_a": "Control self-assessments",
    "choice_b": "Benchmarking",
    "choice_c": "IT steering committee",
    "choice_d": "Balanced scorecard",
    "correct_answer": "C",
    "explanation": "An IT steering committee, with members consisting of executives and leaders from end-user departments, is the best option for getting the IT organization into better alignment with the business. <p>“Control self-assessments” is incorrect because CSAs are used to determine control effectiveness. “Benchmarking” is incorrect because this technique is used to compare one organization to another. “Balanced scorecard” is incorrect because this is a management reporting methodology.</p>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      7,
      6,
      1,
      27,
      4
    ],
    "source": "9781394290116"
  },
  {
    "id": 1158,
    "question": "Which of the following should IS auditors consider a critical component in functional testing?",
    "choice_a": "Each functional requirement must be resilient.",
    "choice_b": "Each functional requirement must be recent.",
    "choice_c": "Developers must test each functional requirement.",
    "choice_d": "Each functional requirement must be verifiable.",
    "correct_answer": "D",
    "explanation": "Each functional requirement must be verifiable because the primary aim of functional testing is to ensure that the software meets specified requirements and performs its intended functions. Verification involves checking that requirements are properly implemented and operating as intended, which is crucial for validating that the application works correctly. A functional requirement being recent is not inherently critical as older requirements could remain relevant and unchanged, thus not impacting the validity of the testing. Although having developers test each requirement may be beneficial, it is not a critical component because testing can be performed by other parties such as a QA team to ensure objectivity. Resilience of requirements relates to the application’s ability to recover from issues, which is important for nonfunctional testing rather than functional testing, where the focus is on verifying specification adherence. Therefore, verifiability is essential for comprehensive and effective functional testing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      117,
      151,
      156,
      153
    ],
    "source": "9781394290116"
  },
  {
    "id": 1159,
    "question": "An auditor is performing a walkthrough with the director of software development, who says that developers use the Burp Suite tool. What is the purpose of this tool in this environment?",
    "choice_a": "Stress testing",
    "choice_b": "User acceptance testing",
    "choice_c": "Functional testing",
    "choice_d": "Security testing",
    "correct_answer": "D",
    "explanation": "Burp Suite is a tool used to test web applications, specifically to identify vulnerabilities in web applications. It is not used for stress testing, which evaluates performance under heavy load. It does not facilitate user acceptance testing, which involves validating that the system meets user needs and requirements. Functional testing focuses on verifying that the application functions as intended, but Burp Suite’s primary purpose is to assess and enhance application security.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      308,
      322,
      268,
      264,
      342
    ],
    "source": "9781394290116"
  },
  {
    "id": 1160,
    "question": "During a review of an organization’s disaster recovery processes, an IS auditor discovers that the disaster recovery procedures are not updated. Which of the following is the main purpose of disaster recovery procedures?",
    "choice_a": "To train staff in new emergency procedures",
    "choice_b": "To create new procedures",
    "choice_c": "To eliminate the need for a disaster recovery plan",
    "choice_d": "To bootstrap services supporting critical business functions",
    "correct_answer": "D",
    "explanation": "The main purpose of disaster recovery procedures is to bootstrap services supporting critical business functions after a disruption. These procedures are essential to ensure that an organization can quickly recover and continue its operations during and after a disaster. Creating new procedures is not the main purpose of disaster recovery; it’s about having existing, tested, and updated procedures ready to implement. Eliminating the need for a disaster recovery plan is unrealistic, as such a plan is crucial for organizational resilience. Although training staff is important, it supports the execution of the procedures rather than being the primary purpose of having the procedures in place.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      248,
      235,
      252,
      236
    ],
    "source": "9781394290116"
  },
  {
    "id": 1161,
    "question": "An auditor is examining the physical configuration of production servers and has observed that they employ dual NICs and dual power supplies. What is the most likely reason for the servers having dual NICs?",
    "choice_a": "They occupy multiple VLANs.",
    "choice_b": "NICs are unreliable.",
    "choice_c": "System resilience.",
    "choice_d": "The servers are connected to a supernet.",
    "correct_answer": "C",
    "explanation": "The prevalent reason for using two NICs is for system resilience purposes; in the event of the failure of one NIC or its corresponding switch or switch port, the server can continue communicating through the other NIC. <p>The answer referring to multiple VLANs is incorrect because a single NIC can be associated with multiple VLANs. The answer citing the unreliability of NICs is incorrect because NICs are not inherently unreliable. The answer referring to connection of servers to a supernet is incorrect because network addressing and masking are unrelated to the number of NICs in use.</p>",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      206,
      201,
      207,
      183,
      187
    ],
    "source": "9781394290116"
  },
  {
    "id": 1162,
    "question": "Why should IS auditors engage in audit planning?",
    "choice_a": "To avoid external audits",
    "choice_b": "To comply with legal requirements",
    "choice_c": "To reduce the amount of workload",
    "choice_d": "To determine the amount of audit resources required",
    "correct_answer": "D",
    "explanation": "Engaging in audit planning is essential for IS auditors to determine the amount of audit resources required. Proper planning ensures that auditors allocate sufficient time, personnel, and tools to effectively and efficiently carry out the audit. This not only helps in managing limited resources but also enhances audit quality by addressing key risk areas and ensuring sufficient coverage. Compliance with legal requirements may guide the scope of the audit but isn’t the primary reason for engaging in planning – it’s more about regulatory adherence during execution. Reducing the workload is not the primary focus of audit planning; rather, planning ensures that workloads are managed wisely without compromising the audit’s integrity. Avoiding external audits is not a valid reason for planning, as audits – whether internal or external – focus on accountability and assurance rather than avoidance.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      85,
      367,
      84,
      61,
      70
    ],
    "source": "9781394290116"
  },
  {
    "id": 1163,
    "question": "The purposes of a dynamic DLP platform are all of the following <i>except</i>:",
    "choice_a": "Passive monitoring of database schema changes",
    "choice_b": "Automatic enforcement of data classification policy",
    "choice_c": "Data exfiltration prevention",
    "choice_d": "Identifying instances of sensitive data on file shares",
    "correct_answer": "A",
    "explanation": "Passive monitoring of database schema changes is the correct answer because dynamic DLP has nothing to do with the monitoring of database schema changes. <p>Automatic enforcement of data classification policy, prevention of exfiltration of data, and identification of instances of sensitive data on file shares are all incorrect because they are all purposes of a dynamic DLP system.</p>",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      266,
      295,
      264,
      306,
      262
    ],
    "source": "9781394290116"
  },
  {
    "id": 1164,
    "question": "Client management should be allowed to respond to the results of an IS audit. Which of the following represents an acceptable way for client management to respond to IS audit findings?",
    "choice_a": "Rewrite the audit report",
    "choice_b": "Deny the findings",
    "choice_c": "Approve the report",
    "choice_d": "Remediate the issues",
    "correct_answer": "D",
    "explanation": "Remediating the issues is an acceptable way for client management to respond to IS audit findings because it demonstrates a proactive approach to addressing and correcting the identified deficiencies, which aligns with the ultimate goal of improving information system controls and processes. Denying the findings is not constructive as it does not address the issues or contribute to risk mitigation and improvement. Approving the report is not a response to the findings themselves but merely an acknowledgment of the report’s existence, which does not provide a plan of action to address the issues. Rewriting the audit report undermines the integrity of the audit process and fails to provide any tangible plan for addressing or correcting the identified issues, instead jeopardizing the independence of the audit findings.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      98,
      364,
      363,
      94,
      357
    ],
    "source": "9781394290116"
  },
  {
    "id": 1165,
    "question": "An auditor wants to audit an IT department’s change control process. What is the best source of information to determine the total population of changes?",
    "choice_a": "Approved changes from the change control process",
    "choice_b": "Logfile containing all changes to a system",
    "choice_c": "Systems events stored in the SIEM",
    "choice_d": "Number of administrator logins",
    "correct_answer": "B",
    "explanation": "The best source of an event population for a change control process is log data of some kind from the systems in scope for the change control process. Obtaining records from change management would only include approved changes. <p>The answer referring to approved changes is incorrect because the list of approved changes represents only approved changes, not unapproved changes, or changes that were not requested at all. The answer referring to events stored in the SIEM is incorrect because the SIEM may not have records of all changes made in the system. The answer referring to the number of administrator logins is incorrect because administrators can log in to a system and not make changes, and administrators can make changes to systems without logging in to them.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      360,
      92,
      88,
      89
    ],
    "source": "9781394290116"
  },
  {
    "id": 1166,
    "question": "Component-based development environments typically structure their applications as:",
    "choice_a": "A set of unrelated modules",
    "choice_b": "Monolithic systems",
    "choice_c": "Standalone applications",
    "choice_d": "Several components working together",
    "correct_answer": "D",
    "explanation": "In component-based development environments, applications are typically structured as several components working together because this approach promotes reusability, scalability, and ease of maintenance, allowing different components to be independently developed and then integrated into a larger system. Unlike monolithic systems, which are large, single-tiered architectures where updates or changes are more complex and riskier, component-based environments are more modular and flexible. Standalone applications do not take advantage of the collaborative interaction between components to build a comprehensive system. Unrelated modules lack cohesion and coordination, which fails to leverage the potential for components to effectively interact and support the application’s functionality as a whole.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      161,
      181,
      166,
      167,
      169
    ],
    "source": "9781394290116"
  },
  {
    "id": 1167,
    "question": "What is the primary purpose of a SIEM?",
    "choice_a": "Server farm session management",
    "choice_b": "Aggregation of log data",
    "choice_c": "Aggregation of log data and alerting",
    "choice_d": "Protection of privacy encryption keys",
    "correct_answer": "C",
    "explanation": "A SIEM, or security information and event management system, is used to collect log data from systems and to devise and produce alerts when security events are suspected. <p>The answer referring to server farm management is incorrect because a SIEM is not used to manage server farm sessions but instead is a log collection, correlation, and alerting system. The answer referring to log data is incorrect because a SIEM is not used <i>only</i> to aggregate log data but also to correlate and alert on events. The answer referring to privacy encryption keys is incorrect because a SIEM is not used as a means for protecting privacy encryption keys but instead is used to store, correlate, and alert on security event logs.</p>",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      346,
      308,
      266,
      264,
      299
    ],
    "source": "9781394290116"
  },
  {
    "id": 1168,
    "question": "An IS auditor is planning an audit review of an organization’s identity and access management (IAM) solution and is contemplating the adoption of a risk-based approach to determine the controls and activities to audit. Which of the following ISACA standards outlines this requirement?",
    "choice_a": "Audit Charter",
    "choice_b": "Audit Planning",
    "choice_c": "Risk Assessment",
    "choice_d": "Risk Assessment in Planning",
    "correct_answer": "D",
    "explanation": "Risk Assessment in Planning is the ISACA standard that outlines a requirement for adopting a risk-based approach when determining the controls and activities to audit. This standard ensures that auditors focus on areas with the highest risk, thereby optimizing audit resources and increasing the effectiveness of the audit process. Audit Planning, although a crucial element of preparing for an audit, is more general and doesn’t specifically mandate a risk-based approach. Risk Assessment is more about identifying and evaluating risks rather than applying those assessments specifically within audit planning. The Audit Charter provides authority to the audit function but doesn’t dictate the methods, such as risk-based planning, that an audit should employ.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      359,
      84,
      85,
      61
    ],
    "source": "9781394290116"
  },
  {
    "id": 1169,
    "question": "Which party approves feasibility studies to support a business case?",
    "choice_a": "CTO",
    "choice_b": "Project manager",
    "choice_c": "IT steering committee",
    "choice_d": "CISO",
    "correct_answer": "C",
    "explanation": "The IT steering committee formally commissions the feasibility study, approves the project, assigns IT resources to the project, and approves the project schedule. <p>“CTO” is incorrect because the CTO does not typically approve a feasibility study. “Project manager” is incorrect because a project manager does not typically approve a feasibility study. “CISO” is incorrect because the CISO does not typically approve a feasibility study.</p>",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      102,
      101,
      105,
      116,
      150
    ],
    "source": "9781394290116"
  },
  {
    "id": 1170,
    "question": "The <i>main</i> reason for conducting a simulation test in the context of business continuity and disaster recovery plans is to:",
    "choice_a": "Assess the effects of the disaster",
    "choice_b": "Respond to the current disaster",
    "choice_c": "Simulate a disaster scenario and ignore the response",
    "choice_d": "Simulate a disaster scenario and evaluate the response",
    "correct_answer": "D",
    "explanation": "Conducting a simulation test for business continuity and disaster recovery plans primarily serves the purpose of simulating a disaster scenario and evaluating the response to it. This approach is critical as it allows organizations to test the effectiveness of their disaster recovery plans in a controlled environment, ensuring that the response mechanisms are efficient and can be improved if necessary. Responding to a current disaster is not the main purpose of a simulation test; instead, it’s meant to prepare for potential future scenarios. Simulating a disaster scenario without evaluating the response undermines the purpose of a simulation test as it does not provide any insights or improvements to existing plans. Assessing the effects of the disaster focuses more on the aftermath rather than testing preparedness and response strategies, which is what a simulation test aims to address.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      245,
      249,
      235,
      240
    ],
    "source": "9781394290116"
  },
  {
    "id": 1171,
    "question": "An IT architect has developed and published a document describing the protocols to be used for multifactor authentication. What kind of a document did the IT architect publish?",
    "choice_a": "Process",
    "choice_b": "Architecture",
    "choice_c": "Standard",
    "choice_d": "Policy",
    "correct_answer": "C",
    "explanation": "A standard is a document that specifies technologies, architectures, protocols, and vendors to be used in an IT organization. <p>“Process” is incorrect because a process is a series of related procedures. “Architecture” is incorrect because an architecture describes the relationship between system components. “Policy” is incorrect because a policy is a statement of expected behavior.</p>",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      15,
      12,
      8,
      54,
      53
    ],
    "source": "9781394290116"
  },
  {
    "id": 1172,
    "question": "Which of the following indicates to an IS auditor that numerous emergency changes were made to an application?",
    "choice_a": "Inadequate test cases",
    "choice_b": "Absence of a change management policy",
    "choice_c": "Well-documented change management process",
    "choice_d": "Numerous back-out procedures",
    "correct_answer": "D",
    "explanation": "Numerous back-out procedures indicate to an IS auditor that emergency changes were frequently made to an application, because these procedures are often employed when unforeseen issues arise after an emergency change. This suggests that those changes were not thoroughly tested or that emergent issues required a quick rollback, revealing a pattern of reactive rather than proactive changes. Although an absence of a change management policy could contribute to a chaotic change environment, it doesn’t directly indicate the frequency or presence of emergency changes. A well-documented change management process suggests effective control and organization in managing changes, which is the opposite of what numerous emergency changes imply. Finally, inadequate test cases imply poor testing but do not themselves indicate the occurrence or frequency of emergency changes; they might lead to errors, but the immediate evidence of emergency changes would be the numerous back-out procedures.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      167,
      168,
      173,
      166,
      169
    ],
    "source": "9781394290116"
  },
  {
    "id": 1173,
    "question": "An auditor is performing a walkthrough of a manufacturing organization’s information security management program and has asked what controls framework is in use. The auditee replied that no international standard is used, but instead the organization implemented its own framework based on the ISO/IEC 27001 standard. What can the auditor conclude from this?",
    "choice_a": "Material weakness",
    "choice_b": "Major deficiency",
    "choice_c": "No conclusion can be drawn at this time.",
    "choice_d": "Minor deficiency",
    "correct_answer": "C",
    "explanation": "The lack of alignment of an organization’s security controls to an international standard is not necessarily a deficiency. The organization may have a sound risk management program that has driven the development of security controls that are adequate for the organization. A manufacturing organization is not necessarily under an obligation to adopt a specific control framework standard. <p>“Material weakness,” “major deficiency,” and “minor deficiency” are all incorrect. The use of any particular controls framework is not grounds for creating any level of issue, whether a minor deficiency, major deficiency, or material weakness. Only a failure of control design or control effectiveness would result in such a finding.</p>",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      303,
      263,
      264,
      253,
      340
    ],
    "source": "9781394290116"
  },
  {
    "id": 1174,
    "question": "The ISACA COBIT 2019 is an important tool that can be used by IS auditors in assessing IT governance processes in a variety of organizational environments. The following diagram shows the COBIT 2019 Goals Cascade. Which of the following does the X represent?<img src=\"/question_assets/CISA/cpt02f004.png\" alt=\"Step-down process connects X, Enterprise goals, Alignment goals, and Governance and management objectives in sequence.\"/>\n\n<figcaption>Step-down process connects X, Enterprise goals, Alignment goals, and Governance and management objectives in sequence.</figcaption>",
    "choice_a": "Environmental scanning",
    "choice_b": "Board of directors directives",
    "choice_c": "Chief executive officer’s strategic plans",
    "choice_d": "Stakeholder drivers and needs",
    "correct_answer": "D",
    "explanation": "In the COBIT 2019 Goals Cascade, X represents stakeholder drivers and needs. This is because the Goals Cascade begins by identifying the needs and expectations of stakeholders, which then guide the development of enterprise goals. These stakeholder drivers and needs are fundamental in shaping the governance and management objectives within the COBIT framework. Board of directors directives reflect the specific governance decisions within an organization but are not the starting point in the cascade. The Chief Executive Officer’s strategic plans are a result of aligning organizational strategies with stakeholder needs rather than the initial input. Environmental scanning is an analysis technique used to understand external influences and is part of strategic planning but not the primary focus of the Goals Cascade. Therefore, stakeholder drivers and needs logically initiate the cascade, as they are the foundational elements on which the framework builds its objectives and processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      2,
      39,
      1,
      7,
      16
    ],
    "source": "9781394290116"
  },
  {
    "id": 1175,
    "question": "An auditor is auditing a server environment and has noted that backup media are stored in locked cabinets adjacent to the primary storage system. The auditor has been told that a second set of backup media is stored at an offsite media storage center. For what reason would an organization employ two sets of backup media for servers?",
    "choice_a": "Business continuity purposes",
    "choice_b": "Disaster recovery purposes",
    "choice_c": "Because backup media cannot be trusted",
    "choice_d": "Rapid data recovery and disaster recovery purposes",
    "correct_answer": "D",
    "explanation": "Using two sets of backup media – one near the primary system and one at an offsite storage facility – permits the organization to rapidly restore data in normal operations circumstances (with the nearby backup media) as well as for disaster recovery purposes (using the backup media at the offsite storage facility). <p>“Business continuity purposes” is incorrect because business continuity alone is not a sufficient reason for having two sets of backup media. “Disaster recovery purposes” is incorrect because disaster recovery (DR) alone is not a sufficient reason for having two sets of backup media; for DR, having one remote set of backup media is sufficient. “Because backup media cannot be trusted” is incorrect because backup media is not inherently untrustworthy.</p>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      247,
      250,
      240,
      238
    ],
    "source": "9781394290116"
  },
  {
    "id": 1176,
    "question": "What type of interface is commonly used to allow applications to interact with a web service without going through the normal user interface?",
    "choice_a": "Graphical user interface (GUI)",
    "choice_b": "User interface",
    "choice_c": "System interface",
    "choice_d": "Application programming interface (API)",
    "correct_answer": "D",
    "explanation": "An API allows applications to interact directly with a web service, bypassing the normal user interface, by providing a set of functions and protocols for communication. A GUI is designed for users, not applications, to interact with systems visually. A user interface is a broader term for any interface designed for user interaction, not for application-to-application communication. A system interface refers to internal interactions within systems and is not specifically designed for web service interaction.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      222,
      216,
      209,
      208,
      189
    ],
    "source": "9781394290116"
  }
];
